var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 667,
    height: 553,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M31.525 18.444c2.476-1.398 4.951-2.118 7.554-.212.38.424.761.847 1.163 1.25 1.63 4.002.233 7.432-3.427 8.47a6.34 6.34 0 0 1-5.247-1.377 6.63 6.63 0 0 1-.297-7.729z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M20.312 28.608c.804 0 1.27-.741 1.926-1.059a6.89 6.89 0 0 1 7.193 1.06c.339.55.698 1.1.995 1.672a6.23 6.23 0 0 1-2.39 8.29 6.2 6.2 0 0 1-3.027.837 9.26 9.26 0 0 1-4.633-1.758 7.61 7.61 0 0 1-.402-8.682c.127-.106.211-.233.338-.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M18.386 39.64c.338.572.72 1.123.994 1.716a5.62 5.62 0 0 1-1.1 6.522 5.33 5.33 0 0 1-6.136 1.186c-3.406-2.118-5.014-5.252-1.925-9.317a6.344 6.344 0 0 1 8.167-.106"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M24.65 47.878a6.64 6.64 0 0 1 6.33 3.864 6.655 6.655 0 0 1-1.189 7.326 6.641 6.641 0 0 1-11.489-4.414 6.74 6.74 0 0 1 1.82-4.659 6.73 6.73 0 0 1 4.527-2.117"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M67.43 4.955a7.02 7.02 0 0 1 4.922 1.992 7.03 7.03 0 0 1 2.124 4.869 6.87 6.87 0 0 1-1.963 4.87 6.853 6.853 0 0 1-11.747-4.743 7 7 0 0 1 1.932-4.832 6.98 6.98 0 0 1 4.733-2.156"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M49.192 7.475 50.716 9a5.234 5.234 0 0 1-.776 6.421 5.224 5.224 0 0 1-6.418.757l-1.185-1.08a5.89 5.89 0 0 1 .148-6.988 6.07 6.07 0 0 1 6.707-.635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M35.714 38.667A5.17 5.17 0 0 1 35.608 49a5.16 5.16 0 0 1-4.736-3.24 5.17 5.17 0 0 1 2.863-6.721 5.2 5.2 0 0 1 1.98-.373"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M46.315 26.787a6.34 6.34 0 0 1 5.851 3.893 6.36 6.36 0 0 1-1.32 6.907 6.345 6.345 0 0 1-10.878-4.32 6.471 6.471 0 0 1 6.347-6.48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M56.957 16.263a6.35 6.35 0 0 1 4.327 1.82 6.36 6.36 0 0 1 1.894 4.3 6.25 6.25 0 0 1-1.864 4.228 6.24 6.24 0 0 1-10.598-3.995c0-1.667.654-3.267 1.821-4.456a6.35 6.35 0 0 1 4.42-1.897"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M14.409 58.148c1.826.049 3.565.8 4.853 2.097a7.12 7.12 0 0 1 2.065 4.87 7.3 7.3 0 0 1-2.085 4.982 7.28 7.28 0 0 1-4.94 2.175c-3.152.127-7.404-3.938-7.045-7.115a7.14 7.14 0 0 1 2.14-4.971 7.13 7.13 0 0 1 5.012-2.038"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M35.694 58.572a6.62 6.62 0 0 1 6.08 4.155 6.63 6.63 0 0 1-1.514 7.211 6.62 6.62 0 0 1-11.252-4.823 6.74 6.74 0 0 1 2.021-4.624 6.73 6.73 0 0 1 4.665-1.92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M14.155 80.298a6.24 6.24 0 0 1 5.86 3.728 6.25 6.25 0 0 1-1.21 6.843A6.24 6.24 0 0 1 8.062 86.65a6.36 6.36 0 0 1 1.768-4.404 6.35 6.35 0 0 1 4.325-1.948"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M24.861 70.578a5.29 5.29 0 0 1 4.885 3.263 5.298 5.298 0 0 1-3.84 7.22 5.285 5.285 0 0 1-5.433-2.232 5.3 5.3 0 0 1-.901-2.936 5.393 5.393 0 0 1 5.29-5.315"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M56.936 37.84a6.005 6.005 0 0 1 5.566 3.698 6.018 6.018 0 0 1-4.365 8.213 6 6 0 0 1-6.175-2.553 6 6 0 0 1-1.014-3.343 6.12 6.12 0 0 1 1.783-4.215 6.1 6.1 0 0 1 4.205-1.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M67.324 26.83a6.34 6.34 0 0 1 6.046 3.627 6.357 6.357 0 0 1-4.187 8.878 6.34 6.34 0 0 1-6.641-2.367 6.356 6.356 0 0 1 4.782-10.139"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M14.41 101.219a6.66 6.66 0 0 1 6.086 4.205 6.68 6.68 0 0 1-1.54 7.241 6.67 6.67 0 0 1-3.43 1.781 6.67 6.67 0 0 1-3.841-.423 6.675 6.675 0 0 1-4.046-6.197 6.73 6.73 0 0 1 6.77-6.607"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M46.336 48.958a5.56 5.56 0 0 1 5.116 3.482 5.57 5.57 0 0 1-1.262 6.062 5.564 5.564 0 0 1-9.461-4.038 5.668 5.668 0 0 1 5.607-5.506"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M88.8 5.442a6.34 6.34 0 0 1 5.863 3.922 6.36 6.36 0 0 1-1.376 6.923 6.345 6.345 0 0 1-10.835-4.492c0-1.685.669-3.3 1.859-4.492a6.35 6.35 0 0 1 4.488-1.86"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M78.242 16.03a6.45 6.45 0 0 1 6.025 3.889 6.465 6.465 0 0 1-1.283 7.06 6.451 6.451 0 0 1-11.09-4.385 6.53 6.53 0 0 1 1.834-4.58 6.51 6.51 0 0 1 4.514-1.984"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M35.609 80.086a6.34 6.34 0 0 1 5.864 3.922 6.36 6.36 0 0 1-1.376 6.923 6.346 6.346 0 0 1-10.836-4.492 6.48 6.48 0 0 1 1.895-4.456 6.47 6.47 0 0 1 4.453-1.897"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M24.86 91.224a5.98 5.98 0 0 1 5.615 3.645 6 6 0 0 1-1.268 6.577 5.986 5.986 0 1 1-8.477-8.454 6 6 0 0 1 4.13-1.768"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M46.314 69.308a6.555 6.555 0 0 1 6.036 4.047 6.57 6.57 0 0 1-1.397 7.136 6.556 6.556 0 0 1-11.219-4.534 6.55 6.55 0 0 1 4.04-6.154 6.5 6.5 0 0 1 2.54-.495"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M56.767 59.292a5.92 5.92 0 0 1 5.6 3.51 5.93 5.93 0 0 1-1.132 6.517 5.923 5.923 0 0 1-10.202-4.035 5.87 5.87 0 0 1 3.5-5.498 5.9 5.9 0 0 1 2.234-.494"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M110.274 6.882a4.86 4.86 0 0 1 4.579 3.05 4.9 4.9 0 0 1 .351 1.905 4.953 4.953 0 0 1-6.909 4.87 4.96 4.96 0 0 1-2.693-2.877 4.95 4.95 0 0 1-.278-1.993 4.86 4.86 0 0 1 1.424-3.53 4.86 4.86 0 0 1 3.526-1.425"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M78.263 37.65a6.17 6.17 0 0 1 5.727 3.812 6.19 6.19 0 0 1-1.345 6.751 6.177 6.177 0 0 1-10.54-4.422 6.12 6.12 0 0 1 3.8-5.685 6.1 6.1 0 0 1 2.358-.456"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M46.251 90.822a6.34 6.34 0 0 1 5.865 3.922 6.36 6.36 0 0 1-1.376 6.923 6.347 6.347 0 0 1-10.836-4.492c0-1.685.669-3.301 1.859-4.492a6.35 6.35 0 0 1 4.488-1.861"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M14.367 143.994a6.58 6.58 0 0 1 6.039 4.124 6.59 6.59 0 0 1-4.882 8.932 6.57 6.57 0 0 1-6.727-2.865 6.6 6.6 0 0 1-1.074-3.669 6.51 6.51 0 0 1 4.107-6.069 6.5 6.5 0 0 1 2.537-.453"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M35.63 101.749a6.1 6.1 0 0 1 4.305 1.837 6.124 6.124 0 0 1-.09 8.655 6.114 6.114 0 0 1-10.393-4.436 6.12 6.12 0 0 1 6.178-6.056"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M88.736 27.38a5.77 5.77 0 0 1 5.468 3.386 5.785 5.785 0 0 1-3.962 8.025 5.77 5.77 0 0 1-6.009-2.291 5.8 5.8 0 0 1-1.062-3.19 5.74 5.74 0 0 1 3.378-5.427 5.7 5.7 0 0 1 2.187-.503"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M14.155 123.221a6.013 6.013 0 0 1 6.064 7.062 6.01 6.01 0 0 1-8.122 4.544 6.02 6.02 0 0 1-3.802-5.508 5.98 5.98 0 0 1 1.664-4.267 5.952 5.952 0 0 1 4.196-1.831"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M57 80.255a6.34 6.34 0 0 1 5.875 3.952 6.36 6.36 0 0 1-1.434 6.938 6.346 6.346 0 0 1-10.789-4.664 6.16 6.16 0 0 1 3.918-5.807 6.2 6.2 0 0 1 2.43-.419"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M99.717 15.776a6.707 6.707 0 0 1 6.45 8.125 6.708 6.708 0 0 1-9.22 4.747 6.71 6.71 0 0 1-4.043-6.265 6.65 6.65 0 0 1 4.228-6.154 6.6 6.6 0 0 1 2.585-.453"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M24.882 112.612a5.943 5.943 0 0 1 5.55 3.609 5.953 5.953 0 0 1-4.26 8.167 5.94 5.94 0 0 1-6.132-2.496 5.96 5.96 0 0 1-1.019-3.309 5.87 5.87 0 0 1 3.594-5.515 5.9 5.9 0 0 1 2.267-.456"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M67.6 69.88a5.92 5.92 0 0 1 5.488 3.645 5.935 5.935 0 0 1-1.27 6.468 5.922 5.922 0 0 1-10.121-4.184 5.81 5.81 0 0 1 3.622-5.507 5.8 5.8 0 0 1 2.28-.423"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M67.536 49.403a5.1 5.1 0 0 1 4.751 3.096 5.11 5.11 0 0 1-1.045 5.577 5.098 5.098 0 0 1-8.742-3.528 5.063 5.063 0 0 1 5.036-5.145"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M78.242 59.165a6.005 6.005 0 0 1 5.572 3.663 6.018 6.018 0 0 1-4.291 8.235 6 6 0 0 1-6.191-2.478 6 6 0 0 1-1.057-3.322 5.96 5.96 0 0 1 3.65-5.638 5.9 5.9 0 0 1 2.317-.46"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M99.612 37.438a6.35 6.35 0 0 1 5.853 3.898 6.36 6.36 0 0 1-1.329 6.91 6.344 6.344 0 0 1-9.751-.849 6.356 6.356 0 0 1 2.773-9.465 6.3 6.3 0 0 1 2.454-.494"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M25.072 134.126a5.755 5.755 0 0 1 5.522 6.963 5.76 5.76 0 0 1-4.57 4.457 5.753 5.753 0 0 1-6.813-5.703 5.7 5.7 0 0 1 1.719-4.102 5.68 5.68 0 0 1 4.142-1.615"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M88.884 49.466a5.05 5.05 0 0 1 4.726 3.105 5.064 5.064 0 0 1-3.719 6.928 5.05 5.05 0 0 1-5.196-2.231 5.06 5.06 0 0 1-.804-2.847 4.98 4.98 0 0 1 3.088-4.584 5 5 0 0 1 1.905-.37"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M46.463 112.231a6.34 6.34 0 0 1 5.768 4.052 6.36 6.36 0 0 1-1.527 6.887 6.35 6.35 0 0 1-6.94 1.229 6.355 6.355 0 0 1 2.7-12.168"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M35.609 122.818a6.34 6.34 0 0 1 5.864 3.922 6.356 6.356 0 0 1-4.626 8.662 6.34 6.34 0 0 1-6.516-2.702 6.354 6.354 0 0 1 5.278-9.882"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M88.968 69.54a6.34 6.34 0 0 1 5.876 3.952 6.36 6.36 0 0 1-1.434 6.938 6.345 6.345 0 0 1-10.789-4.664 6.36 6.36 0 0 1 1.903-4.41 6.34 6.34 0 0 1 4.444-1.815"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M110.19 48.492a6.03 6.03 0 0 1 5.594 3.682 6.035 6.035 0 0 1-7.806 7.95 6.03 6.03 0 0 1-3.776-5.533 6 6 0 0 1 1.716-4.306 5.98 5.98 0 0 1 4.272-1.793"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M120.918 16.75a5.739 5.739 0 1 1-2.228 11.018 5.74 5.74 0 0 1-3.485-5.364 5.69 5.69 0 0 1 5.713-5.654"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M56.957 123.517a5.716 5.716 0 0 1 4.102 9.76 5.71 5.71 0 0 1-8.815-.906 5.72 5.72 0 0 1 4.713-8.854"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M14.112 187.743a5.526 5.526 0 0 1 5.636 6.422 5.53 5.53 0 0 1-4.196 4.484 5.52 5.52 0 0 1-5.744-2.169 5.527 5.527 0 0 1 4.304-8.737"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M78.072 80.086a6.34 6.34 0 0 1 5.918 3.806 6.36 6.36 0 0 1-1.224 6.933 6.346 6.346 0 0 1-10.935-4.196 6.36 6.36 0 0 1 3.8-6.011c.77-.338 1.6-.518 2.441-.532"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M46.082 133.406a6.6 6.6 0 0 1 6.262 3.87 6.61 6.61 0 0 1-4.549 9.175 6.6 6.6 0 0 1-8.06-6.311 6.566 6.566 0 0 1 6.347-6.734"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M110.106 27.338a5.83 5.83 0 0 1 5.509 3.478 5.846 5.846 0 0 1-4.112 8.077 5.835 5.835 0 0 1-6.05-2.416 5.85 5.85 0 0 1-1.018-3.252 5.74 5.74 0 0 1 3.461-5.418 5.7 5.7 0 0 1 2.21-.47"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M67.62 113.416a5.143 5.143 0 0 1 5.044 6.142 5.144 5.144 0 0 1-6.996 3.764 5.146 5.146 0 0 1-3.188-4.739 5.13 5.13 0 0 1 3.165-4.779 5.1 5.1 0 0 1 1.975-.388"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M14.282 165.445a6.47 6.47 0 0 1 5.985 3.961 6.49 6.49 0 0 1-1.343 7.055A6.472 6.472 0 0 1 7.83 172.03a6.36 6.36 0 0 1 3.936-6.112 6.35 6.35 0 0 1 2.517-.473"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M24.755 155.386a5.84 5.84 0 0 1 5.535 3.439 5.85 5.85 0 0 1-1.09 6.427 5.83 5.83 0 0 1-6.358 1.419 5.84 5.84 0 0 1-3.715-5.356 5.78 5.78 0 0 1 5.628-5.929"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M56.894 101.918a5.94 5.94 0 0 1 5.524 3.601 5.953 5.953 0 0 1-4.201 8.164 5.94 5.94 0 0 1-6.137-2.411 5.95 5.95 0 0 1-1.068-3.277 5.87 5.87 0 0 1 5.882-6.077"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M35.587 144.163a6.34 6.34 0 0 1 5.864 3.922 6.357 6.357 0 0 1-4.626 8.662 6.34 6.34 0 0 1-6.515-2.702 6.354 6.354 0 0 1 5.277-9.882"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M67.451 91.394a5.8 5.8 0 0 1 5.454 3.435 5.807 5.807 0 0 1-5.137 8.169 5.8 5.8 0 0 1-5.956-5.643 5.8 5.8 0 0 1 1.586-4.15 5.8 5.8 0 0 1 4.053-1.811"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M99.188 58.826a6.34 6.34 0 0 1 6.08 3.538 6.355 6.355 0 0 1-4.027 8.932 6.34 6.34 0 0 1-6.674-2.222 6.355 6.355 0 0 1 4.62-10.248"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M120.874 39.217a4.63 4.63 0 0 1 4.322 2.809 4.64 4.64 0 0 1-3.305 6.366 4.63 4.63 0 0 1-4.781-1.924 4.64 4.64 0 0 1-.806-2.571 4.63 4.63 0 0 1 1.314-3.29 4.6 4.6 0 0 1 3.256-1.39"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M131.707 6.353a5.506 5.506 0 0 1-.148 11.011 5.4 5.4 0 0 1-3.845-1.603 5.43 5.43 0 0 1-1.571-3.86 5.47 5.47 0 0 1 1.605-3.957 5.47 5.47 0 0 1 3.959-1.591"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M35.546 165.572a6.34 6.34 0 0 1 5.875 3.952 6.355 6.355 0 0 1-4.717 8.646 6.347 6.347 0 0 1-7.506-6.373 6.36 6.36 0 0 1 1.904-4.41 6.34 6.34 0 0 1 4.443-1.815"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M25.03 176.287a6.351 6.351 0 0 1 6.214 7.639 6.35 6.35 0 0 1-5.055 4.959 6.34 6.34 0 0 1-6.499-2.809 6.36 6.36 0 0 1 .896-7.974 6.34 6.34 0 0 1 4.444-1.815"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M131.538 28.439a4.72 4.72 0 0 1 4.398 2.856 4.725 4.725 0 0 1-3.352 6.484 4.71 4.71 0 0 1-4.87-1.942 4.73 4.73 0 0 1-.831-2.613 4.747 4.747 0 0 1 4.655-4.785"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M153.056 5.76a6.07 6.07 0 0 1 4.038 1.958 6.083 6.083 0 0 1-.131 8.345 6.07 6.07 0 0 1-4.098 1.83 6.06 6.06 0 0 1-4.498-1.702 6.08 6.08 0 0 1 2.213-10.104 6.1 6.1 0 0 1 2.433-.327z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M45.997 156.699a4.61 4.61 0 0 1 4.48 2.508 4.62 4.62 0 0 1-2.874 6.541 4.61 4.61 0 0 1-4.875-1.609 4.62 4.62 0 0 1-.962-2.506 4.66 4.66 0 0 1 1.113-3.328 4.65 4.65 0 0 1 3.118-1.606"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M99.485 81.039a5.5 5.5 0 0 1 5.178 3.324 5.51 5.51 0 0 1-3.97 7.578 5.5 5.5 0 0 1-5.677-2.371 5.5 5.5 0 0 1-.905-3.089 5.55 5.55 0 0 1 1.6-3.797 5.54 5.54 0 0 1 3.774-1.645"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M78.115 102.892a5 5 0 0 1 4.72 2.941 5 5 0 0 1-.925 5.488 4.99 4.99 0 0 1-5.423 1.229 5 5 0 0 1-3.196-4.555 5.02 5.02 0 0 1 4.824-5.103"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M88.948 92.495a4.715 4.715 0 0 1 4.357 2.91 4.73 4.73 0 0 1-1.013 5.144 4.72 4.72 0 0 1-5.135 1.037 4.716 4.716 0 0 1-1.547-7.694 4.74 4.74 0 0 1 3.338-1.397"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M142.18 17.576a4.93 4.93 0 0 1 4.621 3.001 4.937 4.937 0 0 1-3.582 6.772 4.93 4.93 0 0 1-5.078-2.136 4.94 4.94 0 0 1-.806-2.767 4.96 4.96 0 0 1 1.442-3.412 4.95 4.95 0 0 1 3.403-1.458"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M25.072 198.182a5.73 5.73 0 0 1 5.204 3.624 5.74 5.74 0 0 1-1.314 6.208 5.732 5.732 0 0 1-9.75-4.072 5.867 5.867 0 0 1 5.86-5.76"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M99.526 101.96a5.92 5.92 0 0 1 5.478 3.622 5.94 5.94 0 0 1-1.224 6.455 5.92 5.92 0 0 1-6.422 1.362 5.92 5.92 0 0 1-3.735-5.404 6.06 6.06 0 0 1 5.903-6.035"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M88.947 113.903a4.65 4.65 0 0 1 4.306 2.891 4.66 4.66 0 0 1-3.437 6.345 4.66 4.66 0 0 1-4.77-2.035 4.67 4.67 0 0 1-.754-2.606 4.745 4.745 0 0 1 4.655-4.595"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M35.545 188.103a5.14 5.14 0 0 1 5.142 5.145 5.14 5.14 0 1 1-10.283 0c0-1.364.542-2.673 1.506-3.638a5.14 5.14 0 0 1 3.635-1.507"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M46.23 176.52a6.065 6.065 0 0 1 5.658 3.712 6.08 6.08 0 0 1-4.399 8.323 6.06 6.06 0 0 1-6.25-2.591 6.1 6.1 0 0 1-1.017-3.388 6.184 6.184 0 0 1 6.008-6.056"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M56.724 144.523a6.05 6.05 0 0 1 5.75 3.563 6.06 6.06 0 0 1-1.14 6.671 6.05 6.05 0 0 1-6.607 1.448 6.05 6.05 0 0 1-3.821-5.583 6.123 6.123 0 0 1 5.818-6.099"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M78.22 124.534a4.7 4.7 0 0 1 4.685 5.532 4.7 4.7 0 0 1-3.606 3.758 4.699 4.699 0 0 1-5.712-4.462 4.786 4.786 0 0 1 4.634-4.828"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M152.866 28.227a4.95 4.95 0 0 1 4.657 2.955 4.95 4.95 0 0 1-.963 5.434 4.947 4.947 0 0 1-7.643-.622 4.95 4.95 0 0 1-.875-2.748 5.04 5.04 0 0 1 4.824-5.019"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M131.517 49.403a5.12 5.12 0 0 1 4.794 3.114 5.122 5.122 0 0 1-6.678 6.74 5.133 5.133 0 0 1-3.152-4.772 5.22 5.22 0 0 1 1.508-3.544 5.2 5.2 0 0 1 3.528-1.538"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M120.917 60.202a4.99 4.99 0 0 1 4.638 3.096 5 5 0 0 1-3.701 6.814 4.99 4.99 0 0 1-5.118-2.211 5 5 0 0 1-.791-2.807 5.057 5.057 0 0 1 4.972-4.892"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M142.159 39.217a4.63 4.63 0 0 1 4.346 2.728 4.64 4.64 0 0 1-.831 5.066 4.63 4.63 0 0 1-7.129-.416 4.64 4.64 0 0 1-.892-2.529 4.746 4.746 0 0 1 4.506-4.849"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M67.6 133.724a6.174 6.174 0 0 1 5.736 3.838 6.186 6.186 0 0 1-4.596 8.425 6.17 6.17 0 0 1-6.328-2.751 6.2 6.2 0 0 1-.97-3.477 6.347 6.347 0 0 1 6.157-6.035"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M110.105 69.71a6.13 6.13 0 0 1 4.37 1.724 6.147 6.147 0 0 1 .149 8.684 6.12 6.12 0 0 1-4.307 1.874 6.136 6.136 0 0 1-6.242-6.035 6.145 6.145 0 0 1 6.03-6.247"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M14.388 209.469a5.123 5.123 0 0 1 3.477 8.784 5.13 5.13 0 0 1-2.622 1.373 5.13 5.13 0 0 1-5.225-2.197 5.13 5.13 0 0 1-.856-2.836 5.23 5.23 0 0 1 5.226-5.124"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M.826 54.633q.111-1.566 0-3.134c-.254-1.588.677-2.118 1.904-2.372A5.73 5.73 0 0 1 8.252 50.8a5.59 5.59 0 0 1 .53 6.353 5.53 5.53 0 0 1-5.417 2.774c-1.672-.19-2.878-.763-2.54-2.816.071-.825.071-1.654 0-2.478"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M.995 75.83v-3.388a1.29 1.29 0 0 1 .952-1.398 5.22 5.22 0 0 1 5.86 1.207 5.15 5.15 0 0 1 .741 6.226 5.31 5.31 0 0 1-5.416 2.562c-1.418-.275-2.455-.805-2.116-2.605a15.3 15.3 0 0 0-.021-2.604"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aG)",
    d: "M2.243 91.055a5.96 5.96 0 0 1 6.347 2.117 5.87 5.87 0 0 1 .762 6.861 6.11 6.11 0 0 1-5.776 3.516c-2.73 0-3.534-.911-3.555-3.706v-2.435q.111-1.727 0-3.452c-.211-1.864.677-2.541 2.222-2.901"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aH)",
    d: "M14.282 230.814a5.115 5.115 0 0 1 4.745 3.148 5.13 5.13 0 0 1-1.096 5.592 5.12 5.12 0 0 1-5.583 1.121 5.12 5.12 0 0 1-3.166-4.737 5.21 5.21 0 0 1 5.1-5.124"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M67.684 156.509a4.745 4.745 0 0 1 .785 9.409 4.74 4.74 0 0 1-4.834-2.1 4.74 4.74 0 0 1-.754-2.651 4.83 4.83 0 0 1 4.803-4.658"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M142.286 60.372a4.82 4.82 0 0 1 4.455 2.975 4.825 4.825 0 0 1-1.036 5.259 4.823 4.823 0 0 1-8.243-3.385 4.893 4.893 0 0 1 4.824-4.85"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M88.926 134.613a5.393 5.393 0 0 1 5.29 5.125 5.28 5.28 0 0 1-3.143 4.973 5.26 5.26 0 0 1-5.788-1.037 5.275 5.275 0 0 1 3.641-9.061"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M56.957 166.779a5.126 5.126 0 0 1 0 10.249 5.12 5.12 0 0 1-5.12-5.125 5.126 5.126 0 0 1 5.12-5.124"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M174.234 5.696a6.355 6.355 0 0 1 6.136 6.12 6.14 6.14 0 0 1-6.125 5.78 6.142 6.142 0 0 1-6.125-5.78 6.354 6.354 0 0 1 6.114-6.12"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M120.874 81.018a5.52 5.52 0 0 1 5.143 3.358 5.53 5.53 0 0 1-1.137 6.039 5.521 5.521 0 0 1-9.464-3.828 5.63 5.63 0 0 1 5.458-5.57"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M35.693 209.998a4.61 4.61 0 0 1 4.22 2.903 4.62 4.62 0 0 1-1.06 5.014 4.61 4.61 0 0 1-5.032.946 4.61 4.61 0 0 1-2.803-4.289 4.68 4.68 0 0 1 4.675-4.574"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M78.22 145.201a5.354 5.354 0 0 1 5.325 6.34 5.36 5.36 0 0 1-4.155 4.259 5.356 5.356 0 0 1-6.459-5.178 5.48 5.48 0 0 1 5.29-5.421"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M25.051 220.226a5.12 5.12 0 0 1 4.68 3.247 5.13 5.13 0 0 1-1.213 5.567 5.118 5.118 0 0 1-8.671-3.795 5.23 5.23 0 0 1 5.204-5.019"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M163.444 16.538a6.07 6.07 0 0 1 6.009 5.908 5.973 5.973 0 0 1-5.906 5.673 5.96 5.96 0 0 1-4.107-1.59 5.98 5.98 0 0 1-1.899-3.977 6.08 6.08 0 0 1 5.903-6.014"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M131.707 70.642a5.227 5.227 0 0 1 5.073 6.3 5.226 5.226 0 0 1-10.341-1.133 5.33 5.33 0 0 1 5.268-5.167"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M110.275 92.05c1.363 0 2.671.542 3.635 1.507a5.15 5.15 0 0 1 0 7.277 5.14 5.14 0 0 1-8.777-3.638c0-1.365.542-2.674 1.506-3.639a5.14 5.14 0 0 1 3.636-1.507"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M1.883 112.633a6.169 6.169 0 0 1 6.501 1.794 6.19 6.19 0 0 1 .989 6.676 5.99 5.99 0 0 1-5.628 3.6c-2.73 0-3.64-.889-3.64-3.558v-2.456a30 30 0 0 0 0-3.642c-.19-1.482.55-2.097 1.778-2.414"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M14.345 251.756a5.52 5.52 0 0 1 5.084 3.477 5.53 5.53 0 0 1-1.292 6.025 5.52 5.52 0 0 1-8.501-1.018 5.53 5.53 0 0 1-.855-3.105 5.59 5.59 0 0 1 5.564-5.379"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M163.444 39.069a4.76 4.76 0 0 1 4.473 2.867 4.77 4.77 0 0 1-.963 5.227 4.76 4.76 0 0 1-8.164-3.33 4.826 4.826 0 0 1 4.654-4.764"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M152.865 49.381a5.14 5.14 0 0 1 4.778 3.198 5.146 5.146 0 0 1-3.84 7.01 5.14 5.14 0 0 1-5.263-2.31 5.14 5.14 0 0 1-.795-2.9 5.224 5.224 0 0 1 5.12-4.997"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aY)",
    d: "M174.34 27.698a5.48 5.48 0 0 1 5.002 3.443 5.491 5.491 0 0 1-1.241 5.948 5.48 5.48 0 0 1-5.962 1.151 5.48 5.48 0 0 1-3.363-5.058 5.51 5.51 0 0 1 1.647-3.896 5.52 5.52 0 0 1 3.917-1.588"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aZ)",
    d: "M46.272 199.05a4.826 4.826 0 0 1 4.76 5.734 4.826 4.826 0 0 1-6.536 3.575 4.82 4.82 0 0 1-3.026-4.417 4.85 4.85 0 0 1 4.802-4.892"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ba)",
    d: "M110.274 114.052a4.486 4.486 0 0 1 4.486 4.489c0 1.19-.473 2.332-1.314 3.174a4.483 4.483 0 0 1-7.657-3.174 4.49 4.49 0 0 1 4.485-4.489"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bb)",
    d: "M67.684 177.981a4.61 4.61 0 0 1 4.453 5.555 4.62 4.62 0 0 1-3.64 3.593 4.61 4.61 0 0 1-5.49-4.532 4.614 4.614 0 0 1 4.677-4.616"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bc)",
    d: "M56.894 188.463a4.893 4.893 0 0 1 1.014 9.689 4.88 4.88 0 0 1-5.03-2.105 4.9 4.9 0 0 1-.808-2.735 4.92 4.92 0 0 1 1.43-3.404 4.9 4.9 0 0 1 3.394-1.445"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bd)",
    d: "M120.558 102.172a5.71 5.71 0 0 1 5.498 3.22 5.717 5.717 0 0 1-7.077 7.867 5.72 5.72 0 0 1 1.579-11.087"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#be)",
    d: "M99.442 123.136a6.09 6.09 0 0 1 5.751 3.65 6.1 6.1 0 0 1-4.342 8.417 6.08 6.08 0 0 1-6.303-2.579 6.1 6.1 0 0 1-1.03-3.411 6.177 6.177 0 0 1 5.924-6.077"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bf)",
    d: "M35.63 230.983a4.973 4.973 0 0 1 4.871 5.971 4.98 4.98 0 0 1-3.94 3.894 4.97 4.97 0 0 1-5.096-2.17 5 5 0 0 1-.807-2.782 4.94 4.94 0 0 1 1.466-3.49 4.93 4.93 0 0 1 3.506-1.423"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bg)",
    d: "M110.274 135.524a4.42 4.42 0 0 1 4.088 2.737 4.43 4.43 0 0 1-.968 4.825 4.43 4.43 0 0 1-2.27 1.207 4.425 4.425 0 0 1-5.272-4.365 4.236 4.236 0 0 1 4.422-4.404"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bh)",
    d: "M99.357 144.523a6.057 6.057 0 0 1 1.72 11.939 6.047 6.047 0 0 1-6.325-2.366 6.06 6.06 0 0 1-1.129-3.347 5.98 5.98 0 0 1 3.462-5.681 6 6 0 0 1 2.272-.545"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi)",
    d: "M195.498 5.633a6.2 6.2 0 0 1 5.786 3.766 6.215 6.215 0 0 1-1.28 6.787 6.197 6.197 0 0 1-10.62-4.328 6.15 6.15 0 0 1 1.759-4.39 6.15 6.15 0 0 1 4.355-1.835"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bj)",
    d: "M131.539 92.029a5.16 5.16 0 0 1 4.812 3.14 5.171 5.171 0 0 1-3.705 7.087 5.16 5.16 0 0 1-5.321-2.168 5.168 5.168 0 0 1 4.214-8.059"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bk)",
    d: "M88.906 155.048a6.17 6.17 0 0 1 5.74 3.792 6.19 6.19 0 0 1-1.322 6.755 6.2 6.2 0 0 1-3.168 1.7 6.18 6.18 0 0 1-7.386-6.085c0-1.631.646-3.195 1.796-4.35a6.15 6.15 0 0 1 4.34-1.812"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bl)",
    d: "M67.663 197.78a6.15 6.15 0 0 1 5.664 3.848 6.165 6.165 0 0 1-4.56 8.368 6.159 6.159 0 0 1-7.303-6.118 6.02 6.02 0 0 1 3.821-5.689 6 6 0 0 1 2.378-.409"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bm)",
    d: "M120.875 123.708a5.5 5.5 0 0 1 5.121 3.34 5.508 5.508 0 0 1-3.922 7.552 5.5 5.5 0 0 1-5.674-2.275 5.5 5.5 0 0 1-.962-3.048 5.44 5.44 0 0 1 5.437-5.569"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bn)",
    d: "M142.075 81.844a4.695 4.695 0 0 1 4.459 2.738 4.71 4.71 0 0 1-.838 5.168 4.7 4.7 0 0 1-5.095 1.187 4.7 4.7 0 0 1-3.032-4.265 4.67 4.67 0 0 1 1.25-3.352 4.66 4.66 0 0 1 3.256-1.476"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bo)",
    d: "M46.209 219.358a5.926 5.926 0 0 1 5.905 7.033 5.928 5.928 0 0 1-8.068 4.381 5.93 5.93 0 0 1-3.677-5.485 5.85 5.85 0 0 1 1.68-4.188 5.85 5.85 0 0 1 4.16-1.741"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bp)",
    d: "M152.675 70.494a5.37 5.37 0 0 1 5.122 3.101 5.38 5.38 0 0 1-3.624 7.503 5.37 5.37 0 0 1-5.61-2.092 5.4 5.4 0 0 1-1.009-2.965 5.279 5.279 0 0 1 3.085-5.079c.64-.29 1.333-.45 2.036-.469"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "M78.157 167.033a4.89 4.89 0 0 1 4.598 2.916 4.893 4.893 0 0 1-3.432 6.753 4.888 4.888 0 0 1-5.927-4.714 4.867 4.867 0 0 1 4.76-4.955"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M174.192 49.043a5.47 5.47 0 0 1 5.104 3.331 5.491 5.491 0 0 1-1.128 5.993 5.48 5.48 0 0 1-9.392-3.798 5.404 5.404 0 0 1 3.315-5.11 5.4 5.4 0 0 1 2.101-.416"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bs)",
    d: "M56.957 209.744a4.846 4.846 0 0 1 4.728 5.808 4.849 4.849 0 0 1-6.608 3.519 4.854 4.854 0 0 1-2.986-4.478 4.766 4.766 0 0 1 4.866-4.849"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bt)",
    d: "M14.367 273.525a5.123 5.123 0 0 1 3.503 8.8 5.12 5.12 0 0 1-5.6 1.027 5.12 5.12 0 0 1-3.087-4.787 5.017 5.017 0 0 1 5.184-5.04"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bu)",
    d: "M184.835 16.602a5.9 5.9 0 0 1 5.513 3.587 5.91 5.91 0 0 1-1.225 6.467 5.9 5.9 0 0 1-9.106-.855 5.9 5.9 0 0 1-1.001-3.291 5.865 5.865 0 0 1 5.819-5.908"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bv)",
    d: "M24.882 242.058a4.57 4.57 0 0 1 4.633 4.447 4.553 4.553 0 0 1-5.339 4.588 4.55 4.55 0 0 1-3.65-3.504 4.555 4.555 0 0 1 4.356-5.531"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bw)",
    d: "M163.444 59.948a5.24 5.24 0 0 1 4.876 3.208 5.26 5.26 0 0 1-1.101 5.734 5.247 5.247 0 0 1-8.98-3.67 5.146 5.146 0 0 1 5.205-5.272"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bx)",
    d: "M2.264 134.973a5.225 5.225 0 0 1 5.586 1.525 5.168 5.168 0 0 1-4.126 8.47c-2.285 0-2.856-.678-2.856-2.965v-2.117a25 25 0 0 0 0-3.071c-.148-1.08.465-1.524 1.396-1.842"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#by)",
    d: "M1.397 155.662a5.94 5.94 0 0 1 6.2.91 5.76 5.76 0 0 1 2.115 6.141 5.65 5.65 0 0 1-4.422 4.426c-3.427.826-5.099-.487-5.099-3.96v-5.463a1.76 1.76 0 0 1 1.206-2.054"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bz)",
    d: "M195.498 50.123c1.162 0 2.276.461 3.097 1.283a4.387 4.387 0 0 1 0 6.2 4.377 4.377 0 0 1-7.476-3.1 4.38 4.38 0 0 1 4.379-4.383"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bA)",
    d: "M35.61 252.349a4.95 4.95 0 0 1 4.584 3.035 4.96 4.96 0 0 1-1.04 5.402 4.95 4.95 0 0 1-7.618-.696 4.96 4.96 0 0 1-.857-2.743 4.84 4.84 0 0 1 1.389-3.563 4.813 4.813 0 0 1 3.541-1.435"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bB)",
    d: "M152.866 113.649a4.913 4.913 0 1 1-1.786 9.464 4.91 4.91 0 0 1-3.059-4.53 4.821 4.821 0 0 1 4.845-4.934"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bC)",
    d: "M131.412 112.823a5.73 5.73 0 0 1 5.429 3.403 5.742 5.742 0 0 1-4.035 7.944 5.735 5.735 0 0 1-6.938-5.587 5.63 5.63 0 0 1 1.567-4.041 5.6 5.6 0 0 1 3.977-1.719"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bD)",
    d: "M206.077 38.836a5.01 5.01 0 0 1 4.74 2.955 5.022 5.022 0 0 1-3.465 6.956 5.01 5.01 0 0 1-5.21-2.011 5 5 0 0 1-.91-2.775 4.95 4.95 0 0 1 1.352-3.577 4.96 4.96 0 0 1 3.493-1.548"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bE)",
    d: "M46.146 242.164a4.469 4.469 0 1 1-1.417 8.613 4.46 4.46 0 0 1-2.815-4.145 4.357 4.357 0 0 1 4.231-4.468"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bF)",
    d: "M184.856 37.798a6.05 6.05 0 0 1 5.647 3.725 6.07 6.07 0 0 1-1.328 6.636 6.05 6.05 0 0 1-6.645 1.26 6.05 6.05 0 0 1-3.661-5.691 5.93 5.93 0 0 1 5.987-5.93"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bG)",
    d: "M142.286 124.449a4.78 4.78 0 0 1 4.383 3.028 4.79 4.79 0 0 1-1.135 5.208 4.78 4.78 0 0 1-7.353-.892 4.8 4.8 0 0 1-.74-2.686 4.72 4.72 0 0 1 1.449-3.343 4.72 4.72 0 0 1 3.396-1.315"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bH)",
    d: "M142.287 102.723a5.16 5.16 0 0 1 4.743 3.18c.39.939.496 1.971.303 2.969a5.18 5.18 0 0 1-1.389 2.641 5.158 5.158 0 0 1-7.922-.679 5.17 5.17 0 0 1-.919-2.839 5.03 5.03 0 0 1 1.441-3.77 5 5 0 0 1 1.714-1.142 5 5 0 0 1 2.029-.36"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bI)",
    d: "M174.024 70.896a4.97 4.97 0 0 1 4.693 2.957 4.978 4.978 0 0 1-3.494 6.88 4.97 4.97 0 0 1-5.153-2.05 4.97 4.97 0 0 1-.87-2.769 4.89 4.89 0 0 1 2.943-4.616 4.9 4.9 0 0 1 1.881-.402"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bJ)",
    d: "M78.285 187.234a6.01 6.01 0 0 1 5.545 3.698 6.02 6.02 0 0 1-1.275 6.546 6.004 6.004 0 0 1-9.236-.843 6 6 0 0 1-1.043-3.323 5.94 5.94 0 0 1 1.711-4.32 5.93 5.93 0 0 1 4.297-1.758"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bK)",
    d: "M99.526 188.907a4.362 4.362 0 0 1 4.418 5.125 4.358 4.358 0 0 1-8.65-.741 4.24 4.24 0 0 1 2.578-4.048 4.2 4.2 0 0 1 1.654-.336"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bL)",
    d: "M67.536 220.84a4.442 4.442 0 0 1 4.46 5.208 4.45 4.45 0 0 1-3.39 3.574 4.437 4.437 0 0 1-4.602-1.75 4.45 4.45 0 0 1-.826-2.437 4.37 4.37 0 0 1 2.635-4.242 4.35 4.35 0 0 1 1.723-.353"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bM)",
    d: "M89.032 177.748a4.84 4.84 0 0 1 4.421 3.066 4.853 4.853 0 0 1-3.63 6.552 4.843 4.843 0 0 1-5.72-4.833 4.75 4.75 0 0 1 3.047-4.477 4.7 4.7 0 0 1 1.882-.308"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bN)",
    d: "M184.751 60.54a4.65 4.65 0 0 1 4.412 2.742 4.663 4.663 0 0 1-3.233 6.462 4.65 4.65 0 0 1-4.836-1.894 4.66 4.66 0 0 1-.829-2.587 4.58 4.58 0 0 1 1.256-3.3 4.57 4.57 0 0 1 3.23-1.422"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bO)",
    d: "M14.26 295.505a4.48 4.48 0 0 1 4.197 2.747 4.492 4.492 0 0 1-3.287 6.15 4.48 4.48 0 0 1-4.613-1.969 4.5 4.5 0 0 1-.719-2.523 4.41 4.41 0 0 1 2.732-4.076 4.4 4.4 0 0 1 1.69-.329"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bP)",
    d: "M99.464 167.287a4.56 4.56 0 0 1 2.578.698 4.58 4.58 0 0 1 2.069 4.674 4.572 4.572 0 0 1-6.212 3.44 4.57 4.57 0 0 1-2.858-4.238 4.49 4.49 0 0 1 4.422-4.574"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bQ)",
    d: "M206.205 17.745a4.74 4.74 0 0 1 4.824 4.659 4.75 4.75 0 0 1-1.329 3.379 4.738 4.738 0 0 1-8.15-3.21 4.75 4.75 0 0 1 2.847-4.434 4.7 4.7 0 0 1 1.808-.394"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bR)",
    d: "M24.797 284.854a4.46 4.46 0 0 1 4.282 2.581 4.47 4.47 0 0 1-3.063 6.238 4.46 4.46 0 0 1-4.658-1.816 4.47 4.47 0 0 1-.792-2.493 4.39 4.39 0 0 1 1.185-3.13 4.38 4.38 0 0 1 3.046-1.38"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bS)",
    d: "M35.503 273.758a4.89 4.89 0 0 1 4.6 2.92 4.9 4.9 0 0 1-.957 5.368 4.89 4.89 0 0 1-5.326 1.145 4.892 4.892 0 0 1-3.077-4.499 4.86 4.86 0 0 1 1.359-3.454 4.85 4.85 0 0 1 3.401-1.48"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bT)",
    d: "M25.009 263.382a4.58 4.58 0 0 1 4.213 2.87 4.6 4.6 0 0 1-1.032 4.996 4.58 4.58 0 0 1-5.005.964 4.59 4.59 0 0 1-2.81-4.256 4.51 4.51 0 0 1 2.855-4.262 4.5 4.5 0 0 1 1.779-.312"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bU)",
    d: "M195.519 27.338a5.84 5.84 0 0 1 5.804 6.914 5.84 5.84 0 0 1-7.902 4.36 5.84 5.84 0 0 1-3.678-5.345 5.72 5.72 0 0 1 5.776-5.93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bV)",
    d: "M57 230.306a5.62 5.62 0 0 1 5.163 3.491 5.64 5.64 0 0 1-1.22 6.117 5.626 5.626 0 0 1-9.614-3.912 5.55 5.55 0 0 1 3.475-5.298 5.5 5.5 0 0 1 2.196-.398"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bW)",
    d: "M110.232 155.619a5.61 5.61 0 0 1 3.999 9.587 5.605 5.605 0 0 1-9.563-4.039 5.55 5.55 0 0 1 3.436-5.132 5.55 5.55 0 0 1 2.128-.416"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bX)",
    d: "M46.209 262.111a5.86 5.86 0 0 1 5.474 3.562 5.868 5.868 0 0 1-4.215 8.05 5.86 5.86 0 0 1-7.035-5.746 5.77 5.77 0 0 1 1.655-4.149 5.75 5.75 0 0 1 4.12-1.717"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bY)",
    d: "M78.115 209.278a5.332 5.332 0 0 1 5.42 6.262 5.34 5.34 0 0 1-4.134 4.29 5.332 5.332 0 0 1-6.448-5.194 5.26 5.26 0 0 1 3.156-4.924 5.3 5.3 0 0 1 2.006-.434"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bZ)",
    d: "M88.884 197.907a6.025 6.025 0 0 1 5.618 3.686 6.04 6.04 0 0 1-1.275 6.601 6.04 6.04 0 0 1-3.093 1.665 6.032 6.032 0 0 1-7.216-5.938 5.93 5.93 0 0 1 3.666-5.567 5.9 5.9 0 0 1 2.3-.447"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ca)",
    d: "M120.833 144.629a5.94 5.94 0 0 1 3.333.953 5.952 5.952 0 0 1-2.041 10.827 5.944 5.944 0 0 1-7.132-5.851 5.8 5.8 0 0 1 .414-2.266 5.816 5.816 0 0 1 5.426-3.663"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cb)",
    d: "M152.865 91.309a5.9 5.9 0 0 1 5.538 3.598 5.915 5.915 0 0 1-1.259 6.487 5.904 5.904 0 0 1-10.076-4.283 5.773 5.773 0 0 1 5.797-5.802"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cc)",
    d: "M216.762 6.353a5.4 5.4 0 0 1 4.012 1.532c.53.515.948 1.134 1.229 1.817.282.684.421 1.417.408 2.156a5.52 5.52 0 0 1-3.319 5.415 5.52 5.52 0 0 1-7.387-3.197 5.5 5.5 0 0 1-.317-2.218 5.42 5.42 0 0 1 5.374-5.505"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cd)",
    d: "M163.444 81.23a5.31 5.31 0 0 1 4.978 3.118 5.32 5.32 0 0 1-3.58 7.359 5.31 5.31 0 0 1-6.561-4.887 5.22 5.22 0 0 1 1.369-3.917 5.2 5.2 0 0 1 3.794-1.674"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ce)",
    d: "M131.581 134.973a4.935 4.935 0 0 1 .896 9.789 4.93 4.93 0 0 1-5.805-5.003 4.83 4.83 0 0 1 3.046-4.447 4.8 4.8 0 0 1 1.863-.339"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cf)",
    d: "M3.174 198.457a5.508 5.508 0 0 1 2.682 10.585c-.705.28-1.46.41-2.217.384-2.497 0-3.195-.783-3.195-3.239v-2.118c.074-.845.074-1.696 0-2.541-.402-2.245.974-2.838 2.73-3.071"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg)",
    d: "M2.645 176.477a5.92 5.92 0 0 1 6.157 2.541 6.21 6.21 0 0 1-2.195 9.049 6.2 6.2 0 0 1-3.39.692c-2.117-.148-2.963-.656-3.174-2.308v-8.343c.317-.996 1.29-1.461 2.602-1.631"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ch)",
    d: "M227.616 16.94a5.48 5.48 0 0 1 5.038 3.43 5.487 5.487 0 0 1-4.067 7.444 5.48 5.48 0 0 1-5.604-2.393 5.5 5.5 0 0 1-.89-3.06 5.47 5.47 0 0 1 1.637-3.858 5.46 5.46 0 0 1 3.886-1.563"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ci)",
    d: "M56.894 251.672a5.62 5.62 0 0 1 5.24 3.423 5.636 5.636 0 0 1-4.03 7.723 5.63 5.63 0 0 1-6.775-5.471 5.57 5.57 0 0 1 5.565-5.675"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cj)",
    d: "M110.339 177.494a5.076 5.076 0 0 1 4.903 6.135 5.085 5.085 0 0 1-4.039 3.943 5.07 5.07 0 0 1-5.185-2.226 5.1 5.1 0 0 1-.821-2.834 5.035 5.035 0 0 1 5.142-5.018"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ck)",
    d: "M67.494 240.978a5.65 5.65 0 0 1 5.297 3.377 5.66 5.66 0 0 1-1.096 6.19 5.647 5.647 0 0 1-9.724-3.807 5.634 5.634 0 0 1 5.523-5.76"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cl)",
    d: "M121.023 165.953a5.96 5.96 0 0 1 5.461 3.77 5.98 5.98 0 0 1-1.395 6.49 5.96 5.96 0 0 1-9.169-1.058 5.97 5.97 0 0 1 .867-7.521 5.96 5.96 0 0 1 4.236-1.681"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cm)",
    d: "M216.825 27.21a5.96 5.96 0 0 1 5.566 3.613 5.981 5.981 0 0 1-1.21 6.528 5.97 5.97 0 0 1-6.491 1.374 5.97 5.97 0 0 1-3.747-5.48 5.93 5.93 0 0 1 5.882-6.034"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cn)",
    d: "M174.214 91.52a5.69 5.69 0 0 1 5.286 3.483 5.7 5.7 0 0 1-1.197 6.219 5.69 5.69 0 0 1-9.739-3.984 5.7 5.7 0 0 1 1.639-4.033 5.67 5.67 0 0 1 4.011-1.684"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#co)",
    d: "M163.571 102.447a5.42 5.42 0 0 1 5.416 5.421 5.417 5.417 0 0 1-9.246 3.834 5.424 5.424 0 0 1 3.83-9.255"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cp)",
    d: "M14.261 317.379a3.958 3.958 0 0 1 3.93 4.699 3.956 3.956 0 0 1-7.844-.718 3.96 3.96 0 0 1 3.914-3.981"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cq)",
    d: "M184.983 81.632a4.908 4.908 0 0 1 4.735 5.94 4.91 4.91 0 0 1-3.917 3.805 4.906 4.906 0 0 1-5.79-4.917 4.913 4.913 0 0 1 4.972-4.828"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cr)",
    d: "M238.322 6.543a5.293 5.293 0 0 1 3.586 9.103 5.287 5.287 0 0 1-8.96-3.915 5.294 5.294 0 0 1 5.374-5.188"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cs)",
    d: "M1.778 219.125a6.51 6.51 0 0 1 6.77 1.948 6.35 6.35 0 0 1 .783 7.221 6.52 6.52 0 0 1-6.157 3.43c-1.735-.148-2.687-.529-3.152-1.503v-9.995a3.05 3.05 0 0 1 1.756-1.101"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ct)",
    d: "M99.718 210.083a4.53 4.53 0 0 1 4.114 2.89c.323.834.393 1.746.2 2.62a4.53 4.53 0 0 1-6.236 3.172 4.53 4.53 0 0 1-2.712-4.235 4.576 4.576 0 0 1 4.633-4.447"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cu)",
    d: "M110.19 199.05a4.804 4.804 0 0 1 4.802 5.708 4.81 4.81 0 0 1-3.775 3.812 4.802 4.802 0 0 1-4.95-2.065 4.8 4.8 0 0 1-.795-2.69 4.85 4.85 0 0 1 4.718-4.765"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cv)",
    d: "M88.863 219.231a6.055 6.055 0 0 1 6.037 7.139 6.06 6.06 0 0 1-4.665 4.834 6.055 6.055 0 0 1-6.252-2.452 6.06 6.06 0 0 1-1.087-3.338 6.08 6.08 0 0 1 1.704-4.329 6.07 6.07 0 0 1 4.263-1.854"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cw)",
    d: "M120.917 187.319a5.94 5.94 0 0 1 5.497 3.635 5.957 5.957 0 0 1-4.244 8.137 5.946 5.946 0 0 1-7.177-5.716 6.049 6.049 0 0 1 5.924-6.056"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cx)",
    d: "M35.63 295.442a4.548 4.548 0 0 1 4.463 5.433 4.55 4.55 0 0 1-3.563 3.582 4.548 4.548 0 0 1-5.45-4.442 4.575 4.575 0 0 1 4.55-4.573"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cy)",
    d: "M206.374 59.292a5.88 5.88 0 0 1 5.618 7.142 5.89 5.89 0 0 1-4.697 4.535 5.88 5.88 0 0 1-5.988-2.596 5.9 5.9 0 0 1-.942-3.28 5.944 5.944 0 0 1 6.009-5.802"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cz)",
    d: "M57.063 272.635a6.01 6.01 0 0 1 5.774 7.251 6.02 6.02 0 0 1-4.746 4.668 6 6 0 0 1-6.137-2.575 6 6 0 0 1-1.006-3.33 6.08 6.08 0 0 1 6.115-6.014"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cA)",
    d: "M78.094 230.814a5.185 5.185 0 0 1 5.304 6.017 5.19 5.19 0 0 1-3.931 4.218 5.181 5.181 0 0 1-6.366-4.878 5.19 5.19 0 0 1 4.993-5.357"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cB)",
    d: "M131.517 156.339a4.911 4.911 0 0 1 3.607 8.333 4.908 4.908 0 0 1-8.431-3.357 4.913 4.913 0 0 1 4.824-4.976"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cC)",
    d: "M67.6 262.281a5.68 5.68 0 0 1 5.232 3.507 5.7 5.7 0 0 1-1.2 6.187 5.688 5.688 0 0 1-8.737-.759 5.7 5.7 0 0 1-1.008-3.133 5.77 5.77 0 0 1 3.513-5.348 5.8 5.8 0 0 1 2.2-.454"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cD)",
    d: "M142.075 144.799a5.77 5.77 0 0 1 5.47 3.433 5.79 5.79 0 0 1-1.128 6.363 5.773 5.773 0 0 1-8.94-.785 5.8 5.8 0 0 1-.988-3.231 5.8 5.8 0 0 1 5.586-5.78"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cE)",
    d: "M24.987 306.665a4 4 0 0 1 3.684 2.495 4.004 4.004 0 0 1-2.959 5.439 4 4 0 0 1-4.093-1.742 4 4 0 0 1-.652-2.233 3.98 3.98 0 0 1 4.02-3.959"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cF)",
    d: "M216.952 49.996a4.53 4.53 0 0 1 4.151 2.821 4.532 4.532 0 0 1-5.921 5.899 4.54 4.54 0 0 1-2.8-4.168 4.6 4.6 0 0 1 1.352-3.214 4.6 4.6 0 0 1 3.218-1.339"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cG)",
    d: "M46.315 286.548a2.751 2.751 0 0 1 1.924 4.699 2.745 2.745 0 0 1-4.223-.404 2.75 2.75 0 0 1-.473-1.521 2.789 2.789 0 0 1 2.772-2.774"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cH)",
    d: "M174.213 113.162a5.39 5.39 0 0 1 5.002 3.276 5.41 5.41 0 0 1-1.087 5.882 5.395 5.395 0 0 1-5.841 1.27 5.4 5.4 0 0 1-3.427-4.901 5.46 5.46 0 0 1 5.353-5.527"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cI)",
    d: "M163.444 123.856a5.37 5.37 0 0 1 5.116 3.13 5.378 5.378 0 0 1-6.81 7.265 5.38 5.38 0 0 1-3.447-4.911 5.45 5.45 0 0 1 1.472-3.774 5.44 5.44 0 0 1 3.669-1.71"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cJ)",
    d: "M195.477 70.24a5.605 5.605 0 0 1 5.607 5.61 5.61 5.61 0 0 1-5.607 5.612 5.612 5.612 0 0 1 0-11.223"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cK)",
    d: "M14.303 339.91a2.77 2.77 0 0 1 2.556 1.703 2.78 2.78 0 0 1-.582 3.018 2.772 2.772 0 0 1-4.746-1.904 2.8 2.8 0 0 1 1.705-2.596c.337-.143.7-.218 1.067-.221"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL)",
    d: "M227.489 38.307a5.54 5.54 0 0 1 5.163 3.328 5.55 5.55 0 0 1-3.866 7.632 5.54 5.54 0 0 1-5.734-2.2 5.55 5.55 0 0 1-1.022-3.043 5.633 5.633 0 0 1 5.459-5.717"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cM)",
    d: "M152.866 134.74a5.16 5.16 0 0 1 4.793 3.146 5.17 5.17 0 0 1-1.064 5.637 5.16 5.16 0 0 1-8.849-3.552 5.21 5.21 0 0 1 5.12-5.231"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cN)",
    d: "M78.093 252.921a4.38 4.38 0 0 1 4.136 2.573 4.385 4.385 0 0 1-3.002 6.078 4.376 4.376 0 0 1-5.365-4.141 4.45 4.45 0 0 1 4.231-4.51"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cO)",
    d: "M24.924 328.941a3.065 3.065 0 0 1 3.055 3.651 3.07 3.07 0 0 1-2.411 2.43 3.064 3.064 0 0 1-3.16-1.316 3.07 3.07 0 0 1-.51-1.715 3.113 3.113 0 0 1 3.026-3.05"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cP)",
    d: "M248.731 16.496a6.13 6.13 0 0 1 4.23 1.662 6.14 6.14 0 0 1 1.927 4.119 6 6 0 0 1-1.522 4.499 6 6 0 0 1-4.309 1.99 6.007 6.007 0 0 1-6.165-6.172 6.136 6.136 0 0 1 5.839-6.099"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cQ)",
    d: "M259.374 5.971a5.964 5.964 0 0 1 6.03 5.845 5.864 5.864 0 0 1-5.79 5.582 5.86 5.86 0 0 1-5.91-5.455 5.973 5.973 0 0 1 5.67-5.972"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cR)",
    d: "M46.21 307.49a3.26 3.26 0 0 1 3.236 3.177 3.175 3.175 0 1 1-6.347 0 3.26 3.26 0 0 1 3.11-3.177"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cS)",
    d: "M131.56 177.621a4.976 4.976 0 1 1-1.88 9.565 4.97 4.97 0 0 1-3.05-4.631 5.06 5.06 0 0 1 1.48-3.454 5.05 5.05 0 0 1 3.45-1.48"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cT)",
    d: "M88.99 240.893a5.737 5.737 0 0 1 5.565 6.932 5.74 5.74 0 0 1-4.584 4.453 5.734 5.734 0 0 1-6.758-5.773 5.845 5.845 0 0 1 5.777-5.612"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cU)",
    d: "M99.527 230.348a5.58 5.58 0 0 1 5.218 3.387 5.59 5.59 0 0 1-7.236 7.382 5.59 5.59 0 0 1-3.483-5.158 5.714 5.714 0 0 1 5.501-5.611"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cV)",
    d: "M152.865 156.911a4.236 4.236 0 0 1 .653 8.396 4.23 4.23 0 0 1-5.011-4.161 4.426 4.426 0 0 1 4.358-4.235"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cW)",
    d: "M206.183 81.081a5.46 5.46 0 0 1 5.088 3.328 5.47 5.47 0 0 1-1.142 5.976 5.46 5.46 0 0 1-5.957 1.213 5.46 5.46 0 0 1-3.384-5.053 5.566 5.566 0 0 1 5.395-5.464"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cX)",
    d: "M35.419 317.739a3.6 3.6 0 0 1 2.728.849 3.61 3.61 0 0 1 1.017 4.013 3.6 3.6 0 0 1-3.428 2.317 3.596 3.596 0 0 1-3.527-3.44 3.6 3.6 0 0 1 3.21-3.739"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cY)",
    d: "M142.287 167.499a4.42 4.42 0 0 1 4.093 2.752 4.43 4.43 0 0 1-.998 4.833 4.417 4.417 0 0 1-6.813-.763 4.42 4.42 0 0 1-.704-2.481 4.504 4.504 0 0 1 4.422-4.341"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cZ)",
    d: "M238.153 28.735a4.42 4.42 0 0 1 4.123 2.632 4.424 4.424 0 0 1-3.034 6.102 4.42 4.42 0 0 1-4.584-1.704 4.43 4.43 0 0 1-.843-2.413 4.51 4.51 0 0 1 1.223-3.2 4.5 4.5 0 0 1 3.115-1.417"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#da)",
    d: "M185.004 102.532a5.354 5.354 0 0 1 5.162 6.415 5.37 5.37 0 0 1-1.455 2.723 5.355 5.355 0 0 1-8.197-.736 5.36 5.36 0 0 1-.947-2.939 5.445 5.445 0 0 1 3.351-5.047 5.5 5.5 0 0 1 2.086-.416"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#db)",
    d: "M195.414 91.203a6 6 0 0 1 5.649 3.551 6.01 6.01 0 0 1-1.109 6.584 6 6 0 0 1-6.5 1.501 6.014 6.014 0 0 1-3.88-5.431 6.15 6.15 0 0 1 1.669-4.282 6.13 6.13 0 0 1 4.171-1.923"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dc)",
    d: "M2.39 241.274a5.25 5.25 0 0 1 5.65 1.822 5.16 5.16 0 0 1 .762 5.886 5.42 5.42 0 0 1-5.036 3.198c-2.518 0-3.449-.953-3.449-3.452v-1.948q.08-1.418 0-2.837c-.253-1.673.635-2.309 2.074-2.669"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dd)",
    d: "M216.847 71.658a4.232 4.232 0 0 1 4.15 5.061 4.233 4.233 0 1 1-7.143-3.82 4.23 4.23 0 0 1 2.993-1.24"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#de)",
    d: "M67.578 286.061a3.239 3.239 0 1 1-2.289 5.531 3.243 3.243 0 0 1 0-4.582 3.23 3.23 0 0 1 2.29-.949"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#df)",
    d: "M56.915 296.839a3.15 3.15 0 0 1 2.94 1.913 3.16 3.16 0 0 1-.647 3.45 3.151 3.151 0 0 1-5.404-2.187 3.177 3.177 0 0 1 3.11-3.176"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dg)",
    d: "M120.981 210.252a4.361 4.361 0 0 1 2.976 7.507 4.357 4.357 0 0 1-7.377-3.272 4.424 4.424 0 0 1 4.401-4.235"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dh)",
    d: "M14.409 358.037a5.98 5.98 0 0 1 5.466 3.802 5.996 5.996 0 0 1-4.522 8.089 5.985 5.985 0 0 1-6.098-2.674 6 6 0 0 1-.94-3.352 6.08 6.08 0 0 1 1.86-4.168 6.07 6.07 0 0 1 4.233-1.697"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#di)",
    d: "M110.296 220.035a5.225 5.225 0 0 1 4.8 3.263 5.24 5.24 0 0 1-1.17 5.688 5.22 5.22 0 0 1-5.697 1.102 5.23 5.23 0 0 1-3.201-4.843 5.354 5.354 0 0 1 5.268-5.21"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dj)",
    d: "M131.708 198.034a5.9 5.9 0 0 1 5.416 3.711 5.912 5.912 0 0 1-4.404 8.006 5.9 5.9 0 0 1-6.029-2.595 5.9 5.9 0 0 1-.95-3.299 5.985 5.985 0 0 1 5.967-5.823"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dk)",
    d: "M142.287 188.463a4.8 4.8 0 0 1 4.353 3.073 4.811 4.811 0 0 1-3.642 6.465 4.805 4.805 0 0 1-5.641-4.816 4.85 4.85 0 0 1 4.93-4.722"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dl)",
    d: "M153.013 177.875a4.725 4.725 0 0 1-.169 9.444 4.725 4.725 0 0 1 .169-9.444"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dm)",
    d: "M25.03 348.635a4.69 4.69 0 0 1 4.3 2.96 4.71 4.71 0 0 1-1.088 5.109 4.7 4.7 0 0 1-5.132.95 4.7 4.7 0 0 1-2.84-4.382 4.81 4.81 0 0 1 4.76-4.637"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dn)",
    d: "M163.445 144.989a5.57 5.57 0 0 1 1.211 11.018 5.555 5.555 0 0 1-5.739-2.302 5.57 5.57 0 0 1-.973-3.083 5.695 5.695 0 0 1 5.501-5.633"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#do)",
    d: "M174.193 134.719a5.18 5.18 0 0 1 4.829 3.149 5.2 5.2 0 0 1 .328 2.996 5.2 5.2 0 0 1-1.392 2.673 5.18 5.18 0 0 1-5.642 1.181 5.19 5.19 0 0 1-3.244-4.769 5.25 5.25 0 0 1 5.121-5.23"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dp)",
    d: "M184.962 124.216a5.018 5.018 0 0 1 3.465 8.604 5.01 5.01 0 0 1-7.711-.848 5.03 5.03 0 0 1-.811-2.801 5.084 5.084 0 0 1 5.057-4.955"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dq)",
    d: "M195.646 113.755a4.787 4.787 0 0 1 0 9.572 4.77 4.77 0 0 1-3.381-1.402 4.8 4.8 0 0 1-1.401-3.384 4.8 4.8 0 0 1 1.401-3.384 4.78 4.78 0 0 1 3.381-1.402"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dr)",
    d: "M99.717 251.862a5.44 5.44 0 0 1 5.214 6.567 5.44 5.44 0 0 1-7.424 3.892 5.44 5.44 0 0 1-3.333-5.017 5.522 5.522 0 0 1 5.543-5.442"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ds)",
    d: "M206.31 102.278a5.58 5.58 0 0 1 5.102 3.466 5.59 5.59 0 0 1-7.231 7.319 5.59 5.59 0 0 1-3.52-5.068 5.7 5.7 0 0 1 5.649-5.717"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dt)",
    d: "M1.862 263.234a5.184 5.184 0 0 1 5.65 1.143 5.15 5.15 0 0 1-.966 7.945 5.14 5.14 0 0 1-2.907.779c-2.349-.106-3.068-.868-3.068-3.197v-1.842q.08-1.43 0-2.859a1.737 1.737 0 0 1 1.29-1.969"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#du)",
    d: "M88.757 263.149a4.82 4.82 0 0 1 4.588 2.84 4.83 4.83 0 0 1-3.371 6.702 4.825 4.825 0 0 1-5.85-4.693 4.893 4.893 0 0 1 4.633-4.849"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dv)",
    d: "M78.2 273.715a4.933 4.933 0 1 1-1.738 9.518 4.93 4.93 0 0 1-3.107-4.52 5.013 5.013 0 0 1 4.845-4.998"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dw)",
    d: "M259.543 27.528a5.6 5.6 0 0 1 5.204 3.475 5.62 5.62 0 0 1-1.25 6.135 5.603 5.603 0 0 1-8.645-.956 5.6 5.6 0 0 1-.895-3.148 5.72 5.72 0 0 1 5.586-5.506"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dx)",
    d: "M227.531 59.525a5.65 5.65 0 0 1 5.245 3.45 5.657 5.657 0 0 1-4.059 7.74 5.64 5.64 0 0 1-5.817-2.36 5.65 5.65 0 0 1-.975-3.134 5.8 5.8 0 0 1 5.606-5.696"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dy)",
    d: "M248.816 39.45a4.4 4.4 0 0 1 4.51 5.117 4.403 4.403 0 0 1-5.911 3.4 4.41 4.41 0 0 1-2.831-4.006 4.47 4.47 0 0 1 4.232-4.51"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dz)",
    d: "M238.216 49.932a4.59 4.59 0 0 1 4.257 2.822 4.6 4.6 0 0 1-.982 5.015 4.588 4.588 0 0 1-7.07-.687 4.6 4.6 0 0 1-.775-2.555 4.66 4.66 0 0 1 4.57-4.595"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dA)",
    d: "M1.27 284.282a5.56 5.56 0 0 1 5.796.508 5.38 5.38 0 0 1 2.116 5.591 5.28 5.28 0 0 1-3.872 4.235c-3.364 1.016-5.247-.466-5.247-3.981v-4.532a1.65 1.65 0 0 1 1.206-1.821"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dB)",
    d: "M120.959 231.513a4.422 4.422 0 0 1 4.348 4.499 4.43 4.43 0 0 1-1.348 3.108 4.4 4.4 0 0 1-3.148 1.244 4.4 4.4 0 0 1-1.687-.365 4.44 4.44 0 0 1-2.353-2.436 4.426 4.426 0 0 1 4.188-6.05"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dC)",
    d: "M270.27 18.232a4.23 4.23 0 0 1 3.91 2.615 4.24 4.24 0 0 1-.917 4.615 4.232 4.232 0 0 1-7.224-2.995 4.23 4.23 0 0 1 4.231-4.235"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dD)",
    d: "M216.91 92.918a4.23 4.23 0 0 1 3.896 2.587 4.238 4.238 0 0 1-2.995 5.786 4.225 4.225 0 0 1-4.359-1.693 4.25 4.25 0 0 1-.774-2.317c0-1.136.442-2.226 1.232-3.04a4.36 4.36 0 0 1 3-1.323"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dE)",
    d: "M67.62 307.977c.534.001 1.056.16 1.5.458a2.695 2.695 0 0 1 1.13 2.78 2.687 2.687 0 1 1-4.508-2.472 2.69 2.69 0 0 1 1.878-.766"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dF)",
    d: "M110.169 241.889a4.71 4.71 0 0 1 4.419 2.855 4.73 4.73 0 0 1-.968 5.175 4.718 4.718 0 0 1-8.085-3.308 4.8 4.8 0 0 1 1.37-3.292 4.78 4.78 0 0 1 3.264-1.43"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dG)",
    d: "M174.277 156.953a4.232 4.232 0 0 1 4.15 5.062 4.232 4.232 0 0 1-7.668 1.526 4.236 4.236 0 0 1 3.518-6.588"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dH)",
    d: "M227.616 80.975a5.56 5.56 0 0 1 5.137 3.483 5.58 5.58 0 0 1-1.278 6.077 5.563 5.563 0 0 1-9.444-4.117 5.62 5.62 0 0 1 1.693-3.852 5.6 5.6 0 0 1 3.892-1.59"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dI)",
    d: "M280.743 6.077a5.755 5.755 0 0 1 5.414 3.437 5.76 5.76 0 0 1-1.122 6.318 5.752 5.752 0 0 1-8.887-.734 5.76 5.76 0 0 1-1.012-3.197 5.8 5.8 0 0 1 1.623-4.05 5.8 5.8 0 0 1 3.984-1.774"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dJ)",
    d: "M14.324 379.784a5.58 5.58 0 0 1 5.155 3.491 5.593 5.593 0 0 1-4.16 7.596 5.58 5.58 0 0 1-5.714-2.471 5.6 5.6 0 0 1-.888-3.132 5.64 5.64 0 0 1 1.693-3.88 5.63 5.63 0 0 1 3.914-1.604"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dK)",
    d: "M163.444 167.012a4.91 4.91 0 0 1 4.869 5.799 4.92 4.92 0 0 1-3.778 3.912 4.911 4.911 0 0 1-5.957-4.671 4.97 4.97 0 0 1 1.39-3.529 4.94 4.94 0 0 1 3.476-1.511"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dL)",
    d: "M57 318.502a2.836 2.836 0 0 1-.106 5.654 2.84 2.84 0 0 1-2.543-2.876A2.833 2.833 0 0 1 57 318.502"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dM)",
    d: "M5.438 305.563a5.336 5.336 0 0 1 3.462 6.373 5.333 5.333 0 0 1-6.086 3.94c-2.243-.36-2.518-.847-2.518-4.489v-2.118c0-3.261 2.031-4.701 5.142-3.706"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dN)",
    d: "M248.922 60.774a4.422 4.422 0 0 1 4.306 5.334 4.425 4.425 0 0 1-3.525 3.444 4.42 4.42 0 0 1-4.522-1.958 4.43 4.43 0 0 1-.702-2.48 4.363 4.363 0 0 1 4.443-4.34"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dO)",
    d: "M184.835 146.217a4.36 4.36 0 0 1 4.114 2.598 4.37 4.37 0 0 1-.853 4.794 4.359 4.359 0 0 1-7.493-3.008 4.234 4.234 0 0 1 4.232-4.384"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dP)",
    d: "M2.878 325.934a6.114 6.114 0 0 1 6.71 4.801 6.12 6.12 0 0 1-4.171 7.121c-2.603.847-4.57.127-5.396-1.779v-8.914a4.23 4.23 0 0 1 2.857-1.229"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dQ)",
    d: "M153.669 103.527a4.46 4.46 0 0 1 3.353 1.192 4.46 4.46 0 0 1 1.418 3.266 4.466 4.466 0 0 1-4.771 4.457 4.46 4.46 0 0 1-4.157-4.457 4.47 4.47 0 0 1 4.157-4.458"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dR)",
    d: "M152.865 198.86a5.075 5.075 0 0 1 4.667 3.181 5.09 5.09 0 0 1-1.157 5.532 5.076 5.076 0 0 1-8.63-3.695 5 5 0 0 1 1.5-3.593 4.99 4.99 0 0 1 3.62-1.425"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dS)",
    d: "M131.707 219.781a5.503 5.503 0 0 1 5.284 6.695 5.497 5.497 0 0 1-10.031 1.736 5.5 5.5 0 0 1-.838-3.095 5.47 5.47 0 0 1 1.688-3.826 5.455 5.455 0 0 1 3.897-1.51"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dT)",
    d: "M24.585 370.276a4.44 4.44 0 0 1 4.326 2.407 4.45 4.45 0 0 1-2.764 6.308 4.442 4.442 0 0 1-5.624-3.972 4.43 4.43 0 0 1 4.062-4.743"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dU)",
    d: "M99.527 273.927a4.72 4.72 0 0 1 4.726 5.567 4.715 4.715 0 0 1-8.528 1.833 4.72 4.72 0 0 1-.832-2.614 4.66 4.66 0 0 1 4.634-4.786"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dV)",
    d: "M259.606 49.89a4.63 4.63 0 0 1 4.257 2.907 4.64 4.64 0 0 1-3.45 6.289 4.63 4.63 0 0 1-4.735-2.033c-.5-.77-.76-1.671-.747-2.59a4.57 4.57 0 0 1 2.894-4.256 4.6 4.6 0 0 1 1.781-.317"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dW)",
    d: "M206.247 124.618a4.61 4.61 0 0 1 4.19 2.937 4.62 4.62 0 0 1-1.095 5.002 4.62 4.62 0 0 1-5.034.913 4.62 4.62 0 0 1-2.779-4.299 4.55 4.55 0 0 1 1.391-3.281 4.54 4.54 0 0 1 3.327-1.272"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dX)",
    d: "M142.287 209.638a4.87 4.87 0 1 1-1.659 9.411 4.86 4.86 0 0 1-2.691-2.579 4.88 4.88 0 0 1-.081-3.727 4.9 4.9 0 0 1 1.021-1.603 4.86 4.86 0 0 1 3.41-1.502"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dY)",
    d: "M238.301 71.023a4.82 4.82 0 0 1 4.422 3.055 4.83 4.83 0 0 1-1.145 5.254 4.823 4.823 0 0 1-8.165-3.608 4.822 4.822 0 0 1 4.888-4.701"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dZ)",
    d: "M78.073 296.903a3.088 3.088 0 0 1 3.268 3.495 3.092 3.092 0 0 1-4.072 2.511 3.08 3.08 0 0 1-2.074-2.745 3.093 3.093 0 0 1 2.878-3.261"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ea)",
    d: "M35.524 358.693a5.325 5.325 0 0 1 4.992 3.201 5.34 5.34 0 0 1-3.756 7.349 5.325 5.325 0 0 1-5.514-2.177 5.34 5.34 0 0 1-.948-2.952 5.295 5.295 0 0 1 5.226-5.421"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eb)",
    d: "M88.969 284.155a5.16 5.16 0 0 1 4.762 3.224 5.17 5.17 0 0 1-3.837 7.022 5.16 5.16 0 0 1-5.282-2.273 5.17 5.17 0 0 1-.827-2.891A5.13 5.13 0 0 1 87 284.523a5.1 5.1 0 0 1 1.969-.368"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ec)",
    d: "M1.227 7.877c-.106-1.63.762-2.117 2.116-2.414A10 10 0 0 1 9.098 6.48a10 10 0 0 1-1.376-3.283c-.105-1.44 0-2.244 1.841-2.117 2.56.17 5.142 0 7.723 0s3.237.635 2.243 3.41c-.17.465-.36.91-.55 1.376a6.71 6.71 0 0 1-8.083 2.117 2.8 2.8 0 0 0-1.058-.805 1.2 1.2 0 0 0-.55 0l1.037 1.377a6.76 6.76 0 0 1-1.735 7.877 7.23 7.23 0 0 1-4.888 1.08c-1.608-.254-2.538-.847-2.39-2.753a43.4 43.4 0 0 0-.085-6.882"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ed)",
    d: "M67.558 328.666a3.34 3.34 0 0 1 3.124 2.002 3.348 3.348 0 0 1-2.335 4.609 3.34 3.34 0 0 1-4.069-3.181 3.26 3.26 0 0 1 1.986-3.173c.409-.173.85-.26 1.294-.257"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ee)",
    d: "M238.216 92.558a4.63 4.63 0 0 1 4.697 4.574 4.64 4.64 0 0 1-1.313 3.298 4.63 4.63 0 0 1-6.552.09 4.64 4.64 0 0 1 3.168-7.962"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ef)",
    d: "M120.706 251.989a5.36 5.36 0 1 1-1.743 10.368 5.3 5.3 0 0 1-1.771-1.11 5.34 5.34 0 0 1-1.68-3.741 5.365 5.365 0 0 1 3.157-5.048 5.4 5.4 0 0 1 2.037-.469"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eg)",
    d: "M2.645 347.279a5.751 5.751 0 0 1 5.797 2.351 5.59 5.59 0 0 1 .635 6.204 5.84 5.84 0 0 1-5.459 3.473c-1.883 0-3.025-.487-3.597-1.652v-9.105a4.24 4.24 0 0 1 2.624-1.271"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eh)",
    d: "M227.51 102.85a5.01 5.01 0 0 1 4.687 3.079 5.022 5.022 0 0 1-3.688 6.869 5.01 5.01 0 0 1-5.152-2.212 5.02 5.02 0 0 1-.798-2.824 4.93 4.93 0 0 1 1.459-3.482 4.929 4.929 0 0 1 3.492-1.43"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ei)",
    d: "M216.973 114.073a4.471 4.471 0 0 1 3.031 7.68 4.462 4.462 0 0 1-7.257-1.571 4.46 4.46 0 0 1 .056-3.419 4.452 4.452 0 0 1 4.17-2.69"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ej)",
    d: "M131.708 242.185a4.44 4.44 0 0 1 4.09 2.76 4.448 4.448 0 0 1-3.252 6.05 4.44 4.44 0 0 1-4.555-1.895 4.45 4.45 0 0 1-.747-2.468 4.35 4.35 0 0 1 1.276-3.185 4.34 4.34 0 0 1 3.188-1.262"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ek)",
    d: "M174.213 178.319a4.24 4.24 0 0 1 3.017 1.181 4.23 4.23 0 0 1 1.299 2.97 4.23 4.23 0 0 1-2.534 3.965 4.23 4.23 0 0 1-4.629-.826 4.237 4.237 0 0 1 2.847-7.29"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#el)",
    d: "M185.004 167.118a4.78 4.78 0 0 1 4.782 4.785c0 1.27-.504 2.487-1.4 3.384a4.78 4.78 0 0 1-6.763 0 4.788 4.788 0 0 1 3.381-8.169"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#em)",
    d: "M280.743 28.905a4.23 4.23 0 0 1 3.984 2.54 4.24 4.24 0 0 1-.849 4.65 4.23 4.23 0 0 1-7.261-2.955 4.24 4.24 0 0 1 4.126-4.235"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#en)",
    d: "M291.555 17.682a4.82 4.82 0 0 1 4.455 2.975 4.832 4.832 0 0 1-3.501 6.585 4.82 4.82 0 0 1-4.955-2.035 4.83 4.83 0 0 1-.823-2.676 4.76 4.76 0 0 1 1.386-3.447 4.76 4.76 0 0 1 3.438-1.402"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eo)",
    d: "M270.165 38.116a5.71 5.71 0 0 1 5.318 3.476 5.72 5.72 0 0 1-1.178 6.246 5.72 5.72 0 0 1-6.219 1.295 5.72 5.72 0 0 1-3.571-5.257 5.594 5.594 0 0 1 3.452-5.337 5.6 5.6 0 0 1 2.198-.423"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ep)",
    d: "M163.634 188.463a4.87 4.87 0 1 1-1.958 9.347 4.87 4.87 0 0 1-2.95-4.541 4.783 4.783 0 0 1 4.908-4.806"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eq)",
    d: "M110.233 263.128a4.823 4.823 0 0 1 4.456 2.98 4.825 4.825 0 0 1-1.045 5.262 4.82 4.82 0 0 1-6.822 0 4.83 4.83 0 0 1 0-6.828 4.82 4.82 0 0 1 3.411-1.414"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#er)",
    d: "M.022 31.192v-3.346c.296-1.144 1.248-1.567 2.517-1.885 2.455-.571 4.465.678 6.58 1.525a8.28 8.28 0 0 1-.655-9.02c2.94-3.558 6.347-3.622 10.155-1.95.233 0 .487.192.72.319-2.116-4.003-2.116-7.666 1.565-10.821a7.49 7.49 0 0 1 7.744 0 2.43 2.43 0 0 0 1.65.339 7.37 7.37 0 0 1-1.967-4.68C28.33.614 28.542.127 29.41 0h11.975c.868.19.973.826.973 1.842 0 1.97-1.375 3.325-1.883 5.019a9.56 9.56 0 0 1-9.33.572c-.233-.127-.487-.212-.72-.36a9.005 9.005 0 0 1-.211 9.973l-.127.127s-.148.127-.212.212c-1.079-.106-1.692.868-2.602 1.186-2.666.995-4.909 0-7.236-1.08q.199.35.36.72a9.2 9.2 0 0 1-.656 9.338l-.19.17-.191.19a29 29 0 0 1-3.428 1.335 8.65 8.65 0 0 1-6.347-1.546q.188.35.338.72a8.16 8.16 0 0 1-.423 9.169 7.76 7.76 0 0 1-7.3 2.117 2.37 2.37 0 0 1-2.115-1.757V34.96c-.021-1.27-.021-2.52-.063-3.77"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#es)",
    d: "M302.176 6.691a5.01 5.01 0 0 1 4.812 3.215c.247.642.359 1.328.33 2.016a5.14 5.14 0 0 1-10.262-.19 5.014 5.014 0 0 1 5.12-5.04"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#et)",
    d: "M142.287 252.582a4.72 4.72 0 0 1 4.307 2.999 4.73 4.73 0 0 1-1.125 5.128 4.71 4.71 0 0 1-5.166.918 4.72 4.72 0 0 1-2.819-4.429 4.67 4.67 0 0 1 1.436-3.313 4.68 4.68 0 0 1 3.367-1.303"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eu)",
    d: "M227.531 125.042a4.23 4.23 0 0 1 3.59 4.1 4.235 4.235 0 0 1-5.25 4.197 4.23 4.23 0 0 1-2.78-2.246 4.236 4.236 0 0 1 4.44-6.051"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ev)",
    d: "M46.272 370.89a3.807 3.807 0 0 1 3.752 4.574 3.815 3.815 0 0 1-3.033 2.985 3.81 3.81 0 0 1-3.904-1.69 3.8 3.8 0 0 1-.602-2.142 3.75 3.75 0 0 1 2.346-3.456 3.8 3.8 0 0 1 1.441-.271"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ew)",
    d: "M88.906 329.047a2.96 2.96 0 0 1 2.764 1.796 2.966 2.966 0 0 1-2.115 4.07 2.96 2.96 0 0 1-3.569-2.88 2.9 2.9 0 0 1 2.92-2.986"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ex)",
    d: "M259.501 92.474a4.74 4.74 0 0 1 4.722 5.613 4.74 4.74 0 0 1-3.685 3.772 4.73 4.73 0 0 1-2.743-.242 4.75 4.75 0 0 1-2.97-4.358 4.68 4.68 0 0 1 4.676-4.786"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ey)",
    d: "M120.917 274.478a4.23 4.23 0 0 1 3.919 2.64 4.237 4.237 0 0 1-3.16 5.761 4.23 4.23 0 0 1-4.99-4.272 4.09 4.09 0 0 1 2.613-3.858 4.1 4.1 0 0 1 1.618-.271"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ez)",
    d: "M248.753 103.76a4.02 4.02 0 0 1 4.168 3.875 4.03 4.03 0 0 1-3.872 4.172 4.02 4.02 0 0 1-4.168-3.875 4.03 4.03 0 0 1 3.872-4.172"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eA)",
    d: "M152.865 220.565a4.715 4.715 0 0 1 4.325 2.934 4.725 4.725 0 0 1-3.436 6.417 4.71 4.71 0 0 1-4.836-1.979 4.7 4.7 0 0 1-.813-2.608 4.6 4.6 0 0 1 1.348-3.415 4.607 4.607 0 0 1 3.412-1.349"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eB)",
    d: "M35.715 380.483a4.888 4.888 0 0 1 4.698 5.896 4.89 4.89 0 0 1-3.86 3.798 4.888 4.888 0 0 1-5.81-4.803 4.77 4.77 0 0 1 3.055-4.581 4.75 4.75 0 0 1 1.917-.31"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eC)",
    d: "M185.004 187.806a5.46 5.46 0 0 1 5.243 6.644 5.47 5.47 0 0 1-4.401 4.202 5.457 5.457 0 0 1-6.385-5.552 5.377 5.377 0 0 1 5.543-5.294"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eD)",
    d: "M195.605 178.023a4.57 4.57 0 0 1 4.383 5.533 4.575 4.575 0 0 1-3.633 3.537 4.565 4.565 0 0 1-4.661-1.995 4.6 4.6 0 0 1-.744-2.543 4.529 4.529 0 0 1 4.655-4.532"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eE)",
    d: "M216.847 135.905a4 4 0 0 1 3.752 2.462c.307.739.386 1.553.227 2.337a3.997 3.997 0 0 1-7.309 1.324 4 4 0 0 1-.606-2.269 3.915 3.915 0 0 1 3.936-3.854"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eF)",
    d: "M88.99 308.21a2.458 2.458 0 0 1 .422 4.869 2.457 2.457 0 0 1-2.918-2.412 2.4 2.4 0 0 1 1.534-2.3c.306-.118.634-.171.962-.157"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eG)",
    d: "M291.449 38.56a5.296 5.296 0 0 1 0 10.588 5.297 5.297 0 0 1-3.74-9.037 5.29 5.29 0 0 1 3.74-1.55"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eH)",
    d: "M238.089 113.925a4.635 4.635 0 0 1 4.712 5.44 4.64 4.64 0 0 1-3.591 3.729 4.634 4.634 0 0 1-5.606-4.511 4.59 4.59 0 0 1 1.278-3.259 4.57 4.57 0 0 1 3.207-1.399"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eI)",
    d: "M302.134 28.968a4.23 4.23 0 0 1 3.909 2.615 4.24 4.24 0 0 1-.917 4.615 4.232 4.232 0 0 1-7.224-2.995 4.236 4.236 0 0 1 4.232-4.235"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eJ)",
    d: "M99.653 296.458a3.44 3.44 0 0 1 3.156 2.16 3.45 3.45 0 0 1-.774 3.747 3.447 3.447 0 0 1-5.873-2.455 3.37 3.37 0 0 1 3.491-3.452"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eK)",
    d: "M259.501 71.086a4.78 4.78 0 0 1 4.469 2.925 4.788 4.788 0 0 1-3.489 6.557 4.78 4.78 0 0 1-4.919-2.077 4.8 4.8 0 0 1-.779-2.683 4.7 4.7 0 0 1 2.909-4.368 4.7 4.7 0 0 1 1.809-.354"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eL)",
    d: "M142.096 231.237a4.72 4.72 0 0 1 4.819 5.52 4.717 4.717 0 0 1-9.368-.755 4.615 4.615 0 0 1 4.549-4.765"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eM)",
    d: "M35.609 401.404a5.314 5.314 0 0 1 5.232 6.339 5.32 5.32 0 0 1-4.167 4.188 5.312 5.312 0 0 1-6.354-5.212 5.23 5.23 0 0 1 5.289-5.315"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eN)",
    d: "M131.517 263.466c1.19 0 2.331.473 3.172 1.315a4.493 4.493 0 0 1 0 6.349 4.48 4.48 0 0 1-3.172 1.315 4.4 4.4 0 0 1-3.168-1.282 4.4 4.4 0 0 1-.967-1.452 4.4 4.4 0 0 1-.329-1.713 4.45 4.45 0 0 1 4.464-4.532"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eO)",
    d: "M206.162 166.376a5.528 5.528 0 0 1 1.245 10.93 5.52 5.52 0 0 1-6.682-5.318 5.51 5.51 0 0 1 1.551-3.939 5.5 5.5 0 0 1 3.886-1.673"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eP)",
    d: "M195.477 157.102a4.23 4.23 0 0 1 4.043 2.478 4.235 4.235 0 0 1-5.424 5.684 4.239 4.239 0 0 1-2.66-3.927 4.07 4.07 0 0 1 2.453-3.904 4.1 4.1 0 0 1 1.588-.331"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eQ)",
    d: "M163.614 210.019a4.58 4.58 0 0 1 4.214 2.859 4.574 4.574 0 0 1-6.048 5.914 4.57 4.57 0 0 1-2.757-4.283 4.51 4.51 0 0 1 2.845-4.173 4.5 4.5 0 0 1 1.746-.317"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eR)",
    d: "M110.338 284.134a5.16 5.16 0 0 1 4.735 3.264 5.168 5.168 0 0 1-3.894 6.989 5.16 5.16 0 0 1-6.067-5.213 5.08 5.08 0 0 1 1.554-3.62 5.068 5.068 0 0 1 3.672-1.42"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eS)",
    d: "M280.701 48.958a5.56 5.56 0 0 1 5.263 3.28 5.57 5.57 0 0 1-3.852 7.72 5.56 5.56 0 0 1-5.781-2.242 5.57 5.57 0 0 1-1.004-3.083 5.485 5.485 0 0 1 5.374-5.675"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eT)",
    d: "M248.689 82.077a4.463 4.463 0 0 1 4.434 4.17 4.464 4.464 0 1 1-8.657-1.21 4.47 4.47 0 0 1 2.44-2.597 4.5 4.5 0 0 1 1.783-.364"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eU)",
    d: "M312.967 17.766a4.71 4.71 0 0 1 4.3 3.003 4.73 4.73 0 0 1-1.126 5.126 4.71 4.71 0 0 1-3.365 1.316 4.72 4.72 0 0 1-3.308-1.45 4.727 4.727 0 0 1 .135-6.679 4.72 4.72 0 0 1 3.364-1.316"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eV)",
    d: "M78.306 317.972a3.343 3.343 0 0 1 3.342 3.346 3.343 3.343 0 1 1-5.707-2.366 3.34 3.34 0 0 1 2.364-.98"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eW)",
    d: "M270.164 60.9a4.23 4.23 0 0 1 3.909 2.615 4.235 4.235 0 0 1-5.528 5.534 4.238 4.238 0 0 1-1.373-6.907 4.23 4.23 0 0 1 2.992-1.241"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eX)",
    d: "M206.077 146.111a4.404 4.404 0 0 1 3.363 7.432 4.401 4.401 0 0 1-7.595-2.964 4.243 4.243 0 0 1 2.557-4.124 4.2 4.2 0 0 1 1.675-.344"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eY)",
    d: "M46.209 391.748a4.235 4.235 0 1 1-1.62 8.148 4.23 4.23 0 0 1-2.612-3.913 4.23 4.23 0 0 1 4.232-4.235"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#eZ)",
    d: "M24.988 391.113a4.928 4.928 0 0 1 4.811 5.909 4.935 4.935 0 0 1-3.878 3.865 4.92 4.92 0 0 1-5.055-2.101 4.94 4.94 0 0 1-.83-2.739 4.81 4.81 0 0 1 3.038-4.601 4.8 4.8 0 0 1 1.914-.333"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fa)",
    d: "M174.023 199.919a4.01 4.01 0 0 1 3.809 2.359 4.03 4.03 0 0 1-.737 4.422 4.019 4.019 0 0 1-6.944-2.673 3.949 3.949 0 0 1 2.346-3.775c.481-.212 1-.325 1.526-.333"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fb)",
    d: "M99.653 318.438a2.905 2.905 0 0 1 2.653 1.835 2.901 2.901 0 0 1-3.859 3.723 2.9 2.9 0 0 1-1.735-2.72 2.87 2.87 0 0 1 .874-2.038 2.84 2.84 0 0 1 2.067-.8"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fc)",
    d: "M152.865 242.651a3.975 3.975 0 0 1 3.677 2.462 3.977 3.977 0 0 1-6.994 3.715 4 4 0 0 1-.661-2.217 3.96 3.96 0 0 1 1.16-2.814 3.94 3.94 0 0 1 2.818-1.146"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fd)",
    d: "M1.46 374.956v-2.329a1.185 1.185 0 0 1 .783-1.208 3.7 3.7 0 0 1 4.409.692 3.71 3.71 0 0 1 .542 4.433 3.79 3.79 0 0 1-4.041 1.736c-2.264-.402-1.587-2.075-1.693-3.324"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fe)",
    d: "M52.937.233c2.727.17 5.461.17 8.188 0 1.84-.127 1.989.783 1.777 2.117a6.12 6.12 0 0 1-3.499 4.605 6.11 6.11 0 0 1-5.768-.37l-1.798-1.82a17 17 0 0 1-.783-2.118C50.694 1.122 50.82 0 52.937.233"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ff)",
    d: "M56.999 382.092a3.26 3.26 0 0 1 2.98 2.042 3.265 3.265 0 0 1-.733 3.539 3.253 3.253 0 0 1-5.001-.513 3.26 3.26 0 0 1-.547-1.807 3.24 3.24 0 0 1 3.3-3.261"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fg)",
    d: "M120.812 294.976a5.01 5.01 0 0 1 4.703 2.971 5.026 5.026 0 0 1-.931 5.489 5.008 5.008 0 0 1-7.724-.519 5.03 5.03 0 0 1-.615-4.697 5 5 0 0 1 2.647-2.81 5 5 0 0 1 1.92-.434"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fh)",
    d: "M227.32 145.73a4.84 4.84 0 0 1 4.617 2.828 4.86 4.86 0 0 1-.883 5.346 4.85 4.85 0 0 1-5.281 1.19 4.856 4.856 0 0 1-3.087-4.451 4.847 4.847 0 0 1 4.634-4.913"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fi)",
    d: "M163.445 231.534a4.42 4.42 0 0 1 4.161 2.719 4.43 4.43 0 0 1-.993 4.873 4.42 4.42 0 0 1-7.506-3.357 4.377 4.377 0 0 1 4.338-4.235"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fj)",
    d: "M280.764 71.277a4.59 4.59 0 0 1 4.312 2.71 4.595 4.595 0 0 1-5.797 6.187 4.593 4.593 0 0 1-2.691-5.914 4.6 4.6 0 0 1 2.419-2.581 4.6 4.6 0 0 1 1.757-.402"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fk)",
    d: "M291.576 59.715a5.465 5.465 0 0 1 0 10.927 5.464 5.464 0 0 1 0-10.927"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fl)",
    d: "M174.235 220.967a4.238 4.238 0 0 1 .901 8.373 4.233 4.233 0 0 1-3.939-7.088 4.24 4.24 0 0 1 3.038-1.285"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fm)",
    d: "M270.291 81.95a4.57 4.57 0 0 1 4.57 4.573 4.575 4.575 0 0 1-4.57 4.574 4.576 4.576 0 0 1-3.231-7.808 4.57 4.57 0 0 1 3.231-1.34"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fn)",
    d: "M323.355 7.73a4.1 4.1 0 0 1 3.923 2.394 4.11 4.11 0 0 1-.754 4.536 4.105 4.105 0 0 1-7.083-2.802 4.087 4.087 0 0 1 3.914-4.129"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fo)",
    d: "M110.338 306.792a3.876 3.876 0 0 1 .643 7.684 3.86 3.86 0 0 1-3.95-1.694 3.876 3.876 0 0 1 3.307-5.99"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fp)",
    d: "M216.868 156.487a4.743 4.743 0 1 1-1.768 9.154 4.74 4.74 0 0 1-1.635-7.735 4.74 4.74 0 0 1 3.403-1.419"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fq)",
    d: "M74.18.72h8.082c.93 0 1.206.339 1.206 1.186a5.34 5.34 0 0 1-5.226 5.124A5.29 5.29 0 0 1 73.1 1.821c.022-.741.233-1.143 1.08-1.101"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fr)",
    d: "M259.353 113.755a4.8 4.8 0 0 1 4.583 2.811 4.81 4.81 0 0 1-3.341 6.686 4.808 4.808 0 0 1-5.833-4.669 4.87 4.87 0 0 1 4.591-4.828"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fs)",
    d: "M323.546 28.058a5.12 5.12 0 0 1 4.738 3.183 5.13 5.13 0 0 1-1.149 5.595 5.12 5.12 0 0 1-5.608 1.056 5.12 5.12 0 0 1-3.102-4.795 5.162 5.162 0 0 1 5.121-5.04"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ft)",
    d: "M184.75 230.581a5.373 5.373 0 0 1 5.465 6.289 5.376 5.376 0 0 1-7.253 4.096 5.38 5.38 0 0 1-3.416-4.922 5.505 5.505 0 0 1 5.204-5.463"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fu)",
    d: "M56.978 401.616a5.09 5.09 0 0 1 4.705 3.19 5.11 5.11 0 0 1-1.167 5.567 5.097 5.097 0 0 1-8.658-3.76 5.146 5.146 0 0 1 5.12-4.997"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fv)",
    d: "M227.404 166.927a4.99 4.99 0 0 1 4.721 2.941 5.01 5.01 0 0 1-.926 5.488 4.99 4.99 0 0 1-8.619-3.326 5.078 5.078 0 0 1 4.824-5.103"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fw)",
    d: "M99.654 338.576a4.08 4.08 0 0 1 4.083 4.087 4.09 4.09 0 0 1-4.083 4.087 4.084 4.084 0 0 1-4.084-4.087 4.084 4.084 0 0 1 4.083-4.087"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fx)",
    d: "M152.76 263.826a4.236 4.236 0 1 1-1.302 8.167 4.23 4.23 0 0 1-2.676-3.931 4.235 4.235 0 0 1 3.978-4.236"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fy)",
    d: "M120.875 318.057a3.275 3.275 0 0 1 3.075 1.982 3.282 3.282 0 0 1-2.348 4.514 3.27 3.27 0 0 1-3.386-1.384 3.3 3.3 0 0 1-.557-1.83 3.326 3.326 0 0 1 3.216-3.282"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fz)",
    d: "M238.068 155.937a5.308 5.308 0 0 1 5.016 3.142 5.318 5.318 0 0 1-3.696 7.359 5.3 5.3 0 0 1-5.512-2.155 5.3 5.3 0 0 1-.95-2.946 5.45 5.45 0 0 1 1.501-3.72 5.43 5.43 0 0 1 3.641-1.68"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fA)",
    d: "M344.682 6.691a5.294 5.294 0 0 1 5.311 4.913 5.16 5.16 0 0 1-1.273 3.864 5.14 5.14 0 0 1-8.989-3.525 5.275 5.275 0 0 1 4.951-5.252"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fB)",
    d: "M46.272 413.284a4.088 4.088 0 0 1 0 8.173 4.087 4.087 0 0 1 0-8.173"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fC)",
    d: "M174.277 241.253a5.355 5.355 0 0 1 5.219 6.447 5.35 5.35 0 0 1-4.256 4.177 5.34 5.34 0 0 1-3.096-.344 5.36 5.36 0 0 1-3.241-5.007 5.458 5.458 0 0 1 5.374-5.273"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fD)",
    d: "M67.641 392.214a3.827 3.827 0 0 1 3.529 2.396 3.835 3.835 0 0 1-2.85 5.205 3.83 3.83 0 0 1-4.53-3.832 3.876 3.876 0 0 1 3.851-3.769"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fE)",
    d: "M110.296 328.221a3.83 3.83 0 0 1 3.545 3.822 3.837 3.837 0 0 1-3.545 3.823 3.84 3.84 0 0 1-2.89-1.013 3.85 3.85 0 0 1-1.224-2.81 3.83 3.83 0 0 1 4.114-3.822"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fF)",
    d: "M238.195 134.655a5.23 5.23 0 1 1-2.064 10.028 5.23 5.23 0 0 1-3.141-4.924 5.269 5.269 0 0 1 5.205-5.104"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fG)",
    d: "M312.86 38.645a5.183 5.183 0 0 1 5.101 6.22 5.183 5.183 0 0 1-10.263-1.116 5.267 5.267 0 0 1 5.162-5.103"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fH)",
    d: "M216.783 177.557a5.038 5.038 0 0 1 3.747 8.541 5.034 5.034 0 0 1-8.656-3.459 5.079 5.079 0 0 1 4.909-5.082"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fI)",
    d: "M163.655 251.989a5.355 5.355 0 0 1 5.168 6.489 5.354 5.354 0 0 1-7.383 3.774 5.36 5.36 0 0 1-3.201-5.032 5.463 5.463 0 0 1 5.416-5.231"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fJ)",
    d: "M248.88 124.131a5.1 5.1 0 0 1 4.762 3.121 5.11 5.11 0 0 1-1.093 5.591 5.096 5.096 0 0 1-7.872-.813 5.1 5.1 0 0 1-.833-2.859 5.122 5.122 0 0 1 5.036-5.04"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fK)",
    d: "M195.413 198.542a5.39 5.39 0 0 1 5.116 3.193 5.4 5.4 0 0 1-1.035 5.945 5.4 5.4 0 0 1-5.894 1.272 5.39 5.39 0 0 1-3.391-4.989 5.443 5.443 0 0 1 5.204-5.421"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fL)",
    d: "M291.533 82.458a4.08 4.08 0 0 1 3.792 2.518 4.088 4.088 0 0 1-2.992 5.58 4.082 4.082 0 0 1-4.862-4.054 4.231 4.231 0 0 1 4.062-4.044"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fM)",
    d: "M131.433 284.727a4.58 4.58 0 0 1 4.362 2.721 4.59 4.59 0 0 1-.893 5.066 4.591 4.591 0 0 1-7.891-3.213 4.597 4.597 0 0 1 4.422-4.574"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fN)",
    d: "M206.289 188.632a4.7 4.7 0 0 1 3.196 1.375 4.7 4.7 0 0 1 1.374 3.199 4.616 4.616 0 0 1-5.502 4.572 4.61 4.61 0 0 1-3.636-3.64 4.62 4.62 0 0 1 4.568-5.506"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fO)",
    d: "M131.559 307.956a2.71 2.71 0 0 1 2.534 1.649 2.71 2.71 0 0 1-.569 2.97 2.704 2.704 0 0 1-4.182-.414 2.7 2.7 0 0 1-.449-1.515 2.775 2.775 0 0 1 2.666-2.69"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fP)",
    d: "M302.26 50.461a4.06 4.06 0 0 1 3.721 2.535 4.07 4.07 0 0 1-.898 4.413 4.06 4.06 0 0 1-4.415.876 4.06 4.06 0 0 1-2.512-3.737 4.06 4.06 0 0 1 1.197-2.904 4.06 4.06 0 0 1 2.907-1.183"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fQ)",
    d: "M184.941 210.019a4.576 4.576 0 0 1 3.231 7.808 4.566 4.566 0 0 1-6.463 0 4.574 4.574 0 0 1 3.232-7.808"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fR)",
    d: "M280.849 93.278a3.93 3.93 0 0 1 3.67 2.412 3.95 3.95 0 0 1-.845 4.312 3.94 3.94 0 0 1-4.309.846 3.94 3.94 0 0 1-2.409-3.673 4 4 0 0 1 3.893-3.897"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fS)",
    d: "M334.125 17.745a4.76 4.76 0 0 1 4.458 2.882 4.77 4.77 0 0 1-.978 5.22 4.758 4.758 0 0 1-8.156-3.337 4.85 4.85 0 0 1 4.676-4.765"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fT)",
    d: "M270.101 102.956a4.928 4.928 0 0 1 4.982 5.778 4.932 4.932 0 0 1-6.639 3.754 4.936 4.936 0 0 1-3.146-4.493 5.02 5.02 0 0 1 4.803-5.039"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fU)",
    d: "M142.054 274.16a4.488 4.488 0 0 1 3.544 7.532 4.482 4.482 0 0 1-6.958-.463 4.492 4.492 0 0 1 3.414-7.069"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fV)",
    d: "M248.838 146.62a3.95 3.95 0 0 1 3.696 2.39 3.97 3.97 0 0 1-.798 4.331 3.96 3.96 0 0 1-4.305.914 3.96 3.96 0 0 1-2.486-3.633 4.045 4.045 0 0 1 3.893-4.002"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fW)",
    d: "M259.544 135.757a4.233 4.233 0 0 1 3.135 7.19 4.228 4.228 0 0 1-6.54-.592 4.237 4.237 0 0 1 .48-5.321 4.23 4.23 0 0 1 2.925-1.277"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fX)",
    d: "M312.861 61.007a4.23 4.23 0 0 1 3.501 4.171 4.232 4.232 0 1 1-8.067-1.789 4.236 4.236 0 0 1 4.566-2.382"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fY)",
    d: "M152.865 284.917a4.4 4.4 0 0 1 3.29 1.215 4.4 4.4 0 0 1 1.358 3.236 4.4 4.4 0 1 1-8.801-.106 4.41 4.41 0 0 1 4.153-4.345"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fZ)",
    d: "M195.562 221.412a3.87 3.87 0 0 1 3.592 2.377 3.874 3.874 0 0 1-6.789 3.653 3.9 3.9 0 0 1-.654-2.155 3.95 3.95 0 0 1 1.145-2.715 3.93 3.93 0 0 1 2.706-1.16"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ga)",
    d: "M206.31 210.04a4.575 4.575 0 0 1 4.199 2.873 4.577 4.577 0 0 1-3.418 6.2 4.565 4.565 0 0 1-4.668-2.024 4.57 4.57 0 0 1-.725-2.559 4.697 4.697 0 0 1 4.612-4.49"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gb)",
    d: "M142.287 295.315c1.234 0 2.418.49 3.291 1.364a4.661 4.661 0 0 1-3.291 7.953 4.658 4.658 0 0 1-3.292-7.953 4.65 4.65 0 0 1 3.292-1.364"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gc)",
    d: "M302.197 71.595a4.236 4.236 0 0 1 0 8.47 4.23 4.23 0 0 1-4.231-4.235 4.235 4.235 0 0 1 4.231-4.235"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gd)",
    d: "M344.661 28.121a5.05 5.05 0 0 1 4.811 2.954 5.07 5.07 0 0 1-.92 5.574 5.052 5.052 0 0 1-7.826-.573 5.07 5.07 0 0 1-.91-2.81 5.15 5.15 0 0 1 1.4-3.537 5.14 5.14 0 0 1 3.445-1.608"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ge)",
    d: "M184.813 252.603a4.69 4.69 0 0 1 4.393 2.787c.376.846.495 1.784.341 2.697a4.696 4.696 0 0 1-9.325-.592 4.783 4.783 0 0 1 4.591-4.892"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gf)",
    d: "M163.445 274.075a4.57 4.57 0 0 1 4.583 5.368 4.573 4.573 0 0 1-6.141 3.475 4.58 4.58 0 0 1-2.928-4.142 4.678 4.678 0 0 1 4.486-4.701"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gg)",
    d: "M334.272 39.26a4.59 4.59 0 0 1 4.198 2.885 4.6 4.6 0 0 1-1.045 4.988 4.59 4.59 0 0 1-5.002.954 4.59 4.59 0 0 1-2.806-4.254 4.7 4.7 0 0 1 1.405-3.227 4.7 4.7 0 0 1 3.25-1.346"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gh)",
    d: "M238.237 178.404a4.232 4.232 0 0 1 4.15 5.062 4.232 4.232 0 0 1-7.668 1.526 4.236 4.236 0 0 1 3.518-6.588"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gi)",
    d: "M78.178 403.458a3.256 3.256 0 0 1 3.314 3.83 3.26 3.26 0 0 1-2.533 2.62 3.26 3.26 0 0 1-3.934-3.189 3.302 3.302 0 0 1 3.152-3.261"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gj)",
    d: "M110.338 348.592a4.763 4.763 0 0 1 3.273 8.163 4.757 4.757 0 0 1-7.309-.773 4.77 4.77 0 0 1-.788-2.646 4.893 4.893 0 0 1 4.824-4.744"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gk)",
    d: "M56.767 422.94A5.12 5.12 0 0 1 62 428.942a5.13 5.13 0 0 1-3.973 4.13 5.12 5.12 0 0 1-6.191-5.008 5.244 5.244 0 0 1 4.93-5.124"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl)",
    d: "M131.707 327.988a4.025 4.025 0 0 1 3.695 2.489 4.03 4.03 0 0 1-.866 4.372 4.018 4.018 0 0 1-6.87-2.795 4.09 4.09 0 0 1 4.041-4.066"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gm)",
    d: "M120.896 339.91a2.77 2.77 0 0 1 2.582 1.664 2.78 2.78 0 0 1-.537 3.026 2.767 2.767 0 0 1-4.263-.309 2.78 2.78 0 0 1-.511-1.522 2.813 2.813 0 0 1 2.729-2.859"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gn)",
    d: "M216.974 199.686a4.23 4.23 0 0 1 3.909 2.614 4.24 4.24 0 0 1-.917 4.615 4.22 4.22 0 0 1-4.612.918 4.23 4.23 0 0 1-2.612-3.912 4.355 4.355 0 0 1 4.232-4.235"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#go)",
    d: "M67.6 413.072a4.23 4.23 0 0 1 4.15 5.061 4.24 4.24 0 0 1-3.325 3.328 4.24 4.24 0 0 1-4.344-1.801 4.24 4.24 0 0 1-.713-2.353 4.38 4.38 0 0 1 4.232-4.235"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gp)",
    d: "M280.807 114.348a4.22 4.22 0 0 1 2.327.702 4.236 4.236 0 0 1-3.805 7.504 4.24 4.24 0 0 1-2.754-3.759 4.4 4.4 0 0 1 1.208-3.089 4.38 4.38 0 0 1 3.024-1.358"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gq)",
    d: "M227.489 189.437a3.83 3.83 0 0 1 3.581 2.274 3.831 3.831 0 0 1-4.842 5.147 3.83 3.83 0 0 1-2.484-3.44 3.92 3.92 0 0 1 3.745-3.981"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gr)",
    d: "M270.122 124.025a5.2 5.2 0 0 1 4.855 3.129 5.215 5.215 0 0 1-1.018 5.688 5.195 5.195 0 0 1-5.637 1.248 5.2 5.2 0 0 1-3.32-4.728 5.31 5.31 0 0 1 5.12-5.337"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gs)",
    d: "M291.534 103.506a4.375 4.375 0 0 1 4.05 2.668 4.382 4.382 0 0 1-5.628 5.797 4.385 4.385 0 0 1-2.78-3.976 4.466 4.466 0 0 1 4.358-4.489"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt)",
    d: "M174.15 263.445a4.5 4.5 0 0 1 4.236 2.705 4.515 4.515 0 0 1-.898 4.948 4.51 4.51 0 0 1-4.917 1.04 4.51 4.51 0 0 1-2.821-4.161 4.616 4.616 0 0 1 4.4-4.532"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gu)",
    d: "M323.482 49.657a4.868 4.868 0 0 1 4.833 5.829 4.87 4.87 0 0 1-3.877 3.828 4.86 4.86 0 0 1-4.997-2.168 4.88 4.88 0 0 1-.762-2.746 4.98 4.98 0 0 1 1.475-3.312 4.97 4.97 0 0 1 3.328-1.431"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gv)",
    d: "M105.747 1.673a6.16 6.16 0 0 1-6.146 5.8c-1.57 0-3.082-.6-4.224-1.678a6.16 6.16 0 0 1-1.922-4.122c0-.91.169-1.461 1.015-1.567h10.177c.825.021 1.143.487 1.1 1.567"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gw)",
    d: "M127.265 1.08a6.36 6.36 0 0 1-1.822 4.507 6.344 6.344 0 0 1-8.976.075 6.35 6.35 0 0 1-1.897-4.476c0-.593.148-.953.444-1.144h11.828a1.32 1.32 0 0 1 .423 1.038"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gx)",
    d: "M259.522 156.699a4.633 4.633 0 0 1 4.591 5.524 4.634 4.634 0 0 1-9.182-.907 4.66 4.66 0 0 1 4.591-4.617"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gy)",
    d: "M138.054.19c1.355.106 2.73 0 4.105 0h4.232c1.079 0 1.333.382 1.333 1.377a5.7 5.7 0 0 1-1.621 3.9 5.7 5.7 0 0 1-3.859 1.712 5.713 5.713 0 0 1-5.671-5.421c-.042-1.229.339-1.652 1.481-1.567"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gz)",
    d: "M142.18 317.125a4.23 4.23 0 0 1 3.984 2.54 4.236 4.236 0 0 1-3.013 5.84 4.23 4.23 0 0 1-5.097-4.145 4.236 4.236 0 0 1 4.126-4.235"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gA)",
    d: "M355.536 17.703a4.8 4.8 0 0 1 4.428 2.948 4.81 4.81 0 0 1-1.003 5.228 4.8 4.8 0 0 1-5.205 1.095 4.805 4.805 0 0 1-3.023-4.38 4.866 4.866 0 0 1 4.803-4.892"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gB)",
    d: "M195.414 241.719a4.9 4.9 0 0 1 2.763.739 4.92 4.92 0 0 1 2.245 4.993 4.91 4.91 0 0 1-9.747-.734 5 5 0 0 1 4.739-4.998"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gC)",
    d: "M312.84 82.33a4.23 4.23 0 0 1 3.909 2.615 4.24 4.24 0 0 1-.917 4.615 4.232 4.232 0 0 1-7.224-2.994 4.235 4.235 0 0 1 4.232-4.235"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gD)",
    d: "M152.865 306.368a4.232 4.232 0 0 1 4.15 5.061 4.231 4.231 0 0 1-8.381-.826 4.34 4.34 0 0 1 4.231-4.235"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gE)",
    d: "M248.88 166.8a5.1 5.1 0 0 1 4.73 3.146 5.104 5.104 0 0 1-6.685 6.662 5.1 5.1 0 0 1-3.123-4.747 5.21 5.21 0 0 1 5.078-5.061"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gF)",
    d: "M302.092 91.987a5.22 5.22 0 0 1 4.913 3.13 5.236 5.236 0 0 1-1.031 5.737 5.23 5.23 0 0 1-5.696 1.218 5.23 5.23 0 0 1-3.285-4.813 5.316 5.316 0 0 1 5.099-5.272"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gG)",
    d: "M206.204 230.814a5.13 5.13 0 0 1 4.784 3.157 5.144 5.144 0 0 1-6.729 6.734 5.15 5.15 0 0 1-3.154-4.788 5.17 5.17 0 0 1 5.099-5.103"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gH)",
    d: "M366.03 6.924a4.885 4.885 0 0 1 4.623 2.876 4.89 4.89 0 0 1-.902 5.373 4.89 4.89 0 0 1-5.308 1.205 4.89 4.89 0 0 1-3.131-4.456 4.95 4.95 0 0 1 4.718-4.997"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gI)",
    d: "M170.066 1.673a6.67 6.67 0 0 1-6.347 5.993 6.628 6.628 0 0 1-6.622-5.93 2.29 2.29 0 0 1 .275-1.694h12.419a2.1 2.1 0 0 1 .275 1.63"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gJ)",
    d: "M99.569 403.246a3.456 3.456 0 0 1 2.438 5.893 3.445 3.445 0 0 1-4.877 0 3.456 3.456 0 0 1 0-4.882 3.45 3.45 0 0 1 2.439-1.011"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gK)",
    d: "M78.22 446.656a2.752 2.752 0 1 1-2.219 4.289 2.76 2.76 0 0 1-.468-1.536 2.7 2.7 0 0 1 .764-1.943 2.7 2.7 0 0 1 1.923-.81"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gL)",
    d: "M355.43 60.33a4.865 4.865 0 0 1 4.569 2.926 4.875 4.875 0 0 1-.977 5.34 4.866 4.866 0 0 1-8.352-3.375 4.74 4.74 0 0 1 2.905-4.523 4.7 4.7 0 0 1 1.855-.369"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gM)",
    d: "M248.837 210.697a3.918 3.918 0 1 1-1.42 7.542 3.916 3.916 0 0 1-2.431-3.625 3.833 3.833 0 0 1 3.851-3.917"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gN)",
    d: "M227.532 210.57a4.03 4.03 0 0 1 3.761 2.462 4.04 4.04 0 0 1-.839 4.419 4.037 4.037 0 0 1-6.227-.57 4.05 4.05 0 0 1-.694-2.245 4.02 4.02 0 0 1 1.155-2.865 4.02 4.02 0 0 1 2.844-1.201"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gO)",
    d: "M334.082 82.585a4.06 4.06 0 0 1 4.126 4.778 4.063 4.063 0 0 1-7.367 1.559 4.07 4.07 0 0 1-.694-2.272 4 4 0 0 1 1.12-2.855 3.98 3.98 0 0 1 2.815-1.21"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gP)",
    d: "M238.385 199.05a4.86 4.86 0 0 1 3.398 1.488 4.862 4.862 0 0 1 .947 5.305 4.85 4.85 0 0 1-4.536 2.906 4.76 4.76 0 0 1-4.802-4.934 4.804 4.804 0 0 1 4.993-4.765"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gQ)",
    d: "M163.592 298.088a1.906 1.906 0 1 1-1.594 2.95 1.9 1.9 0 0 1-.31-1.065 1.885 1.885 0 0 1 1.904-1.885"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gR)",
    d: "M259.48 199.601a4.23 4.23 0 0 1 3.891 2.578 4.24 4.24 0 0 1-.844 4.592 4.23 4.23 0 0 1-4.553 1.024 4.23 4.23 0 0 1-2.726-3.79 4.24 4.24 0 0 1 2.572-4.066 4.2 4.2 0 0 1 1.66-.338"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gS)",
    d: "M376.948 18.296a4.23 4.23 0 0 1 3.91 2.614 4.23 4.23 0 0 1-.918 4.616 4.225 4.225 0 0 1-4.611.918 4.23 4.23 0 0 1-2.612-3.913 4.1 4.1 0 0 1 1.2-3.034 4.1 4.1 0 0 1 3.031-1.201"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gT)",
    d: "M387.569 7.75a3.97 3.97 0 0 1 3.789 2.624c.187.515.266 1.064.231 1.611a4.067 4.067 0 0 1-4.063 4.066 4.06 4.06 0 0 1-4.062-4.066 3.96 3.96 0 0 1 4.105-4.235"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gU)",
    d: "M227.532 231.809a4.233 4.233 0 0 1 3.1 7.243 4.228 4.228 0 0 1-6.566-.767 4.23 4.23 0 0 1-.639-2.41 4.06 4.06 0 0 1 1.198-2.897 4.1 4.1 0 0 1 1.336-.878 4.1 4.1 0 0 1 1.571-.291"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gV)",
    d: "M302.239 114.348a4.234 4.234 0 1 1-2.992 7.23 4.235 4.235 0 0 1 2.992-7.23"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gW)",
    d: "M344.957 71.086a4.78 4.78 0 0 1 4.371 3.054 4.79 4.79 0 0 1-1.169 5.205 4.78 4.78 0 0 1-7.351-.948 4.8 4.8 0 0 1-.717-2.694 4.677 4.677 0 0 1 4.866-4.617"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gX)",
    d: "M323.503 71.404a4.469 4.469 0 1 1-1.8 8.668 4.46 4.46 0 0 1-2.602-2.43 4.47 4.47 0 0 1 4.402-6.238"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gY)",
    d: "M184.919 296.458a3.512 3.512 0 0 1 3.439 4.225 3.51 3.51 0 0 1-2.793 2.745 3.51 3.51 0 0 1-3.597-1.548 3.5 3.5 0 0 1-.561-1.97 3.438 3.438 0 0 1 2.169-3.214 3.45 3.45 0 0 1 1.343-.238"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gZ)",
    d: "M280.955 157.271a3.97 3.97 0 0 1 3.627 2.496 3.983 3.983 0 0 1-2.925 5.391 3.978 3.978 0 0 1-4.743-3.885 3.876 3.876 0 0 1 4.041-4.002"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ha)",
    d: "M120.875 360.133a3.893 3.893 0 0 1 3.892 4.601 3.9 3.9 0 0 1-3.02 3.106 3.894 3.894 0 0 1-4.702-3.768 3.84 3.84 0 0 1 1.084-2.779 3.8 3.8 0 0 1 1.255-.859 3.8 3.8 0 0 1 1.491-.301"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hb)",
    d: "M174.192 284.197a5.13 5.13 0 0 1 2.858.83 5.13 5.13 0 0 1 2.238 5.24 5.123 5.123 0 0 1-6.947 3.807 5.12 5.12 0 0 1-3.205-4.71 5.09 5.09 0 0 1 3.1-4.766 5.1 5.1 0 0 1 1.956-.401"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hc)",
    d: "M195.477 285.383a3.94 3.94 0 0 1 2.213.61 3.95 3.95 0 0 1 1.767 4.022 3.94 3.94 0 0 1-3.053 3.157 3.93 3.93 0 0 1-4.756-3.829 3.853 3.853 0 0 1 3.829-3.96"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hd)",
    d: "M67.705 434.226a4.508 4.508 0 0 1 4.315 5.481 4.51 4.51 0 0 1-3.617 3.471 4.5 4.5 0 0 1-4.587-2.022 4.5 4.5 0 0 1-.702-2.525 4.47 4.47 0 0 1 4.591-4.405"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#he)",
    d: "M270.228 168.092a3.8 3.8 0 0 1 2.693 1.116 3.81 3.81 0 0 1 .825 4.154 3.807 3.807 0 0 1-6.211 1.236 3.813 3.813 0 0 1 2.693-6.506"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hf)",
    d: "M89.011 433.739a4.997 4.997 0 1 1-2.048 9.583 5 5 0 0 1-3.009-4.67 4.9 4.9 0 0 1 1.484-3.534 4.88 4.88 0 0 1 3.573-1.379"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hg)",
    d: "M334.294 61.41a3.765 3.765 0 0 1 3.588 4.594 3.77 3.77 0 0 1-3.036 2.888 3.764 3.764 0 0 1-4.403-3.82 3.746 3.746 0 0 1 3.851-3.663"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hh)",
    d: "M366.263 29.392a3.785 3.785 0 0 1 3.451 2.378 3.787 3.787 0 1 1-7.302 1.433 3.684 3.684 0 0 1 3.851-3.811"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hi)",
    d: "M152.654 328.221a3.705 3.705 0 0 1 3.015 6.162 3.696 3.696 0 0 1-3.999 1.029 3.71 3.71 0 0 1-2.465-3.316 3.629 3.629 0 0 1 2.056-3.528 3.6 3.6 0 0 1 1.393-.347"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hj)",
    d: "M312.924 104.036a3.85 3.85 0 0 1 3.714 4.687 3.85 3.85 0 0 1-3.116 2.966 3.845 3.845 0 0 1-3.918-1.772 3.85 3.85 0 0 1-.573-2.176 3.77 3.77 0 0 1 1.17-2.67 3.77 3.77 0 0 1 2.723-1.035"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hk)",
    d: "M355.599 39.704a4.23 4.23 0 0 1 3.921 2.645 4.24 4.24 0 0 1-3.176 5.759 4.23 4.23 0 0 1-4.326-1.91 4.24 4.24 0 0 1-.65-2.386 4.1 4.1 0 0 1 1.24-2.957 4.08 4.08 0 0 1 2.991-1.15"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hl)",
    d: "M238.279 220.226a5.07 5.07 0 0 1 4.672 3.197 5.09 5.09 0 0 1-1.186 5.538 5.077 5.077 0 0 1-8.606-3.78 4.95 4.95 0 0 1 1.51-3.565 4.96 4.96 0 0 1 3.61-1.39"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hm)",
    d: "M323.292 92.24a4.97 4.97 0 0 1 4.726 2.822 4.975 4.975 0 0 1-.767 5.454 4.967 4.967 0 0 1-7.658-.27 4.97 4.97 0 0 1-1.019-2.69 4.87 4.87 0 0 1 4.718-5.315"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hn)",
    d: "M280.849 135.693a4.234 4.234 0 0 1 2.992 7.23 4.236 4.236 0 0 1-6.511-.642 4.236 4.236 0 0 1 3.519-6.588"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ho)",
    d: "M301.859 135.672a4.23 4.23 0 0 1 4.129 2.276 4.23 4.23 0 0 1-.536 4.687 4.23 4.23 0 0 1-7.444-2.432 4.236 4.236 0 0 1 3.851-4.531"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hp)",
    d: "M184.898 274.838a3.802 3.802 0 0 1 3.544 2.369 3.81 3.81 0 0 1-5.065 4.928 3.817 3.817 0 0 1-2.266-3.613 3.763 3.763 0 0 1 3.787-3.684"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hq)",
    d: "M206.226 274.817a3.8 3.8 0 0 1 2.693 1.116 3.81 3.81 0 0 1 .825 4.154 3.82 3.82 0 0 1-2.061 2.063 3.806 3.806 0 0 1-4.15-.827 3.813 3.813 0 0 1 2.693-6.506"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hr)",
    d: "M216.868 220.861a4.43 4.43 0 0 1 4.113 2.698 4.428 4.428 0 0 1-3.18 6.063 4.43 4.43 0 0 1-2.559-.236 4.428 4.428 0 0 1 1.626-8.525"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hs)",
    d: "M312.882 125.486a3.75 3.75 0 0 1 3.465 2.329 3.745 3.745 0 0 1-.841 4.092 3.74 3.74 0 0 1-4.102.772 3.74 3.74 0 0 1-2.267-3.508 3.66 3.66 0 0 1 3.745-3.685"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ht)",
    d: "M291.597 125.19c.8.008 1.58.254 2.24.707a4.042 4.042 0 0 1 .537 6.234 4.04 4.04 0 0 1-6.213-.7 4.05 4.05 0 0 1-.647-2.26 4.014 4.014 0 0 1 1.208-2.847 4 4 0 0 1 2.875-1.134"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hu)",
    d: "M366.242 49.868a4.65 4.65 0 0 1 4.275 2.92 4.657 4.657 0 0 1-6.153 6.02 4.66 4.66 0 0 1-2.819-4.344 4.54 4.54 0 0 1 1.368-3.301 4.55 4.55 0 0 1 3.329-1.295"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hv)",
    d: "M344.767 49.572a4.95 4.95 0 0 1 4.632 2.952 4.96 4.96 0 0 1-.94 5.415 4.95 4.95 0 0 1-8.537-3.264 4.866 4.866 0 0 1 4.845-5.103"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hw)",
    d: "M78.432 423.109a4.937 4.937 0 0 1-.19 9.868 4.941 4.941 0 0 1-4.835-5.029 4.94 4.94 0 0 1 3.131-4.5 4.9 4.9 0 0 1 1.894-.339"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hx)",
    d: "M259.458 178.192a4.404 4.404 0 1 1-1.488 8.482 4.4 4.4 0 0 1-2.743-4.098 4.3 4.3 0 0 1 .278-1.667 4.25 4.25 0 0 1 2.299-2.381 4.2 4.2 0 0 1 1.654-.336"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hy)",
    d: "M99.612 423.723a4.23 4.23 0 0 1 3.833 2.687 4.237 4.237 0 0 1-3.152 5.708 4.232 4.232 0 0 1-4.687-5.805 4.23 4.23 0 0 1 2.354-2.298 4.2 4.2 0 0 1 1.652-.292"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hz)",
    d: "M270.249 146.831a3.73 3.73 0 0 1 3.427 2.321 3.73 3.73 0 0 1-.831 4.056 3.717 3.717 0 0 1-5.725-.597 3.73 3.73 0 0 1-.616-2.074 3.75 3.75 0 0 1 3.745-3.706"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hA)",
    d: "M291.428 145.815a4.76 4.76 0 0 1 4.483 2.842 4.773 4.773 0 0 1-.93 5.229 4.758 4.758 0 0 1-7.354-.616 4.76 4.76 0 0 1-.832-2.648 4.63 4.63 0 0 1 1.295-3.389 4.65 4.65 0 0 1 1.525-1.05 4.65 4.65 0 0 1 1.813-.368"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hB)",
    d: "M195.583 263.466a4.5 4.5 0 0 1 4.16 2.775 4.512 4.512 0 0 1-3.255 6.154 4.5 4.5 0 0 1-4.631-1.882 4.5 4.5 0 0 1-.78-2.494 4.427 4.427 0 0 1 4.506-4.553"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hC)",
    d: "M163.444 318.841a2.49 2.49 0 0 1 2.327 1.494 2.497 2.497 0 0 1-1.732 3.44 2.49 2.49 0 0 1-2.585-.982 2.5 2.5 0 0 1-.464-1.369 2.4 2.4 0 0 1 .149-.979 2.44 2.44 0 0 1 1.335-1.406c.307-.131.637-.199.97-.198"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hD)",
    d: "M131.475 348.317a5.03 5.03 0 0 1 4.723 2.985 5.045 5.045 0 0 1-.935 5.511 5.036 5.036 0 0 1-8.696-3.287 4.98 4.98 0 0 1 1.349-3.647 4.97 4.97 0 0 1 3.559-1.562"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hE)",
    d: "M216.889 242.037a4.59 4.59 0 0 1 4.245 2.798 4.6 4.6 0 0 1-.935 5.001 4.586 4.586 0 0 1-7.054-.573 4.6 4.6 0 0 1-.826-2.525 4.47 4.47 0 0 1 2.773-4.372 4.4 4.4 0 0 1 1.797-.329"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hF)",
    d: "M206.078 252.243a5.05 5.05 0 0 1 3.607 1.364 5.04 5.04 0 0 1 1.587 3.517 5.04 5.04 0 0 1-1.363 3.611 5.048 5.048 0 0 1-3.514 1.588 5.042 5.042 0 0 1-.317-10.08"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hG)",
    d: "M174.235 307.046a3.59 3.59 0 0 1 3.329 2.188 3.605 3.605 0 0 1-.729 3.92 3.594 3.594 0 0 1-5.528-.445 3.6 3.6 0 0 1-.648-1.979 3.52 3.52 0 0 1 .989-2.619 3.5 3.5 0 0 1 2.587-1.065"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hH)",
    d: "M141.927 338.809c.761-.063 1.523.1 2.192.469a3.875 3.875 0 0 1 1.977 3.812 3.87 3.87 0 0 1-4.992 3.283 3.87 3.87 0 0 1-2.711-3.329 3.794 3.794 0 0 1 3.534-4.235"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hI)",
    d: "M89.054 413.072a4.23 4.23 0 0 1 3.77 2.742 4.24 4.24 0 0 1-1.035 4.548 4.22 4.22 0 0 1-4.586.836 4.24 4.24 0 0 1 .173-7.86 4.2 4.2 0 0 1 1.678-.266"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hJ)",
    d: "M248.901 189.564a3.58 3.58 0 0 1 2.583 1.009 3.6 3.6 0 0 1 1.098 2.548 3.707 3.707 0 0 1-4.338 3.799 3.7 3.7 0 0 1-2.984-2.884 3.705 3.705 0 0 1 3.641-4.472"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hK)",
    d: "M190.843 1.758a6.072 6.072 0 0 1-5.882 5.548 6.12 6.12 0 0 1-5.987-5.442c0-.89 0-1.546.592-1.822h10.727c.55.276.656.89.55 1.716"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hL)",
    d: "M259.459 220.904a4.382 4.382 0 0 1 4.459 5.151 4.377 4.377 0 0 1-7.952 1.666 4.4 4.4 0 0 1-.739-2.455 4.405 4.405 0 0 1 4.232-4.362"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hM)",
    d: "M398.296 18.613a3.89 3.89 0 0 1 3.554 2.454 3.9 3.9 0 0 1-.894 4.227 3.892 3.892 0 0 1-6.616-2.806 3.88 3.88 0 0 1 3.956-3.875"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hN)",
    d: "M408.684 7.03a4.802 4.802 0 0 1 4.902 5.621 4.8 4.8 0 0 1-3.706 3.879 4.8 4.8 0 0 1-4.986-1.975 4.8 4.8 0 0 1-.843-2.675 4.781 4.781 0 0 1 4.633-4.85"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hO)",
    d: "M280.892 178.489a4.1 4.1 0 0 1 3.79 2.531 4.11 4.11 0 0 1-2.977 5.603 4.1 4.1 0 0 1-4.216-1.728 4.1 4.1 0 0 1-.702-2.277 4.06 4.06 0 0 1 1.182-2.931 4.06 4.06 0 0 1 2.923-1.198"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hP)",
    d: "M291.343 167.965a3.95 3.95 0 0 1 3.766 2.237 3.957 3.957 0 0 1-4.835 5.468 3.96 3.96 0 0 1-2.676-3.47 3.94 3.94 0 0 1 .977-2.911 3.9 3.9 0 0 1 1.25-.943 3.9 3.9 0 0 1 1.518-.381"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hQ)",
    d: "M270.185 209.829a4.785 4.785 0 0 1 4.457 2.95 4.786 4.786 0 0 1-3.533 6.539 4.78 4.78 0 0 1-4.907-2.118 4.8 4.8 0 0 1-.756-2.691 4.825 4.825 0 0 1 4.739-4.68"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hR)",
    d: "M163.445 338.661a4.02 4.02 0 0 1 3.767 2.41 4.03 4.03 0 0 1-.789 4.404 4.02 4.02 0 0 1-6.914-2.727 3.96 3.96 0 0 1 2.398-3.768 3.95 3.95 0 0 1 1.538-.319"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hS)",
    d: "M270.143 189.14a4.128 4.128 0 1 1-3.288 6.508 4.13 4.13 0 0 1-.753-2.273 4.05 4.05 0 0 1 2.45-3.91 4.05 4.05 0 0 1 1.591-.325"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hT)",
    d: "M376.757 62.32a2.87 2.87 0 0 1 2.73 1.697 2.88 2.88 0 0 1-2.01 3.994 2.875 2.875 0 0 1-2.988-1.186 2.9 2.9 0 0 1-.504-1.604 2.898 2.898 0 0 1 2.772-2.901"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hU)",
    d: "M174.256 327.946a4.06 4.06 0 0 1 3.751 2.505 4.07 4.07 0 0 1-.871 4.428 4.06 4.06 0 0 1-4.42.895 4.07 4.07 0 0 1-2.522-3.741 4.01 4.01 0 0 1 1.169-2.901 4.03 4.03 0 0 1 2.893-1.186"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hV)",
    d: "M110.233 415.168a2.12 2.12 0 0 1 1.939 1.281 2.116 2.116 0 1 1-2.779-1.108c.265-.115.551-.173.84-.173"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hW)",
    d: "M355.642 81.907a4.61 4.61 0 0 1 4.406 5.572 4.62 4.62 0 0 1-3.637 3.576 4.61 4.61 0 0 1-4.707-1.963 4.6 4.6 0 0 1-.78-2.547 4.64 4.64 0 0 1 1.387-3.31 4.63 4.63 0 0 1 3.331-1.328"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hX)",
    d: "M323.44 135.27a4.61 4.61 0 0 1 4.311 2.73 4.6 4.6 0 0 1 .339 2.645 4.61 4.61 0 0 1-8.27 1.967 4.6 4.6 0 0 1-.887-2.514 4.68 4.68 0 0 1 4.507-4.828"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hY)",
    d: "M376.821 40.085a3.74 3.74 0 0 1 3.488 2.28 3.747 3.747 0 0 1-6.546 3.57 3.75 3.75 0 0 1-.644-2.08 3.703 3.703 0 0 1 3.702-3.77"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hZ)",
    d: "M344.703 93.342a3.87 3.87 0 0 1 3.992 4.454 3.88 3.88 0 0 1-2.894 3.178 3.87 3.87 0 0 1-4.043-1.452 3.9 3.9 0 0 1-.758-2.114 3.857 3.857 0 0 1 2.225-3.71 3.85 3.85 0 0 1 1.478-.356"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ia)",
    d: "M227.637 252.836a4.467 4.467 0 0 1 3.056 7.664 4.461 4.461 0 0 1-6.856-.751 4.47 4.47 0 0 1-.727-2.487 4.427 4.427 0 0 1 4.527-4.426"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ib)",
    d: "M184.877 318.798a2.54 2.54 0 0 1 2.379 2.472 2.54 2.54 0 0 1-3.293 2.491 2.544 2.544 0 0 1-.12-4.812c.33-.122.683-.173 1.034-.151"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic)",
    d: "M110.36 435.094a3.643 3.643 0 1 1-1.497 6.999 3.637 3.637 0 0 1-1.125-5.956 3.65 3.65 0 0 1 2.622-1.043"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#id)",
    d: "M195.54 307.49a3.15 3.15 0 0 1 2.932 1.943 3.16 3.16 0 0 1-.689 3.451 3.152 3.152 0 0 1-5.374-2.281 3.177 3.177 0 0 1 3.131-3.113"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ie)",
    d: "M323.503 114.899a3.657 3.657 0 0 1 3.41 2.227 3.665 3.665 0 0 1-2.625 5.023 3.65 3.65 0 0 1-3.772-1.532 3.66 3.66 0 0 1-.63-2.034 3.611 3.611 0 0 1 1.03-2.608 3.6 3.6 0 0 1 2.587-1.076"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#if)",
    d: "M334.082 102.934a4.934 4.934 0 1 1-1.669 9.537 4.94 4.94 0 0 1-3.155-4.476 4.9 4.9 0 0 1 .329-1.902 4.92 4.92 0 0 1 2.612-2.741 4.9 4.9 0 0 1 1.883-.418"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ig)",
    d: "M216.72 263.551a4.426 4.426 0 1 1-1.341 8.575 4.425 4.425 0 0 1-2.89-3.98 4.35 4.35 0 0 1 1.147-3.191 4.35 4.35 0 0 1 3.084-1.404"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ih)",
    d: "M99.675 446.021a3.36 3.36 0 0 1 3.06 2.117 3.367 3.367 0 0 1-2.477 4.554 3.367 3.367 0 0 1-4.01-3.283 3.41 3.41 0 0 1 2.122-3.137 3.4 3.4 0 0 1 1.305-.251"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ii)",
    d: "M248.795 231.47a4.46 4.46 0 0 1 4.175 2.639 4.47 4.47 0 0 1-3.036 6.174 4.46 4.46 0 0 1-4.636-1.701 4.47 4.47 0 0 1-.861-2.432 4.48 4.48 0 0 1 1.2-3.253 4.49 4.49 0 0 1 3.158-1.427"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ij)",
    d: "M238.11 242.46a4.23 4.23 0 0 1 4.043 2.478 4.238 4.238 0 0 1-2.954 5.892 4.24 4.24 0 0 1-4.401-1.763 4.24 4.24 0 0 1 .442-5.301 4.23 4.23 0 0 1 2.87-1.306"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ik)",
    d: "M302.282 157.292a3.94 3.94 0 1 1-1.628 7.553 3.939 3.939 0 0 1 1.628-7.553"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#il)",
    d: "M365.966 71.277a4.592 4.592 0 0 1 4.768 5.302 4.6 4.6 0 0 1-3.487 3.76 4.59 4.59 0 0 1-4.409-7.593 4.6 4.6 0 0 1 3.128-1.469"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#im)",
    d: "M206.183 297.114a2.88 2.88 0 0 1 2.708 1.743 2.88 2.88 0 0 1-.602 3.165 2.88 2.88 0 0 1-3.158.626 2.88 2.88 0 0 1-1.762-2.696 2.88 2.88 0 0 1 2.814-2.838"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#in)",
    d: "M312.946 146.831a3.748 3.748 0 1 1-1.497 7.211 3.74 3.74 0 0 1-2.312-3.441 3.745 3.745 0 0 1 2.351-3.501 3.8 3.8 0 0 1 1.458-.269"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#io)",
    d: "M387.464 28.502a4.67 4.67 0 0 1 4.376 2.875 4.684 4.684 0 0 1-3.457 6.405 4.67 4.67 0 0 1-4.802-2.087 4.7 4.7 0 0 1-.73-2.64 4.61 4.61 0 0 1 4.613-4.553"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ip)",
    d: "M216.804 284.578a4.74 4.74 0 0 1 4.765 5.61 4.74 4.74 0 0 1-3.708 3.779 4.74 4.74 0 0 1-5.69-4.666 4.79 4.79 0 0 1 4.633-4.723"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iq)",
    d: "M211.917 1.292a5.693 5.693 0 0 1-8.92 4.668 5.7 5.7 0 0 1-2.294-3.313c-.254-1.27-.254-2.266.635-2.605h9.923c.487.149.635.572.656 1.25"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ir)",
    d: "M238.258 263.403a4.574 4.574 0 1 1-1.804 8.785 4.565 4.565 0 0 1-2.787-4.254 4.657 4.657 0 0 1 4.591-4.531"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#is)",
    d: "M291.491 188.886a4.38 4.38 0 0 1 4.463 5.129 4.38 4.38 0 0 1-3.379 3.534 4.375 4.375 0 0 1-4.545-1.799 4.4 4.4 0 0 1-.771-2.438 4.505 4.505 0 0 1 4.232-4.426"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#it)",
    d: "M344.682 113.713a4.84 4.84 0 0 1 4.59 2.821 4.845 4.845 0 0 1-.851 5.323 4.84 4.84 0 0 1-5.241 1.246 4.85 4.85 0 0 1-3.152-4.372 4.93 4.93 0 0 1 4.654-5.018"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iu)",
    d: "M387.505 51.88a2.646 2.646 0 1 1-2.623 2.605 2.69 2.69 0 0 1 2.623-2.605"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iv)",
    d: "M184.962 339.084a3.6 3.6 0 0 1 .591 7.143 3.6 3.6 0 0 1-3.668-1.609 3.6 3.6 0 0 1-.562-2.018 3.68 3.68 0 0 1 3.639-3.516"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iw)",
    d: "M227.531 274.372a4.235 4.235 0 1 1-1.619 8.148 4.24 4.24 0 0 1-2.612-3.913 4.231 4.231 0 0 1 4.231-4.235"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ix)",
    d: "M174.214 349.969a3.389 3.389 0 1 1-1.258 6.516 3.395 3.395 0 0 1-2.085-3.149 3.45 3.45 0 0 1 3.343-3.367"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iy)",
    d: "M334.125 124.936a4.23 4.23 0 0 1 3.896 2.586 4.237 4.237 0 0 1-2.996 5.787 4.23 4.23 0 0 1-5.132-4.011 4.426 4.426 0 0 1 4.232-4.362"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iz)",
    d: "M408.875 28.396a4.78 4.78 0 0 1 4.446 2.92 4.79 4.79 0 0 1-3.442 6.554 4.78 4.78 0 0 1-5.743-4.667 4.91 4.91 0 0 1 4.739-4.807"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iA)",
    d: "M120.917 423.257a4.803 4.803 0 0 1 4.729 5.755 4.802 4.802 0 0 1-9.511-1.011 4.89 4.89 0 0 1 4.782-4.744"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iB)",
    d: "M280.87 200.13a3.81 3.81 0 0 1 3.755 4.558 3.82 3.82 0 0 1-3.009 2.996 3.81 3.81 0 0 1-4.533-3.784 3.9 3.9 0 0 1 3.787-3.77"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iC)",
    d: "M398.148 38.942a4.88 4.88 0 0 1 4.541 2.98 4.895 4.895 0 0 1-3.504 6.7 4.88 4.88 0 0 1-5.035-2.036 4.9 4.9 0 0 1-.848-2.71 5.02 5.02 0 0 1 4.846-4.934"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iD)",
    d: "M233.074 1.461a5.459 5.459 0 0 1-4.803 5.4 5.54 5.54 0 0 1-6.114-4.235c-.445-2.012-.191-2.52 1.565-2.605h8.464c.761.148.888.635.888 1.44"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iE)",
    d: "M291.449 210.104a4.5 4.5 0 0 1 2.534.71 4.513 4.513 0 0 1-1.522 8.218 4.51 4.51 0 0 1-5.413-4.439 4.59 4.59 0 0 1 4.401-4.489"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iF)",
    d: "M355.621 104.078a3.8 3.8 0 0 1 3.481 2.422 3.81 3.81 0 0 1-5.091 4.873 3.809 3.809 0 0 1-2.262-3.589 3.874 3.874 0 0 1 3.872-3.706"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iG)",
    d: "M398.063 62.49a2.77 2.77 0 0 1 2.835 2.646 2.815 2.815 0 0 1-2.602 2.753 2.71 2.71 0 0 1-2.613-2.592 2.71 2.71 0 0 1 2.38-2.808"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iH)",
    d: "M387.442 72.484a3.384 3.384 0 0 1 3.444 3.93 3.39 3.39 0 0 1-2.552 2.751 3.385 3.385 0 0 1-4.171-3.145 3.45 3.45 0 0 1 3.279-3.536"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iI)",
    d: "M184.962 360.811a3.19 3.19 0 0 1 3.282 1.868 3.202 3.202 0 0 1-1.952 4.357c-.43.135-.883.179-1.33.127a3.23 3.23 0 0 1-2.192-.955 3.24 3.24 0 0 1-.94-2.2 3.3 3.3 0 0 1 3.132-3.197"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iJ)",
    d: "M216.953 308.93a1.8 1.8 0 0 1 1.671 1.694 1.756 1.756 0 0 1-1.714 1.737 1.775 1.775 0 0 1-1.735-1.737 1.8 1.8 0 0 1 1.778-1.694"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iK)",
    d: "M376.778 81.844a4.695 4.695 0 0 1 4.409 2.867 4.71 4.71 0 0 1-1.012 5.165 4.693 4.693 0 0 1-7.264-.789 4.7 4.7 0 0 1-.745-2.648 4.782 4.782 0 0 1 4.612-4.595"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iL)",
    d: "M227.404 296.585a3.411 3.411 0 0 1 .937 6.727 3.402 3.402 0 0 1-3.555-1.362 3.4 3.4 0 0 1-.619-1.892 3.476 3.476 0 0 1 3.237-3.473"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iM)",
    d: "M110.274 457.244a2.83 2.83 0 0 1 2.618 1.747 2.837 2.837 0 0 1-4.965 2.682 2.84 2.84 0 0 1-.488-1.57 2.925 2.925 0 0 1 2.835-2.859"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iN)",
    d: "M366.136 92.813a4.375 4.375 0 0 1 4.163 2.636 4.386 4.386 0 0 1-3.199 6.051 4.38 4.38 0 0 1-5.196-4.452 4.534 4.534 0 0 1 4.232-4.236"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iO)",
    d: "M238.322 285.722a3.6 3.6 0 1 1-1.48 6.917 3.6 3.6 0 0 1-2.202-3.317 3.67 3.67 0 0 1 1.102-2.557 3.66 3.66 0 0 1 2.58-1.043"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iP)",
    d: "M344.83 135.524a4.44 4.44 0 0 1 4.384 5.369 4.45 4.45 0 0 1-1.267 2.283 4.44 4.44 0 0 1-4.917.843 4.45 4.45 0 0 1-2.601-4.26 4.527 4.527 0 0 1 4.401-4.235"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iQ)",
    d: "M195.647 328.221a3.79 3.79 0 0 1 3.637 4.592 3.788 3.788 0 0 1-5.209 2.675 3.79 3.79 0 0 1-2.279-3.54 3.897 3.897 0 0 1 3.851-3.727"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iR)",
    d: "M302.197 178.743a3.85 3.85 0 0 1 3.801 4.593 3.855 3.855 0 0 1-3.02 3.039 3.852 3.852 0 0 1-4.61-3.778 3.937 3.937 0 0 1 3.829-3.854"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iS)",
    d: "M430.202 7.835a4.109 4.109 0 0 1 3.957 3.875 4.01 4.01 0 0 1-2.33 3.991 3.998 3.998 0 0 1-5.647-3.864 4.11 4.11 0 0 1 4.02-4.002"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iT)",
    d: "M280.722 220.925a4.34 4.34 0 0 1 4.496 4.182 4.34 4.34 0 0 1-4.179 4.5 4.424 4.424 0 0 1-4.485-4.235 4.482 4.482 0 0 1 4.168-4.447"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iU)",
    d: "M334.145 147.085a3.49 3.49 0 0 1 3.501 4.091 3.495 3.495 0 0 1-4.673 2.672 3.5 3.5 0 0 1-2.255-3.141 3.6 3.6 0 0 1 3.427-3.622"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iV)",
    d: "M248.922 253.281a4.02 4.02 0 0 1 3.916 4.837 4.02 4.02 0 0 1-7.957-.856 4.235 4.235 0 0 1 4.041-3.981"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iW)",
    d: "M131.602 435.306a3.428 3.428 0 0 1 3.366 4.077 3.427 3.427 0 0 1-6.793-.583 3.514 3.514 0 0 1 3.427-3.494"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iX)",
    d: "M270.228 231.089a4.869 4.869 0 0 1 3.455 8.299 4.864 4.864 0 0 1-8.322-3.386 5.014 5.014 0 0 1 4.867-4.913"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iY)",
    d: "M206.226 319.899c.284-.004.564.077.803.231a1.45 1.45 0 0 1 .633 1.469 1.45 1.45 0 0 1-1.114 1.148 1.433 1.433 0 0 1-1.485-.59 1.44 1.44 0 0 1-.255-.797 1.48 1.48 0 0 1 1.418-1.461"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#iZ)",
    d: "M259.691 243.011a3.62 3.62 0 0 1 2.347 6.26 3.618 3.618 0 0 1-6.092-2.745 3.68 3.68 0 0 1 3.745-3.515"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ja)",
    d: "M419.348 18.465a4.23 4.23 0 0 1 4.232 3.918 4.03 4.03 0 0 1-3.861 4.182 4.026 4.026 0 0 1-4.179-3.865 4.23 4.23 0 0 1 3.808-4.235"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jb)",
    d: "M120.939 446.127a3.275 3.275 0 0 1 3.025 2.016 3.284 3.284 0 0 1-2.36 4.48 3.28 3.28 0 0 1-3.945-3.172 3.39 3.39 0 0 1 3.28-3.324"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jc)",
    d: "M312.819 167.859a4.06 4.06 0 0 1 3.809 2.496 4.07 4.07 0 0 1-.898 4.467 4.065 4.065 0 0 1-4.478.827 4.06 4.06 0 0 1-2.432-3.852 4.23 4.23 0 0 1 3.999-3.938"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jd)",
    d: "M323.525 156.89a4.36 4.36 0 0 1 4.109 2.589 4.37 4.37 0 0 1-.834 4.787 4.36 4.36 0 0 1-4.742 1.044 4.36 4.36 0 0 1-2.765-3.995 4.5 4.5 0 0 1 1.245-3.047 4.48 4.48 0 0 1 2.987-1.378"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#je)",
    d: "M245.748.17h3.026q1.83.095 3.66 0c1.65-.191 1.777.698 1.629 1.926a5.204 5.204 0 0 1-10.24.657c-.55-2.118-.212-2.562 1.925-2.584"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jf)",
    d: "M267.541.656q1.354.08 2.708 0 1.365.08 2.729 0c1.566-.169 1.693.657 1.439 1.864a4.359 4.359 0 0 1-4.232 3.558 4.4 4.4 0 0 1-4.231-3.622c-.212-1.291.106-1.948 1.587-1.8"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jg)",
    d: "M216.952 328.92a3.07 3.07 0 1 1-1.255 5.891 3.07 3.07 0 0 1-1.855-2.863 3.06 3.06 0 0 1 .922-2.165 3.04 3.04 0 0 1 2.188-.863"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jh)",
    d: "M302.155 200.3a3.64 3.64 0 0 1 3.64 4.313 3.65 3.65 0 0 1-2.843 2.896 3.64 3.64 0 0 1-4.373-3.567 3.68 3.68 0 0 1 3.576-3.642"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ji)",
    d: "M430.223 29.01a4.23 4.23 0 0 1 3.921 2.646 4.238 4.238 0 0 1-3.176 5.758 4.23 4.23 0 0 1-4.325-1.909 4.235 4.235 0 0 1 3.58-6.495"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jj)",
    d: "M206.247 339.868a2.79 2.79 0 0 1 2.584 1.735 2.8 2.8 0 0 1-.625 3.052 2.792 2.792 0 0 1-4.752-2.034 2.813 2.813 0 0 1 2.793-2.753"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jk)",
    d: "M259.606 263.953a4.02 4.02 0 0 1 3.708 2.524c.298.742.368 1.556.201 2.337a4.02 4.02 0 1 1-6.728-3.727 4.02 4.02 0 0 1 2.819-1.134"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jl)",
    d: "M312.797 189.331a3.93 3.93 0 0 1 3.696 2.372 3.94 3.94 0 0 1-.798 4.32 3.94 3.94 0 0 1-4.299.893 3.94 3.94 0 0 1-1.327-6.402 3.93 3.93 0 0 1 2.728-1.183"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jm)",
    d: "M408.748 50.229a4.23 4.23 0 0 1 3.899 2.59 4.24 4.24 0 0 1-3.01 5.785 4.23 4.23 0 0 1-4.356-1.711 4.23 4.23 0 0 1-.764-2.324 4.358 4.358 0 0 1 4.231-4.34"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jn)",
    d: "M366.178 114.517a4.02 4.02 0 0 1 4.02 4.024 4.022 4.022 0 0 1-6.862 2.845 4.026 4.026 0 0 1 0-5.69 4.02 4.02 0 0 1 2.842-1.179"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jo)",
    d: "M376.905 104.205a3.663 3.663 0 0 1 2.588 6.254 3.657 3.657 0 0 1-5.176 0 3.663 3.663 0 0 1 2.588-6.254"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jp)",
    d: "M195.541 351.091a2.26 2.26 0 0 1 2.482 2.255c0 .316-.066.629-.193.918a2.28 2.28 0 0 1-1.358 1.233 2.26 2.26 0 0 1-2.389-.628 2.267 2.267 0 0 1 1.458-3.778"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jq)",
    d: "M270.164 253.535a3.78 3.78 0 0 1 2.105.601 3.78 3.78 0 0 1 1.662 3.848 3.76 3.76 0 0 1-2.92 3.006 3.76 3.76 0 0 1-2.181-.186 3.77 3.77 0 0 1-2.369-3.457 3.75 3.75 0 0 1 2.268-3.508 3.8 3.8 0 0 1 1.435-.304"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jr)",
    d: "M355.43 124.364a4.846 4.846 0 0 1 5.004 4.691 4.854 4.854 0 0 1-4.687 5.008 4.847 4.847 0 0 1-5.003-4.691 4.853 4.853 0 0 1 4.686-5.008"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#js)",
    d: "M248.921 274.626a4.02 4.02 0 0 1 3.91 4.861 4.025 4.025 0 0 1-3.221 3.122 4.02 4.02 0 0 1-4.106-1.804 4.04 4.04 0 0 1-.624-2.262 4.07 4.07 0 0 1 4.041-3.917"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jt)",
    d: "M323.588 178.785a3.81 3.81 0 0 1 2.612 6.544 3.806 3.806 0 0 1-5.855-.665 3.814 3.814 0 0 1 3.243-5.879"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ju)",
    d: "M419.454 40.064a3.791 3.791 0 1 1-1.535 7.265 3.79 3.79 0 0 1 1.535-7.265"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jv)",
    d: "M227.531 318.968a2.368 2.368 0 0 1 2.375 2.785 2.375 2.375 0 0 1-1.817 1.901 2.37 2.37 0 0 1-2.885-2.251 2.33 2.33 0 0 1 2.327-2.435"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jw)",
    d: "M291.682 232.423a3.533 3.533 0 0 1 3.312 4.34 3.54 3.54 0 0 1-2.862 2.683 3.534 3.534 0 0 1-4.11-3.593 3.475 3.475 0 0 1 3.66-3.43"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jx)",
    d: "M451.381 7.073a4.65 4.65 0 0 1 4.505 2.854c.245.585.368 1.213.361 1.847a4.76 4.76 0 0 1-1.273 3.572 4.758 4.758 0 0 1-7.96-1.654 4.8 4.8 0 0 1-.267-1.918 4.68 4.68 0 0 1 1.341-3.314 4.66 4.66 0 0 1 3.293-1.387"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jy)",
    d: "M302.113 221.814a3.48 3.48 0 0 1 1.956.533 3.48 3.48 0 0 1 1.565 3.55 3.474 3.474 0 0 1-4.718 2.607 3.47 3.47 0 0 1-2.167-3.217 3.38 3.38 0 0 1 .953-2.443 3.39 3.39 0 0 1 2.411-1.03"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jz)",
    d: "M312.671 210.019a4.588 4.588 0 0 1 4.38 2.667 4.598 4.598 0 0 1-3.142 6.402 4.59 4.59 0 0 1-5.618-4.389 4.49 4.49 0 0 1 4.38-4.68"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jA)",
    d: "M238.195 307.702a2.962 2.962 0 0 1 2.956 3.494 2.97 2.97 0 0 1-2.283 2.367 2.958 2.958 0 0 1-3.593-2.833 2.897 2.897 0 0 1 2.92-3.028"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jB)",
    d: "M248.879 296.289a3.7 3.7 0 0 1 3.445 2.298 3.71 3.71 0 0 1-.838 4.058 3.702 3.702 0 0 1-6.288-2.757 3.6 3.6 0 0 1 2.279-3.35 3.6 3.6 0 0 1 1.402-.249"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jC)",
    d: "M259.543 285.574a3.74 3.74 0 0 1 3.464 2.275 3.76 3.76 0 0 1-.752 4.078 3.743 3.743 0 0 1-6.436-2.499 3.66 3.66 0 0 1 1.024-2.738 3.67 3.67 0 0 1 2.7-1.116"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jD)",
    d: "M280.891 242.46a4.237 4.237 0 0 1 1.62 8.148 4.23 4.23 0 0 1-5.77-3.086 4.24 4.24 0 0 1 1.8-4.348 4.23 4.23 0 0 1 2.35-.714"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jE)",
    d: "M270.122 275.282a3.47 3.47 0 0 1 3.276 2.06 3.48 3.48 0 0 1-.665 3.814 3.468 3.468 0 0 1-5.975-2.358 3.4 3.4 0 0 1 .938-2.471 3.38 3.38 0 0 1 2.426-1.045"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jF)",
    d: "M355.452 146.958a3.62 3.62 0 0 1 3.382 2.14 3.623 3.623 0 0 1-2.462 5.003 3.62 3.62 0 0 1-4.454-3.352 3.54 3.54 0 0 1 3.534-3.791"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jG)",
    d: "M430.033 50.61a3.91 3.91 0 0 1 3.688 2.338 3.916 3.916 0 0 1-5.04 5.213 3.92 3.92 0 0 1-2.457-3.613 3.81 3.81 0 0 1 3.809-3.938"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jH)",
    d: "M419.454 63.06a2.11 2.11 0 0 1 1.954 1.308 2.12 2.12 0 0 1-1.542 2.887 2.113 2.113 0 0 1-2.528-2.077 2.116 2.116 0 0 1 2.116-2.117"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jI)",
    d: "M398.296 84.702a1.77 1.77 0 0 1 1.628 1.118 1.77 1.77 0 0 1-.408 1.934 1.775 1.775 0 0 1-2.731-.303 1.8 1.8 0 0 1-.288-.991 1.736 1.736 0 0 1 1.799-1.758"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jJ)",
    d: "M195.498 372.224a2.47 2.47 0 0 1 2.305 1.477 2.48 2.48 0 0 1-1.702 3.413 2.473 2.473 0 0 1-3.036-2.306 2.45 2.45 0 0 1 .658-1.819 2.432 2.432 0 0 1 1.775-.765"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jK)",
    d: "M440.908 18.783a3.724 3.724 0 0 1 3.579 4.5 3.73 3.73 0 0 1-2.952 2.888 3.72 3.72 0 0 1-3.801-1.613 3.73 3.73 0 0 1-.613-2.07 3.68 3.68 0 0 1 1.108-2.657 3.67 3.67 0 0 1 2.679-1.048"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jL)",
    d: "M131.453 456.291a3.788 3.788 0 0 1 3.879 4.443 3.789 3.789 0 0 1-6.878 1.453 3.8 3.8 0 0 1-.64-2.127 3.707 3.707 0 0 1 3.639-3.769"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jM)",
    d: "M387.611 93.575a3.64 3.64 0 0 1 3.468 4.427 3.639 3.639 0 0 1-7.192-.849 3.59 3.59 0 0 1 1.099-2.584 3.58 3.58 0 0 1 2.625-.994"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jN)",
    d: "M334.336 168.282a3.64 3.64 0 0 1 3.442 4.447 3.64 3.64 0 0 1-5.023 2.524 3.64 3.64 0 0 1-2.164-3.413 3.58 3.58 0 0 1 2.329-3.337 3.6 3.6 0 0 1 1.416-.221"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jO)",
    d: "M121.129 466.752a3.983 3.983 0 0 1 0 7.962 3.975 3.975 0 0 1-3.978-3.981 3.983 3.983 0 0 1 3.978-3.981"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jP)",
    d: "M366.263 136.222a3.684 3.684 0 1 1-1.472 7.089 3.69 3.69 0 0 1-2.273-3.383 3.6 3.6 0 0 1 1.066-2.669 3.6 3.6 0 0 1 2.679-1.037"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jQ)",
    d: "M408.706 73.903a1.968 1.968 0 0 1 1.634 3.248 1.97 1.97 0 0 1-2.104.588 1.97 1.97 0 0 1-1.35-1.719 1.94 1.94 0 0 1 .456-1.45 1.93 1.93 0 0 1 1.364-.667"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jR)",
    d: "M142.286 445.005a4.4 4.4 0 0 1 4.07 2.68 4.41 4.41 0 0 1-.894 4.794 4.4 4.4 0 0 1-4.762 1.031 4.41 4.41 0 0 1-2.793-3.995 4.23 4.23 0 0 1 1.187-3.23 4.23 4.23 0 0 1 3.192-1.28"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jS)",
    d: "M376.736 125.931a3.302 3.302 0 0 1 2.527 5.568 3.299 3.299 0 0 1-5.103-.371 3.3 3.3 0 0 1-.598-1.83 3.26 3.26 0 0 1 .88-2.351 3.24 3.24 0 0 1 2.294-1.016"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jT)",
    d: "M344.915 157.038a4.225 4.225 0 0 1 3.909 2.614 4.236 4.236 0 0 1-5.528 5.534 4.237 4.237 0 0 1-2.613-3.913 4.14 4.14 0 0 1 1.207-3.027 4.12 4.12 0 0 1 3.025-1.208"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jU)",
    d: "M323.334 199.728a4.237 4.237 0 1 1-2.74 7.335 4.24 4.24 0 0 1 2.74-7.335"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jV)",
    d: "M206.204 360.683c.437.007.867.1 1.267.274a3.3 3.3 0 0 1 1.77 1.828 3.33 3.33 0 0 1-.778 3.611 3.33 3.33 0 0 1-2.364.937 3.32 3.32 0 0 1-3.269-3.378 3.323 3.323 0 0 1 3.374-3.272"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jW)",
    d: "M296.993 1.673a5.459 5.459 0 0 1-10.833.445c-.169-1.038 0-1.716.423-2.118h10.008c.402.339.444.91.402 1.673"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jX)",
    d: "M291.661 253.239a4.06 4.06 0 0 1 3.64 2.654 4.07 4.07 0 0 1-1.045 4.385 4.055 4.055 0 0 1-4.445.725 4.071 4.071 0 0 1-2.382-3.826 3.96 3.96 0 0 1 1.262-2.888 3.96 3.96 0 0 1 2.97-1.05"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jY)",
    d: "M451.529 29.286a3.89 3.89 0 0 1 3.585 2.43 3.9 3.9 0 0 1-.876 4.244 3.9 3.9 0 0 1-4.255.807 3.891 3.891 0 0 1-2.368-3.628 3.78 3.78 0 0 1 1.13-2.767 3.8 3.8 0 0 1 2.784-1.086"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jZ)",
    d: "M344.936 178.341a4.232 4.232 0 0 1 4.151 5.061 4.24 4.24 0 0 1-1.158 2.168 4.22 4.22 0 0 1-4.612.918 4.23 4.23 0 0 1-2.612-3.912 4.231 4.231 0 0 1 4.231-4.235"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ka)",
    d: "M227.511 339.021a3.65 3.65 0 0 1 3.426 2.217 3.663 3.663 0 0 1-4.749 4.836 3.66 3.66 0 0 1-2.274-3.39 3.55 3.55 0 0 1 1.017-2.599 3.55 3.55 0 0 1 2.58-1.064"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kb)",
    d: "M398.085 104.12a3.77 3.77 0 1 1-1.238 7.29 3.77 3.77 0 0 1-2.423-3.415 3.7 3.7 0 0 1 .228-1.46 3.72 3.72 0 0 1 1.989-2.105 3.7 3.7 0 0 1 1.444-.31"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kc)",
    d: "M440.611 39.662a4.23 4.23 0 0 1 4.363 4.938 4.24 4.24 0 0 1-3.274 3.431 4.232 4.232 0 0 1-5.13-4.134 4.08 4.08 0 0 1 1.128-2.971 4.07 4.07 0 0 1 2.913-1.264"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kd)",
    d: "M131.708 476.789c1.223 0 2.396.486 3.261 1.352a4.619 4.619 0 0 1-3.261 7.881 4.615 4.615 0 0 1-3.262-7.881 4.6 4.6 0 0 1 3.262-1.352"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ke)",
    d: "M387.548 113.903a4.637 4.637 0 1 1-1.859 8.895 4.63 4.63 0 0 1-2.796-4.342 4.56 4.56 0 0 1 1.369-3.257 4.557 4.557 0 0 1 3.286-1.296"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kf)",
    d: "M333.955 188.928a4.23 4.23 0 0 1 4.322 4.864 4.24 4.24 0 0 1-3.127 3.47 4.228 4.228 0 0 1-5.278-3.802 4.236 4.236 0 0 1 4.083-4.532"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kg)",
    d: "M280.701 264.695a3.36 3.36 0 0 1 3.225 1.914 3.37 3.37 0 0 1-.548 3.712 3.36 3.36 0 0 1-3.64.899 3.37 3.37 0 0 1-2.211-3.031 3.299 3.299 0 0 1 3.174-3.494"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kh)",
    d: "M238.28 328.497a3.51 3.51 0 0 1 3.391 4.25 3.51 3.51 0 0 1-6.946-.799 3.432 3.432 0 0 1 3.555-3.451"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ki)",
    d: "M318.383 1.567a5.527 5.527 0 0 1-5.16 5.188 5.523 5.523 0 0 1-5.778-4.49 2.66 2.66 0 0 1 .254-2.117h10.409c.255.426.353.928.275 1.419"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kj)",
    d: "M339.393 1.525a5.19 5.19 0 0 1-5.003 5.087 5.18 5.18 0 0 1-5.343-4.727c-.127-.869 0-1.525.444-1.843h9.394c.423.254.55.763.508 1.483"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kk)",
    d: "M472.75 28.608a4.548 4.548 0 0 1 4.558 5.38 4.56 4.56 0 0 1-3.541 3.628 4.545 4.545 0 0 1-4.698-1.902 4.55 4.55 0 0 1-.783-2.532 4.617 4.617 0 0 1 4.464-4.574"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kl)",
    d: "M408.875 116.063a2.49 2.49 0 0 1 2.29 1.553 2.5 2.5 0 0 1-.546 2.713 2.493 2.493 0 0 1-3.832-.366 2.5 2.5 0 0 1-.244-2.347 2.505 2.505 0 0 1 2.332-1.553"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#km)",
    d: "M259.437 327.734a4.232 4.232 0 0 1 4.151 5.062 4.23 4.23 0 0 1-8.382-.827 4.237 4.237 0 0 1 4.231-4.235"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kn)",
    d: "M366.158 156.699a4.613 4.613 0 0 1 4.576 5.46 4.62 4.62 0 0 1-3.568 3.67 4.61 4.61 0 0 1-4.757-1.883 4.6 4.6 0 0 1-.822-2.546 4.549 4.549 0 0 1 4.571-4.701"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ko)",
    d: "M152.866 457.392a2.69 2.69 0 1 1-.947 5.19 2.69 2.69 0 0 1-1.698-2.458 2.65 2.65 0 0 1 2.645-2.732"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kp)",
    d: "M163.445 466.985a3.746 3.746 0 0 1 3.724 4.43 3.75 3.75 0 0 1-2.898 2.983 3.74 3.74 0 0 1-3.864-1.533 3.75 3.75 0 0 1-.665-2.069 3.83 3.83 0 0 1 3.703-3.811"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kq)",
    d: "M430.033 71.573a4.23 4.23 0 0 1 3.885 2.57 4.24 4.24 0 0 1-.827 4.586 4.22 4.22 0 0 1-4.537 1.05 4.23 4.23 0 0 1-2.494-5.444 4.24 4.24 0 0 1 3.973-2.762"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kr)",
    d: "M248.922 317.295a4.04 4.04 0 0 1 3.936 4.862 4.048 4.048 0 0 1-3.203 3.156 4.043 4.043 0 0 1-4.796-4.016 3.96 3.96 0 0 1 1.181-2.866 3.96 3.96 0 0 1 2.882-1.136"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ks)",
    d: "M312.798 252.942a4.355 4.355 0 0 1 4.116 2.603 4.366 4.366 0 0 1-3.091 6.026 4.357 4.357 0 0 1-5.257-4.267 4.402 4.402 0 0 1 4.232-4.362"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kt)",
    d: "M270.249 317.634a3.745 3.745 0 0 1 3.646 4.507 3.744 3.744 0 0 1-7.412-.802 3.81 3.81 0 0 1 3.766-3.705"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ku)",
    d: "M462.171 39.302a4.526 4.526 0 0 1 4.528 4.531 4.534 4.534 0 0 1-4.528 4.532 4.54 4.54 0 0 1-3.286-1.318 4.55 4.55 0 0 1-1.347-3.277 4.594 4.594 0 0 1 4.633-4.468"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kv)",
    d: "M398.106 125.825a3.38 3.38 0 0 1 3.167 1.996 3.392 3.392 0 0 1-2.293 4.685 3.385 3.385 0 0 1-4.175-3.123 3.43 3.43 0 0 1 3.301-3.558"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kw)",
    d: "M142.287 487.589a4.48 4.48 0 0 1 3.147 1.374 4.5 4.5 0 0 1 .88 4.911 4.5 4.5 0 0 1-2.473 2.384 4.48 4.48 0 0 1-4.87-1.066 4.49 4.49 0 0 1 3.316-7.603"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kx)",
    d: "M280.954 285.574a3.747 3.747 0 1 1-3.171 5.839 3.75 3.75 0 0 1-.637-2.07 3.703 3.703 0 0 1 3.808-3.769"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ky)",
    d: "M387.611 135.714a4.23 4.23 0 0 1 3.928 2.679 4.24 4.24 0 0 1-1.037 4.642 4.232 4.232 0 0 1-7.123-3.34 4.24 4.24 0 0 1 1.326-2.831 4.23 4.23 0 0 1 2.906-1.15"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kz)",
    d: "M408.875 93.638a3.55 3.55 0 0 1 3.232 2.275 3.57 3.57 0 0 1-.065 2.722 3.56 3.56 0 0 1-3.336 2.118 3.556 3.556 0 0 1-3.47-3.642 3.556 3.556 0 0 1 3.639-3.473"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kA)",
    d: "M302.24 242.968a3.664 3.664 0 1 1-1.456 7.034 3.66 3.66 0 0 1-2.225-3.412 3.575 3.575 0 0 1 3.681-3.622"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kB)",
    d: "M323.63 242.27a4.35 4.35 0 0 1 3.976 2.781 4.37 4.37 0 0 1-1.056 4.739 4.36 4.36 0 0 1-4.781.825 4.36 4.36 0 0 1-2.582-4.11 4.426 4.426 0 0 1 4.443-4.235"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kC)",
    d: "M430.033 93.765a3.45 3.45 0 0 1 3.229 2.082 3.46 3.46 0 0 1-.697 3.78 3.45 3.45 0 0 1-5.917-2.389 3.51 3.51 0 0 1 3.385-3.473"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kD)",
    d: "M376.927 147.213a3.372 3.372 0 0 1 3.062 2.171c.158.415.231.857.217 1.301a3.35 3.35 0 0 1-2.164 3.005 3.348 3.348 0 0 1-2.975-5.952 3.34 3.34 0 0 1 1.86-.525"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kE)",
    d: "M291.386 275.155a3.494 3.494 0 1 1-1.096 6.747 3.49 3.49 0 0 1-2.226-3.21 3.517 3.517 0 0 1 3.322-3.537"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kF)",
    d: "M462.298 17.872a4.633 4.633 0 0 1 4.387 5.673 4.64 4.64 0 0 1-3.75 3.536 4.63 4.63 0 0 1-4.697-2.118 4.64 4.64 0 0 1-.7-2.602 4.55 4.55 0 0 1 4.76-4.489"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kG)",
    d: "M483.435 17.957a4.53 4.53 0 0 1 4.492 5.366 4.527 4.527 0 0 1-8.977-.771 4.64 4.64 0 0 1 4.485-4.595"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kH)",
    d: "M323.545 222.047a3.216 3.216 0 0 1 2.696 3.176 3.22 3.22 0 0 1-4.076 3.102 3.229 3.229 0 0 1-2.059-1.75 3.24 3.24 0 0 1 0-2.703 3.22 3.22 0 0 1 2.059-1.75c.449-.125.92-.15 1.38-.075"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kI)",
    d: "M366.22 179.569a3.02 3.02 0 0 1 2.788 1.904 3.032 3.032 0 0 1-2.28 4.105 3.027 3.027 0 0 1-3.554-3.066 3.046 3.046 0 0 1 3.046-2.943"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kJ)",
    d: "M152.865 477.636a3.787 3.787 0 0 1 3.681 4.583 3.79 3.79 0 0 1-3.038 2.939 3.786 3.786 0 0 1-4.451-3.837 3.834 3.834 0 0 1 3.808-3.685"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kK)",
    d: "M216.846 371.187a3.515 3.515 0 1 1-1.208 6.791 3.515 3.515 0 0 1-2.24-3.192 3.48 3.48 0 0 1 .969-2.524 3.48 3.48 0 0 1 2.479-1.075"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kL)",
    d: "M451.529 51.076a3.45 3.45 0 0 1 2.361 5.944 3.448 3.448 0 0 1-5.831-2.62 3.47 3.47 0 0 1 3.47-3.325"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kM)",
    d: "M142.075 466.54a4.234 4.234 0 0 1 4.411 4.055 4.24 4.24 0 0 1-4.051 4.415 4.22 4.22 0 0 1-3.045-1.113 4.23 4.23 0 0 1-1.113-4.576 4.24 4.24 0 0 1 3.798-2.781"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kN)",
    d: "M472.92 7.22a4.53 4.53 0 0 1 4.507 4.744 4.655 4.655 0 1 1-9.31-.17 4.555 4.555 0 0 1 4.803-4.573"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kO)",
    d: "M355.515 189.839a3.428 3.428 0 0 1 3.38 4.11 3.427 3.427 0 0 1-6.787-.743 3.454 3.454 0 0 1 3.407-3.367"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kP)",
    d: "M270.291 296.564a3.427 3.427 0 0 1 3.287 4.153 3.426 3.426 0 0 1-6.778-.765 3.434 3.434 0 0 1 3.491-3.388"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kQ)",
    d: "M238.195 350.731a2.63 2.63 0 0 1 2.005.677 2.62 2.62 0 0 1 .631 2.997 2.62 2.62 0 0 1-2.636 1.556 2.668 2.668 0 0 1-2.518-2.647 2.627 2.627 0 0 1 2.518-2.583"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kR)",
    d: "M419.454 83.305a3.23 3.23 0 0 1 3.058 1.96 3.25 3.25 0 0 1-.686 3.57 3.23 3.23 0 0 1-3.566.685 3.24 3.24 0 0 1-1.959-3.06 3.2 3.2 0 0 1 3.153-3.155"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kS)",
    d: "M259.67 307.533c.81.016 1.581.353 2.143.936.563.583.873 1.366.862 2.177a3.14 3.14 0 0 1-1.95 2.92 3.125 3.125 0 0 1-3.434-.724 3.137 3.137 0 0 1 .604-4.843 3.13 3.13 0 0 1 1.775-.466"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kT)",
    d: "M333.955 210.083a4.52 4.52 0 0 1 4.376 2.559 4.532 4.532 0 0 1-5.665 6.208 4.53 4.53 0 0 1-1.76-7.301 4.53 4.53 0 0 1 3.049-1.466"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kU)",
    d: "M344.851 200.469a3.46 3.46 0 0 1 3.23 2.155 3.472 3.472 0 0 1-4.606 4.497 3.46 3.46 0 0 1-1.538-1.325 3.48 3.48 0 0 1 .511-4.34 3.47 3.47 0 0 1 2.403-.987"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kV)",
    d: "M440.802 60.605a4.59 4.59 0 0 1 4.256 2.774 4.595 4.595 0 0 1-5.86 6.11 4.59 4.59 0 0 1-2.944-4.141 4.552 4.552 0 0 1 4.548-4.743"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kW)",
    d: "M312.967 231.767a4.232 4.232 0 0 1 4.15 5.061 4.232 4.232 0 0 1-8.382-.826 4.232 4.232 0 0 1 4.232-4.235"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kX)",
    d: "M216.889 394.395a1.65 1.65 0 0 1 1.65 1.609 1.674 1.674 0 0 1-1.608 1.673 1.7 1.7 0 0 1-1.161-.481 1.7 1.7 0 0 1-.51-1.149 1.672 1.672 0 0 1 1.629-1.652"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kY)",
    d: "M376.905 167.753a4.22 4.22 0 0 1 3.487.899 4.237 4.237 0 0 1-3.487 7.423 4.24 4.24 0 0 1-3.487-.899 4.237 4.237 0 0 1 0-6.524 4.22 4.22 0 0 1 3.487-.899"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kZ)",
    d: "M355.515 167.901a4.02 4.02 0 0 1 3.729 2.469 4.027 4.027 0 0 1-2.916 5.499 4.017 4.017 0 0 1-4.133-1.707 4.02 4.02 0 0 1-.679-2.238 3.94 3.94 0 0 1 1.144-2.862 3.94 3.94 0 0 1 2.855-1.161"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#la)",
    d: "M206.289 383.278a2.11 2.11 0 0 1 1.954 1.307 2.125 2.125 0 0 1-.458 2.308 2.112 2.112 0 0 1-3.612-1.498 2.116 2.116 0 0 1 2.116-2.117"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lb)",
    d: "M419.453 105.243a2.62 2.62 0 0 1 2.687 2.752 2.647 2.647 0 0 1-3.207 2.48 2.64 2.64 0 0 1-2.031-2.081 2.643 2.643 0 0 1 2.551-3.151"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lc)",
    d: "M302.112 264.356a3.6 3.6 0 0 1 0 7.2 3.6 3.6 0 0 1 0-7.2"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ld)",
    d: "M248.879 340.291a2.391 2.391 0 0 1 1.712 4.085 2.395 2.395 0 0 1-2.615.515 2.39 2.39 0 0 1-1.467-2.228 2.395 2.395 0 0 1 2.37-2.372"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#le)",
    d: "M462.214 61.917a3.28 3.28 0 0 1 2.254 5.626 3.279 3.279 0 0 1-5.576-2.365 3.39 3.39 0 0 1 3.322-3.26"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lf)",
    d: "M334.23 232.021a3.91 3.91 0 0 1 3.603 2.438 3.914 3.914 0 1 1-7.538 1.458 4.043 4.043 0 0 1 3.935-3.896"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lg)",
    d: "M248.88 360.789a3.24 3.24 0 1 1-1.319 6.191 3.242 3.242 0 0 1-1.897-3.099 3.323 3.323 0 0 1 3.216-3.092"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lh)",
    d: "M280.806 306.368a4.236 4.236 0 1 1-1.533 8.183 4.23 4.23 0 0 1-2.698-3.821 4.385 4.385 0 0 1 4.231-4.362"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#li)",
    d: "M355.536 210.655a3.936 3.936 0 0 1 3.936 3.938 3.94 3.94 0 0 1-3.936 3.939 3.939 3.939 0 0 1 0-7.877"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lj)",
    d: "M302.282 285.171a4.232 4.232 0 0 1 4.15 5.062 4.232 4.232 0 0 1-7.668 1.526 4.235 4.235 0 0 1 3.518-6.588"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lk)",
    d: "M440.929 82.013a4.506 4.506 0 0 1 4.365 5.447 4.5 4.5 0 0 1-3.597 3.5 4.5 4.5 0 0 1-4.602-1.997 4.5 4.5 0 0 1-.715-2.524 4.632 4.632 0 0 1 4.549-4.426"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ll)",
    d: "M387.421 156.911a4.234 4.234 0 1 1-1.492 8.2 4.24 4.24 0 0 1-2.739-3.774 4.45 4.45 0 0 1 4.231-4.426"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lm)",
    d: "M353.082.19h2.348a28 28 0 0 0 2.962 0c1.693-.19 1.926.678 1.672 2.118a4.704 4.704 0 0 1-4.232 3.854 4.61 4.61 0 0 1-4.654-3.26C350.5.655 350.839.19 353.082.19"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ln)",
    d: "M451.19 71.362a4.5 4.5 0 0 1 4.34 2.558 4.52 4.52 0 0 1-.739 4.985A4.506 4.506 0 0 1 446.959 76a4.636 4.636 0 0 1 4.231-4.637"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lo)",
    d: "M494.184 7.306a4.619 4.619 0 0 1 4.485 4.553 4.52 4.52 0 0 1-1.208 3.402 4.53 4.53 0 0 1-3.309 1.439 4.52 4.52 0 0 1-4.267-3.015 4.5 4.5 0 0 1-.25-1.827 4.64 4.64 0 0 1 4.549-4.552"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lp)",
    d: "M227.595 383.553a1.8 1.8 0 1 1-1.272 3.073 1.803 1.803 0 0 1 0-2.546 1.8 1.8 0 0 1 1.272-.527"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lq)",
    d: "M291.512 296.119a3.9 3.9 0 0 1 2.156.628 3.878 3.878 0 0 1-1.304 7.037 3.874 3.874 0 0 1-4.681-3.726 3.98 3.98 0 0 1 3.829-3.939"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lr)",
    d: "M398.084 146.726a3.84 3.84 0 0 1 3.616 2.272 3.858 3.858 0 0 1-2.632 5.332 3.84 3.84 0 0 1-4-1.493 3.85 3.85 0 0 1-.728-2.109 3.94 3.94 0 0 1 3.744-4.002"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ls)",
    d: "M408.875 135.862a4.024 4.024 0 0 1 0 8.047 4.02 4.02 0 0 1-4.02-4.023 4.024 4.024 0 0 1 4.02-4.024"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lt)",
    d: "M344.957 221.391a3.89 3.89 0 0 1 3.54 2.473 3.9 3.9 0 0 1-.917 4.221 3.89 3.89 0 0 1-4.245.78 3.898 3.898 0 0 1-2.355-3.62 4.023 4.023 0 0 1 3.977-3.854"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lu)",
    d: "M430.223 115.386a3.255 3.255 0 0 1 3.11 3.197 3.18 3.18 0 0 1-1.96 2.955 3.172 3.172 0 0 1-4.332-2.346 3.173 3.173 0 0 1 3.182-3.764z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lv)",
    d: "M152.865 499.743a3.005 3.005 0 0 1 2.705 3.046 3.005 3.005 0 0 1-2.811 2.947 3.003 3.003 0 0 1-2.705-3.045 3.01 3.01 0 0 1 2.811-2.948"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lw)",
    d: "M472.666 51.647a2.877 2.877 0 0 1 3.046 3.857 2.874 2.874 0 0 1-4.687 1.084 2.88 2.88 0 0 1 1.641-4.94"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lx)",
    d: "M323.377 264.335a3.613 3.613 0 0 1 3.448 2.091 3.623 3.623 0 0 1-2.447 5.049 3.61 3.61 0 0 1-3.776-1.415 3.63 3.63 0 0 1-.674-1.998 3.75 3.75 0 0 1 3.449-3.727"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ly)",
    d: "M440.886 104.819a3.07 3.07 0 1 1-2.545 4.848 3.07 3.07 0 0 1-.565-1.672 3.2 3.2 0 0 1 .224-1.207 3.129 3.129 0 0 1 2.886-1.969"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lz)",
    d: "M163.445 489.156a2.897 2.897 0 0 1 2.938 3.405 2.896 2.896 0 0 1-5.247 1.131 2.9 2.9 0 0 1-.505-1.614 2.94 2.94 0 0 1 2.814-2.922"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lA)",
    d: "M280.871 329.174a2.836 2.836 0 0 1 .555 5.624 2.83 2.83 0 0 1-1.644-.175 2.84 2.84 0 0 1-1.725-2.654 2.9 2.9 0 0 1 2.814-2.795"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lB)",
    d: "M494.205 28.756a4.42 4.42 0 0 1 4.069 2.809 4.42 4.42 0 0 1-1.074 4.829 4.421 4.421 0 0 1-7.46-3.402 4.527 4.527 0 0 1 4.465-4.235"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lC)",
    d: "M270.185 339.889a2.8 2.8 0 0 1 2.613 1.701 2.795 2.795 0 0 1-3.644 3.674 2.8 2.8 0 0 1-1.719-2.601 2.86 2.86 0 0 1 2.75-2.774"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lD)",
    d: "M312.628 274.308a4.23 4.23 0 0 1 3.988 2.465 4.237 4.237 0 0 1-5.282 5.752 4.24 4.24 0 0 1-2.79-3.77 4.49 4.49 0 0 1 4.084-4.447"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lE)",
    d: "M387.505 179.823a2.77 2.77 0 0 1 2.739 3.318 2.77 2.77 0 0 1-2.195 2.18 2.77 2.77 0 0 1-2.846-1.212 2.76 2.76 0 0 1-.448-1.554 2.835 2.835 0 0 1 2.75-2.732"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lF)",
    d: "M376.842 190.114a3.177 3.177 0 0 1 0 6.353 3.174 3.174 0 0 1-3.174-3.176 3.177 3.177 0 0 1 3.174-3.177"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lG)",
    d: "M259.565 351.049a2.39 2.39 0 0 1 2.285 2.244 2.353 2.353 0 0 1-2.307 2.33 2.287 2.287 0 0 1 0-4.574z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lH)",
    d: "M419.454 126.143a3.09 3.09 0 0 1 2.847 1.894 3.088 3.088 0 1 1-5.936 1.261 3.173 3.173 0 0 1 3.089-3.155"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lI)",
    d: "M483.414 41.589a2.37 2.37 0 0 1 2.327 2.117 2.244 2.244 0 1 1-4.485.127 2.35 2.35 0 0 1 2.158-2.244"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lJ)",
    d: "M366.052 201.295a2.64 2.64 0 0 1 2.539 1.513 2.648 2.648 0 0 1-1.781 3.705 2.64 2.64 0 0 1-3.255-2.508 2.735 2.735 0 0 1 2.497-2.71"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lK)",
    d: "M334.146 254.107a3.11 3.11 0 0 1 3.121 3.68 3.11 3.11 0 0 1-2.427 2.48 3.1 3.1 0 0 1-3.212-1.312 3.1 3.1 0 0 1-.529-1.735 3.2 3.2 0 0 1 3.047-3.113"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lL)",
    d: "M504.635 18.147a4.35 4.35 0 0 1 4.097 2.567 4.371 4.371 0 0 1-.789 4.772 4.357 4.357 0 0 1-7.539-2.807 4.383 4.383 0 0 1 4.231-4.532"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lM)",
    d: "M174.214 479.055a2.369 2.369 0 0 1 1.661 3.912c-.386.45-.926.739-1.513.81a2.437 2.437 0 0 1-2.476-2.35 2.394 2.394 0 0 1 2.328-2.372"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lN)",
    d: "M398.296 167.901a4.023 4.023 0 1 1-1.854 7.69 4.028 4.028 0 0 1-2.378-3.751 4.067 4.067 0 0 1 4.232-3.939"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lO)",
    d: "M238.195 393.421a2.62 2.62 0 0 1 2.451 1.586 2.62 2.62 0 0 1-.532 2.873 2.62 2.62 0 0 1-2.857.602 2.62 2.62 0 0 1-1.644-2.414 2.626 2.626 0 0 1 2.582-2.647"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lP)",
    d: "M291.491 317.316a4 4 0 0 1 3.999 4.002 4 4 0 0 1-3.999 4.002 4.001 4.001 0 0 1 0-8.004"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lQ)",
    d: "M451.571 92.855a4.357 4.357 0 0 1 4.191 5.299 4.35 4.35 0 0 1-3.508 3.36 4.35 4.35 0 0 1-4.437-1.974 4.37 4.37 0 0 1-.668-2.45 4.379 4.379 0 0 1 4.422-4.235"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lR)",
    d: "M344.809 242.651a3.98 3.98 0 0 1 3.975 4.702 4 4 0 0 1-1.062 2.056 3.978 3.978 0 0 1-6.828-2.735 4.019 4.019 0 0 1 3.915-4.023"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lS)",
    d: "M227.595 404.453a2.265 2.265 0 0 1 2.116 2.118 2.11 2.11 0 0 1-1.306 1.956 2.11 2.11 0 0 1-2.306-.459 2.118 2.118 0 0 1 1.496-3.615"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lT)",
    d: "M381.37 1.927a4.547 4.547 0 0 1-3.809 4.002 4.61 4.61 0 0 1-5.035-2.71c-.973-2.287-.402-3.155 2.116-3.155h5.374c1.354-.064 1.565.656 1.354 1.863"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lU)",
    d: "M396.18.53h1.819q1.186.063 2.37 0c1.312-.191 1.566.444 1.439 1.545a3.69 3.69 0 0 1-3.195 3.261 3.765 3.765 0 0 1-4.126-2.562c-.423-1.736-.063-2.223 1.693-2.245"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lV)",
    d: "M424.236 2.118a4.887 4.887 0 0 1-4.232 3.939 4.76 4.76 0 0 1-4.908-3.05c-.678-1.694-.614-2.541.338-2.922h8.463c.487.36.487 1.1.339 2.033"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lW)",
    d: "M462.341 82.246a4.23 4.23 0 0 1 3.74 2.77 4.234 4.234 0 0 1-5.641 5.35 4.23 4.23 0 0 1-2.563-3.885 4.24 4.24 0 0 1 2.773-3.982 4.2 4.2 0 0 1 1.691-.253"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lX)",
    d: "M312.713 295.717a4.23 4.23 0 0 1 3.999 2.524 4.245 4.245 0 0 1-.835 4.658 4.23 4.23 0 0 1-7.269-2.947 4.235 4.235 0 0 1 4.105-4.235"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lY)",
    d: "M483.456 62.066a3.137 3.137 0 0 1 2.248 5.357 3.13 3.13 0 0 1-3.439.657 3.14 3.14 0 0 1-1.898-2.944 3.08 3.08 0 0 1 .906-2.179 3.07 3.07 0 0 1 2.183-.891"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lZ)",
    d: "M494.162 51.647a2.875 2.875 0 0 1 2.664 1.793 2.883 2.883 0 0 1-2.142 3.92 2.878 2.878 0 0 1-3.399-2.896 2.8 2.8 0 0 1 .84-2.021 2.79 2.79 0 0 1 2.037-.796"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ma)",
    d: "M334.145 275.896a2.753 2.753 0 0 1 .191 5.485 2.71 2.71 0 0 1-2.034-.739 2.7 2.7 0 0 1-.844-1.993 2.7 2.7 0 0 1 .764-1.943 2.7 2.7 0 0 1 1.923-.81"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mb)",
    d: "M323.355 285.553a3.764 3.764 0 0 1 3.909 4.357 3.765 3.765 0 0 1-2.873 3.08 3.76 3.76 0 0 1-3.931-1.51 3.8 3.8 0 0 1-.681-2.095 3.7 3.7 0 0 1 .994-2.658 3.7 3.7 0 0 1 2.582-1.174"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mc)",
    d: "M302.261 327.84a4.235 4.235 0 1 1-1.71 8.11 4.23 4.23 0 0 1-2.522-4.002 4.08 4.08 0 0 1 1.234-2.964 4.07 4.07 0 0 1 2.998-1.144"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#md)",
    d: "M355.493 232.254a3.7 3.7 0 0 1 3.442 2.239 3.71 3.71 0 0 1-.738 4.041 3.702 3.702 0 0 1-6.364-2.49c-.014-.491.07-.98.247-1.438a3.7 3.7 0 0 1 1.986-2.056 3.7 3.7 0 0 1 1.427-.296"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#me)",
    d: "M408.875 158.033a3.218 3.218 0 1 1-2.664 5.023 3.2 3.2 0 0 1-.552-1.783 3.18 3.18 0 0 1 3.216-3.24"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mf)",
    d: "M291.555 340.588a2.11 2.11 0 0 1 1.955 1.307 2.119 2.119 0 0 1-2.765 2.767 2.115 2.115 0 0 1-1.306-1.957 2.02 2.02 0 0 1 .586-1.531 2 2 0 0 1 1.53-.586"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mg)",
    d: "M163.634 510.331a3.112 3.112 0 0 1 2.032 5.211 3.11 3.11 0 0 1-3.298.835 3.1 3.1 0 0 1-1.838-1.693 3.11 3.11 0 0 1 .741-3.541c.317-.291.69-.514 1.097-.654a3.1 3.1 0 0 1 1.266-.158"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mh)",
    d: "M366.263 222.979a2.285 2.285 0 0 1 2.285 2.287 2.285 2.285 0 0 1-2.285 2.287 2.27 2.27 0 0 1-2.143-1.418 2.308 2.308 0 0 1 2.143-3.156"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mi)",
    d: "M408.875 178.955a3.635 3.635 0 0 1 3.383 2.248 3.65 3.65 0 0 1-.804 3.984 3.637 3.637 0 0 1-6.197-2.654 3.56 3.56 0 0 1 3.618-3.578"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mj)",
    d: "M259.31 371.525a3.17 3.17 0 0 1 3.074 1.761 3.178 3.178 0 0 1-2.047 4.482 3.17 3.17 0 0 1-3.341-1.175 3.2 3.2 0 0 1-.627-1.743 3.16 3.16 0 0 1 2.941-3.325"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mk)",
    d: "M398.169 190.58a2.629 2.629 0 0 1 1.868 4.49 2.622 2.622 0 0 1-4.47-1.906 2.56 2.56 0 0 1 2.602-2.584"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ml)",
    d: "M270.249 361.255a2.77 2.77 0 0 1 2.529 2.764 2.774 2.774 0 0 1-2.529 2.763 2.765 2.765 0 0 1-2.779-1.646 2.774 2.774 0 0 1 2.779-3.881"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mm)",
    d: "M376.969 212.433a2.116 2.116 0 1 1 0 4.235 2.116 2.116 0 0 1 0-4.235"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mn)",
    d: "M280.807 350.434a2.9 2.9 0 0 1 2.733 1.722 2.9 2.9 0 0 1-.554 3.184 2.9 2.9 0 0 1-3.154.695 2.9 2.9 0 0 1-1.839-2.657 2.84 2.84 0 0 1 1.711-2.712c.348-.15.724-.229 1.103-.232"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mo)",
    d: "M387.569 201.803a2.11 2.11 0 0 1 1.955 1.307 2.119 2.119 0 0 1-2.765 2.767 2.115 2.115 0 0 1-1.306-1.956 2.12 2.12 0 0 1 2.116-2.118"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mp)",
    d: "M515.531 7.539a4.23 4.23 0 0 1 3.91 2.614 4.235 4.235 0 0 1-.918 4.615 4.225 4.225 0 0 1-4.611.918 4.23 4.23 0 0 1-2.612-3.912 4.235 4.235 0 0 1 4.231-4.235"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mq)",
    d: "M302.112 306.707a3.95 3.95 0 0 1 3.713 2.338 3.965 3.965 0 0 1-.724 4.33 3.96 3.96 0 0 1-4.271.999 3.954 3.954 0 0 1-2.568-3.559 3.946 3.946 0 0 1 2.331-3.768 3.9 3.9 0 0 1 1.519-.34"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mr)",
    d: "M344.703 264.081a3.89 3.89 0 0 1 3.706 2.265 3.897 3.897 0 0 1-4.927 5.267 3.9 3.9 0 0 1-2.502-3.551 3.79 3.79 0 0 1 1.017-2.782 3.8 3.8 0 0 1 2.706-1.199"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ms)",
    d: "M462.108 105.306a2.58 2.58 0 0 1 2.46 1.481 2.58 2.58 0 1 1-4.915 1.208 2.536 2.536 0 0 1 2.455-2.689"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mt)",
    d: "M185.025 489.537a2.476 2.476 0 0 1 2.433 2.626 2.514 2.514 0 0 1-2.581 2.477 2.56 2.56 0 0 1-2.519-1.595 2.57 2.57 0 0 1 .06-2.062 2.57 2.57 0 0 1 1.559-1.349 2.55 2.55 0 0 1 1.048-.097"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mu)",
    d: "M451.55 116.466a2.19 2.19 0 1 1 0 4.381 2.19 2.19 0 0 1 0-4.381"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mv)",
    d: "M504.783 40.848a3 3 0 0 1 2.808 1.831 3.01 3.01 0 0 1-.633 3.294 3.006 3.006 0 0 1-4.638-.459 3 3 0 0 1-.499-1.68 2.93 2.93 0 0 1 1.817-2.77 2.9 2.9 0 0 1 1.145-.216"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mw)",
    d: "M355.621 253.641a3.662 3.662 0 1 1-3.745 3.557 3.585 3.585 0 0 1 2.33-3.337 3.6 3.6 0 0 1 1.415-.22"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mx)",
    d: "M440.802 127.053a2.21 2.21 0 0 1 2.211 2.213 2.213 2.213 0 0 1-2.211 2.213 2.114 2.114 0 0 1-2.116-2.117 2.118 2.118 0 0 1 2.116-2.309"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#my)",
    d: "M430.033 137.027a2.875 2.875 0 0 1 3.012 3.315 2.877 2.877 0 0 1-5.72-.393 2.823 2.823 0 0 1 .748-2.023 2.81 2.81 0 0 1 1.96-.899"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mz)",
    d: "M472.877 72.865a3.003 3.003 0 0 1 3.141 3.1 3.004 3.004 0 0 1-3.331 2.893 2.983 2.983 0 0 1-2.856-3.007 2.965 2.965 0 0 1 3.046-2.986"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mA)",
    d: "M174.023 500.209a2.555 2.555 0 0 1 2.469 1.437 2.563 2.563 0 0 1-1.674 3.604 2.55 2.55 0 0 1-2.689-.964 2.56 2.56 0 0 1-.497-1.409 2.5 2.5 0 0 1 .632-1.839 2.5 2.5 0 0 1 1.759-.829"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mB)",
    d: "M515.405 30.09a3.086 3.086 0 0 1 3.344 3.082 3.1 3.1 0 0 1-.997 2.274 3.085 3.085 0 0 1-4.365-.18 3.092 3.092 0 0 1 2.018-5.175"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mC)",
    d: "M419.327 147.573a3 3 0 0 1 2.905 1.713 3 3 0 0 1-.515 3.335 3 3 0 0 1-4.671-.338 3 3 0 0 1-.533-1.682 2.982 2.982 0 0 1 2.814-3.028"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mD)",
    d: "M248.816 403.67a3.04 3.04 0 0 1 2.867 1.808 3.053 3.053 0 0 1-2.119 4.216 3.045 3.045 0 0 1-3.71-2.911 2.968 2.968 0 0 1 1.793-2.874c.369-.158.767-.24 1.169-.239"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mE)",
    d: "M174.023 521.088a3.025 3.025 0 0 1 3.156 3.509 3.03 3.03 0 0 1-2.331 2.471 3.03 3.03 0 0 1-3.157-1.253 3.03 3.03 0 0 1-.524-1.698 2.987 2.987 0 0 1 2.856-3.029"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mF)",
    d: "M302.176 349.757a3.6 3.6 0 0 1 3.361 2.213 3.6 3.6 0 0 1-.791 3.947 3.595 3.595 0 0 1-5.557-.618 3.6 3.6 0 0 1-.567-2.027 3.575 3.575 0 0 1 3.554-3.515"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mG)",
    d: "M291.534 361.022a3 3 0 0 1 2.798 1.862 3.007 3.007 0 0 1-3.981 3.9 3 3 0 0 1-1.8-2.839 2.94 2.94 0 0 1 2.983-2.923"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mH)",
    d: "M280.933 372.139a2.57 2.57 0 0 1 2.337 1.616 2.564 2.564 0 0 1-1.908 3.465 2.56 2.56 0 0 1-3.031-2.539 2.476 2.476 0 0 1 2.602-2.542"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mI)",
    d: "M312.734 338.619a4.06 4.06 0 0 1 4.178 4.64 4.064 4.064 0 0 1-7.223 1.924 4.07 4.07 0 0 1-.848-2.181 4.095 4.095 0 0 1 2.318-3.991 4.1 4.1 0 0 1 1.575-.392"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mJ)",
    d: "M184.772 510.649a2.75 2.75 0 0 1 2.898 2.731 2.78 2.78 0 0 1-.679 2.126 2.76 2.76 0 0 1-2.024.937 2.766 2.766 0 0 1-2.659-1.828 2.8 2.8 0 0 1-.16-1.129 2.74 2.74 0 0 1 .724-1.963 2.74 2.74 0 0 1 1.9-.874"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mK)",
    d: "M270.207 383.087a2.26 2.26 0 0 1 1.601.664 2.262 2.262 0 0 1-.735 3.695 2.3 2.3 0 0 1-.866.173 2.1 2.1 0 0 1-.867-.181 2.1 2.1 0 0 1-1.16-1.288 2.1 2.1 0 0 1-.089-.882c-.008-.283.04-.565.142-.83a2.13 2.13 0 0 1 1.149-1.184c.261-.11.542-.167.825-.167"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mL)",
    d: "M323.334 327.946a4.05 4.05 0 0 1 3.858 2.311 4.053 4.053 0 0 1-1.925 5.393 4.046 4.046 0 0 1-5.773-3.458 4.05 4.05 0 0 1 3.84-4.246"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mM)",
    d: "M195.562 500.167a2.58 2.58 0 0 1 2.582 2.583 2.583 2.583 0 0 1-4.407 1.827 2.583 2.583 0 0 1 1.825-4.41"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mN)",
    d: "M312.882 318.184a3.155 3.155 0 1 1-2.632 4.893 3.16 3.16 0 0 1-.521-1.759 3.069 3.069 0 0 1 3.153-3.134"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mO)",
    d: "M323.355 307.046a3.533 3.533 0 0 1 3.66 3.409 3.54 3.54 0 0 1-3.406 3.663 3.53 3.53 0 0 1-3.66-3.409 3.54 3.54 0 0 1 3.406-3.663"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mP)",
    d: "M334.336 296.754a3.24 3.24 0 1 1-1.453 6.194 3.24 3.24 0 0 1-1.911-3.038 3.17 3.17 0 0 1 1.004-2.303 3.17 3.17 0 0 1 2.36-.853"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mQ)",
    d: "M472.751 93.173a4.23 4.23 0 0 1 4.028 2.493 4.235 4.235 0 0 1-5.437 5.668 4.23 4.23 0 0 1-2.654-3.926 4.02 4.02 0 0 1 4.063-4.236"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mR)",
    d: "M419.454 190.453a2.816 2.816 0 1 1-1.83 4.709 2.815 2.815 0 0 1 1.83-4.709"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mS)",
    d: "M526.153 19.185a3.32 3.32 0 0 1 3.256 3.981 3.324 3.324 0 0 1-4.542 2.409 3.324 3.324 0 0 1-2.036-3.087 3.22 3.22 0 0 1 3.322-3.303"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mT)",
    d: "M355.684 275.452a3.19 3.19 0 0 1 2.849 2.088 3.2 3.2 0 0 1-.813 3.439 3.19 3.19 0 0 1-3.482.588 3.2 3.2 0 0 1-1.897-2.981 3.174 3.174 0 0 1 3.343-3.134"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mU)",
    d: "M440.971 147.467a3.066 3.066 0 0 1 2.963 3.091 3.1 3.1 0 0 1-1.939 2.867 3.08 3.08 0 0 1-3.38-.73 3.09 3.09 0 0 1 2.356-5.228"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mV)",
    d: "M445.669 2.118a4.77 4.77 0 0 1-4.232 4.023 4.661 4.661 0 0 1-5.057-2.859c-.846-1.673-.825-2.71 0-3.24h8.992a2.35 2.35 0 0 1 .297 2.075"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mW)",
    d: "M430.16 179.145a3.45 3.45 0 0 1 3.207 2.131 3.457 3.457 0 0 1-2.545 4.712 3.44 3.44 0 0 1-3.538-1.518 3.44 3.44 0 0 1-.552-1.937 3.47 3.47 0 0 1 3.428-3.388"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mX)",
    d: "M408.875 200.109a3.831 3.831 0 0 1 2.547 6.632 3.822 3.822 0 0 1-4.226.677 3.835 3.835 0 0 1-2.214-3.667 3.79 3.79 0 0 1 3.893-3.642"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mY)",
    d: "M493.993 72.442a3.426 3.426 0 0 1 3.555 3.916 3.427 3.427 0 0 1-6.813-.274 3.37 3.37 0 0 1 .846-2.523 3.36 3.36 0 0 1 2.412-1.12"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mZ)",
    d: "M451.36 136.328a3.58 3.58 0 0 1 3.405 2.099 3.58 3.58 0 0 1-.668 3.946 3.58 3.58 0 0 1-3.906.858 3.58 3.58 0 0 1-2.258-3.303 3.48 3.48 0 0 1 .962-2.517 3.5 3.5 0 0 1 2.465-1.083"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#na)",
    d: "M419.454 168.875a3.05 3.05 0 1 1-1.262 5.844 3.05 3.05 0 0 1-1.827-2.858 2.96 2.96 0 0 1 .904-2.156 2.96 2.96 0 0 1 2.185-.83"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nb)",
    d: "M398.127 212.772a1.843 1.843 0 1 1-.569 3.572 1.84 1.84 0 0 1-1.208-1.645 1.77 1.77 0 0 1 .465-1.355 1.78 1.78 0 0 1 1.312-.572"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nc)",
    d: "M536.859 9.275a2.535 2.535 0 0 1 2.299 1.612 2.539 2.539 0 1 1-4.902.929 2.5 2.5 0 0 1 .753-1.833 2.5 2.5 0 0 1 1.85-.708"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nd)",
    d: "M366.136 242.587a4.043 4.043 0 0 1 2.958 6.866 4.04 4.04 0 0 1-4.397.933 4.04 4.04 0 0 1-2.539-3.712 3.935 3.935 0 0 1 2.424-3.786 3.9 3.9 0 0 1 1.554-.301"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ne)",
    d: "M376.884 233.63a2.3 2.3 0 0 1 1.612.721 2.32 2.32 0 0 1 .431 2.529 2.3 2.3 0 0 1-1.282 1.215 2.303 2.303 0 0 1-3.13-2.22 2.31 2.31 0 0 1 2.369-2.245"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nf)",
    d: "M483.414 83.093a3.36 3.36 0 0 1 3.236 2.078c.174.421.261.875.255 1.331a3.433 3.433 0 0 1-3.348 3.245 3.426 3.426 0 0 1-3.486-3.097 3.37 3.37 0 0 1 2.017-3.278 3.4 3.4 0 0 1 1.326-.28"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ng)",
    d: "M387.569 222.343a3.026 3.026 0 0 1 2.918 3.653 3.03 3.03 0 0 1-2.399 2.351 3.03 3.03 0 0 1-3.09-1.313 3.03 3.03 0 0 1-.497-1.684 2.96 2.96 0 0 1 3.068-3.007"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nh)",
    d: "M376.799 253.366a3.935 3.935 0 0 1 3.934 4.652 3.94 3.94 0 0 1-3.053 3.139 3.937 3.937 0 0 1-4.753-3.81 3.96 3.96 0 0 1 3.872-3.981"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ni)",
    d: "M472.813 115.301a3.26 3.26 0 0 1 3.024 1.993 3.265 3.265 0 0 1-2.346 4.462 3.256 3.256 0 0 1-3.915-3.173 3.26 3.26 0 0 1 3.237-3.282"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nj)",
    d: "M366.22 264.695a3.298 3.298 0 0 1 3.216 3.388 3.3 3.3 0 0 1-5.694 2.191 3.31 3.31 0 0 1 .12-4.672 3.3 3.3 0 0 1 2.358-.907"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nk)",
    d: "M504.784 61.642a3.552 3.552 0 0 1 3.524 4.265 3.56 3.56 0 0 1-2.84 2.791 3.55 3.55 0 0 1-3.647-1.595c-.379-.6-.571-1.3-.55-2.01a3.49 3.49 0 0 1 3.513-3.452"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nl)",
    d: "M483.435 104.226a3.66 3.66 0 0 1 3.429 2.222 3.664 3.664 0 0 1-4.766 4.826 3.66 3.66 0 0 1-2.259-3.406 3.68 3.68 0 0 1 3.596-3.642"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nm)",
    d: "M344.809 286.887a2.432 2.432 0 0 1 2.462 2.832 2.44 2.44 0 0 1-1.838 1.971 2.432 2.432 0 0 1-2.993-2.262 2.4 2.4 0 0 1 1.426-2.34c.297-.131.618-.199.943-.201"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nn)",
    d: "M526.025 40.34a3.55 3.55 0 0 1 3.618 3.324 3.51 3.51 0 0 1-2.008 3.368 3.51 3.51 0 0 1-4.913-2.356 3.512 3.512 0 0 1 3.303-4.337"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#no)",
    d: "M536.541 29.752a3.42 3.42 0 0 1 3.327 1.873c.307.608.426 1.293.342 1.968a3.426 3.426 0 0 1-6.822-.2 3.45 3.45 0 0 1 3.153-3.642"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#np)",
    d: "M462.15 126.27a2.944 2.944 0 0 1 0 5.887 2.94 2.94 0 0 1-2.941-2.944 2.941 2.941 0 0 1 2.941-2.943"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nq)",
    d: "M430.245 157.822a3.42 3.42 0 0 1 3.124 2.171 3.425 3.425 0 0 1-.802 3.721 3.42 3.42 0 0 1-3.741.688 3.43 3.43 0 0 1-2.072-3.192c-.007-.456.08-.908.255-1.329a3.33 3.33 0 0 1 1.901-1.845 3.3 3.3 0 0 1 1.335-.214"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nr)",
    d: "M494.078 93.173a3.95 3.95 0 0 1 3.708 2.37 3.963 3.963 0 0 1-2.782 5.458 3.954 3.954 0 0 1-4.798-3.805 3.998 3.998 0 0 1 3.872-4.023"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ns)",
    d: "M280.828 392.934a3.104 3.104 0 0 1 2.913 1.867 3.115 3.115 0 0 1-2.194 4.288 3.11 3.11 0 0 1-3.766-3 3.15 3.15 0 0 1 .886-2.194 3.15 3.15 0 0 1 2.161-.961"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nt)",
    d: "M344.767 307.872a2.773 2.773 0 0 1 2.05 4.698c-.51.53-1.209.836-1.944.85a2.84 2.84 0 0 1-2.772-2.796 2.875 2.875 0 0 1 2.666-2.752"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nu)",
    d: "M184.92 531.02a3.768 3.768 0 0 1 2.677 6.419 3.76 3.76 0 0 1-5.788-.525 3.77 3.77 0 0 1-.655-2.083 3.895 3.895 0 0 1 3.766-3.811"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nv)",
    d: "M440.738 167.88a4.04 4.04 0 0 1 3.86 3.945 4.05 4.05 0 0 1-3.669 4.123 4.036 4.036 0 0 1-4.039-2.329 4.046 4.046 0 0 1 3.848-5.739"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nw)",
    d: "M558.165 8.47a3.516 3.516 0 0 1 3.364 3.261 3.4 3.4 0 0 1-.835 2.596 3.42 3.42 0 0 1-2.47 1.152 3.4 3.4 0 0 1-2.523-1.028 3.42 3.42 0 0 1-.964-2.55 3.492 3.492 0 0 1 3.428-3.43"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nx)",
    d: "M291.407 381.711a3.662 3.662 0 0 1 3.752 4.298 3.67 3.67 0 0 1-2.86 2.949 3.655 3.655 0 0 1-3.797-1.565 3.67 3.67 0 0 1-.608-2.061 3.79 3.79 0 0 1 3.513-3.621"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ny)",
    d: "M504.847 83.432a3.11 3.11 0 0 1 2.856 1.931 3.12 3.12 0 0 1-.678 3.383 3.11 3.11 0 0 1-5.31-2.18 3.173 3.173 0 0 1 3.132-3.134"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nz)",
    d: "M408.875 221.751a3.534 3.534 0 0 1 3.441 4.239 3.536 3.536 0 0 1-4.82 2.562 3.53 3.53 0 0 1-2.176-3.265 3.665 3.665 0 0 1 3.555-3.536"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nA)",
    d: "M387.527 244.43a2.12 2.12 0 0 1 1.955 1.307 2.116 2.116 0 1 1-4.071.81 2.24 2.24 0 0 1 2.116-2.117"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nB)",
    d: "M355.515 298.237a1.754 1.754 0 0 1 1.563 1.747 1.755 1.755 0 0 1-1.563 1.747 1.845 1.845 0 0 1-1.82-1.716 1.82 1.82 0 0 1 1.82-1.778"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nC)",
    d: "M462.107 147.424a3.237 3.237 0 0 1 3.195 3.134 3.175 3.175 0 0 1-5.38 2.337 3.18 3.18 0 0 1-.967-2.231 3.26 3.26 0 0 1 3.152-3.24"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nD)",
    d: "M547.543 19.058a3.512 3.512 0 0 1 3.366 4.27 3.512 3.512 0 0 1-6.941-.84 3.58 3.58 0 0 1 3.575-3.43"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nE)",
    d: "M451.445 157.97a3.26 3.26 0 0 1 3.364 3.155 3.263 3.263 0 0 1-4.408 3.159 3.27 3.27 0 0 1-1.82-1.707 3.264 3.264 0 0 1 2.864-4.607"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nF)",
    d: "M466.868 1.61a4.635 4.635 0 0 1-3.999 4.234 4.755 4.755 0 0 1-5.204-3.091c-.466-1.419-.445-2.266.211-2.71h8.759c.247.482.329 1.033.233 1.566"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nG)",
    d: "M334.294 318.163a3.176 3.176 0 1 1-1.393 6.07 3.17 3.17 0 0 1-1.866-3 3.26 3.26 0 0 1 3.259-3.07"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nH)",
    d: "M302.303 371.356a3.34 3.34 0 0 1 3.18 4.064 3.35 3.35 0 0 1-2.669 2.573 3.345 3.345 0 0 1-3.938-3.334 3.45 3.45 0 0 1 3.427-3.303"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nI)",
    d: "M430.033 200.808a3.24 3.24 0 0 1 3.153 3.028 3.18 3.18 0 0 1-.93 2.246 3.17 3.17 0 0 1-4.488 0 3.18 3.18 0 0 1-.93-2.246 3.26 3.26 0 0 1 3.195-3.028"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nJ)",
    d: "M312.861 360.853a3.17 3.17 0 0 1 2.954 1.966 3.18 3.18 0 0 1-.713 3.479 3.173 3.173 0 0 1-5.394-2.354c.043-.817.39-1.588.974-2.161a3.25 3.25 0 0 1 2.179-.93"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nK)",
    d: "M419.454 211.396a3.21 3.21 0 0 1 3.07 1.871 3.22 3.22 0 0 1-2.213 4.483 3.22 3.22 0 0 1-3.925-3.093 3.32 3.32 0 0 1 3.068-3.261"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nL)",
    d: "M323.673 349.397a3.934 3.934 0 0 1 3.692 4.862 3.936 3.936 0 0 1-5.505 2.636 3.94 3.94 0 0 1-2.25-3.771 4.07 4.07 0 0 1 4.063-3.727"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nM)",
    d: "M536.859 50.821a3.63 3.63 0 0 1 3.341 2.309 3.648 3.648 0 0 1-2.77 4.923 3.638 3.638 0 0 1-4.253-3.716 3.75 3.75 0 0 1 3.682-3.516"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nN)",
    d: "M206.31 511.051a2.5 2.5 0 0 1 2.306 2.372 2.373 2.373 0 0 1-2.856 2.32 2.373 2.373 0 0 1-1.684-3.273 2.371 2.371 0 0 1 2.234-1.419"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nO)",
    d: "M195.371 520.453a3.661 3.661 0 0 1 2.896 6.147 3.66 3.66 0 0 1-3.988.934 3.665 3.665 0 0 1-2.357-3.354 3.79 3.79 0 0 1 3.449-3.727"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nP)",
    d: "M366.115 286.294a3.027 3.027 0 1 1-2.941 3.176 3.13 3.13 0 0 1 2.941-3.176"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nQ)",
    d: "M376.757 275.282a3.452 3.452 0 1 1-1.174 6.656 3.45 3.45 0 0 1-2.169-3.183 3.58 3.58 0 0 1 3.343-3.473"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nR)",
    d: "M483.308 125.529a3.68 3.68 0 0 1 3.504 2.126 3.68 3.68 0 0 1-.631 4.052 3.68 3.68 0 0 1-3.985.958 3.68 3.68 0 0 1-2.4-3.325 3.84 3.84 0 0 1 1.014-2.59 3.82 3.82 0 0 1 2.498-1.221"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nS)",
    d: "M472.878 137.641a2.245 2.245 0 1 1-.91 4.314 2.24 2.24 0 0 1-1.375-2.069 2.326 2.326 0 0 1 2.285-2.245"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nT)",
    d: "M487.963 2.118a4.39 4.39 0 0 1-3.83 3.515 4.374 4.374 0 0 1-4.76-2.541c-.804-1.589-.783-2.605 0-3.113h8.463a2.58 2.58 0 0 1 .127 2.139"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nU)",
    d: "M195.647 542.878a2.585 2.585 0 0 1 .39 5.126 2.586 2.586 0 0 1-3.035-2.585 2.604 2.604 0 0 1 2.645-2.541"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nV)",
    d: "M344.894 329.937a2.116 2.116 0 1 1 0 4.233 2.116 2.116 0 0 1 0-4.233"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nW)",
    d: "M291.576 404.263a2.455 2.455 0 0 1 1.691 4.215 2.454 2.454 0 0 1-4.166-1.801 2.514 2.514 0 0 1 2.475-2.414"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nX)",
    d: "M558.101 30.98a2.11 2.11 0 0 1 1.955 1.307 2.117 2.117 0 1 1-4.071.81 2.246 2.246 0 0 1 2.116-2.117"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nY)",
    d: "M504.72 105.878a2.12 2.12 0 0 1 2.116 1.884 2.118 2.118 0 0 1-1.883 2.118 1.98 1.98 0 0 1-1.445-.492 2 2 0 0 1-.671-1.371 2.12 2.12 0 0 1 1.883-2.139"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#nZ)",
    d: "M440.612 189.373a3.894 3.894 0 0 1 4.036 4.473 3.9 3.9 0 0 1-2.916 3.202 3.895 3.895 0 0 1-4.823-3.609 3.98 3.98 0 0 1 3.703-4.066"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oa)",
    d: "M334.145 338.809a3.84 3.84 0 0 1 3.579 2.312 3.834 3.834 0 0 1-2.719 5.269 3.82 3.82 0 0 1-3.955-1.582 3.84 3.84 0 0 1-.671-2.124 3.916 3.916 0 0 1 3.766-3.875"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ob)",
    d: "M355.6 319.751a1.544 1.544 0 0 1 .974 2.563 1.55 1.55 0 0 1-1.618.447 1.56 1.56 0 0 1-.946-.842 1.548 1.548 0 0 1 1.59-2.168"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oc)",
    d: "M547.437 41.61a2.24 2.24 0 0 1 2.158 1.29 2.245 2.245 0 0 1-2.843 3.044 2.245 2.245 0 0 1-1.431-2.068 2.305 2.305 0 0 1 2.116-2.266"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#od)",
    d: "M494.099 115.661a2.897 2.897 0 0 1 2.915 3.419 2.899 2.899 0 0 1-5.751-.497 2.947 2.947 0 0 1 2.836-2.922"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oe)",
    d: "M568.765 19.863a2.644 2.644 0 0 1 2.645 3.114 2.65 2.65 0 0 1-2.033 2.117 2.645 2.645 0 0 1-3.215-2.52 2.67 2.67 0 0 1 2.603-2.711"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#of)",
    d: "M302.028 393.188a2.85 2.85 0 0 1 2.902 1.581 2.87 2.87 0 0 1 .102 2.282 2.87 2.87 0 0 1-1.602 1.628 2.857 2.857 0 0 1-3.242-4.503 2.86 2.86 0 0 1 1.84-.988"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#og)",
    d: "M462.213 169.743a2.12 2.12 0 0 1 1.955 1.308 2.115 2.115 0 0 1-.459 2.307 2.12 2.12 0 0 1-2.305.459 2.11 2.11 0 0 1-1.306-1.956 2.115 2.115 0 0 1 2.115-2.118"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oh)",
    d: "M451.445 178.722a3.87 3.87 0 0 1 3.617 2.338 3.876 3.876 0 0 1-2.749 5.327 3.87 3.87 0 0 1-4.677-3.748c0-1.021.398-2.001 1.109-2.733a3.9 3.9 0 0 1 2.7-1.184"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oi)",
    d: "M387.463 264.695a3.234 3.234 0 0 1 3.249 3.816 3.236 3.236 0 0 1-6.422-.534 3.303 3.303 0 0 1 3.173-3.282"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oj)",
    d: "M507.978 4.235a4.37 4.37 0 0 1-3.559 1.322 4.37 4.37 0 0 1-3.253-1.957 3.54 3.54 0 0 1-.677-3.303q.064-.153.148-.297h8.357q.087.142.148.296a3.82 3.82 0 0 1-1.164 3.94"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ok)",
    d: "M579.47 8.47a3.428 3.428 0 0 1 3.314 4.194 3.43 3.43 0 0 1-4.805 2.339 3.43 3.43 0 0 1-1.957-3.314 3.385 3.385 0 0 1 3.448-3.219"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ol)",
    d: "M430.032 222.492a2.793 2.793 0 0 1 2.254 4.671 2.79 2.79 0 0 1-4.338-.26 2.8 2.8 0 0 1-.518-1.553 2.73 2.73 0 0 1 2.602-2.858"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#om)",
    d: "M419.453 233.355a2.605 2.605 0 1 1-.832 5.05 2.6 2.6 0 0 1-1.706-2.319 2.585 2.585 0 0 1 1.528-2.509 2.6 2.6 0 0 1 1.01-.222"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#on)",
    d: "M440.823 212.052a2.54 2.54 0 0 1 0 5.082 2.42 2.42 0 0 1-1.781-.75 2.45 2.45 0 0 1-.673-1.812 2.48 2.48 0 0 1 1.504-2.321c.3-.129.623-.196.95-.199"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oo)",
    d: "M547.395 62.87a2.327 2.327 0 0 1 2.378 2.722 2.326 2.326 0 0 1-4.621-.371 2.26 2.26 0 0 1 .625-1.65 2.26 2.26 0 0 1 1.618-.7"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#op)",
    d: "M494.077 136.582a3.326 3.326 0 0 1 2.464 5.644 3.32 3.32 0 0 1-3.63.76 3.33 3.33 0 0 1-2.071-3.079 3.2 3.2 0 0 1 .215-1.269 3.23 3.23 0 0 1 1.76-1.807c.4-.167.829-.252 1.262-.249"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oq)",
    d: "M206.268 532.036a2.75 2.75 0 0 1 2.66 3.351 2.753 2.753 0 0 1-3.83 1.905 2.76 2.76 0 0 1-1.602-2.63 2.68 2.68 0 0 1 .839-1.891 2.7 2.7 0 0 1 1.933-.735"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#or)",
    d: "M334.209 360.302a3.64 3.64 0 0 1 3.426 2.249c.186.448.28.929.277 1.415a3.703 3.703 0 1 1-7.127-1.366 3.7 3.7 0 0 1 3.424-2.298"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#os)",
    d: "M216.889 521.491a2.62 2.62 0 0 1 2.443 1.616 2.625 2.625 0 0 1-4.623 2.44 2.63 2.63 0 0 1-.423-1.473 2.56 2.56 0 0 1 2.603-2.583"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ot)",
    d: "M472.772 158.817a2.34 2.34 0 0 1 1.802.601 2.34 2.34 0 0 1 .769 1.739 2.355 2.355 0 0 1-1.607 2.23 2.349 2.349 0 0 1-3.09-2.23 2.347 2.347 0 0 1 2.126-2.34"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ou)",
    d: "M323.503 371.61a3 3 0 0 1 2.866 1.817c.159.369.242.767.244 1.169a3.09 3.09 0 0 1-5.225 2.337 3.09 3.09 0 0 1 2.115-5.323"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ov)",
    d: "M312.903 381.605a3.768 3.768 0 0 1 2.569 6.502 3.763 3.763 0 0 1-5.806-.766 3.77 3.77 0 0 1-.55-2.136 3.707 3.707 0 0 1 3.787-3.6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ow)",
    d: "M366.158 308.401a2.22 2.22 0 0 1 2.285 2.118 2.25 2.25 0 0 1-1.284 2.157 2.24 2.24 0 0 1-2.479-.384 2.246 2.246 0 0 1 1.478-3.891"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ox)",
    d: "M377.011 297.241a2.753 2.753 0 1 1-1.291 5.253 2.75 2.75 0 0 1-1.608-2.584c.002-.37.08-.736.23-1.074a2.67 2.67 0 0 1 1.581-1.456c.349-.12.72-.168 1.088-.139"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oy)",
    d: "M387.485 286.569a2.727 2.727 0 0 1 2.729 2.732 2.73 2.73 0 0 1-2.729 2.731 2.73 2.73 0 0 1-2.73-2.731 2.73 2.73 0 0 1 2.73-2.732"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oz)",
    d: "M312.84 403.225a3.495 3.495 0 1 1-1.226 6.75 3.5 3.5 0 0 1-2.223-3.171 3.4 3.4 0 0 1 .943-2.543 3.37 3.37 0 0 1 2.506-1.036"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oA)",
    d: "M430.033 243.667a2.96 2.96 0 0 1 2.8 1.78 2.968 2.968 0 0 1-2.132 4.09 2.96 2.96 0 0 1-3.546-2.947 2.9 2.9 0 0 1 2.878-2.923"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oB)",
    d: "M344.957 350.392a2.96 2.96 0 0 1 2.684 1.914c.208.549.248 1.147.115 1.719a2.96 2.96 0 0 1-2.403 2.256 2.962 2.962 0 0 1-3.442-3.03 2.85 2.85 0 0 1 .902-2.092 2.855 2.855 0 0 1 2.144-.767"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oC)",
    d: "M398.106 275.833a2.79 2.79 0 0 1 2.616 1.662 2.8 2.8 0 0 1-1.934 3.858 2.792 2.792 0 0 1-3.411-2.64 2.72 2.72 0 0 1 .745-2.028 2.73 2.73 0 0 1 1.984-.852"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oD)",
    d: "M451.444 200.85a3.092 3.092 0 1 1-1.074 5.966 3.09 3.09 0 0 1-1.951-2.832 3 3 0 0 1 .841-2.216c.283-.293.623-.526.998-.684a3 3 0 0 1 1.186-.234"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oE)",
    d: "M462.341 189.627a3.64 3.64 0 0 1 3.248 2.393 3.65 3.65 0 0 1-.952 3.923 3.64 3.64 0 0 1-3.984.633 3.64 3.64 0 0 1-2.121-3.434 3.543 3.543 0 0 1 2.377-3.331c.46-.159.947-.222 1.432-.184"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oF)",
    d: "M376.715 318.904a2.435 2.435 0 1 1-1.842 3.833 2.44 2.44 0 0 1-.443-1.355 2.38 2.38 0 0 1 .626-1.716 2.36 2.36 0 0 1 1.659-.762"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oG)",
    d: "M579.449 30.323a2.75 2.75 0 0 1 2.677 1.615c.153.338.235.704.243 1.075a2.856 2.856 0 1 1-4.459-2.193 2.85 2.85 0 0 1 1.603-.497z"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oH)",
    d: "M472.814 180.331a2.12 2.12 0 0 1 1.658.622 2.115 2.115 0 0 1 .606 1.665 2.27 2.27 0 0 1-1.412 2.078 2.265 2.265 0 0 1-2.46-.504 2.27 2.27 0 0 1 .352-3.48 2.27 2.27 0 0 1 1.256-.381"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oI)",
    d: "M216.847 542.751a2.624 2.624 0 0 1 2.75 2.541 2.715 2.715 0 0 1-1.54 2.617c-.488.232-1.035.313-1.569.232a2.7 2.7 0 0 1-1.431-.688 2.715 2.715 0 0 1 .281-4.21 2.7 2.7 0 0 1 1.509-.492"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oJ)",
    d: "M568.617 40.467a3.38 3.38 0 0 1 3.253 1.903 3.39 3.39 0 0 1-.521 3.735 3.385 3.385 0 0 1-5.906-2.081 3.33 3.33 0 0 1 1.893-3.24c.401-.191.837-.299 1.281-.317"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oK)",
    d: "M302.176 413.898a3.488 3.488 0 0 1 3.476 4.118 3.495 3.495 0 0 1-2.687 2.788 3.485 3.485 0 0 1-3.606-1.406 3.5 3.5 0 0 1-.632-1.922 3.358 3.358 0 0 1 3.449-3.578"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oL)",
    d: "M323.587 393.082a2.965 2.965 0 1 1-1.156 5.711 2.96 2.96 0 0 1-1.848-2.704 2.899 2.899 0 0 1 3.004-3.007"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oM)",
    d: "M483.456 169.087a2.83 2.83 0 0 1 2.656 1.742 2.83 2.83 0 0 1-.626 3.117 2.834 2.834 0 0 1-4.823-2.106 2.773 2.773 0 0 1 2.793-2.753"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oN)",
    d: "M355.515 339.55a3.176 3.176 0 0 1 0 6.353 3.05 3.05 0 0 1-3.026-3.282c-.005-.401.069-.8.218-1.172a3.027 3.027 0 0 1 2.808-1.899"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oO)",
    d: "M366.072 328.518a3.49 3.49 0 0 1 3.559 4.126 3.493 3.493 0 0 1-4.796 2.582 3.495 3.495 0 0 1-2.127-3.299 3.4 3.4 0 0 1 .977-2.402 3.4 3.4 0 0 1 2.387-1.007"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oP)",
    d: "M557.932 50.821a3.615 3.615 0 0 1 3.465 2.044 3.623 3.623 0 0 1-2.358 5.078 3.617 3.617 0 0 1-4.514-3.31 3.498 3.498 0 0 1 3.407-3.812"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oQ)",
    d: "M589.944 19.29a3.21 3.21 0 0 1 3.096 1.836 3.215 3.215 0 0 1-.543 3.56 3.21 3.21 0 0 1-3.502.828 3.215 3.215 0 0 1-2.077-2.94 3.156 3.156 0 0 1 3.026-3.283"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oR)",
    d: "M408.748 286.442a2.877 2.877 0 0 1 2.825 2.731 2.88 2.88 0 0 1-3.695 2.908 2.89 2.89 0 0 1-1.755-1.477 2.9 2.9 0 0 1-.118-2.292 2.87 2.87 0 0 1 2.743-1.87"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oS)",
    d: "M451.529 222.492a2.79 2.79 0 0 1 2.574 1.766 2.8 2.8 0 0 1-.668 3.05 2.79 2.79 0 0 1-4.303-.549 2.79 2.79 0 0 1 .445-3.494 2.8 2.8 0 0 1 1.952-.773"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oT)",
    d: "M227.553 532.1a2.687 2.687 0 0 1 1.913 4.598 2.685 2.685 0 0 1-4.579-1.951 2.67 2.67 0 0 1 2.666-2.647"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oU)",
    d: "M355.579 360.705a3.32 3.32 0 0 1 3.044 2.096 3.328 3.328 0 0 1-2.494 4.499 3.32 3.32 0 0 1-3.915-3.334 3.4 3.4 0 0 1 1.028-2.307 3.38 3.38 0 0 1 2.337-.954"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oV)",
    d: "M557.953 72.484a3.38 3.38 0 0 1 3.247 1.931 3.39 3.39 0 0 1-.562 3.74 3.384 3.384 0 0 1-5.88-2.177 3.39 3.39 0 0 1 3.195-3.494"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oW)",
    d: "M494.226 158.372c.757 0 1.484.301 2.019.837a2.86 2.86 0 0 1 0 4.043 2.85 2.85 0 0 1-2.019.837 2.81 2.81 0 0 1-2.835-2.964 2.86 2.86 0 0 1 2.835-2.753"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oX)",
    d: "M238.195 522.782a1.335 1.335 0 1 1-.431 2.622 1.33 1.33 0 0 1-.849-.687 1.34 1.34 0 0 1 .256-1.557 1.33 1.33 0 0 1 1.024-.378"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oY)",
    d: "M344.873 371.123a3.583 3.583 0 0 1 2.497 6.139 3.574 3.574 0 0 1-5.512-.634c-.383-.6-.578-1.3-.561-2.011a3.6 3.6 0 0 1 3.576-3.494"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#oZ)",
    d: "M334.167 383.278a2.1 2.1 0 0 1 1.621.631 2.118 2.118 0 0 1 .6 1.635 2.1 2.1 0 0 1-.664 1.544 2.12 2.12 0 0 1-1.579.573 2.116 2.116 0 0 1-2.115-2.117 2.108 2.108 0 0 1 1.285-2.098c.269-.115.559-.172.852-.168"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pa)",
    d: "M398.169 296.987a3.009 3.009 0 0 1 2.138 5.141 3.01 3.01 0 0 1-3.291.634 3.002 3.002 0 0 1-1.83-2.81 3.026 3.026 0 0 1 2.983-2.965"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pb)",
    d: "M600.818 9.593a2.24 2.24 0 0 1 2.066 1.432 2.245 2.245 0 0 1-3.042 2.845 2.24 2.24 0 0 1-1.288-2.16 2.246 2.246 0 0 1 2.264-2.117"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pc)",
    d: "M440.823 233.567a2.384 2.384 0 0 1 2.227 1.472 2.4 2.4 0 0 1-.523 2.62 2.393 2.393 0 0 1-4.074-1.742 2.373 2.373 0 0 1 2.37-2.35"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pd)",
    d: "M387.527 307.787a2.88 2.88 0 1 1-1.146 5.522 2.88 2.88 0 0 1-1.732-2.706 2.86 2.86 0 0 1 2.878-2.816"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pe)",
    d: "M528.945 4.362a4.225 4.225 0 0 1-5.031.543 4.25 4.25 0 0 1-1.316-1.22 3.57 3.57 0 0 1-.487-3.558h7.998l.127.233a3.731 3.731 0 0 1-1.291 4.002"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pf)",
    d: "M462.066 212.497a2.115 2.115 0 0 1 2.116 1.969 2.12 2.12 0 0 1-2.116 2.118 2.116 2.116 0 0 1-2.116-2.118 2.12 2.12 0 0 1 2.116-1.969"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pg)",
    d: "M568.764 62.976a2.203 2.203 0 1 1 .148 4.403 2.203 2.203 0 0 1-.148-4.403"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ph)",
    d: "M546.549.53q.339-.033.677 0a5.4 5.4 0 0 1 1.016 0c.656.148 1.629-.509 1.925.486a2.46 2.46 0 0 1-.846 2.605 2.75 2.75 0 0 1-3.957-.254 2.44 2.44 0 0 1-.592-2.372c.296-.89 1.185-.317 1.777-.466"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pi)",
    d: "M600.839 31.128a2.115 2.115 0 0 1 2.075 2.53 2.113 2.113 0 0 1-2.884 1.544 2.118 2.118 0 0 1 .809-4.074"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pj)",
    d: "M483.477 191.046a2.116 2.116 0 0 1 2.116 2.118 2.25 2.25 0 0 1-.566 1.625 2.25 2.25 0 0 1-1.55.746 2.307 2.307 0 0 1-2.327-2.117 2.264 2.264 0 0 1 2.327-2.372"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pk)",
    d: "M398.085 318.417a3.02 3.02 0 0 1 2.983 2.71 2.9 2.9 0 1 1-2.983-2.71"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pl)",
    d: "M238.173 543.577a1.927 1.927 0 0 1 1.926 1.863 1.906 1.906 0 0 1-1.799 1.864 1.884 1.884 0 0 1-1.925-1.864 1.923 1.923 0 0 1 1.798-1.863"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pm)",
    d: "M440.611 254.89a2.415 2.415 0 0 1 2.327 1.374c.206.435.278.922.206 1.398a2.409 2.409 0 0 1-3.241 1.895 2.41 2.41 0 0 1-1.556-2.21 2.503 2.503 0 0 1 2.264-2.457"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pn)",
    d: "M451.402 243.519a3.04 3.04 0 0 1 2.866 1.768 3.048 3.048 0 0 1-5.194 3.121 3.05 3.05 0 0 1-.613-1.649 3.133 3.133 0 0 1 2.941-3.24"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#po)",
    d: "M334.166 403.458a3.26 3.26 0 0 1 3.048 2.004 3.26 3.26 0 0 1-.718 3.578 3.25 3.25 0 0 1-3.584.671 3.26 3.26 0 0 1-1.962-3.077 3.39 3.39 0 0 1 3.216-3.176"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pp)",
    d: "M611.44 19.842a2.66 2.66 0 0 1 2.469 1.613 2.67 2.67 0 0 1-1.87 3.659 2.66 2.66 0 0 1-2.752-1.059 2.66 2.66 0 0 1-.491-1.46 2.75 2.75 0 0 1 2.644-2.753"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pq)",
    d: "M494.225 179.505a3.07 3.07 0 0 1 2.151.945 3.067 3.067 0 0 1-.09 4.342 3.065 3.065 0 0 1-4.338-.09 3.08 3.08 0 0 1-.854-2.19 3.06 3.06 0 0 1 .943-2.152 3.063 3.063 0 0 1 2.188-.855"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pr)",
    d: "M579.534 51.817a2.709 2.709 0 0 1 1.797 4.678 2.705 2.705 0 0 1-4.157-.531 2.7 2.7 0 0 1-.411-1.522 2.774 2.774 0 0 1 2.771-2.625"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ps)",
    d: "M568.765 84.702a1.86 1.86 0 0 1 1.936 1.79 1.87 1.87 0 0 1-1.081 1.767 1.87 1.87 0 0 1-1.441.05 1.9 1.9 0 0 1-1.065-.997 1.9 1.9 0 0 1-.169-.725 1.926 1.926 0 0 1 1.82-1.885"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pt)",
    d: "M344.682 393.315a2.73 2.73 0 0 1 2.645 1.534 2.74 2.74 0 0 1-.436 3.029 2.73 2.73 0 0 1-4.748-1.768 2.815 2.815 0 0 1 2.539-2.795"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pu)",
    d: "M323.651 414.194a3.13 3.13 0 0 1 3.068 3.134 3.23 3.23 0 0 1-.927 2.282 3.22 3.22 0 0 1-2.268.958 3.277 3.277 0 0 1-3.174-3.261 3.22 3.22 0 0 1 3.301-3.113"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pv)",
    d: "M355.388 382.727a2.647 2.647 0 1 1 .621 5.257 2.647 2.647 0 0 1-.621-5.257"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pw)",
    d: "M590.176 41.398a2.39 2.39 0 0 1 2.391 2.372 2.47 2.47 0 0 1-.682 1.763 2.45 2.45 0 0 1-1.73.757 2.517 2.517 0 0 1-2.497-2.457 2.48 2.48 0 0 1 1.567-2.262c.303-.12.626-.178.951-.173"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#px)",
    d: "M408.875 308.189a2.461 2.461 0 0 1 1.896.636 2.47 2.47 0 0 1 .808 1.831 2.48 2.48 0 0 1-1.689 2.349 2.474 2.474 0 0 1-3.262-2.349 2.478 2.478 0 0 1 2.247-2.467"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#py)",
    d: "M462.171 233.355a2.71 2.71 0 0 1 2.582 2.541 2.6 2.6 0 0 1-.415 1.446 2.575 2.575 0 0 1-2.644 1.135 2.58 2.58 0 0 1-2.051-2.019 2.585 2.585 0 0 1 2.528-3.103"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pz)",
    d: "M622.061 9.02a2.917 2.917 0 0 1 2.856 2.69 2.78 2.78 0 0 1-.773 1.995 2.791 2.791 0 0 1-4.812-1.868 2.88 2.88 0 0 1 2.729-2.816"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pA)",
    d: "M504.593 168.706a3.214 3.214 0 0 1 3.415 3.661 3.22 3.22 0 0 1-2.415 2.674 3.21 3.21 0 0 1-3.38-1.246 3.22 3.22 0 0 1-.604-1.786 3.35 3.35 0 0 1 2.984-3.303"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pB)",
    d: "M387.612 328.497a3.51 3.51 0 0 1 3.181 2.222 3.517 3.517 0 0 1-2.599 4.743 3.51 3.51 0 0 1-4.179-3.429 3.617 3.617 0 0 1 3.597-3.536"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pC)",
    d: "M472.856 200.406a3.53 3.53 0 0 1 3.26 3.525 3.54 3.54 0 0 1-3.26 3.526 3.525 3.525 0 0 1-3.511-2.109 3.54 3.54 0 0 1 0-2.833 3.528 3.528 0 0 1 3.511-2.109"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pD)",
    d: "M376.778 340.44a2.24 2.24 0 0 1 2.329 2.648 2.241 2.241 0 0 1-4.12.762 2.25 2.25 0 0 1-.325-1.293 2.12 2.12 0 0 1 2.116-2.117"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pE)",
    d: "M419.454 275.621a3.003 3.003 0 0 1 3.004 3.007 3.01 3.01 0 0 1-3.004 3.007 3.005 3.005 0 0 1-3.005-3.007 3.005 3.005 0 0 1 3.005-3.007"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pF)",
    d: "M248.943 532.629a2.11 2.11 0 0 1 1.955 1.307 2.119 2.119 0 0 1-2.765 2.767 2.115 2.115 0 0 1-1.306-1.956 2.246 2.246 0 0 1 2.116-2.118"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pG)",
    d: "M366.242 350.413a2.94 2.94 0 0 1 2.692 1.862 2.95 2.95 0 0 1-.694 3.2 2.938 2.938 0 0 1-4.52-.534 2.95 2.95 0 0 1-.462-1.648 2.99 2.99 0 0 1 2.984-2.88"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pH)",
    d: "M312.945 426.179a1.88 1.88 0 0 1 1.766 2.322 1.881 1.881 0 0 1-3.441.54 1.9 1.9 0 0 1-.272-1.062 1.907 1.907 0 0 1 1.947-1.8"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pI)",
    d: "M376.758 360.768a3.26 3.26 0 1 1 0 6.501 3.2 3.2 0 0 1-2.313-.98 3.23 3.23 0 0 1-.903-2.345 3.154 3.154 0 0 1 3.216-3.176"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pJ)",
    d: "M419.454 297.453a2.624 2.624 0 0 1 2.476 2.562 2.544 2.544 0 0 1-2.529 2.31 2.54 2.54 0 0 1-2.528-2.31 2.626 2.626 0 0 1 2.581-2.562"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pK)",
    d: "M572.234 2.69a3.94 3.94 0 0 1-3.364 2.329 3.9 3.9 0 0 1-3.237-1.821 3.11 3.11 0 0 1-.508-2.774q.08-.205.211-.382h6.602c.825.403.909 1.25.296 2.647"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pL)",
    d: "M430.202 287.098a2.11 2.11 0 0 1 1.862 1.392 2.119 2.119 0 0 1-2.826 2.667 2.116 2.116 0 0 1-1.279-1.941 2.265 2.265 0 0 1 2.243-2.118"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pM)",
    d: "M483.541 211.946a2.68 2.68 0 0 1 1.47.485 2.672 2.672 0 0 1-1.076 4.811 2.66 2.66 0 0 1-2.709-1.199 2.66 2.66 0 0 1-.414-1.492 2.707 2.707 0 0 1 2.729-2.605"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pN)",
    d: "M590.177 62.277a2.96 2.96 0 0 1 2.771 2.965 2.918 2.918 0 0 1-3.538 2.813 2.915 2.915 0 0 1-2.255-2.34 2.924 2.924 0 0 1 2.937-3.438z"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pO)",
    d: "M579.407 72.971a2.898 2.898 0 0 1 2.917 3.412 2.898 2.898 0 0 1-5.752-.469 3.01 3.01 0 0 1 2.835-2.943"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pP)",
    d: "M472.877 222.343a2.98 2.98 0 0 1 2.747 1.873 2.98 2.98 0 0 1-.689 3.254 3 3 0 0 1-1.544.797 2.99 2.99 0 0 1-3.048-1.328 3 3 0 0 1-.47-1.673 3.046 3.046 0 0 1 3.004-2.923"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pQ)",
    d: "M366.136 371.674a3.02 3.02 0 0 1 2.836 1.815 3.04 3.04 0 0 1-.596 3.315 3.026 3.026 0 0 1-4.667-.383 3.03 3.03 0 0 1-.535-1.677 3.115 3.115 0 0 1 2.962-3.07"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pR)",
    d: "M494.078 200.766a3 3 0 0 1 3.237 2.964 3.15 3.15 0 0 1-.837 2.398 3.14 3.14 0 0 1-2.337.99 3.17 3.17 0 0 1-3.173-3.176 3.177 3.177 0 0 1 3.173-3.176z"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pS)",
    d: "M334.166 426.116a1.94 1.94 0 0 1 1.981 1.145 1.95 1.95 0 0 1-.475 2.24 1.94 1.94 0 0 1-1.506.49 1.947 1.947 0 0 1 0-3.875"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pT)",
    d: "M600.628 51.287a3.235 3.235 0 0 1 3.184 3.08 3.24 3.24 0 0 1-2.866 3.379 3.195 3.195 0 0 1-3.386-3.282 3.12 3.12 0 0 1 1.876-2.922 3.1 3.1 0 0 1 1.192-.255"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pU)",
    d: "M387.442 350.35a2.98 2.98 0 0 1 2.891 2.857 2.99 2.99 0 0 1-2.637 3.093 2.813 2.813 0 0 1-3.131-2.668 2.98 2.98 0 0 1 .718-2.274 2.96 2.96 0 0 1 2.159-1.008"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pV)",
    d: "M593.562 1.25a3.36 3.36 0 0 1-.971 2.422 3.34 3.34 0 0 1-2.414.987 3.3 3.3 0 0 1-3.576-3.325A2.12 2.12 0 0 1 587.024 0h6.136c.381.233.402.593.402 1.25"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pW)",
    d: "M504.677 190.051a2.978 2.978 0 0 1 3.365 2.986 3.25 3.25 0 0 1-.844 2.334 3.26 3.26 0 0 1-2.246 1.054 3.25 3.25 0 0 1-2.332-.845 3.3 3.3 0 0 1-.75-1.018 3.3 3.3 0 0 1-.303-1.229 3.073 3.073 0 0 1 3.11-3.282"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pX)",
    d: "M355.494 405.067a1.63 1.63 0 0 1 1.629 1.631 1.628 1.628 0 0 1-1.629 1.63c-1.037 0-1.566-.571-1.693-1.672a1.563 1.563 0 0 1 1.693-1.589"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pY)",
    d: "M408.642 328.814a3.18 3.18 0 0 1 3.375 2.975 3.178 3.178 0 1 1-6.347.403 3.175 3.175 0 0 1 1.773-3.059 3.2 3.2 0 0 1 1.199-.319"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pZ)",
    d: "M398.02 339.466a2.97 2.97 0 0 1 2.367.711 2.985 2.985 0 0 1 1.019 2.253 3.26 3.26 0 0 1-.829 2.341 3.25 3.25 0 0 1-2.239 1.068 3.23 3.23 0 0 1-3.095-1.843 3.3 3.3 0 0 1-.312-1.227 3.055 3.055 0 0 1 1.849-3.063 3 3 0 0 1 1.24-.24"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qa)",
    d: "M622.145 30.366a2.624 2.624 0 0 1 2.73 2.837 2.52 2.52 0 0 1-2.793 2.795 2.52 2.52 0 0 1-2.73-2.816 2.63 2.63 0 0 1 .754-2.046 2.62 2.62 0 0 1 2.039-.77"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qb)",
    d: "M462.192 254.382a2.9 2.9 0 0 1 2.899 2.901 2.898 2.898 0 0 1-2.899 2.901c-1.841 0-2.771-1.122-2.92-3.07a2.79 2.79 0 0 1 1.827-2.562 2.8 2.8 0 0 1 1.093-.17"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qc)",
    d: "M611.461 41.928a1.84 1.84 0 0 1 1.847 1.312c.079.26.098.536.057.805a1.775 1.775 0 0 1-1.258 1.717c-.244.074-.5.095-.752.062a1.904 1.904 0 0 1-1.852-1.959 1.904 1.904 0 0 1 1.958-1.853z"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qd)",
    d: "M515.384 180.162a2.112 2.112 0 0 1 2.382 1.351c.114.313.153.648.114.978a2.115 2.115 0 0 1-2.306 2.499 2.41 2.41 0 0 1-2.507-2.319 2.417 2.417 0 0 1 2.317-2.509"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qe)",
    d: "M344.661 414.406a2.87 2.87 0 0 1 2.969 1.743c.16.379.237.789.226 1.2a2.9 2.9 0 0 1-1.754 2.815 2.9 2.9 0 0 1-1.145.235 2.86 2.86 0 0 1-2.158-.759 2.85 2.85 0 0 1-.91-2.1 2.77 2.77 0 0 1 2.772-3.134"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qf)",
    d: "M366.031 393.971a1.96 1.96 0 0 1 1.479.5 1.96 1.96 0 0 1 .637 1.427 1.86 1.86 0 0 1-.461 1.502 1.86 1.86 0 0 1-1.444.616 1.84 1.84 0 0 1-1.975-1.111 1.8 1.8 0 0 1-.14-.795 1.92 1.92 0 0 1 .476-1.494 1.93 1.93 0 0 1 1.428-.645"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qg)",
    d: "M440.612 297.072a2.9 2.9 0 0 1 2.272 4.893 2.897 2.897 0 0 1-5.002-2.013 2.77 2.77 0 0 1 .752-2.022 2.76 2.76 0 0 1 1.978-.858"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qh)",
    d: "M579.492 94.274a2.66 2.66 0 0 1 2.753 1.799c.127.374.169.772.124 1.165 0 1.885-1.121 2.817-3.131 2.965a2.82 2.82 0 0 1-2.587-1.905 2.8 2.8 0 0 1-.143-1.123 2.69 2.69 0 0 1 1.811-2.775 2.7 2.7 0 0 1 1.173-.126"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qi)",
    d: "M643.346 9.487a2.11 2.11 0 0 1 1.828.525 2.12 2.12 0 0 1 .668 1.783c0 1.524-.867 2.287-2.496 2.456a2.28 2.28 0 0 1-2.111-1.558 2.3 2.3 0 0 1-.111-.92 2.11 2.11 0 0 1 .592-1.648 2.11 2.11 0 0 1 1.63-.638"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qj)",
    d: "M344.64 436.047a2.5 2.5 0 0 1 2.899 2.393 2.712 2.712 0 0 1-2.95 3.008 2.711 2.711 0 0 1 .051-5.401"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qk)",
    d: "M622.082 52.283a2.12 2.12 0 0 1 1.593.565 2.105 2.105 0 0 1 .671 1.552 2.12 2.12 0 0 1-.603 1.689 2.12 2.12 0 0 1-1.682.62 2.116 2.116 0 0 1-2.116-2.013 2.24 2.24 0 0 1 .558-1.66 2.24 2.24 0 0 1 1.579-.754"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ql)",
    d: "M494.12 222.343a2.75 2.75 0 0 1 2.114.817 2.75 2.75 0 0 1 .784 2.127 2.65 2.65 0 0 1-1.713 2.633 2.65 2.65 0 0 1-1.101.162 2.9 2.9 0 0 1-1.216-.237 2.89 2.89 0 0 1-1.609-1.809c-.12-.4-.153-.822-.094-1.236a2.67 2.67 0 0 1 2.835-2.457"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qm)",
    d: "M483.689 233.757a2.12 2.12 0 0 1 1.448.738 2.13 2.13 0 0 1 .498 1.549 1.966 1.966 0 0 1-2.115 2.118 1.95 1.95 0 0 1-1.554-.563 1.94 1.94 0 0 1-.562-1.555c-.043-1.525.804-2.181 2.285-2.287"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qn)",
    d: "M504.846 212.243a2.11 2.11 0 0 1 1.72.608 2.13 2.13 0 0 1 .608 1.721 2.4 2.4 0 0 1-1.446 2.261 2.39 2.39 0 0 1-2.635-.506 2.396 2.396 0 0 1 .402-3.708 2.4 2.4 0 0 1 1.351-.376"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qo)",
    d: "M614.529 1.27a3.046 3.046 0 0 1-3.047 3.092 3.09 3.09 0 0 1-3.11-3.05c0-.74.212-1.1.487-1.27h5.247a1.48 1.48 0 0 1 .423 1.229"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qp)",
    d: "M408.875 350.456a2.68 2.68 0 0 1 2.101.742 2.7 2.7 0 0 1 .819 2.074 2.95 2.95 0 0 1-.764 2.241 2.96 2.96 0 0 1-2.166.952 2.94 2.94 0 0 1-2.783-1.992 2.95 2.95 0 0 1-.148-1.201 2.83 2.83 0 0 1 .869-2.038c.275-.263.6-.468.956-.602a2.8 2.8 0 0 1 1.116-.176"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qq)",
    d: "M472.856 244.027a2.38 2.38 0 0 1 1.901.707c.245.251.431.553.545.885s.153.685.114 1.034a2.594 2.594 0 0 1-1.542 2.618 2.6 2.6 0 0 1-2.971-.627 2.6 2.6 0 0 1-.671-1.991 2.376 2.376 0 0 1 2.624-2.626"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qr)",
    d: "M611.503 62.637a2.37 2.37 0 0 1 2.455 2.287 2.437 2.437 0 0 1-2.349 2.837 2.37 2.37 0 0 1-2.423-1.302 2.4 2.4 0 0 1-.243-.942 2.546 2.546 0 0 1 2.56-2.88"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qs)",
    d: "M515.426 201.168a2.58 2.58 0 0 1 2.617 1.581c.14.338.207.701.196 1.066a2.677 2.677 0 0 1-1.719 2.685 2.7 2.7 0 0 1-1.116.174 2.725 2.725 0 0 1-2.534-1.716 2.7 2.7 0 0 1-.195-1.058 2.66 2.66 0 0 1 .787-1.959 2.67 2.67 0 0 1 1.964-.773"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qt)",
    d: "M419.454 318.713a2.624 2.624 0 0 1 2.858 2.616 2.63 2.63 0 0 1-.853 1.938 2.63 2.63 0 0 1-2.005.677c-1.672 0-2.518-.953-2.709-2.711a2.49 2.49 0 0 1 .79-1.868 2.47 2.47 0 0 1 1.919-.652"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qu)",
    d: "M590.092 83.94c1.608.148 2.581.953 2.56 2.605a2.54 2.54 0 0 1-2.528 2.309 2.54 2.54 0 0 1-2.529-2.31c-.063-1.588.889-2.413 2.497-2.604"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qv)",
    d: "M430.032 307.49a2.984 2.984 0 0 1 3.238 3.029c.061.399.035.806-.077 1.194a2.78 2.78 0 0 1-1.526 1.772 2.8 2.8 0 0 1-1.169.252 2.85 2.85 0 0 1-2.392-.581 2.85 2.85 0 0 1-1.036-2.235c-.169-2.012.847-3.113 2.962-3.431"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qw)",
    d: "M376.736 382.494c1.798.127 2.898.974 2.941 2.817a2.82 2.82 0 0 1-2.708 2.922 2.815 2.815 0 0 1-2.92-2.711 2.68 2.68 0 0 1 .656-2.124 2.7 2.7 0 0 1 2.031-.904"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qx)",
    d: "M259.48 543.683a1.61 1.61 0 0 1 1.841 1.715 1.78 1.78 0 0 1-2.424 1.897 1.78 1.78 0 0 1-1.11-1.77 1.62 1.62 0 0 1 .407-1.325 1.6 1.6 0 0 1 1.286-.517"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qy)",
    d: "M600.755 73.14a2.705 2.705 0 0 1 2.554 1.65 2.715 2.715 0 0 1-.585 2.984 2.706 2.706 0 0 1-4.194-.473 2.7 2.7 0 0 1-.42-1.535 2.607 2.607 0 0 1 2.645-2.626"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qz)",
    d: "M387.569 372.118a2.37 2.37 0 0 1 2.475 2.308 2.44 2.44 0 0 1-1.353 2.556c-.311.15-.65.231-.995.24a2.4 2.4 0 0 1-1.853-.536 2.38 2.38 0 0 1-.855-1.73 2.54 2.54 0 0 1 1.522-2.633 2.5 2.5 0 0 1 1.059-.205"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qA)",
    d: "M355.409 425.269a2.686 2.686 0 0 1 2.723 1.71c.138.359.198.744.176 1.127a2.74 2.74 0 0 1-1.704 2.575 2.7 2.7 0 0 1-1.068.199c-1.671-.19-2.75-1.037-2.771-2.774a2.558 2.558 0 0 1 2.644-2.837"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qB)",
    d: "M397.745 361.065a2.98 2.98 0 0 1 3.064 1.597 3 3 0 0 1 .322 1.177 2.75 2.75 0 0 1-.653 2.167 2.75 2.75 0 0 1-2.056.945 2.83 2.83 0 0 1-2.963-1.69 2.8 2.8 0 0 1-.231-1.189 2.77 2.77 0 0 1 .636-2.026 2.781 2.781 0 0 1 1.881-.981"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qC)",
    d: "M355.451 446.805a2.475 2.475 0 0 1 2.539 2.371 2.37 2.37 0 0 1-.577 1.799 2.364 2.364 0 0 1-1.708.806 2.52 2.52 0 0 1-2.666-2.435c.01-.65.263-1.272.71-1.743a2.58 2.58 0 0 1 1.702-.798"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qD)",
    d: "M590.134 105.603a2.26 2.26 0 0 1 2.263 2.265 2.267 2.267 0 0 1-2.263 2.266c-1.418 0-2.116-.889-2.307-2.266.17-1.376.889-2.265 2.307-2.265"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qE)",
    d: "M462.108 297.199a2.754 2.754 0 0 1 2.835 2.668 2.84 2.84 0 0 1-2.856 2.944 2.797 2.797 0 0 1-2.708-2.669 2.875 2.875 0 0 1 2.729-2.943"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qF)",
    d: "M366.178 415.041c1.397.17 2.306.868 2.306 2.329a2.287 2.287 0 0 1-2.285 2.287 2.288 2.288 0 0 1-2.285-2.287c-.021-1.439.889-2.159 2.264-2.329"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qG)",
    d: "M451.529 308.295a2.327 2.327 0 0 1 2.264 2.308 2.113 2.113 0 0 1-1.414 2.228 2.1 2.1 0 0 1-.935.102 2.123 2.123 0 0 1-2.09-1.37 2.1 2.1 0 0 1-.131-.875c-.149-1.525.909-2.202 2.306-2.393"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qH)",
    d: "M398.021 382.727a2.64 2.64 0 0 1 2.021.683 2.65 2.65 0 0 1 .636 3.021 2.65 2.65 0 0 1-2.657 1.569c-1.544 0-2.369-1.08-2.602-2.605a2.62 2.62 0 0 1 2.602-2.668"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qI)",
    d: "M632.661 42.14a1.605 1.605 0 0 1 1.7.934c.095.212.143.442.141.675 0 1.08-.571 1.651-1.65 1.863a1.69 1.69 0 0 1-1.629-.996 1.7 1.7 0 0 1-.149-.655 1.594 1.594 0 0 1 .921-1.682c.209-.095.437-.142.666-.14"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qJ)",
    d: "M622.103 74.115a1.8 1.8 0 0 1 0 3.6 1.86 1.86 0 0 1-1.798-1.843 1.74 1.74 0 0 1 .529-1.258 1.75 1.75 0 0 1 1.269-.5"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qK)",
    d: "M408.706 372.69a1.93 1.93 0 0 1 1.448.456 1.93 1.93 0 0 1 .667 1.365 2.115 2.115 0 0 1-1.967 2.118 2.116 2.116 0 0 1-2.116-1.927 2.116 2.116 0 0 1 1.968-2.012"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qL)",
    d: "M483.562 254.996a2.245 2.245 0 0 1 2.116 2.308 2.224 2.224 0 0 1-2.222 2.224 2.22 2.22 0 0 1-2.221-2.224c0-1.376.888-2.096 2.327-2.308"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qM)",
    d: "M526.111 191.321a1.945 1.945 0 0 1 1.743 1.938 1.943 1.943 0 0 1-1.743 1.937c-1.228 0-1.841-.741-1.989-1.927s.783-1.948 1.989-1.948"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qN)",
    d: "M440.844 318.353a2.98 2.98 0 0 1 2.732 2.976 2.987 2.987 0 0 1-2.732 2.975c-1.883 0-2.856-1.101-3.153-2.922.318-1.821 1.27-3.029 3.153-3.029"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qO)",
    d: "M494.246 244.874a1.64 1.64 0 0 1 1.206.507 1.63 1.63 0 0 1 .445 1.23 1.64 1.64 0 0 1-.479 1.294 1.63 1.63 0 0 1-1.298.463c-1.122 0-1.651-.741-1.778-1.821.212-1.059.804-1.736 1.904-1.673"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qP)",
    d: "M419.454 339.656a3.01 3.01 0 0 1 2.312.737 3.03 3.03 0 0 1 .804 3.421 3.03 3.03 0 0 1-2.968 1.877c-1.904 0-2.878-1.122-3.153-2.943.17-1.821 1.079-3.05 3.005-3.092"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qQ)",
    d: "M430.033 328.941c1.84.212 3.046 1.144 3.068 3.05a2.98 2.98 0 0 1-5.041 2.237 3 3 0 0 1-.926-2.089c-.042-1.8 1.143-2.901 2.899-3.198"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qR)",
    d: "M515.383 223.36a1.926 1.926 0 0 1 1.989 1.863 1.927 1.927 0 0 1-1.862 1.991 1.9 1.9 0 0 1-1.772-1.157 1.9 1.9 0 0 1-.153-.728 1.85 1.85 0 0 1 .477-1.37 1.85 1.85 0 0 1 1.321-.599"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qS)",
    d: "M504.741 233.969a1.87 1.87 0 0 1 1.535.487 1.87 1.87 0 0 1 .581 1.503 1.823 1.823 0 0 1-1.905 1.949 1.932 1.932 0 0 1-1.487-.508 1.94 1.94 0 0 1-.628-1.441 1.99 1.99 0 0 1 1.904-1.99"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qT)",
    d: "M472.751 266.05c.266-.036.537-.015.795.061a1.918 1.918 0 0 1 1.384 1.785 1.93 1.93 0 0 1-2.052 1.987c-1.228 0-1.841-.699-2.116-1.927.233-1.144.783-1.885 1.989-1.906"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qU)",
    d: "M387.59 393.866a2.1 2.1 0 0 1 1.568.686 2.1 2.1 0 0 1 .548 1.622 2.11 2.11 0 0 1-1.364 1.917 2.12 2.12 0 0 1-2.731-1.229 2.1 2.1 0 0 1-.136-.815c-.106-1.398.783-2.076 2.115-2.181"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qV)",
    d: "M376.927 403.733a2.964 2.964 0 0 1 0 5.93c-1.883 0-2.836-1.144-3.089-2.965.253-1.821 1.184-3.007 3.089-2.965"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qW)",
    d: "M600.903 94.57a2.43 2.43 0 0 1 1.831.733 2.43 2.43 0 0 1 .687 1.85 2.475 2.475 0 0 1-2.645 2.69c-1.671 0-2.496-1.101-2.687-2.71.275-1.61 1.206-2.648 2.814-2.563"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qX)",
    d: "M611.504 83.961c1.459.254 2.454 1.059 2.454 2.541a2.38 2.38 0 0 1-.743 1.8 2.37 2.37 0 0 1-1.838.635 2.308 2.308 0 0 1-2.412-2.456c-.022-1.525.909-2.33 2.539-2.52"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qY)",
    d: "M632.724 4.235a2.967 2.967 0 0 1-2.962-2.859c0-.762.127-1.122.424-1.334h5.204c.293.34.444.78.424 1.229a3.04 3.04 0 0 1-.931 2.122 3.02 3.02 0 0 1-2.159.842"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#qZ)",
    d: "M632.725 62.34a2.855 2.855 0 0 1 2.682 2.79 2.86 2.86 0 0 1-2.555 2.907c-1.757 0-2.709-1.08-2.984-2.88a2.85 2.85 0 0 1 .846-2 2.83 2.83 0 0 1 2.011-.816"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ra)",
    d: "M483.625 276.341a2.1 2.1 0 0 1 1.56.679 2.12 2.12 0 0 1 .556 1.608 2.13 2.13 0 0 1-.623 1.716 2.108 2.108 0 0 1-1.725.592 2.26 2.26 0 0 1-1.646-.685 2.28 2.28 0 0 1-.639-1.665c.275-1.44 1.1-2.33 2.517-2.245"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rb)",
    d: "M430.033 351.176a2.11 2.11 0 0 1 2.149 1.255c.119.272.18.565.178.862 0 1.334-.761 2.118-2.115 2.308a2.116 2.116 0 0 1-2.116-2.117 2.116 2.116 0 0 1 1.904-2.308"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rc)",
    d: "M526.11 211.756a2.87 2.87 0 0 1 2.671 1.758c.148.348.225.722.228 1.1a2.88 2.88 0 0 1-2.798 3.181 2.9 2.9 0 0 1-1.161-.217 2.87 2.87 0 0 1-1.603-1.667 2.9 2.9 0 0 1-.172-1.17c-.148-1.821 1.1-2.795 2.835-2.985"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rd)",
    d: "M643.451 53.045a1.42 1.42 0 0 1 1.418 1.46 1.3 1.3 0 0 1-.352 1.006 1.32 1.32 0 0 1-.981.414 1.333 1.333 0 0 1-1.524-1.356c-.042-.889.529-1.397 1.439-1.524"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#re)",
    d: "M366.242 436.365a2.37 2.37 0 0 1 2.146 2.361 2.374 2.374 0 0 1-2.146 2.361 2.35 2.35 0 0 1-2.182-1.48 2.4 2.4 0 0 1-.167-.913c.106-1.44.91-2.371 2.349-2.329"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rf)",
    d: "M440.887 339.847c.365 0 .727.073 1.064.215s.641.352.896.614a2.72 2.72 0 0 1 .769 1.987 2.78 2.78 0 0 1-2.888 2.658 2.775 2.775 0 0 1-2.655-2.891 2.71 2.71 0 0 1 2.814-2.583"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rg)",
    d: "M536.859 201.168a2.794 2.794 0 0 1 0 5.59c-1.735 0-2.688-1.059-2.92-2.774a2.8 2.8 0 0 1 .861-2.03 2.8 2.8 0 0 1 2.059-.786"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rh)",
    d: "M419.454 361.382a2.49 2.49 0 0 1 1.914.75 2.49 2.49 0 0 1 .688 1.94 2.666 2.666 0 0 1-2.687 2.646c-1.608-.254-2.645-1.143-2.602-2.752a2.46 2.46 0 0 1 .757-1.902c.255-.245.559-.432.891-.55a2.5 2.5 0 0 1 1.039-.132"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ri)",
    d: "M654.179 41.483a2.11 2.11 0 0 1 1.757.709 2.12 2.12 0 0 1 .486 1.832 2.29 2.29 0 0 1-2.328 2.224c-1.46-.17-2.348-.953-2.348-2.351a2.116 2.116 0 0 1 2.433-2.414"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rj)",
    d: "M376.821 425.502a2.54 2.54 0 0 1 2.624 2.456 2.538 2.538 0 0 1-2.454 2.626c-1.566 0-2.476-.889-2.73-2.541a2.56 2.56 0 0 1 2.56-2.541"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rk)",
    d: "M494.141 265.33a2.42 2.42 0 0 1 1.891.647 2.42 2.42 0 0 1 .754 1.852 2.64 2.64 0 0 1-1.443 2.698 2.65 2.65 0 0 1-2.11.11 2.65 2.65 0 0 1-1.715-2.533 2.46 2.46 0 0 1 1.551-2.618 2.45 2.45 0 0 1 1.072-.156"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rl)",
    d: "M654.031.106c.74.487 2.391-.847 2.391 1.143a2.27 2.27 0 0 1-.644 1.74 2.26 2.26 0 0 1-1.726.674 2.11 2.11 0 0 1-1.681-.62 2.123 2.123 0 0 1-.604-1.689c-.085-1.862 1.375-.93 2.264-1.248"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rm)",
    d: "M387.463 415.041a2.41 2.41 0 0 1 2.638 2.404 2.42 2.42 0 0 1-.789 1.785 2.4 2.4 0 0 1-1.849.618 2.41 2.41 0 0 1-2.186-2.403 2.412 2.412 0 0 1 2.186-2.404"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rn)",
    d: "M366.157 457.964a1.91 1.91 0 0 1 1.494.484 1.9 1.9 0 0 1 .622 1.443 1.95 1.95 0 0 1-.442 1.611 1.94 1.94 0 0 1-1.526.676 2 2 0 0 1-1.596-.483 1.996 1.996 0 0 1-.668-1.529c.085-1.355.72-2.181 2.116-2.202"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ro)",
    d: "M622.104 94.612a2.604 2.604 0 1 1-2.616 3.645 2.604 2.604 0 0 1 2.616-3.645"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rp)",
    d: "M376.884 448.054a1.2 1.2 0 0 1 .964.348 1.21 1.21 0 0 1 .348.965 1.25 1.25 0 0 1-1.375 1.376 1.267 1.267 0 0 1-1.354-1.313c.063-.889.507-1.397 1.417-1.376"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rq)",
    d: "M643.494 73.543a2.114 2.114 0 0 1 2.349 2.265 2.118 2.118 0 0 1-2.37 2.372 2.328 2.328 0 0 1-.851-4.548c.309-.096.635-.127.957-.09z"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rr)",
    d: "M632.81 84.512a2.12 2.12 0 0 1 1.053 3.253 2.12 2.12 0 0 1-1.053.77 1.884 1.884 0 0 1-2.116-1.99c.148-1.292.804-2.055 2.116-2.033"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rs)",
    d: "M664.779 31.319a1.775 1.775 0 0 1 1.819 1.736 1.69 1.69 0 0 1-.405 1.352 1.7 1.7 0 0 1-1.287.575 1.69 1.69 0 0 1-1.834-1.053 1.7 1.7 0 0 1-.113-.747c-.021-1.122.656-1.736 1.82-1.863"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rt)",
    d: "M611.419 105.878a1.92 1.92 0 0 1 1.562.554 1.921 1.921 0 0 1 .553 1.563 2.116 2.116 0 1 1-4.231 0 1.92 1.92 0 0 1 .553-1.563 1.93 1.93 0 0 1 1.563-.554"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ru)",
    d: "M472.708 308.126a2.325 2.325 0 0 1 2.423 1.413c.13.309.191.644.18.98a2.24 2.24 0 0 1-.465 1.785 2.213 2.213 0 0 1-1.651.819 2.28 2.28 0 0 1-2.73-1.179 2.3 2.3 0 0 1-.232-1.044 2.4 2.4 0 0 1 1.436-2.591 2.4 2.4 0 0 1 1.039-.183"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rv)",
    d: "M451.465 330.339a1.775 1.775 0 0 1 1.584 1.768 1.78 1.78 0 0 1-1.584 1.768 1.7 1.7 0 0 1-.703-.087 1.702 1.702 0 0 1-1.138-1.649c.149-1.207.699-1.8 1.841-1.8"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rw)",
    d: "M536.837 223.783a1.483 1.483 0 0 1 0 2.965c-.909 0-1.375-.551-1.46-1.546a1.4 1.4 0 0 1 .424-1.025 1.39 1.39 0 0 1 1.036-.394"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rx)",
    d: "M504.868 255.674a1.48 1.48 0 0 1 1.507 1.026c.067.208.087.429.059.647.009.216-.027.433-.107.634a1.55 1.55 0 0 1-.359.534 1.536 1.536 0 0 1-1.185.42 1.54 1.54 0 0 1-1.511-1.047 1.54 1.54 0 0 1-.076-.647 1.508 1.508 0 0 1 1.029-1.501c.207-.068.426-.091.643-.066"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ry)",
    d: "M419.623 383.108a2.12 2.12 0 0 1 1.986 1.381c.1.269.144.556.13.843a2.12 2.12 0 0 1-2.264 2.287 2.28 2.28 0 0 1-1.717-.63 2.28 2.28 0 0 1-.692-1.695 2.28 2.28 0 0 1 .786-1.653 2.27 2.27 0 0 1 1.75-.533z"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rz)",
    d: "M408.875 394.056a1.796 1.796 0 0 1 1.859 1.206c.087.252.116.52.087.785a1.77 1.77 0 0 1-.518 1.445 1.8 1.8 0 0 1-.668.416c-.251.087-.518.117-.782.087a1.85 1.85 0 0 1-1.538-.494 1.84 1.84 0 0 1-.556-1.518 1.9 1.9 0 0 1 .148-.793 1.879 1.879 0 0 1 1.968-1.134"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rA)",
    d: "M547.48 213.217a1.27 1.27 0 0 1 1.333 1.292 1.35 1.35 0 0 1-.328 1.065 1.36 1.36 0 0 1-1.573.339 1.355 1.355 0 0 1-.786-1.404c-.022-.763.486-1.186 1.354-1.292"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rB)",
    d: "M526.237 233.99c.516 0 1.011.205 1.376.571a1.945 1.945 0 0 1 0 2.755c-.365.365-.86.57-1.376.57-1.269 0-1.904-.741-1.968-2.117a1.85 1.85 0 0 1 1.239-1.682c.234-.081.482-.114.729-.097"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rC)",
    d: "M430.181 372.881a1.627 1.627 0 0 1 1.798 1.736 1.69 1.69 0 0 1-.448 1.379 1.69 1.69 0 0 1-1.35.527c-1.121 0-1.798-.635-1.82-1.758a1.67 1.67 0 0 1 1.08-1.789c.236-.087.489-.12.74-.095"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rD)",
    d: "M462.15 319.751a1.54 1.54 0 0 1 1.24.438 1.56 1.56 0 0 1 .453 1.235 1.686 1.686 0 0 1-1.682 1.883 1.7 1.7 0 0 1-.691-.148 1.68 1.68 0 0 1-.922-1.031 1.7 1.7 0 0 1-.069-.704 1.54 1.54 0 0 1 1.671-1.673"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rE)",
    d: "M398.063 404.898a1.7 1.7 0 0 1 1.32.401 1.68 1.68 0 0 1 .584 1.251 1.8 1.8 0 0 1-.365 1.388 1.794 1.794 0 0 1-2.622.218 1.8 1.8 0 0 1-.43-.594 1.8 1.8 0 0 1-.158-.716 1.7 1.7 0 0 1 .397-1.35 1.71 1.71 0 0 1 1.274-.598"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rF)",
    d: "M515.468 245.001a1.49 1.49 0 0 1 1.18.429 1.478 1.478 0 0 1 .428 1.181 1.61 1.61 0 0 1-1.597 1.425 1.609 1.609 0 0 1-1.598-1.425 1.51 1.51 0 0 1 .429-1.165 1.5 1.5 0 0 1 1.158-.445"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rG)",
    d: "M462.087 341.371a1.2 1.2 0 0 1 .961.311 1.19 1.19 0 0 1 .372.939 1.2 1.2 0 0 1-.303.952 1.2 1.2 0 0 1-.924.382c-.804 0-1.227-.466-1.375-1.292a1.313 1.313 0 0 1 1.269-1.292"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rH)",
    d: "M451.444 352.001a1.254 1.254 0 0 1 1.323.758c.071.169.103.351.095.534a1.32 1.32 0 0 1-.329 1.004 1.32 1.32 0 0 1-.962.436c-.846 0-1.396-.466-1.438-1.313a1.247 1.247 0 0 1 1.311-1.419"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rI)",
    d: "M440.823 361.933a1.874 1.874 0 0 1 2.033 1.264c.092.274.121.566.082.853a1.9 1.9 0 0 1-.544 1.573 1.9 1.9 0 0 1-1.571.545c-1.291 0-1.926-.847-2.116-2.118a1.968 1.968 0 0 1 2.116-2.117"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rJ)",
    d: "M515.489 266.071a1.8 1.8 0 0 1 1.726 1.16c.087.231.127.478.115.725a1.862 1.862 0 0 1-3.703 0c0-1.144.741-1.737 1.862-1.885"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rK)",
    d: "M398.296 426.476a1.44 1.44 0 0 1 1.461.985c.067.201.088.414.063.624a1.424 1.424 0 0 1-.966 1.463c-.2.067-.412.088-.621.062-1.016 0-1.481-.614-1.566-1.588s.55-1.567 1.629-1.546"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rL)",
    d: "M408.875 415.888a1.502 1.502 0 0 1 .846 2.535 1.5 1.5 0 0 1-.973.451c-.931 0-1.375-.635-1.481-1.652s.656-1.397 1.608-1.334"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rM)",
    d: "M622.083 116.339a2.119 2.119 0 0 1 2.07 1.276c.114.266.173.552.172.841a2.114 2.114 0 0 1-2.115 2.308c-1.354-.148-2.243-.826-2.264-2.117a2.12 2.12 0 0 1 1.274-2.138 2.1 2.1 0 0 1 .863-.17"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rN)",
    d: "M504.868 276.871a1.75 1.75 0 0 1 1.583 1.143 1.752 1.752 0 0 1-.45 1.902 1.75 1.75 0 0 1-1.26.47c-1.122 0-1.651-.72-1.735-1.821a1.72 1.72 0 0 1 .561-1.255 1.72 1.72 0 0 1 1.301-.439"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rO)",
    d: "M494.141 287.734a1.56 1.56 0 0 1 1.566 1.567 1.56 1.56 0 0 1-.966 1.447c-.19.079-.394.12-.6.12a1.5 1.5 0 0 1-1.114-.455 1.49 1.49 0 0 1-.409-1.134 1.51 1.51 0 0 1 .932-1.433 1.5 1.5 0 0 1 .591-.112"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rP)",
    d: "M387.717 437.17a1.456 1.456 0 0 1 1.333 1.545 1.357 1.357 0 0 1-1.481 1.504 1.38 1.38 0 0 1-1.174-.404 1.37 1.37 0 0 1-.371-1.184c.021-.953.614-1.398 1.693-1.461"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rQ)",
    d: "M632.618 106.005a1.884 1.884 0 1 1 .078 3.767 1.884 1.884 0 0 1-.078-3.767"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rR)",
    d: "M376.884 469.06c.931.169 1.587.678 1.587 1.652a1.498 1.498 0 0 1-.94 1.525 1.5 1.5 0 0 1-.626.105 1.524 1.524 0 0 1-1.671-1.673c.021-.974.698-1.482 1.65-1.609"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rS)",
    d: "M440.76 383.786c.22-.023.442.003.65.076a1.482 1.482 0 0 1 .979 1.554 1.46 1.46 0 0 1-.448 1.101 1.46 1.46 0 0 1-1.117.403c-.931 0-1.439-.614-1.608-1.588a1.627 1.627 0 0 1 1.544-1.546"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rT)",
    d: "M419.454 405.11a1.607 1.607 0 0 1 1.259 2.602c-.248.317-.607.53-1.005.595-1.016 0-1.566-.571-1.778-1.609.064-.847.487-1.525 1.524-1.588"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rU)",
    d: "M387.378 458.388a1.574 1.574 0 0 1 1.642.864c.097.2.15.417.157.639a1.59 1.59 0 0 1-.937 1.736 1.6 1.6 0 0 1-.692.127c-.995 0-1.566-.635-1.756-1.609a1.713 1.713 0 0 1 1.586-1.757"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rV)",
    d: "M643.367 95.057a2.116 2.116 0 0 1 2.243 2.118 2.117 2.117 0 1 1-4.232.148 2.13 2.13 0 0 1 .521-1.55 2.12 2.12 0 0 1 1.468-.716"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rW)",
    d: "M536.795 244.811a1.69 1.69 0 0 1 1.706 1.024c.092.218.138.454.135.691 0 1.186-.699 1.779-1.799 1.969a1.867 1.867 0 0 1-1.862-1.778 1.715 1.715 0 0 1 1.82-1.906"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rX)",
    d: "M483.478 320.005a1.24 1.24 0 0 1 .959.334 1.24 1.24 0 0 1 .395.937c0 .847-.508 1.291-1.333 1.44a1.375 1.375 0 0 1-1.354-1.313 1.262 1.262 0 0 1 .796-1.311c.17-.067.353-.097.537-.087"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rY)",
    d: "M472.729 330.614a1.31 1.31 0 0 1 1.46 1.377 1.28 1.28 0 0 1-.346.99 1.28 1.28 0 0 1-.966.407c-.888 0-1.333-.529-1.481-1.376 0-.36.138-.706.386-.967.249-.26.588-.414.947-.431"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rZ)",
    d: "M430.245 394.374c.909.19 1.544.699 1.523 1.652a1.61 1.61 0 0 1-1.597 1.425 1.61 1.61 0 0 1-1.598-1.425c0-1.017.677-1.546 1.672-1.652"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sa)",
    d: "M653.988 84.872a1.65 1.65 0 0 1 1.186.439 1.656 1.656 0 0 1 .089 2.335c-.297.322-.71.512-1.148.53-.973 0-1.523-.615-1.714-1.632a1.717 1.717 0 0 1 1.587-1.672"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sb)",
    d: "M526.11 255.759c.994 0 1.502.614 1.629 1.567.127.952-.635 1.503-1.544 1.503a1.44 1.44 0 0 1-1.16-.422 1.44 1.44 0 0 1-.406-1.166 1.43 1.43 0 0 1 .414-1.068 1.4 1.4 0 0 1 1.067-.414"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sc)",
    d: "M547.523 234.477a1.483 1.483 0 0 1 1.459 1.461c-.127.868-.592 1.461-1.459 1.483a1.5 1.5 0 0 1-1.16-.363 1.48 1.48 0 0 1-.368-1.717 1.48 1.48 0 0 1 1.528-.864"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sd)",
    d: "M462.299 362.399a1.48 1.48 0 0 1 1.12.499 1.49 1.49 0 0 1 .361 1.174 1.52 1.52 0 0 1-1.091 1.522 1.5 1.5 0 0 1-.665.045 1.64 1.64 0 0 1-1.191-.533 1.634 1.634 0 0 1 .8-2.677c.218-.056.444-.066.666-.03"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#se)",
    d: "M515.489 288.136a1.07 1.07 0 0 1 .834.299q.167.161.253.376c.057.142.083.295.077.447a1.2 1.2 0 0 1-.245.945 1.18 1.18 0 0 1-1.776.08 1.2 1.2 0 0 1-.328-.919 1.11 1.11 0 0 1 .301-.896 1.11 1.11 0 0 1 .884-.332"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sf)",
    d: "M526.11 276.659a1.857 1.857 0 0 1 1.804 1.096c.103.228.158.475.164.725a1.786 1.786 0 0 1-.966 1.938 1.8 1.8 0 0 1-.748.179 1.797 1.797 0 0 1-2.116-1.863c-.084-1.228.614-1.906 1.862-2.075"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sg)",
    d: "M472.729 351.282a2.116 2.116 0 0 1 1.496 3.614 2.1 2.1 0 0 1-1.496.621 1.95 1.95 0 0 1-1.554-.563 1.94 1.94 0 0 1-.562-1.555 1.97 1.97 0 0 1 .57-1.547 1.959 1.959 0 0 1 1.546-.57"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sh)",
    d: "M504.868 298.11a1.78 1.78 0 0 1 1.354.548 1.781 1.781 0 0 1 .487 1.379 1.88 1.88 0 0 1-.574 1.334 1.9 1.9 0 0 1-1.352.529 1.86 1.86 0 0 1-1.841-1.969 1.75 1.75 0 0 1 .549-1.349 1.75 1.75 0 0 1 1.377-.472"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#si)",
    d: "M558.079 223.191a1.966 1.966 0 0 1 2.116 2.117c0 1.271-.783 1.969-2.116 2.118a2.115 2.115 0 0 1-2.115-2.118 2 2 0 0 1 .578-1.539 1.98 1.98 0 0 1 1.537-.578"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sj)",
    d: "M408.875 436.767a1.87 1.87 0 0 1 1.407.506 1.86 1.86 0 0 1 .581 1.379 1.94 1.94 0 0 1-1.144 1.983 1.944 1.944 0 0 1-2.643-1.178 1.9 1.9 0 0 1-.084-.805 1.85 1.85 0 0 1 .538-1.346 1.85 1.85 0 0 1 1.345-.539"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sk)",
    d: "M398.296 447.567a1.73 1.73 0 0 1 1.311.544 1.729 1.729 0 0 1 .467 1.34 1.85 1.85 0 0 1-.554 1.297 1.85 1.85 0 0 1-1.308.525 1.869 1.869 0 0 1-1.799-1.927 1.75 1.75 0 0 1 .544-1.312 1.74 1.74 0 0 1 1.339-.467"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sl)",
    d: "M632.746 127.053a2.24 2.24 0 0 1 1.724.572 2.243 2.243 0 0 1-1.724 3.896 2.1 2.1 0 0 1-1.551-.671 2.1 2.1 0 0 1-.449-.738 2.1 2.1 0 0 1-.116-.856 2.11 2.11 0 0 1 1.286-2.034c.262-.111.545-.169.83-.169"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sm)",
    d: "M451.466 372.309a2.327 2.327 0 0 1 2.348 2.308 2.374 2.374 0 0 1-2.274 2.467 2.37 2.37 0 0 1-2.465-2.276c0-1.462.973-2.266 2.391-2.499"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sn)",
    d: "M419.623 426.772a1.2 1.2 0 0 1 .89.413 1.193 1.193 0 0 1 .274.943 1.2 1.2 0 0 1-.361.882 1.2 1.2 0 0 1-.888.346c-.846 0-1.311-.53-1.311-1.292a1.204 1.204 0 0 1 1.396-1.292"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#so)",
    d: "M664.884 73.628a2.243 2.243 0 0 1 1.359 3.778 2.24 2.24 0 0 1-1.464.69 2.24 2.24 0 0 1-2.116-2.266c.106-1.355.804-2.245 2.221-2.203"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sp)",
    d: "M387.548 480.283a1 1 0 0 1 1.051.661 1 1 0 0 1 .049.44 1.04 1.04 0 0 1-1.185 1.165c-.698 0-1.037-.424-1.121-1.186a1.08 1.08 0 0 1 .754-1.037c.146-.046.3-.061.452-.043"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sq)",
    d: "M536.795 266.156a1.672 1.672 0 0 1 1.799 1.778 1.791 1.791 0 0 1-1.055 1.839 1.797 1.797 0 0 1-2.521-1.839 1.696 1.696 0 0 1 1.777-1.778"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sr)",
    d: "M430.245 415.549a1.68 1.68 0 0 1 1.33.536 1.68 1.68 0 0 1 .426 1.37 1.85 1.85 0 0 1-.524 1.399 1.84 1.84 0 0 1-2.128.362 1.853 1.853 0 0 1-1.008-1.909 1.67 1.67 0 0 1 1.171-1.699c.237-.074.487-.094.733-.059"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss)",
    d: "M494.204 330.169a1.7 1.7 0 0 1 .697.095 1.661 1.661 0 0 1 1.08 1.663 1.735 1.735 0 0 1-1.84 1.927c-1.122 0-1.799-.678-1.799-1.779a1.68 1.68 0 0 1 .458-1.415 1.67 1.67 0 0 1 1.404-.491"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#st)",
    d: "M547.544 255.42a1.863 1.863 0 0 1 1.788 1.937 1.867 1.867 0 0 1-1.936 1.79c-1.143 0-1.714-.699-1.82-1.843a1.78 1.78 0 0 1 1.203-1.801c.246-.083.507-.112.765-.083"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#su)",
    d: "M440.866 405.385a1.18 1.18 0 0 1 .954.327 1.18 1.18 0 0 1 .357.944 1.265 1.265 0 0 1-.804 1.337 1.26 1.26 0 0 1-.55.081 1.26 1.26 0 0 1-.954-.363 1.26 1.26 0 0 1-.379-.949 1.23 1.23 0 0 1 1.376-1.377"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sv)",
    d: "M483.541 341.244a1.355 1.355 0 0 1 1.354 1.483 1.28 1.28 0 0 1-.419 1.007 1.3 1.3 0 0 1-1.04.327 1.28 1.28 0 0 1-1.016-.412 1.27 1.27 0 0 1-.317-1.049 1.31 1.31 0 0 1 1.438-1.356"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw)",
    d: "M643.388 116.677a1.74 1.74 0 0 1 1.772 1.06c.094.227.14.473.133.719a1.73 1.73 0 0 1-.426 1.383 1.71 1.71 0 0 1-1.331.565 1.7 1.7 0 0 1-1.392-.455 1.7 1.7 0 0 1-.533-1.366 1.757 1.757 0 0 1 1.777-1.906"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sx)",
    d: "M654.031 106.704a1.183 1.183 0 0 1 1.117 1.109 1.186 1.186 0 0 1-.969 1.241 1.1 1.1 0 0 1-.916-.276 1.1 1.1 0 0 1-.354-.888 1.113 1.113 0 0 1 .674-1.102c.141-.059.294-.088.448-.084"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sy)",
    d: "M536.879 287.501c1.016.19 1.693.762 1.672 1.778a1.77 1.77 0 0 1-.438 1.366 1.754 1.754 0 0 1-2.98-.636 1.8 1.8 0 0 1-.073-.73c0-1.08.762-1.651 1.819-1.778"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sz)",
    d: "M398.085 490.68a1.3 1.3 0 0 1 1.023.305 1.328 1.328 0 0 1 .458.966 1.345 1.345 0 0 1-.812 1.449 1.3 1.3 0 0 1-.585.097c-.825 0-1.29-.551-1.438-1.44a1.48 1.48 0 0 1 1.354-1.377"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sA)",
    d: "M430.223 437.275a1.34 1.34 0 0 1 1.016.397 1.34 1.34 0 0 1 .38 1.022 1.362 1.362 0 0 1-.906 1.418 1.36 1.36 0 0 1-.596.065c-.868 0-1.312-.593-1.439-1.44s.593-1.504 1.545-1.462"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sB)",
    d: "M419.454 448.202a1.19 1.19 0 0 1 1.185 1.186 1.186 1.186 0 0 1-1.185 1.186c-.762 0-1.143-.466-1.227-1.313a1.18 1.18 0 0 1 1.227-1.059"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sC)",
    d: "M643.346 138.298a1.612 1.612 0 0 1 1.191 2.616 1.61 1.61 0 0 1-1.666.547 1.598 1.598 0 0 1-1.193-1.459 1.615 1.615 0 0 1 1.668-1.704"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sD)",
    d: "M547.416 277.4a1.36 1.36 0 0 1 1.065.328 1.36 1.36 0 0 1 .339 1.574 1.36 1.36 0 0 1-1.404.787c-.867 0-1.311-.55-1.417-1.376s.635-1.313 1.417-1.313"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sE)",
    d: "M515.553 309.46a1.1 1.1 0 0 1 .818.359 1.11 1.11 0 0 1 .282.848 1.16 1.16 0 0 1-.378.808 1.165 1.165 0 0 1-1.949-.914 1.105 1.105 0 0 1 .767-1.057c.148-.047.305-.062.46-.044"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sF)",
    d: "M664.885 117.249a1.31 1.31 0 0 1 1.142 1.334 1.163 1.163 0 0 1-1.185 1.292 1.19 1.19 0 0 1-.978-.324 1.2 1.2 0 0 1-.355-.968c.022-.826.551-1.228 1.376-1.334"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sG)",
    d: "M451.487 415.782a1.63 1.63 0 0 1 1.566 1.44 1.56 1.56 0 0 1-.385 1.121 1.54 1.54 0 0 1-1.065.52 1.54 1.54 0 0 1-1.12-.385 1.55 1.55 0 0 1-.519-1.065c-.064-.911.571-1.419 1.523-1.631"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sH)",
    d: "M558.058 266.982a.992.992 0 0 1 1.139.984.99.99 0 0 1-.344.753.99.99 0 0 1-.795.232.995.995 0 0 1 0-1.969"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sI)",
    d: "M440.887 426.73c.741.148 1.227.551 1.227 1.292-.04.311-.192.597-.427.805a1.293 1.293 0 0 1-2.133-.805 1.33 1.33 0 0 1 .399-.922 1.3 1.3 0 0 1 .934-.37"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sJ)",
    d: "M526.153 297.983a1.83 1.83 0 0 1 1.391.477 1.85 1.85 0 0 1 .598 1.344 1.885 1.885 0 0 1-1.883 2.117c-1.291 0-1.968-.699-2.116-2.117.169-.953.677-1.843 2.01-1.821"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sK)",
    d: "M654.052 127.879a1.248 1.248 0 0 1 1.375 1.377 1.25 1.25 0 0 1-1.29 1.313c-.868 0-1.291-.551-1.418-1.44-.127-.89.55-1.25 1.333-1.25"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sL)",
    d: "M472.856 373.177c.91.127 1.481.614 1.439 1.567a1.35 1.35 0 0 1-.388 1.015 1.36 1.36 0 0 1-1.009.404 1.38 1.38 0 0 1-1.117-.365 1.379 1.379 0 0 1-.427-1.096c-.021-.953.571-1.419 1.502-1.525"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sM)",
    d: "M494.205 352.256c.592.127.994.444.994 1.058a1.058 1.058 0 1 1-2.116 0c.022-.635.424-.974 1.122-1.058"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sN)",
    d: "M504.72 341.52a1.15 1.15 0 0 1 .922.276 1.158 1.158 0 0 1 .294 1.359 1.17 1.17 0 0 1-.725.634 1.2 1.2 0 0 1-.491.039c-.677 0-1.058-.445-1.206-1.101a1.15 1.15 0 0 1 .34-.867c.113-.113.248-.202.397-.261s.309-.085.469-.079"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sO)",
    d: "M408.875 458.769c.171-.003.341.029.5.094a1.26 1.26 0 0 1 .692.716c.06.16.086.331.078.503a1.21 1.21 0 0 1-.788 1.199 1.2 1.2 0 0 1-.503.071 1.16 1.16 0 0 1-1.225-.711 1.2 1.2 0 0 1-.087-.496 1.208 1.208 0 0 1 1.333-1.376"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sP)",
    d: "M462.15 383.384a1.818 1.818 0 0 1 1.989 2.117c0 1.228-.867 1.8-2.116 1.843a1.88 1.88 0 0 1-1.393-.648 1.9 1.9 0 0 1-.448-1.47 1.8 1.8 0 0 1 .57-1.365 1.8 1.8 0 0 1 1.398-.477"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sQ)",
    d: "M483.351 362.759a1.19 1.19 0 0 1 .986.269 1.2 1.2 0 0 1 .41.938 1.186 1.186 0 0 1-.787 1.254c-.168.059-.347.079-.525.059a1.273 1.273 0 0 1-.79-2.099c.204-.232.485-.382.79-.421z"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sR)",
    d: "M398.084 468.764a1.81 1.81 0 0 1 1.613.504 1.82 1.82 0 0 1 .503 1.613c0 1.249-.783 1.842-2.01 1.927a1.9 1.9 0 0 1-.766-.133 1.9 1.9 0 0 1-1.063-1.088 1.9 1.9 0 0 1-.117-.769 1.77 1.77 0 0 1 .432-1.465 1.77 1.77 0 0 1 1.408-.589"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sS)",
    d: "M451.444 394.797a1.153 1.153 0 0 1 1.264.764c.057.17.073.351.048.528a1.22 1.22 0 0 1-.368.891 1.2 1.2 0 0 1-.902.337c-.782 0-1.227-.466-1.248-1.249a1.146 1.146 0 0 1 1.206-1.271"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sT)",
    d: "M568.828 234.816a1.05 1.05 0 0 1 .996.649c.055.129.083.269.083.41a1.101 1.101 0 1 1-2.116 0c-.106-.614.296-.974 1.037-1.059"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sU)",
    d: "M558.207 245.488a1.04 1.04 0 0 1 1.037 1.102 1.1 1.1 0 0 1-.18.965 1.1 1.1 0 0 1-1.936-.965c-.148-.699.339-.953 1.079-1.102"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sV)",
    d: "M408.875 480.389a.96.96 0 0 1 .792.257.96.96 0 0 1 .287.781.98.98 0 0 1-.318.775.98.98 0 0 1-.803.241 1.058 1.058 0 0 1 0-2.118z"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sW)",
    d: "M568.87 256.224a.96.96 0 0 1 .736.351c.089.11.153.238.187.375.033.137.036.28.008.418a1.02 1.02 0 0 1-1.058.91c-.635-.148-1.037-.508-.952-1.185a.94.94 0 0 1 .101-.375.95.95 0 0 1 .591-.475.9.9 0 0 1 .387-.019"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sX)",
    d: "M462.383 404.94a1.66 1.66 0 0 1 1.501 1.206c.061.221.076.452.043.679a1.67 1.67 0 0 1-1.988 1.652 1.776 1.776 0 0 1-1.587-1.843c.233-1.143.888-1.821 2.031-1.694"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sY)",
    d: "M536.901 309.756a.83.83 0 0 1 .762.559.8.8 0 0 1 .042.331.826.826 0 0 1-.931.889.82.82 0 0 1-.653-.261.83.83 0 0 1-.214-.671.875.875 0 0 1 .628-.823.9.9 0 0 1 .366-.024"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sZ)",
    d: "M494.141 373.643a.98.98 0 0 1 .744.253.99.99 0 0 1 .314.721 1.058 1.058 0 1 1-2.116 0 .945.945 0 0 1 .308-.728.95.95 0 0 1 .75-.246"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ta)",
    d: "M504.846 362.653a1.25 1.25 0 0 1 .997.383 1.25 1.25 0 0 1 .336 1.014c0 .89-.55 1.292-1.523 1.356a1.315 1.315 0 0 1-1.206-1.419 1.25 1.25 0 0 1 .383-.998 1.24 1.24 0 0 1 1.013-.336"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tb)",
    d: "M483.477 384.125a1.15 1.15 0 0 1 .929.336 1.145 1.145 0 0 1 .32.934 1.18 1.18 0 0 1-.36.915c-.123.117-.27.206-.431.26s-.331.072-.5.054a1.21 1.21 0 0 1-.913-.427 1.21 1.21 0 0 1-.272-.971 1.145 1.145 0 0 1 1.227-1.101"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tc)",
    d: "M579.428 245.743a.88.88 0 0 1 .714.203.887.887 0 0 1-.714 1.554.84.84 0 0 1-.662-.223.84.84 0 0 1-.269-.645.84.84 0 0 1 .261-.66.85.85 0 0 1 .67-.229"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#td)",
    d: "M472.793 394.946a1 1 0 0 1 .789.28q.157.152.24.355c.053.135.078.279.071.423a.974.974 0 0 1-.931 1.101.985.985 0 0 1-1.109-.544 1 1 0 0 1-.097-.43 1.05 1.05 0 0 1 .246-.831 1.02 1.02 0 0 1 .791-.354"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#te)",
    d: "M654.115 149.521a.92.92 0 0 1 .762.259.94.94 0 0 1 .275.757.955.955 0 0 1-.671 1.058.95.95 0 0 1-.45.022c-.677 0-.974-.445-.995-1.08s.402-1.037 1.079-1.016"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tf)",
    d: "M664.694 138.827a1 1 0 0 1 .415.016.973.973 0 0 1 .728.916 1 1 0 0 1-.017.461.98.98 0 0 1-.604.665 1 1 0 0 1-.458.06c-.677 0-1.016-.382-1.079-1.144a.97.97 0 0 1 1.015-.974"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tg)",
    d: "M472.899 416.206a1.093 1.093 0 0 1 1.029.709c.053.138.077.286.071.434a1.16 1.16 0 0 1-.339.889 1.154 1.154 0 0 1-.888.339c-.677-.127-1.121-.487-1.121-1.164a1.11 1.11 0 0 1 .338-.9 1.12 1.12 0 0 1 .91-.307"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#th)",
    d: "M579.449 267.045a.93.93 0 0 1 .889.784.83.83 0 0 1-.173.697.82.82 0 0 1-.652.298.78.78 0 0 1-.622-.165.774.774 0 0 1-.288-.576c-.085-.572.254-.911.846-1.038"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ti)",
    d: "M558.228 288.369a.85.85 0 0 1 .618.299.9.9 0 0 1 .171.305q.054.17.036.349a.82.82 0 0 1-.252.668.84.84 0 0 1-.314.188.8.8 0 0 1-.365.033.81.81 0 0 1-.667-.252.83.83 0 0 1-.221-.68c0-.592.36-.868.994-.91"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tj)",
    d: "M462.213 426.857c.15-.012.3.008.442.058a1.07 1.07 0 0 1 .626.604c.056.14.081.289.075.439a1.1 1.1 0 0 1-1.164 1.292 1.14 1.14 0 0 1-1.248-1.207c.085-.784.487-1.228 1.269-1.186"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tk)",
    d: "M451.529 437.847a.89.89 0 0 1 .752.879.891.891 0 0 1-.752.879.831.831 0 0 1-.846-.911.81.81 0 0 1 .234-.612.816.816 0 0 1 .612-.235"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tl)",
    d: "M409.023 501.861a.97.97 0 0 1 .804 1.101.905.905 0 0 1-.616.822.9.9 0 0 1-.357.046.88.88 0 0 1-.727-.262.89.89 0 0 1-.247-.733c.021-.741.423-.974 1.143-.974"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tm)",
    d: "M568.87 277.654a.94.94 0 0 1 .688.339.92.92 0 0 1 .201.741.963.963 0 0 1-.647.841.963.963 0 0 1-.729-.048.96.96 0 0 1-.529-.92.9.9 0 0 1 .287-.713.9.9 0 0 1 .729-.24"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tn)",
    d: "M419.454 490.596a1.39 1.39 0 0 1 1.061.308 1.41 1.41 0 0 1 .505.983 1.52 1.52 0 0 1-.322 1.165 1.52 1.52 0 0 1-1.075.551 1.46 1.46 0 0 1-1.565-1.335 1.4 1.4 0 0 1 .297-1.171 1.39 1.39 0 0 1 1.099-.501"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#to)",
    d: "M419.454 469.886a.784.784 0 0 1 .867.889.868.868 0 1 1-1.714-.127.78.78 0 0 1 .259-.564.776.776 0 0 1 .588-.198"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tp)",
    d: "M430.223 458.938a1 1 0 0 1 .775.289 1.01 1.01 0 0 1 .304.77 1.04 1.04 0 0 1-.64 1.137 1 1 0 0 1-.46.07c-.741 0-1.122-.402-1.185-1.144a1.09 1.09 0 0 1 .343-.84 1.07 1.07 0 0 1 .863-.282"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tq)",
    d: "M547.395 299.063c.572 0 .931.233.995.804a.912.912 0 0 1-1.476.81.91.91 0 0 1-.3-.969.91.91 0 0 1 .781-.645"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tr)",
    d: "M440.611 447.948a1.46 1.46 0 1 1 0 2.922 1.33 1.33 0 0 1-1.438-1.419 1.29 1.29 0 0 1 1.438-1.503"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ts)",
    d: "M515.595 351.938a1.34 1.34 0 0 1 .979.501 1.332 1.332 0 0 1 .27 1.066 1.25 1.25 0 0 1-.411.903 1.24 1.24 0 0 1-.944.304 1.24 1.24 0 0 1-1.035-.372 1.249 1.249 0 0 1-.34-1.047c.021-.889.55-1.313 1.481-1.355"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tt)",
    d: "M547.353 320.513a.783.783 0 0 1 .952.805c0 .487-.318.762-.804.868a.867.867 0 0 1-.868-.762.787.787 0 0 1 .72-.911"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tu)",
    d: "M590.155 255.928a1.31 1.31 0 0 1 1.333 1.207 1.295 1.295 0 0 1-.728 1.383c-.169.079-.354.12-.541.12-.846 0-1.312-.508-1.502-1.312.148-.826.592-1.398 1.438-1.398"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tv)",
    d: "M536.774 330.826a1.166 1.166 0 0 1 .967 1.928 1.16 1.16 0 0 1-.798.401c-.719.127-1.121-.402-1.333-1.08a1.225 1.225 0 0 1 1.164-1.249"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tw)",
    d: "M558.038 309.46c.154-.024.311-.016.461.025.151.04.291.111.412.209q.185.148.293.358c.072.138.114.29.124.445a1.14 1.14 0 0 1-.269.976 1.13 1.13 0 0 1-.937.38 1.21 1.21 0 0 1-1.046-1.197 1.205 1.205 0 0 1 1.046-1.196z"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tx)",
    d: "M504.678 384.082a1.28 1.28 0 0 1 .919.32 1.26 1.26 0 0 1 .424.877 1.265 1.265 0 0 1-.715 1.219 1.3 1.3 0 0 1-.48.126c-.741 0-1.164-.466-1.312-1.229a1.31 1.31 0 0 1 1.164-1.313"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ty)",
    d: "M664.778 159.981c.16-.002.319.027.468.086q.225.091.399.26a1.22 1.22 0 0 1 .36.861 1.18 1.18 0 0 1-.835 1.258c-.175.053-.36.065-.54.034a1.15 1.15 0 0 1-1.07-.833 1.14 1.14 0 0 1-.03-.48 1.227 1.227 0 0 1 1.248-1.186"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tz)",
    d: "M494.099 394.967a.98.98 0 0 1 .778.22.98.98 0 0 1 .343.733 1.02 1.02 0 0 1-.256.866 1.01 1.01 0 0 1-.844.319c-.635 0-.973-.444-1.058-1.058a1.1 1.1 0 0 1 .073-.407 1.05 1.05 0 0 1 .561-.585c.127-.055.264-.085.403-.088"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tA)",
    d: "M483.541 405.385a1.25 1.25 0 0 1 1.269 1.186 1.297 1.297 0 0 1-.725 1.336 1.3 1.3 0 0 1-.523.125c-.825 0-1.27-.529-1.46-1.419.233-.635.592-1.249 1.439-1.228"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tB)",
    d: "M430.308 480.198a1.186 1.186 0 0 1 1.1 1.186 1.29 1.29 0 0 1-1.248 1.292c-.741-.169-1.291-.572-1.206-1.334a1.17 1.17 0 0 1 .413-.885 1.17 1.17 0 0 1 .941-.259"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tC)",
    d: "M440.823 469.78a.934.934 0 0 1 .948.667.9.9 0 0 1 .025.413.89.89 0 0 1-.661.83.9.9 0 0 1-.375.017.992.992 0 0 1-.91-.995.974.974 0 0 1 .973-.932"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tD)",
    d: "M451.635 459.044a.973.973 0 0 1 .888 1.122 1.056 1.056 0 0 1-1.036.953c-.614 0-1.016-.444-1.016-1.037a1 1 0 0 1 .331-.801 1 1 0 0 1 .833-.237"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tE)",
    d: "M166.089 553h-5.226a4.225 4.225 0 0 1 5.226 0"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tF)",
    d: "M462.32 448.562a.762.762 0 0 1 .677.953c0 .529-.381.741-.91.741a.79.79 0 0 1-.581-.273.8.8 0 0 1-.181-.616.762.762 0 0 1 .995-.805"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tG)",
    d: "M568.722 299.02a.852.852 0 0 1 1.015.826c0 .678-.254 1.101-.973 1.08s-.889-.339-.931-.932a.88.88 0 0 1 .22-.691.87.87 0 0 1 .669-.283"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tH)",
    d: "M515.341 373.749a.864.864 0 0 1 .966.407c.063.109.101.23.113.355a.9.9 0 0 1-.167.795.9.9 0 0 1-.332.253.9.9 0 0 1-.411.074c-.592 0-.91-.275-.994-.952a.867.867 0 0 1 .825-.932"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tI)",
    d: "M600.839 267.13c.445.148.804.381.762.889a.784.784 0 0 1-.867.741.75.75 0 0 1-.557-.26.77.77 0 0 1-.184-.587.846.846 0 0 1 .846-.783"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tJ)",
    d: "M590.092 278.078a.57.57 0 0 1 .462.561.57.57 0 0 1-.131.363.56.56 0 0 1-.331.198.55.55 0 0 1-.614-.593c.127-.339.297-.529.614-.529"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tK)",
    d: "M547.417 341.858a.79.79 0 0 1 .794.449.8.8 0 0 1 .073.314c0 .508-.317.762-.762.889a.846.846 0 0 1-.867-.783.78.78 0 0 1 .19-.602.78.78 0 0 1 .572-.267"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tL)",
    d: "M526.09 363.267a.67.67 0 0 1 .61.178.68.68 0 0 1 .194.605c0 .445-.275.678-.804.763a.784.784 0 0 1-.699-.636.696.696 0 0 1 .699-.91"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tM)",
    d: "M579.492 288.348a.92.92 0 0 1 .646.302.917.917 0 0 1 .242.672.826.826 0 0 1-.825.91.86.86 0 0 1-.737-.214.87.87 0 0 1-.278-.717c0-.53.317-.826.952-.953"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tN)",
    d: "M494.099 416.46a.93.93 0 0 1 .747.214.95.95 0 0 1 .324.707.934.934 0 0 1-1.071.921c-.55 0-.846-.36-1.037-1.016.297-.318.445-.805 1.037-.826"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tO)",
    d: "M483.52 427.408a.634.634 0 0 1 .448 1.084.63.63 0 0 1-.448.186.54.54 0 0 1-.428-.16.53.53 0 0 1-.144-.433c-.021-.466.17-.656.572-.677"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tP)",
    d: "M186.146 552.831h-2.517a1.96 1.96 0 0 1 2.517 0"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tQ)",
    d: "M472.793 438.207a.47.47 0 0 1 .413.121.47.47 0 0 1 .137.409.467.467 0 0 1-.487.508.5.5 0 0 1-.219-.02.5.5 0 0 1-.19-.111.507.507 0 0 1-.162-.399c.064-.381.191-.508.508-.508"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tR)",
    d: "M419.602 512.449a.8.8 0 0 1 .34.07.8.8 0 0 1 .282.2.851.851 0 0 1 .225.64.89.89 0 0 1-1.037.974c-.529 0-.825-.402-.868-1.101a.928.928 0 0 1 1.058-.783"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tS)",
    d: "M440.866 491.506a.55.55 0 0 1 .529.614.535.535 0 0 1-.371.509.5.5 0 0 1-.222.021.59.59 0 0 1-.398-.183.58.58 0 0 1-.152-.41c.085-.318.254-.572.614-.551"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tT)",
    d: "M430.265 502.115a.68.68 0 0 1 .529.593q.014.12-.022.237a.59.59 0 0 1-.528.419.56.56 0 0 1-.511-.149.58.58 0 0 1-.166-.507c.021-.36.254-.551.698-.593"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tU)",
    d: "M.021 129.425v-.445q.015.222 0 .445"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tV)",
    d: "M228.335 552.831c-.55.169-.952.296-1.439-.106a2.1 2.1 0 0 1 1.439.106"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tW)",
    d: "M207.093 552.809h-1.439a1.275 1.275 0 0 1 1.439 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 702.628,
    x2: -173.758,
    y1: 483.692,
    y2: -121.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 694.23,
    x2: -182.199,
    y1: 495.911,
    y2: -109.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 685.854,
    x2: -190.555,
    y1: 508.002,
    y2: -96.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 684.246,
    x2: -192.163,
    y1: 510.352,
    y2: -94.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 717.992,
    x2: -158.438,
    y1: 461.5,
    y2: -143.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 711.135,
    x2: -165.336,
    y1: 471.495,
    y2: -133.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 692.686,
    x2: -183.743,
    y1: 498.134,
    y2: -106.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 701.106,
    x2: -175.302,
    y1: 485.916,
    y2: -119.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 709.547,
    x2: -166.86,
    y1: 473.697,
    y2: -131.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 675.843,
    x2: -200.522,
    y1: 522.465,
    y2: -82.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 682.701,
    x2: -193.708,
    y1: 512.576,
    y2: -92.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 665.838,
    x2: -210.571,
    y1: 537.012,
    y2: -67.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 674.278,
    x2: -202.129,
    y1: 524.794,
    y2: -80.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 699.605,
    x2: -176.846,
    y1: 488.16,
    y2: -116.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 707.982,
    x2: -168.404,
    y1: 475.921,
    y2: -128.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 655.874,
    x2: -220.535,
    y1: 551.454,
    y2: -53.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 691.119,
    x2: -185.267,
    y1: 500.336,
    y2: -104.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 724.866,
    x2: -151.542,
    y1: 451.506,
    y2: -153.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 716.423,
    x2: -159.984,
    y1: 463.724,
    y2: -141.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 672.715,
    x2: -203.673,
    y1: 527.018,
    y2: -77.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 664.291,
    x2: -212.117,
    y1: 539.236,
    y2: -65.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 681.134,
    x2: -195.232,
    y1: 514.799,
    y2: -90.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 689.597,
    x2: -186.811,
    y1: 502.602,
    y2: -102.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 731.745,
    x2: -144.643,
    y1: 441.511,
    y2: -163.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 706.441,
    x2: -169.947,
    y1: 478.166,
    y2: -126.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 671.192,
    x2: -205.217,
    y1: 529.262,
    y2: -75.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 635.942,
    x2: -240.488,
    y1: 580.38,
    y2: -24.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 662.748,
    x2: -213.661,
    y1: 541.481,
    y2: -63.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 714.881,
    x2: -161.507,
    y1: 465.947,
    y2: -138.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 645.905,
    x2: -230.523,
    y1: 565.917,
    y2: -39.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 679.589,
    x2: -196.777,
    y1: 517.023,
    y2: -87.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 723.343,
    x2: -153.086,
    y1: 453.75,
    y2: -151.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 654.328,
    x2: -222.081,
    y1: 553.678,
    y2: -51.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 688.051,
    x2: -188.357,
    y1: 504.826,
    y2: -100.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 698.039,
    x2: -178.391,
    y1: 490.384,
    y2: -114.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 696.514,
    x2: -179.936,
    y1: 492.628,
    y2: -112.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 713.316,
    x2: -163.05,
    y1: 468.171,
    y2: -136.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 644.342,
    x2: -232.046,
    y1: 568.119,
    y2: -36.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 704.937,
    x2: -171.493,
    y1: 480.41,
    y2: -124.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 661.202,
    x2: -215.184,
    y1: 543.704,
    y2: -61.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 652.784,
    x2: -223.625,
    y1: 555.922,
    y2: -49.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 694.951,
    x2: -181.458,
    y1: 494.852,
    y2: -110.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 711.833,
    x2: -164.617,
    y1: 470.436,
    y2: -134.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 730.219,
    x2: -146.21,
    y1: 443.755,
    y2: -161.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 659.658,
    x2: -216.729,
    y1: 545.927,
    y2: -58.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 615.988,
    x2: -260.441,
    y1: 609.263,
    y2: 4.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 686.507,
    x2: -189.901,
    y1: 507.049,
    y2: -97.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 651.237,
    x2: -225.171,
    y1: 558.167,
    y2: -46.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 721.801,
    x2: -154.629,
    y1: 455.974,
    y2: -148.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 668.101,
    x2: -208.307,
    y1: 533.73,
    y2: -71.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 625.933,
    x2: -250.455,
    y1: 594.801,
    y2: -10.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 634.395,
    x2: -242.034,
    y1: 582.604,
    y2: -22.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 669.667,
    x2: -206.762,
    y1: 531.507,
    y2: -73.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 642.795,
    x2: -233.592,
    y1: 570.364,
    y2: -34.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 678.067,
    x2: -198.321,
    y1: 519.267,
    y2: -85.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 703.411,
    x2: -173.06,
    y1: 482.655,
    y2: -122.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 720.274,
    x2: -156.197,
    y1: 458.218,
    y2: -146.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 738.662,
    x2: -137.767,
    y1: 431.558,
    y2: -173.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 632.811,
    x2: -243.555,
    y1: 584.805,
    y2: -20.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 624.369,
    x2: -251.977,
    y1: 597.003,
    y2: -7.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 728.675,
    x2: -147.733,
    y1: 445.979,
    y2: -158.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 745.56,
    x2: -130.891,
    y1: 421.563,
    y2: -183.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 641.296,
    x2: -235.155,
    y1: 572.629,
    y2: -32.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 693.383,
    x2: -183.003,
    y1: 497.075,
    y2: -107.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 676.519,
    x2: -199.867,
    y1: 521.491,
    y2: -83.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 684.92,
    x2: -191.424,
    y1: 509.272,
    y2: -95.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 737.116,
    x2: -139.313,
    y1: 433.782,
    y2: -171.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 614.403,
    x2: -261.964,
    y1: 611.466,
    y2: 6.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 683.44,
    x2: -192.989,
    y1: 511.538,
    y2: -93.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 674.936,
    x2: -201.389,
    y1: 523.714,
    y2: -81.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 622.867,
    x2: -253.542,
    y1: 599.269,
    y2: -5.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 631.285,
    x2: -245.101,
    y1: 587.05,
    y2: -17.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 649.671,
    x2: -226.694,
    y1: 560.39,
    y2: -44.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 666.534,
    x2: -209.831,
    y1: 535.953,
    y2: -68.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 735.531,
    x2: -140.835,
    y1: 435.984,
    y2: -168.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 718.688,
    x2: -157.72,
    y1: 460.442,
    y2: -144.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 710.206,
    x2: -166.118,
    y1: 472.618,
    y2: -132.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 727.11,
    x2: -149.277,
    y1: 448.223,
    y2: -156.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 658.113,
    x2: -218.273,
    y1: 548.151,
    y2: -56.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 701.867,
    x2: -174.604,
    y1: 484.9,
    y2: -120.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 605.941,
    x2: -270.383,
    y1: 623.663,
    y2: 18.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 677.514,
    x2: -198.914,
    y1: 520.114,
    y2: -84.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 667.508,
    x2: -208.879,
    y1: 534.577,
    y2: -70.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 657.436,
    x2: -218.93,
    y1: 549.125,
    y2: -55.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 596.016,
    x2: -280.371,
    y1: 638.147,
    y2: 33.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 648.171,
    x2: -228.258,
    y1: 562.635,
    y2: -42.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 717.144,
    x2: -159.264,
    y1: 462.665,
    y2: -142.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 665.011,
    x2: -211.376,
    y1: 538.198,
    y2: -66.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 639.706,
    x2: -236.68,
    y1: 574.832,
    y2: -30.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aM",
    x1: 752.413,
    x2: -123.995,
    y1: 411.568,
    y2: -193.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 700.303,
    x2: -176.127,
    y1: 487.102,
    y2: -117.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 612.899,
    x2: -263.53,
    y1: 613.732,
    y2: 8.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 656.569,
    x2: -219.796,
    y1: 550.395,
    y2: -54.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 604.479,
    x2: -271.972,
    y1: 625.95,
    y2: 20.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 744.014,
    x2: -132.436,
    y1: 423.808,
    y2: -181.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 708.682,
    x2: -167.664,
    y1: 474.862,
    y2: -130.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 691.817,
    x2: -184.527,
    y1: 499.299,
    y2: -105.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 647.474,
    x2: -228.914,
    y1: 563.588,
    y2: -41.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 586.071,
    x2: -290.379,
    y1: 652.61,
    y2: 47.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: 734.007,
    x2: -142.401,
    y1: 438.228,
    y2: -166.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: 725.628,
    x2: -150.844,
    y1: 450.468,
    y2: -154.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: 742.47,
    x2: -133.981,
    y1: 426.031,
    y2: -178.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: 621.321,
    x2: -255.087,
    y1: 601.513,
    y2: -3.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 681.894,
    x2: -194.535,
    y1: 513.761,
    y2: -91.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 638.163,
    x2: -238.224,
    y1: 577.055,
    y2: -27.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 629.745,
    x2: -246.644,
    y1: 589.295,
    y2: -15.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 690.337,
    x2: -186.113,
    y1: 501.565,
    y2: -103.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 673.453,
    x2: -202.954,
    y1: 525.98,
    y2: -78.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 602.913,
    x2: -273.495,
    y1: 628.173,
    y2: 23.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 671.95,
    x2: -204.521,
    y1: 528.246,
    y2: -76.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 663.444,
    x2: -212.921,
    y1: 540.401,
    y2: -64.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 759.333,
    x2: -117.117,
    y1: 401.595,
    y2: -203.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 698.738,
    x2: -177.649,
    y1: 489.325,
    y2: -115.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 655.047,
    x2: -221.361,
    y1: 552.64,
    y2: -52.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 628.218,
    x2: -248.211,
    y1: 591.539,
    y2: -13.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 680.331,
    x2: -196.057,
    y1: 515.985,
    y2: -88.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 707.221,
    x2: -169.25,
    y1: 477.149,
    y2: -127.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 611.356,
    x2: -265.074,
    y1: 615.976,
    y2: 11.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 715.578,
    x2: -160.787,
    y1: 464.888,
    y2: -140.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 646.625,
    x2: -229.804,
    y1: 564.859,
    y2: -40.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 732.462,
    x2: -143.925,
    y1: 440.473,
    y2: -164.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 619.778,
    x2: -256.631,
    y1: 603.736,
    y2: -1.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 576.066,
    x2: -300.322,
    y1: 667.052,
    y2: 62.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 750.869,
    x2: -125.517,
    y1: 413.792,
    y2: -191.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 594.473,
    x2: -281.915,
    y1: 640.392,
    y2: 35.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 724.042,
    x2: -152.367,
    y1: 452.691,
    y2: -152.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: 637.569,
    x2: -238.839,
    y1: 577.966,
    y2: -26.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 627.583,
    x2: -248.846,
    y1: 592.471,
    y2: -12.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 739.36,
    x2: -137.048,
    y1: 430.499,
    y2: -174.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bA",
    x1: 592.905,
    x2: -283.46,
    y1: 642.594,
    y2: 37.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bB",
    x1: 695.669,
    x2: -180.739,
    y1: 493.814,
    y2: -111.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bC",
    x1: 688.771,
    x2: -187.637,
    y1: 503.767,
    y2: -101.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bD",
    x1: 747.759,
    x2: -128.585,
    y1: 418.26,
    y2: -186.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bE",
    x1: 601.349,
    x2: -275.017,
    y1: 630.397,
    y2: 25.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bF",
    x1: 740.947,
    x2: -135.524,
    y1: 428.276,
    y2: -176.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bG",
    x1: 687.226,
    x2: -189.182,
    y1: 506.012,
    y2: -98.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bH",
    x1: 697.192,
    x2: -179.195,
    y1: 491.57,
    y2: -113.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bI",
    x1: 722.476,
    x2: -153.889,
    y1: 454.894,
    y2: -149.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bJ",
    x1: 636.659,
    x2: -239.791,
    y1: 579.322,
    y2: -25.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bK",
    x1: 643.535,
    x2: -232.873,
    y1: 569.327,
    y2: -35.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bL",
    x1: 618.254,
    x2: -258.176,
    y1: 605.981,
    y2: 1.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bM",
    x1: 645.058,
    x2: -231.328,
    y1: 567.081,
    y2: -37.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bN",
    x1: 730.918,
    x2: -145.468,
    y1: 442.696,
    y2: -162.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bO",
    x1: 566.119,
    x2: -310.309,
    y1: 681.514,
    y2: 76.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bP",
    x1: 653.499,
    x2: -222.907,
    y1: 554.885,
    y2: -50.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bQ",
    x1: 757.79,
    x2: -118.64,
    y1: 403.839,
    y2: -201.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bR",
    x1: 574.541,
    x2: -301.866,
    y1: 669.296,
    y2: 64.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bS",
    x1: 582.963,
    x2: -293.425,
    y1: 657.057,
    y2: 52.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bT",
    x1: 584.526,
    x2: -291.903,
    y1: 654.855,
    y2: 49.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bU",
    x1: 749.325,
    x2: -127.062,
    y1: 416.036,
    y2: -188.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bV",
    x1: 609.853,
    x2: -266.618,
    y1: 618.221,
    y2: 13.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bW",
    x1: 661.923,
    x2: -214.465,
    y1: 542.645,
    y2: -62.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bX",
    x1: 591.405,
    x2: -285.004,
    y1: 644.86,
    y2: 39.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bY",
    x1: 626.652,
    x2: -249.734,
    y1: 593.742,
    y2: -11.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bZ",
    x1: 635.072,
    x2: -241.293,
    y1: 581.523,
    y2: -23.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 670.385,
    x2: -206.044,
    y1: 530.469,
    y2: -74.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: 705.656,
    x2: -170.774,
    y1: 479.352,
    y2: -125.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    x1: 766.187,
    x2: -110.199,
    y1: 391.6,
    y2: -213.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    x1: 714.056,
    x2: -162.332,
    y1: 467.133,
    y2: -137.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: 678.786,
    x2: -197.601,
    y1: 518.208,
    y2: -86.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 607.633,
    x2: -268.818,
    y1: 621.397,
    y2: 16.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg",
    x1: 617.556,
    x2: -258.853,
    y1: 606.977,
    y2: 2.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ch",
    x1: 764.643,
    x2: -111.744,
    y1: 393.823,
    y2: -211.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ci",
    x1: 599.824,
    x2: -276.563,
    y1: 632.641,
    y2: 27.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cj",
    x1: 652,
    x2: -224.472,
    y1: 557.129,
    y2: -47.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ck",
    x1: 608.265,
    x2: -268.142,
    y1: 620.423,
    y2: 15.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cl",
    x1: 660.378,
    x2: -216.008,
    y1: 544.89,
    y2: -60.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cm",
    x1: 756.244,
    x2: -120.186,
    y1: 406.084,
    y2: -198.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 712.511,
    x2: -163.876,
    y1: 469.356,
    y2: -135.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "co",
    x1: 704.089,
    x2: -172.319,
    y1: 481.575,
    y2: -123.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cp",
    x1: 556.152,
    x2: -320.296,
    y1: 695.956,
    y2: 91.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cq",
    x1: 721.016,
    x2: -155.477,
    y1: 457.181,
    y2: -147.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cr",
    x1: 773.106,
    x2: -103.323,
    y1: 381.647,
    y2: -223.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cs",
    x1: 597.644,
    x2: -278.848,
    y1: 635.945,
    y2: 30.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ct",
    x1: 633.55,
    x2: -242.837,
    y1: 583.768,
    y2: -21.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cu",
    x1: 642.013,
    x2: -234.438,
    y1: 571.571,
    y2: -33.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cv",
    x1: 625.108,
    x2: -251.258,
    y1: 595.965,
    y2: -8.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 650.433,
    x2: -225.996,
    y1: 559.353,
    y2: -45.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cx",
    x1: 573.018,
    x2: -303.433,
    y1: 671.541,
    y2: 66.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cy",
    x1: 737.794,
    x2: -138.571,
    y1: 432.702,
    y2: -172.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cz",
    x1: 589.859,
    x2: -286.549,
    y1: 647.083,
    y2: 42.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cA",
    x1: 616.731,
    x2: -259.72,
    y1: 608.226,
    y2: 3.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cB",
    x1: 668.841,
    x2: -207.588,
    y1: 532.693,
    y2: -72.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cC",
    x1: 598.258,
    x2: -278.107,
    y1: 634.843,
    y2: 29.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cD",
    x1: 677.24,
    x2: -199.147,
    y1: 520.453,
    y2: -84.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cE",
    x1: 564.598,
    x2: -311.873,
    y1: 683.758,
    y2: 78.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cF",
    x1: 746.194,
    x2: -130.13,
    y1: 420.462,
    y2: -184.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cG",
    x1: 581.524,
    x2: -295.031,
    y1: 659.364,
    y2: 54.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cH",
    x1: 702.523,
    x2: -173.842,
    y1: 483.798,
    y2: -121.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cI",
    x1: 694.102,
    x2: -182.284,
    y1: 496.016,
    y2: -108.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cJ",
    x1: 729.393,
    x2: -147.014,
    y1: 444.941,
    y2: -159.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cK",
    x1: 546.168,
    x2: -330.262,
    y1: 710.419,
    y2: 105.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL",
    x1: 754.699,
    x2: -121.73,
    y1: 408.307,
    y2: -196.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cM",
    x1: 685.683,
    x2: -190.704,
    y1: 508.235,
    y2: -96.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cN",
    x1: 606.699,
    x2: -269.687,
    y1: 622.646,
    y2: 17.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cO",
    x1: 554.629,
    x2: -321.843,
    y1: 698.202,
    y2: 93.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cP",
    x1: 771.583,
    x2: -104.889,
    y1: 383.892,
    y2: -221.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cQ",
    x1: 780.004,
    x2: -96.446,
    y1: 371.652,
    y2: -233.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cR",
    x1: 571.494,
    x2: -304.977,
    y1: 673.785,
    y2: 68.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cS",
    x1: 658.812,
    x2: -217.533,
    y1: 547.113,
    y2: -57.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cT",
    x1: 615.164,
    x2: -261.266,
    y1: 610.449,
    y2: 5.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cU",
    x1: 623.584,
    x2: -252.824,
    y1: 598.231,
    y2: -6.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cV",
    x1: 675.738,
    x2: -200.713,
    y1: 522.719,
    y2: -82.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cW",
    x1: 727.808,
    x2: -148.537,
    y1: 447.143,
    y2: -157.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cX",
    x1: 563.034,
    x2: -313.397,
    y1: 685.983,
    y2: 81.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cY",
    x1: 667.296,
    x2: -209.133,
    y1: 534.916,
    y2: -70.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cZ",
    x1: 763.121,
    x2: -113.288,
    y1: 396.068,
    y2: -208.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 710.967,
    x2: -165.42,
    y1: 471.601,
    y2: -133.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "db",
    x1: 719.408,
    x2: -156.979,
    y1: 459.383,
    y2: -145.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc",
    x1: 587.66,
    x2: -288.749,
    y1: 650.28,
    y2: 45.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 736.312,
    x2: -140.159,
    y1: 434.989,
    y2: -169.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: 588.335,
    x2: -288.115,
    y1: 649.349,
    y2: 44.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "df",
    x1: 579.875,
    x2: -296.516,
    y1: 661.526,
    y2: 56.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: 640.468,
    x2: -235.982,
    y1: 573.816,
    y2: -31.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: 536.182,
    x2: -340.227,
    y1: 724.84,
    y2: 119.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "di",
    x1: 631.982,
    x2: -244.361,
    y1: 585.991,
    y2: -18.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dj",
    x1: 648.869,
    x2: -227.519,
    y1: 561.576,
    y2: -43.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dk",
    x1: 657.31,
    x2: -219.098,
    y1: 549.358,
    y2: -55.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dl",
    x1: 665.751,
    x2: -210.678,
    y1: 537.161,
    y2: -67.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 544.624,
    x2: -331.806,
    y1: 712.643,
    y2: 107.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dn",
    x1: 684.139,
    x2: -192.248,
    y1: 510.479,
    y2: -94.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "do",
    x1: 692.579,
    x2: -183.829,
    y1: 498.282,
    y2: -106.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dp",
    x1: 701,
    x2: -175.386,
    y1: 486.043,
    y2: -118.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dq",
    x1: 709.441,
    x2: -166.966,
    y1: 473.846,
    y2: -131.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr",
    x1: 613.554,
    x2: -262.769,
    y1: 612.63,
    y2: 7.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ds",
    x1: 717.885,
    x2: -158.544,
    y1: 461.627,
    y2: -143.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dt",
    x1: 577.673,
    x2: -298.715,
    y1: 664.702,
    y2: 59.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "du",
    x1: 605.176,
    x2: -271.232,
    y1: 624.891,
    y2: 19.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dv",
    x1: 596.735,
    x2: -279.653,
    y1: 637.089,
    y2: 32.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: 769.975,
    x2: -106.391,
    y1: 386.073,
    y2: -218.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dx",
    x1: 744.671,
    x2: -131.674,
    y1: 422.728,
    y2: -182.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dy",
    x1: 761.554,
    x2: -114.812,
    y1: 398.291,
    y2: -206.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: 753.135,
    x2: -123.253,
    y1: 410.51,
    y2: -194.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dA",
    x1: 567.706,
    x2: -308.703,
    y1: 679.165,
    y2: 74.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dB",
    x1: 630.502,
    x2: -245.948,
    y1: 588.257,
    y2: -16.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dC",
    x1: 778.48,
    x2: -97.991,
    y1: 373.897,
    y2: -231.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dD",
    x1: 726.305,
    x2: -150.103,
    y1: 449.409,
    y2: -155.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dE",
    x1: 578.347,
    x2: -298.08,
    y1: 663.789,
    y2: 58.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dF",
    x1: 621.996,
    x2: -254.326,
    y1: 600.433,
    y2: -4.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dG",
    x1: 682.658,
    x2: -193.835,
    y1: 512.745,
    y2: -92.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dH",
    x1: 734.747,
    x2: -141.681,
    y1: 437.212,
    y2: -167.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dI",
    x1: 786.881,
    x2: -89.549,
    y1: 361.679,
    y2: -243.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dJ",
    x1: 526.196,
    x2: -350.19,
    y1: 739.302,
    y2: 134.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dK",
    x1: 674.215,
    x2: -202.256,
    y1: 524.963,
    y2: -80.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dL",
    x1: 569.886,
    x2: -306.479,
    y1: 675.966,
    y2: 71.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dM",
    x1: 557.675,
    x2: -318.667,
    y1: 693.627,
    y2: 88.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dN",
    x1: 751.611,
    x2: -124.818,
    y1: 412.754,
    y2: -192.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dO",
    x1: 691.057,
    x2: -185.372,
    y1: 500.506,
    y2: -104.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dP",
    x1: 547.775,
    x2: -328.675,
    y1: 708.111,
    y2: 103.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dQ",
    x1: 657.648,
    x2: -218.823,
    y1: 456.418,
    y2: -148.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dR",
    x1: 655.744,
    x2: -220.621,
    y1: 551.581,
    y2: -53.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dS",
    x1: 638.944,
    x2: -237.527,
    y1: 576.06,
    y2: -28.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dT",
    x1: 534.657,
    x2: -341.793,
    y1: 727.106,
    y2: 122.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dU",
    x1: 603.654,
    x2: -272.796,
    y1: 627.136,
    y2: 22.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dV",
    x1: 760.051,
    x2: -116.399,
    y1: 400.557,
    y2: -204.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dW",
    x1: 707.856,
    x2: -168.467,
    y1: 476.048,
    y2: -128.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dX",
    x1: 647.345,
    x2: -229.084,
    y1: 563.821,
    y2: -41.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dY",
    x1: 743.168,
    x2: -133.24,
    y1: 424.972,
    y2: -179.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dZ",
    x1: 586.747,
    x2: -289.616,
    y1: 651.529,
    y2: 46.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea",
    x1: 543.078,
    x2: -333.33,
    y1: 714.866,
    y2: 109.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eb",
    x1: 595.231,
    x2: -281.219,
    y1: 639.354,
    y2: 34.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec",
    x1: 700.812,
    x2: -175.597,
    y1: 486.318,
    y2: -118.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ed",
    x1: 568.362,
    x2: -308.045,
    y1: 678.232,
    y2: 73.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee",
    x1: 733.224,
    x2: -143.227,
    y1: 439.436,
    y2: -165.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef",
    x1: 620.495,
    x2: -255.912,
    y1: 602.699,
    y2: -2.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eg",
    x1: 537.746,
    x2: -338.682,
    y1: 722.616,
    y2: 117.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eh",
    x1: 724.782,
    x2: -151.647,
    y1: 451.654,
    y2: -153.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ei",
    x1: 716.361,
    x2: -160.089,
    y1: 463.872,
    y2: -141.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: 628.916,
    x2: -247.449,
    y1: 590.459,
    y2: -14.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: 672.649,
    x2: -203.78,
    y1: 527.166,
    y2: -77.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "el",
    x1: 681.05,
    x2: -195.338,
    y1: 514.948,
    y2: -89.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "em",
    x1: 776.914,
    x2: -99.515,
    y1: 376.12,
    y2: -228.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "en",
    x1: 785.314,
    x2: -91.072,
    y1: 363.881,
    y2: -241.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eo",
    x1: 768.452,
    x2: -107.935,
    y1: 388.318,
    y2: -216.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ep",
    x1: 664.249,
    x2: -212.243,
    y1: 539.405,
    y2: -65.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eq",
    x1: 612.053,
    x2: -264.313,
    y1: 614.897,
    y2: 9.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "er",
    x1: 699.308,
    x2: -177.058,
    y1: 488.457,
    y2: -116.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es",
    x1: 793.8,
    x2: -82.672,
    y1: 351.705,
    y2: -253.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "et",
    x1: 627.394,
    x2: -249.036,
    y1: 592.725,
    y2: -12.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eu",
    x1: 714.774,
    x2: -161.613,
    y1: 466.096,
    y2: -138.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ev",
    x1: 541.514,
    x2: -334.874,
    y1: 717.09,
    y2: 112.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: 575.321,
    x2: -301.212,
    y1: 668.279,
    y2: 63.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: 740.1,
    x2: -136.329,
    y1: 429.462,
    y2: -175.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ey",
    x1: 610.488,
    x2: -265.836,
    y1: 617.12,
    y2: 12.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ez",
    x1: 731.636,
    x2: -144.728,
    y1: 441.638,
    y2: -163.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eA",
    x1: 645.8,
    x2: -230.607,
    y1: 566.044,
    y2: -38.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eB",
    x1: 533.071,
    x2: -343.295,
    y1: 729.308,
    y2: 124.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eC",
    x1: 671.084,
    x2: -205.324,
    y1: 529.41,
    y2: -75.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eD",
    x1: 679.505,
    x2: -196.861,
    y1: 517.171,
    y2: -87.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eE",
    x1: 706.353,
    x2: -170.055,
    y1: 478.314,
    y2: -126.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eF",
    x1: 585.248,
    x2: -291.18,
    y1: 653.795,
    y2: 48.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eG",
    x1: 775.349,
    x2: -101.059,
    y1: 378.344,
    y2: -226.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eH",
    x1: 723.259,
    x2: -153.213,
    y1: 453.898,
    y2: -151.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eI",
    x1: 783.812,
    x2: -92.638,
    y1: 366.147,
    y2: -238.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eJ",
    x1: 593.687,
    x2: -282.764,
    y1: 641.599,
    y2: 36.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eK",
    x1: 750.046,
    x2: -126.321,
    y1: 414.978,
    y2: -189.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eL",
    x1: 637.359,
    x2: -239.029,
    y1: 578.263,
    y2: -26.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eM",
    x1: 523.149,
    x2: -353.303,
    y1: 743.792,
    y2: 138.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eN",
    x1: 618.929,
    x2: -257.437,
    y1: 604.923,
    y2: 0.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eO",
    x1: 687.969,
    x2: -188.461,
    y1: 504.974,
    y2: -99.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eP",
    x1: 689.491,
    x2: -186.917,
    y1: 502.729,
    y2: -102.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eQ",
    x1: 654.242,
    x2: -222.187,
    y1: 553.826,
    y2: -51.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eR",
    x1: 602.068,
    x2: -274.3,
    y1: 629.339,
    y2: 24.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eS",
    x1: 766.95,
    x2: -109.501,
    y1: 390.583,
    y2: -214.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eT",
    x1: 741.646,
    x2: -134.784,
    y1: 427.217,
    y2: -177.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eU",
    x1: 792.19,
    x2: -84.175,
    y1: 353.907,
    y2: -251.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eV",
    x1: 576.826,
    x2: -299.625,
    y1: 666.036,
    y2: 61.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eW",
    x1: 758.486,
    x2: -117.922,
    y1: 402.78,
    y2: -202.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eX",
    x1: 697.954,
    x2: -178.497,
    y1: 490.532,
    y2: -114.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eY",
    x1: 531.569,
    x2: -344.859,
    y1: 731.552,
    y2: 126.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eZ",
    x1: 524.631,
    x2: -351.694,
    y1: 741.505,
    y2: 136.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: 662.663,
    x2: -213.744,
    y1: 541.607,
    y2: -63.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: 583.725,
    x2: -292.747,
    y1: 656.04,
    y2: 51.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 635.877,
    x2: -240.638,
    y1: 580.529,
    y2: -24.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd",
    x1: 527.906,
    x2: -348.564,
    y1: 736.931,
    y2: 131.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe",
    x1: 718.711,
    x2: -157.655,
    y1: 460.336,
    y2: -144.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: 539.967,
    x2: -336.398,
    y1: 719.334,
    y2: 114.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fg",
    x1: 600.543,
    x2: -275.843,
    y1: 631.582,
    y2: 26.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: 704.83,
    x2: -171.599,
    y1: 480.537,
    y2: -124.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fi",
    x1: 644.257,
    x2: -232.153,
    y1: 568.289,
    y2: -36.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fj",
    x1: 756.921,
    x2: -119.445,
    y1: 405.004,
    y2: -199.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fk",
    x1: 765.385,
    x2: -111.023,
    y1: 392.786,
    y2: -212.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fl",
    x1: 652.697,
    x2: -223.731,
    y1: 556.07,
    y2: -48.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fm",
    x1: 748.522,
    x2: -127.886,
    y1: 417.222,
    y2: -187.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fn",
    x1: 800.612,
    x2: -75.732,
    y1: 341.689,
    y2: -263.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fo",
    x1: 592.121,
    x2: -284.285,
    y1: 643.8,
    y2: 38.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp",
    x1: 696.346,
    x2: -179.998,
    y1: 492.734,
    y2: -112.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fq",
    x1: 725.611,
    x2: -150.778,
    y1: 450.383,
    y2: -154.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fr",
    x1: 730.114,
    x2: -146.294,
    y1: 443.903,
    y2: -161.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs",
    x1: 790.647,
    x2: -85.719,
    y1: 356.131,
    y2: -248.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ft",
    x1: 651.132,
    x2: -225.255,
    y1: 558.294,
    y2: -46.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: 530.002,
    x2: -346.362,
    y1: 733.775,
    y2: 128.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fv",
    x1: 694.802,
    x2: -181.522,
    y1: 494.958,
    y2: -109.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fw",
    x1: 573.714,
    x2: -302.693,
    y1: 670.482,
    y2: 65.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fx",
    x1: 625.869,
    x2: -250.581,
    y1: 594.97,
    y2: -10.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fy",
    x1: 590.622,
    x2: -285.872,
    y1: 646.067,
    y2: 41.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fz",
    x1: 703.286,
    x2: -173.144,
    y1: 482.782,
    y2: -122.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fA",
    x1: 807.551,
    x2: -68.878,
    y1: 331.715,
    y2: -273.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fB",
    x1: 521.644,
    x2: -354.869,
    y1: 746.037,
    y2: 141.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fC",
    x1: 642.732,
    x2: -233.697,
    y1: 570.533,
    y2: -34.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fD",
    x1: 538.446,
    x2: -337.963,
    y1: 721.579,
    y2: 116.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fE",
    x1: 582.157,
    x2: -294.272,
    y1: 658.264,
    y2: 53.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fF",
    x1: 713.294,
    x2: -163.178,
    y1: 468.34,
    y2: -136.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fG",
    x1: 782.226,
    x2: -94.14,
    y1: 368.349,
    y2: -236.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fH",
    x1: 686.423,
    x2: -190.007,
    y1: 507.219,
    y2: -97.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fI",
    x1: 634.29,
    x2: -242.14,
    y1: 582.731,
    y2: -22.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fJ",
    x1: 721.714,
    x2: -154.757,
    y1: 456.143,
    y2: -148.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fK",
    x1: 669.561,
    x2: -206.869,
    y1: 531.634,
    y2: -73.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fL",
    x1: 755.418,
    x2: -121.011,
    y1: 407.249,
    y2: -197.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fM",
    x1: 608.987,
    x2: -267.421,
    y1: 619.385,
    y2: 14.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fN",
    x1: 678.002,
    x2: -198.427,
    y1: 519.437,
    y2: -85.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fO",
    x1: 598.935,
    x2: -277.325,
    y1: 633.785,
    y2: 28.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fP",
    x1: 773.826,
    x2: -102.604,
    y1: 380.589,
    y2: -224.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fQ",
    x1: 661.14,
    x2: -215.311,
    y1: 543.852,
    y2: -61.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fR",
    x1: 746.977,
    x2: -129.432,
    y1: 419.467,
    y2: -185.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fS",
    x1: 799.11,
    x2: -77.298,
    y1: 343.934,
    y2: -260.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fT",
    x1: 738.534,
    x2: -137.853,
    y1: 431.664,
    y2: -173.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fU",
    x1: 617.427,
    x2: -259.002,
    y1: 607.167,
    y2: 2.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fV",
    x1: 711.706,
    x2: -164.702,
    y1: 470.564,
    y2: -134.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fW",
    x1: 720.149,
    x2: -156.28,
    y1: 458.345,
    y2: -146.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fX",
    x1: 772.26,
    x2: -104.126,
    y1: 382.812,
    y2: -222.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fY",
    x1: 615.883,
    x2: -260.524,
    y1: 609.39,
    y2: 4.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fZ",
    x1: 659.595,
    x2: -216.856,
    y1: 546.097,
    y2: -58.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ga",
    x1: 668.016,
    x2: -208.413,
    y1: 533.878,
    y2: -71.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gb",
    x1: 607.419,
    x2: -268.945,
    y1: 621.587,
    y2: 16.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc",
    x1: 763.861,
    x2: -112.59,
    y1: 395.03,
    y2: -209.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gd",
    x1: 797.544,
    x2: -78.822,
    y1: 346.136,
    y2: -258.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ge",
    x1: 641.145,
    x2: -235.199,
    y1: 572.736,
    y2: -32.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gf",
    x1: 624.282,
    x2: -252.084,
    y1: 597.173,
    y2: -7.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gg",
    x1: 789.144,
    x2: -87.285,
    y1: 358.397,
    y2: -246.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gh",
    x1: 693.256,
    x2: -183.066,
    y1: 497.202,
    y2: -107.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gi",
    x1: 536.922,
    x2: -339.53,
    y1: 723.824,
    y2: 118.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gj",
    x1: 572.151,
    x2: -304.216,
    y1: 672.685,
    y2: 67.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gk",
    x1: 520.039,
    x2: -356.37,
    y1: 748.239,
    y2: 143.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl",
    x1: 589.055,
    x2: -287.375,
    y1: 648.291,
    y2: 43.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gm",
    x1: 580.55,
    x2: -295.752,
    y1: 660.466,
    y2: 55.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn",
    x1: 676.436,
    x2: -199.972,
    y1: 521.639,
    y2: -83.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "go",
    x1: 528.52,
    x2: -347.97,
    y1: 736.041,
    y2: 131.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp",
    x1: 736.99,
    x2: -139.375,
    y1: 433.887,
    y2: -171.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gq",
    x1: 684.9,
    x2: -191.551,
    y1: 509.463,
    y2: -95.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr",
    x1: 728.591,
    x2: -147.859,
    y1: 446.148,
    y2: -158.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gs",
    x1: 745.412,
    x2: -130.954,
    y1: 421.669,
    y2: -183.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt",
    x1: 632.746,
    x2: -243.662,
    y1: 584.954,
    y2: -19.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gu",
    x1: 780.703,
    x2: -95.706,
    y1: 370.594,
    y2: -234.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gv",
    x1: 732.568,
    x2: -143.776,
    y1: 440.24,
    y2: -164.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gw",
    x1: 739.572,
    x2: -136.836,
    y1: 430.203,
    y2: -174.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gx",
    x1: 710.141,
    x2: -166.225,
    y1: 472.787,
    y2: -132.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gy",
    x1: 746.427,
    x2: -130.003,
    y1: 420.272,
    y2: -184.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gz",
    x1: 597.475,
    x2: -278.933,
    y1: 636.072,
    y2: 31.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gA",
    x1: 806.006,
    x2: -70.423,
    y1: 333.96,
    y2: -270.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gB",
    x1: 649.588,
    x2: -226.778,
    y1: 560.517,
    y2: -44.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gC",
    x1: 762.316,
    x2: -114.113,
    y1: 397.275,
    y2: -207.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gD",
    x1: 605.874,
    x2: -270.471,
    y1: 623.812,
    y2: 18.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gE",
    x1: 701.742,
    x2: -174.666,
    y1: 485.005,
    y2: -119.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gF",
    x1: 753.875,
    x2: -122.555,
    y1: 409.472,
    y2: -195.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gG",
    x1: 658.008,
    x2: -218.336,
    y1: 548.299,
    y2: -56.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gH",
    x1: 814.428,
    x2: -61.98,
    y1: 321.72,
    y2: -283.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gI",
    x1: 753.408,
    x2: -123.042,
    y1: 410.192,
    y2: -194.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gJ",
    x1: 543.8,
    x2: -332.611,
    y1: 713.829,
    y2: 108.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gK",
    x1: 517.01,
    x2: -359.503,
    y1: 752.728,
    y2: 147.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gL",
    x1: 786.055,
    x2: -90.353,
    y1: 362.865,
    y2: -242.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gM",
    x1: 681.79,
    x2: -194.64,
    y1: 513.91,
    y2: -91.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gN",
    x1: 674.915,
    x2: -201.515,
    y1: 523.883,
    y2: -81.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gO",
    x1: 769.194,
    x2: -107.236,
    y1: 387.301,
    y2: -217.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gP",
    x1: 683.312,
    x2: -193.054,
    y1: 511.665,
    y2: -93.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gQ",
    x1: 614.317,
    x2: -262.068,
    y1: 611.613,
    y2: 6.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gR",
    x1: 690.211,
    x2: -186.176,
    y1: 501.691,
    y2: -103.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gS",
    x1: 812.862,
    x2: -63.482,
    y1: 323.944,
    y2: -280.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gT",
    x1: 821.324,
    x2: -55.105,
    y1: 311.768,
    y2: -293.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gU",
    x1: 664.947,
    x2: -211.502,
    y1: 538.346,
    y2: -66.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gV",
    x1: 743.908,
    x2: -132.521,
    y1: 423.935,
    y2: -181.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gW",
    x1: 777.613,
    x2: -98.795,
    y1: 375.062,
    y2: -229.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gX",
    x1: 770.716,
    x2: -105.671,
    y1: 385.035,
    y2: -219.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gY",
    x1: 621.234,
    x2: -255.194,
    y1: 601.661,
    y2: -3.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gZ",
    x1: 717.059,
    x2: -159.349,
    y1: 462.813,
    y2: -142.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha",
    x1: 570.647,
    x2: -305.781,
    y1: 674.95,
    y2: 69.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hb",
    x1: 622.759,
    x2: -253.627,
    y1: 599.416,
    y2: -5.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hc",
    x1: 629.636,
    x2: -246.729,
    y1: 589.421,
    y2: -15.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hd",
    x1: 518.515,
    x2: -357.937,
    y1: 750.484,
    y2: 145.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "he",
    x1: 708.618,
    x2: -167.791,
    y1: 475.032,
    y2: -129.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hf",
    x1: 525.392,
    x2: -351.017,
    y1: 740.489,
    y2: 135.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hg",
    x1: 779.158,
    x2: -97.229,
    y1: 372.817,
    y2: -232.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hh",
    x1: 804.464,
    x2: -71.967,
    y1: 336.205,
    y2: -268.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hi",
    x1: 595.931,
    x2: -280.477,
    y1: 638.295,
    y2: 33.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hj",
    x1: 752.308,
    x2: -124.057,
    y1: 411.695,
    y2: -193.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hk",
    x1: 796.02,
    x2: -80.367,
    y1: 348.402,
    y2: -256.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hl",
    x1: 673.369,
    x2: -203.06,
    y1: 526.128,
    y2: -78.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hm",
    x1: 760.751,
    x2: -115.657,
    y1: 399.498,
    y2: -205.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hn",
    x1: 727.023,
    x2: -149.384,
    y1: 448.371,
    y2: -156.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ho",
    x1: 733.965,
    x2: -142.528,
    y1: 438.398,
    y2: -166.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hp",
    x1: 631.2,
    x2: -245.208,
    y1: 587.199,
    y2: -17.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hq",
    x1: 638.079,
    x2: -238.31,
    y1: 577.204,
    y2: -27.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr",
    x1: 666.472,
    x2: -209.937,
    y1: 536.102,
    y2: -68.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hs",
    x1: 742.386,
    x2: -134.087,
    y1: 426.18,
    y2: -178.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ht",
    x1: 735.445,
    x2: -140.941,
    y1: 436.132,
    y2: -168.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hu",
    x1: 794.475,
    x2: -81.933,
    y1: 350.625,
    y2: -254.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hv",
    x1: 787.62,
    x2: -88.83,
    y1: 360.62,
    y2: -244.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hw",
    x1: 526.915,
    x2: -349.473,
    y1: 738.244,
    y2: 133.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hx",
    x1: 700.218,
    x2: -176.232,
    y1: 487.249,
    y2: -117.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hy",
    x1: 533.834,
    x2: -342.594,
    y1: 728.29,
    y2: 123.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hz",
    x1: 718.666,
    x2: -157.868,
    y1: 460.611,
    y2: -144.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hA",
    x1: 725.501,
    x2: -150.928,
    y1: 450.595,
    y2: -154.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hB",
    x1: 639.665,
    x2: -236.808,
    y1: 575.002,
    y2: -29.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hC",
    x1: 604.373,
    x2: -272.055,
    y1: 626.097,
    y2: 21.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hD",
    x1: 579.089,
    x2: -297.361,
    y1: 662.732,
    y2: 57.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hE",
    x1: 656.505,
    x2: -219.945,
    y1: 550.565,
    y2: -54.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hF",
    x1: 648.043,
    x2: -228.322,
    y1: 562.762,
    y2: -42.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hG",
    x1: 612.793,
    x2: -263.615,
    y1: 613.859,
    y2: 8.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hH",
    x1: 587.51,
    x2: -288.919,
    y1: 650.514,
    y2: 45.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hI",
    x1: 535.357,
    x2: -341.03,
    y1: 726.025,
    y2: 121.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hJ",
    x1: 691.797,
    x2: -184.675,
    y1: 499.468,
    y2: -105.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hK",
    x1: 760.285,
    x2: -116.166,
    y1: 400.239,
    y2: -204.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hL",
    x1: 680.223,
    x2: -196.142,
    y1: 516.133,
    y2: -88.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hM",
    x1: 819.781,
    x2: -56.627,
    y1: 313.991,
    y2: -290.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hN",
    x1: 828.18,
    x2: -48.164,
    y1: 301.752,
    y2: -303.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hO",
    x1: 707.051,
    x2: -169.292,
    y1: 477.233,
    y2: -127.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hP",
    x1: 715.515,
    x2: -160.893,
    y1: 465.037,
    y2: -139.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hQ",
    x1: 688.644,
    x2: -187.701,
    y1: 503.915,
    y2: -100.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hR",
    x1: 594.388,
    x2: -282.022,
    y1: 640.54,
    y2: 35.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hS",
    x1: 698.653,
    x2: -177.755,
    y1: 489.473,
    y2: -115.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hT",
    x1: 792.953,
    x2: -83.477,
    y1: 352.891,
    y2: -252.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hU",
    x1: 602.871,
    x2: -273.643,
    y1: 628.343,
    y2: 23.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hV",
    x1: 542.255,
    x2: -334.154,
    y1: 716.052,
    y2: 111.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hW",
    x1: 776.111,
    x2: -100.36,
    y1: 377.327,
    y2: -227.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hX",
    x1: 740.798,
    x2: -135.588,
    y1: 428.382,
    y2: -176.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hY",
    x1: 802.897,
    x2: -73.49,
    y1: 338.407,
    y2: -266.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hZ",
    x1: 767.626,
    x2: -108.739,
    y1: 389.503,
    y2: -215.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ia",
    x1: 654.983,
    x2: -221.488,
    y1: 552.809,
    y2: -52.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib",
    x1: 611.268,
    x2: -265.16,
    y1: 616.103,
    y2: 11.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic",
    x1: 532.29,
    x2: -344.139,
    y1: 730.514,
    y2: 125.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id",
    x1: 619.712,
    x2: -256.758,
    y1: 603.905,
    y2: -1.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie",
    x1: 750.806,
    x2: -125.644,
    y1: 413.961,
    y2: -190.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "if",
    x1: 759.228,
    x2: -117.201,
    y1: 401.743,
    y2: -203.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig",
    x1: 646.499,
    x2: -229.867,
    y1: 564.985,
    y2: -39.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ih",
    x1: 523.807,
    x2: -352.518,
    y1: 742.691,
    y2: 137.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ii",
    x1: 671.782,
    x2: -204.541,
    y1: 528.331,
    y2: -76.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ij",
    x1: 663.382,
    x2: -213.047,
    y1: 540.57,
    y2: -64.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ik",
    x1: 723.957,
    x2: -152.472,
    y1: 452.84,
    y2: -152.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "il",
    x1: 784.488,
    x2: -91.877,
    y1: 365.067,
    y2: -239.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "im",
    x1: 628.114,
    x2: -248.296,
    y1: 591.667,
    y2: -13.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "in",
    x1: 732.399,
    x2: -144.051,
    y1: 440.621,
    y2: -164.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "io",
    x1: 811.34,
    x2: -65.047,
    y1: 326.188,
    y2: -278.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ip",
    x1: 636.533,
    x2: -239.832,
    y1: 579.427,
    y2: -25.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iq",
    x1: 767.162,
    x2: -109.268,
    y1: 390.223,
    y2: -214.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ir",
    x1: 653.395,
    x2: -222.991,
    y1: 555.012,
    y2: -49.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "is",
    x1: 705.549,
    x2: -170.88,
    y1: 479.5,
    y2: -125.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "it",
    x1: 757.64,
    x2: -118.704,
    y1: 403.945,
    y2: -200.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iu",
    x1: 801.372,
    x2: -75.035,
    y1: 340.651,
    y2: -264.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iv",
    x1: 601.285,
    x2: -275.144,
    y1: 630.566,
    y2: 25.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iw",
    x1: 644.997,
    x2: -231.453,
    y1: 567.251,
    y2: -37.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix",
    x1: 592.864,
    x2: -283.586,
    y1: 642.763,
    y2: 37.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iy",
    x1: 749.219,
    x2: -127.146,
    y1: 416.163,
    y2: -188.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iz",
    x1: 818.215,
    x2: -58.15,
    y1: 316.215,
    y2: -288.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iA",
    x1: 540.707,
    x2: -335.7,
    y1: 718.297,
    y2: 113.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iB",
    x1: 697.127,
    x2: -179.322,
    y1: 491.718,
    y2: -113.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iC",
    x1: 809.815,
    x2: -66.614,
    y1: 328.454,
    y2: -276.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iD",
    x1: 774.08,
    x2: -102.371,
    y1: 380.25,
    y2: -224.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iE",
    x1: 695.585,
    x2: -180.865,
    y1: 493.962,
    y2: -111.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iF",
    x1: 766.104,
    x2: -110.304,
    y1: 391.748,
    y2: -213.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iG",
    x1: 799.85,
    x2: -76.601,
    y1: 342.896,
    y2: -262.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iH",
    x1: 791.386,
    x2: -85,
    y1: 355.093,
    y2: -249.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iI",
    x1: 591.298,
    x2: -285.11,
    y1: 644.987,
    y2: 40.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iJ",
    x1: 626.59,
    x2: -249.859,
    y1: 593.91,
    y2: -11.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iK",
    x1: 783.009,
    x2: -93.484,
    y1: 367.333,
    y2: -237.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iL",
    x1: 634.989,
    x2: -241.377,
    y1: 581.672,
    y2: -23.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iM",
    x1: 522.323,
    x2: -354.13,
    y1: 744.979,
    y2: 140.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iN",
    x1: 774.545,
    x2: -101.884,
    y1: 379.551,
    y2: -225.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iO",
    x1: 643.495,
    x2: -233.042,
    y1: 569.496,
    y2: -35.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iP",
    x1: 747.718,
    x2: -128.733,
    y1: 418.429,
    y2: -186.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iQ",
    x1: 609.684,
    x2: -266.661,
    y1: 618.306,
    y2: 13.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iR",
    x1: 714.012,
    x2: -162.479,
    y1: 467.302,
    y2: -137.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iS",
    x1: 835.099,
    x2: -41.309,
    y1: 291.778,
    y2: -313.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iT",
    x1: 687.141,
    x2: -189.266,
    y1: 506.16,
    y2: -98.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iU",
    x1: 739.297,
    x2: -137.154,
    y1: 430.647,
    y2: -174.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iV",
    x1: 661.88,
    x2: -214.612,
    y1: 542.836,
    y2: -62.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iW",
    x1: 539.208,
    x2: -337.263,
    y1: 720.541,
    y2: 115.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iX",
    x1: 678.721,
    x2: -197.729,
    y1: 518.378,
    y2: -86.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iY",
    x1: 618.123,
    x2: -258.261,
    y1: 606.108,
    y2: 1.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iZ",
    x1: 670.28,
    x2: -206.149,
    y1: 530.596,
    y2: -74.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ja",
    x1: 826.657,
    x2: -49.73,
    y1: 303.996,
    y2: -300.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jb",
    x1: 530.788,
    x2: -345.708,
    y1: 732.76,
    y2: 127.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jc",
    x1: 722.369,
    x2: -153.975,
    y1: 455.042,
    y2: -149.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jd",
    x1: 730.855,
    x2: -145.596,
    y1: 442.866,
    y2: -162.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "je",
    x1: 780.956,
    x2: -95.473,
    y1: 370.255,
    y2: -234.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jf",
    x1: 787.727,
    x2: -88.618,
    y1: 360.345,
    y2: -244.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jg",
    x1: 616.58,
    x2: -259.806,
    y1: 608.332,
    y2: 3.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jh",
    x1: 704.006,
    x2: -172.424,
    y1: 481.723,
    y2: -123.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ji",
    x1: 825.156,
    x2: -51.295,
    y1: 306.262,
    y2: -298.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jj",
    x1: 608.202,
    x2: -268.292,
    y1: 620.593,
    y2: 15.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jk",
    x1: 660.272,
    x2: -216.093,
    y1: 545.017,
    y2: -59.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jl",
    x1: 712.425,
    x2: -163.982,
    y1: 469.505,
    y2: -135.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jm",
    x1: 808.271,
    x2: -68.137,
    y1: 330.678,
    y2: -274.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jn",
    x1: 764.58,
    x2: -111.849,
    y1: 393.993,
    y2: -210.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jo",
    x1: 773,
    x2: -103.429,
    y1: 381.774,
    y2: -223.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jp",
    x1: 599.761,
    x2: -276.687,
    y1: 632.788,
    y2: 27.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jq",
    x1: 668.755,
    x2: -207.715,
    y1: 532.841,
    y2: -72.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jr",
    x1: 756.117,
    x2: -120.27,
    y1: 406.19,
    y2: -198.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "js",
    x1: 651.85,
    x2: -224.537,
    y1: 557.257,
    y2: -47.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jt",
    x1: 720.869,
    x2: -155.54,
    y1: 457.286,
    y2: -147.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ju",
    x1: 816.671,
    x2: -59.695,
    y1: 318.438,
    y2: -286.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jv",
    x1: 625.065,
    x2: -251.427,
    y1: 596.155,
    y2: -8.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jw",
    x1: 685.618,
    x2: -190.831,
    y1: 508.404,
    y2: -96.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jx",
    x1: 841.975,
    x2: -34.391,
    y1: 281.804,
    y2: -323.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jy",
    x1: 694.041,
    x2: -182.41,
    y1: 496.186,
    y2: -108.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jz",
    x1: 702.46,
    x2: -173.947,
    y1: 483.968,
    y2: -120.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jA",
    x1: 633.466,
    x2: -242.965,
    y1: 583.917,
    y2: -21.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jB",
    x1: 641.864,
    x2: -234.481,
    y1: 571.677,
    y2: -33.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jC",
    x1: 650.285,
    x2: -226.038,
    y1: 559.459,
    y2: -45.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jD",
    x1: 677.176,
    x2: -199.273,
    y1: 520.622,
    y2: -84.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jE",
    x1: 658.726,
    x2: -217.618,
    y1: 547.262,
    y2: -57.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jF",
    x1: 746.152,
    x2: -130.235,
    y1: 420.653,
    y2: -184.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jG",
    x1: 815.147,
    x2: -61.261,
    y1: 320.683,
    y2: -284.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jH",
    x1: 806.768,
    x2: -69.746,
    y1: 332.944,
    y2: -272.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jI",
    x1: 789.863,
    x2: -86.544,
    y1: 357.338,
    y2: -247.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jJ",
    x1: 589.794,
    x2: -286.698,
    y1: 647.253,
    y2: 42.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jK",
    x1: 833.534,
    x2: -42.811,
    y1: 294.002,
    y2: -310.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jL",
    x1: 529.199,
    x2: -347.209,
    y1: 734.962,
    y2: 130.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jM",
    x1: 781.378,
    x2: -94.945,
    y1: 369.535,
    y2: -235.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jN",
    x1: 729.309,
    x2: -147.14,
    y1: 445.089,
    y2: -159.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jO",
    x1: 520.78,
    x2: -355.671,
    y1: 747.201,
    y2: 142.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jP",
    x1: 754.616,
    x2: -121.856,
    y1: 408.455,
    y2: -196.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jQ",
    x1: 798.242,
    x2: -78.06,
    y1: 345.077,
    y2: -259.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jR",
    x1: 537.62,
    x2: -338.767,
    y1: 722.744,
    y2: 117.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jS",
    x1: 762.994,
    x2: -113.351,
    y1: 396.195,
    y2: -208.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jT",
    x1: 737.73,
    x2: -138.698,
    y1: 432.871,
    y2: -172.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jU",
    x1: 710.86,
    x2: -165.485,
    y1: 471.728,
    y2: -133.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jV",
    x1: 598.195,
    x2: -278.213,
    y1: 635.013,
    y2: 30.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jW",
    x1: 794.814,
    x2: -81.636,
    y1: 350.202,
    y2: -254.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jX",
    x1: 675.61,
    x2: -200.776,
    y1: 522.825,
    y2: -82.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jY",
    x1: 832.031,
    x2: -44.399,
    y1: 296.267,
    y2: -308.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jZ",
    x1: 727.766,
    x2: -148.663,
    y1: 447.313,
    y2: -157.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ka",
    x1: 615.036,
    x2: -261.328,
    y1: 610.576,
    y2: 5.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kb",
    x1: 779.899,
    x2: -96.552,
    y1: 371.801,
    y2: -233.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kc",
    x1: 823.589,
    x2: -52.841,
    y1: 308.486,
    y2: -296.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kd",
    x1: 519.212,
    x2: -357.174,
    y1: 749.425,
    y2: 144.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ke",
    x1: 771.435,
    x2: -104.931,
    y1: 383.998,
    y2: -220.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kf",
    x1: 719.323,
    x2: -157.084,
    y1: 459.531,
    y2: -145.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kg",
    x1: 667.191,
    x2: -209.217,
    y1: 535.043,
    y2: -69.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kh",
    x1: 623.478,
    x2: -252.928,
    y1: 598.357,
    y2: -6.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ki",
    x1: 801.734,
    x2: -74.717,
    y1: 340.186,
    y2: -264.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kj",
    x1: 808.588,
    x2: -67.82,
    y1: 330.191,
    y2: -274.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kk",
    x1: 838.907,
    x2: -37.501,
    y1: 286.273,
    y2: -318.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kl",
    x1: 778.354,
    x2: -98.075,
    y1: 374.024,
    y2: -230.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "km",
    x1: 630.398,
    x2: -246.052,
    y1: 588.405,
    y2: -16.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kn",
    x1: 744.608,
    x2: -131.801,
    y1: 422.876,
    y2: -182.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ko",
    x1: 536.076,
    x2: -340.312,
    y1: 724.989,
    y2: 120.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kp",
    x1: 534.532,
    x2: -341.835,
    y1: 727.212,
    y2: 122.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kq",
    x1: 805.182,
    x2: -71.227,
    y1: 335.125,
    y2: -269.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr",
    x1: 631.92,
    x2: -244.488,
    y1: 586.161,
    y2: -18.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ks",
    x1: 682.489,
    x2: -193.856,
    y1: 512.83,
    y2: -92.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kt",
    x1: 638.818,
    x2: -237.632,
    y1: 576.187,
    y2: -28.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ku",
    x1: 830.487,
    x2: -45.943,
    y1: 298.491,
    y2: -306.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kv",
    x1: 769.932,
    x2: -106.518,
    y1: 386.242,
    y2: -218.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kw",
    x1: 517.712,
    x2: -358.782,
    y1: 751.691,
    y2: 146.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kx",
    x1: 657.203,
    x2: -219.182,
    y1: 549.505,
    y2: -55.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ky",
    x1: 761.47,
    x2: -114.939,
    y1: 398.461,
    y2: -206.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kz",
    x1: 788.319,
    x2: -88.089,
    y1: 359.561,
    y2: -245.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kA",
    x1: 684.011,
    x2: -192.291,
    y1: 510.586,
    y2: -94.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kB",
    x1: 690.972,
    x2: -185.499,
    y1: 500.654,
    y2: -104.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kC",
    x1: 795.216,
    x2: -81.213,
    y1: 349.587,
    y2: -255.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kD",
    x1: 753.029,
    x2: -123.338,
    y1: 410.658,
    y2: -194.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kE",
    x1: 665.71,
    x2: -210.825,
    y1: 537.33,
    y2: -67.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kF",
    x1: 840.452,
    x2: -35.956,
    y1: 284.049,
    y2: -320.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kG",
    x1: 847.37,
    x2: -29.101,
    y1: 274.075,
    y2: -330.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kH",
    x1: 700.894,
    x2: -175.45,
    y1: 486.17,
    y2: -118.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kI",
    x1: 734.664,
    x2: -141.787,
    y1: 437.339,
    y2: -167.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kJ",
    x1: 526.111,
    x2: -350.298,
    y1: 739.451,
    y2: 134.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kK",
    x1: 596.671,
    x2: -279.781,
    y1: 637.258,
    y2: 32.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kL",
    x1: 822.045,
    x2: -54.385,
    y1: 310.709,
    y2: -294.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kM",
    x1: 527.634,
    x2: -348.732,
    y1: 737.185,
    y2: 132.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kN",
    x1: 848.873,
    x2: -27.514,
    y1: 271.81,
    y2: -333.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kO",
    x1: 726.2,
    x2: -150.187,
    y1: 449.536,
    y2: -155.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kP",
    x1: 648.784,
    x2: -227.603,
    y1: 561.703,
    y2: -43.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kQ",
    x1: 613.513,
    x2: -262.895,
    y1: 612.821,
    y2: 7.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kR",
    x1: 796.76,
    x2: -79.689,
    y1: 347.364,
    y2: -257.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kS",
    x1: 640.363,
    x2: -236.068,
    y1: 573.943,
    y2: -31.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kT",
    x1: 709.358,
    x2: -167.072,
    y1: 473.973,
    y2: -130.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kU",
    x1: 717.779,
    x2: -158.609,
    y1: 461.755,
    y2: -143.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kV",
    x1: 813.603,
    x2: -62.784,
    y1: 322.927,
    y2: -282.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kW",
    x1: 692.475,
    x2: -183.913,
    y1: 498.409,
    y2: -106.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kX",
    x1: 586.619,
    x2: -289.64,
    y1: 651.657,
    y2: 46.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kY",
    x1: 743.063,
    x2: -133.304,
    y1: 425.1,
    y2: -179.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kZ",
    x1: 736.207,
    x2: -140.264,
    y1: 435.115,
    y2: -169.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "la",
    x1: 588.187,
    x2: -288.158,
    y1: 649.434,
    y2: 44.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb",
    x1: 786.752,
    x2: -89.613,
    y1: 361.784,
    y2: -243.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lc",
    x1: 674.089,
    x2: -202.343,
    y1: 525.07,
    y2: -79.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ld",
    x1: 621.956,
    x2: -254.474,
    y1: 600.603,
    y2: -4.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "le",
    x1: 820.522,
    x2: -55.929,
    y1: 312.954,
    y2: -292.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lf",
    x1: 699.35,
    x2: -177.016,
    y1: 488.415,
    y2: -116.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg",
    x1: 611.969,
    x2: -264.438,
    y1: 615.065,
    y2: 10.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lh",
    x1: 647.238,
    x2: -229.171,
    y1: 563.949,
    y2: -40.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "li",
    x1: 716.235,
    x2: -160.151,
    y1: 463.999,
    y2: -140.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lj",
    x1: 664.124,
    x2: -212.328,
    y1: 539.533,
    y2: -65.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lk",
    x1: 803.616,
    x2: -72.749,
    y1: 337.369,
    y2: -267.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ll",
    x1: 751.505,
    x2: -124.904,
    y1: 412.903,
    y2: -192.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lm",
    x1: 815.443,
    x2: -60.944,
    y1: 320.238,
    y2: -284.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ln",
    x1: 812.036,
    x2: -64.308,
    y1: 325.151,
    y2: -279.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lo",
    x1: 855.771,
    x2: -20.637,
    y1: 261.857,
    y2: -343.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lp",
    x1: 595.106,
    x2: -281.28,
    y1: 639.481,
    y2: 34.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lq",
    x1: 655.659,
    x2: -220.728,
    y1: 551.729,
    y2: -53.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lr",
    x1: 759.946,
    x2: -116.483,
    y1: 400.684,
    y2: -204.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ls",
    x1: 768.388,
    x2: -108.062,
    y1: 388.487,
    y2: -216.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lt",
    x1: 707.814,
    x2: -168.614,
    y1: 476.217,
    y2: -128.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lu",
    x1: 785.251,
    x2: -91.22,
    y1: 364.05,
    y2: -240.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lv",
    x1: 516.062,
    x2: -360.158,
    y1: 753.829,
    y2: 149.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lw",
    x1: 828.964,
    x2: -47.529,
    y1: 300.757,
    y2: -304.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lx",
    x1: 680.985,
    x2: -195.465,
    y1: 515.096,
    y2: -89.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ly",
    x1: 793.629,
    x2: -82.694,
    y1: 351.811,
    y2: -253.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lz",
    x1: 524.566,
    x2: -351.842,
    y1: 741.674,
    y2: 136.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lA",
    x1: 637.252,
    x2: -239.113,
    y1: 578.389,
    y2: -26.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lB",
    x1: 845.805,
    x2: -30.624,
    y1: 276.299,
    y2: -328.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lC",
    x1: 628.832,
    x2: -247.577,
    y1: 590.629,
    y2: -14.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lD",
    x1: 672.543,
    x2: -203.887,
    y1: 527.315,
    y2: -77.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lE",
    x1: 741.559,
    x2: -134.934,
    y1: 427.366,
    y2: -177.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lF",
    x1: 733.097,
    x2: -143.311,
    y1: 439.562,
    y2: -165.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lG",
    x1: 620.411,
    x2: -256.019,
    y1: 602.848,
    y2: -2.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lH",
    x1: 776.788,
    x2: -99.599,
    y1: 376.248,
    y2: -228.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lI",
    x1: 837.279,
    x2: -38.918,
    y1: 288.454,
    y2: -316.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lJ",
    x1: 724.697,
    x2: -151.774,
    y1: 451.802,
    y2: -153.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lK",
    x1: 689.406,
    x2: -187.002,
    y1: 502.877,
    y2: -102.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lL",
    x1: 854.226,
    x2: -22.183,
    y1: 264.081,
    y2: -340.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lM",
    x1: 532.985,
    x2: -343.403,
    y1: 729.457,
    y2: 124.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lN",
    x1: 749.96,
    x2: -126.427,
    y1: 415.126,
    y2: -189.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lO",
    x1: 593.56,
    x2: -282.828,
    y1: 641.705,
    y2: 36.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lP",
    x1: 645.715,
    x2: -230.714,
    y1: 566.192,
    y2: -38.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lQ",
    x1: 802.135,
    x2: -74.379,
    y1: 339.635,
    y2: -265.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lR",
    x1: 697.869,
    x2: -178.624,
    y1: 490.681,
    y2: -114.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lS",
    x1: 585.078,
    x2: -291.204,
    y1: 653.902,
    y2: 49.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lT",
    x1: 822.361,
    x2: -54.025,
    y1: 310.222,
    y2: -294.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lU",
    x1: 829.217,
    x2: -47.191,
    y1: 300.291,
    y2: -304.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lV",
    x1: 836.242,
    x2: -40.166,
    y1: 290.148,
    y2: -314.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lW",
    x1: 810.514,
    x2: -65.852,
    y1: 327.374,
    y2: -277.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lX",
    x1: 662.599,
    x2: -213.894,
    y1: 541.777,
    y2: -63.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lY",
    x1: 827.397,
    x2: -49.032,
    y1: 302.959,
    y2: -301.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lZ",
    x1: 835.841,
    x2: -40.611,
    y1: 290.762,
    y2: -314.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ma",
    x1: 679.397,
    x2: -196.928,
    y1: 517.299,
    y2: -87.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mb",
    x1: 670.977,
    x2: -205.409,
    y1: 529.537,
    y2: -75.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mc",
    x1: 644.15,
    x2: -232.237,
    y1: 568.416,
    y2: -36.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "md",
    x1: 706.269,
    x2: -170.139,
    y1: 478.441,
    y2: -126.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "me",
    x1: 758.402,
    x2: -118.028,
    y1: 402.929,
    y2: -202.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mf",
    x1: 635.708,
    x2: -240.638,
    y1: 580.614,
    y2: -24.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mg",
    x1: 514.537,
    x2: -361.722,
    y1: 756.094,
    y2: 151.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mh",
    x1: 714.689,
    x2: -161.696,
    y1: 466.222,
    y2: -138.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mi",
    x1: 748.416,
    x2: -127.992,
    y1: 417.37,
    y2: -187.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mj",
    x1: 610.404,
    x2: -265.942,
    y1: 617.268,
    y2: 12.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mk",
    x1: 739.994,
    x2: -136.413,
    y1: 429.589,
    y2: -175.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ml",
    x1: 618.888,
    x2: -257.564,
    y1: 605.071,
    y2: 0.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mm",
    x1: 723.174,
    x2: -153.34,
    y1: 454.047,
    y2: -150.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mn",
    x1: 627.329,
    x2: -249.183,
    y1: 592.873,
    y2: -12.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mo",
    x1: 731.575,
    x2: -144.875,
    y1: 441.807,
    y2: -163.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mp",
    x1: 862.624,
    x2: -13.698,
    y1: 251.841,
    y2: -353.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mq",
    x1: 654.115,
    x2: -222.252,
    y1: 553.953,
    y2: -50.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mr",
    x1: 687.861,
    x2: -188.547,
    y1: 505.101,
    y2: -99.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ms",
    x1: 800.569,
    x2: -75.882,
    y1: 341.859,
    y2: -263.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt",
    x1: 531.506,
    x2: -345.009,
    y1: 731.722,
    y2: 126.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mu",
    x1: 792.085,
    x2: -84.238,
    y1: 354.034,
    y2: -250.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mv",
    x1: 844.197,
    x2: -32.063,
    y1: 278.48,
    y2: -326.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mw",
    x1: 696.304,
    x2: -180.125,
    y1: 492.904,
    y2: -112.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mx",
    x1: 783.623,
    x2: -92.617,
    y1: 366.232,
    y2: -238.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "my",
    x1: 775.243,
    x2: -101.144,
    y1: 378.471,
    y2: -226.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mz",
    x1: 818.998,
    x2: -57.495,
    y1: 315.198,
    y2: -289.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mA",
    x1: 523.023,
    x2: -353.365,
    y1: 743.898,
    y2: 138.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mB",
    x1: 852.702,
    x2: -23.748,
    y1: 266.325,
    y2: -338.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mC",
    x1: 766.823,
    x2: -109.585,
    y1: 390.71,
    y2: -214.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mD",
    x1: 592.016,
    x2: -284.37,
    y1: 643.949,
    y2: 39.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mE",
    x1: 513.078,
    x2: -363.374,
    y1: 758.361,
    y2: 153.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mF",
    x1: 634.164,
    x2: -242.182,
    y1: 582.858,
    y2: -22.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mG",
    x1: 625.743,
    x2: -250.642,
    y1: 595.075,
    y2: -9.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mH",
    x1: 617.321,
    x2: -259.086,
    y1: 607.294,
    y2: 2.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mI",
    x1: 642.584,
    x2: -233.759,
    y1: 570.639,
    y2: -34.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mJ",
    x1: 521.499,
    x2: -354.933,
    y1: 746.143,
    y2: 141.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mK",
    x1: 608.921,
    x2: -267.57,
    y1: 619.534,
    y2: 14.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mL",
    x1: 651.025,
    x2: -225.341,
    y1: 558.421,
    y2: -46.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mM",
    x1: 529.896,
    x2: -346.468,
    y1: 733.924,
    y2: 129.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mN",
    x1: 652.591,
    x2: -223.818,
    y1: 556.219,
    y2: -48.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mO",
    x1: 661.033,
    x2: -215.395,
    y1: 544,
    y2: -60.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mP",
    x1: 669.456,
    x2: -206.932,
    y1: 531.761,
    y2: -73.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mQ",
    x1: 808.991,
    x2: -67.439,
    y1: 329.64,
    y2: -275.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mR",
    x1: 746.872,
    x2: -129.515,
    y1: 419.593,
    y2: -185.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mS",
    x1: 861.081,
    x2: -15.242,
    y1: 254.086,
    y2: -350.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mT",
    x1: 686.339,
    x2: -190.132,
    y1: 507.366,
    y2: -97.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mU",
    x1: 773.742,
    x2: -102.709,
    y1: 380.737,
    y2: -224.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mV",
    x1: 843.097,
    x2: -33.248,
    y1: 280.132,
    y2: -324.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mW",
    x1: 755.27,
    x2: -121.032,
    y1: 407.355,
    y2: -197.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mX",
    x1: 738.472,
    x2: -137.999,
    y1: 431.833,
    y2: -173.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mY",
    x1: 825.874,
    x2: -50.597,
    y1: 305.204,
    y2: -299.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mZ",
    x1: 782.141,
    x2: -94.246,
    y1: 368.497,
    y2: -236.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "na",
    x1: 756.879,
    x2: -119.593,
    y1: 405.173,
    y2: -199.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nb",
    x1: 730.03,
    x2: -146.421,
    y1: 444.03,
    y2: -160.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nc",
    x1: 869.544,
    x2: -6.843,
    y1: 241.867,
    y2: -363.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nd",
    x1: 704.725,
    x2: -171.684,
    y1: 480.664,
    y2: -124.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ne",
    x1: 713.104,
    x2: -163.178,
    y1: 468.425,
    y2: -136.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nf",
    x1: 817.411,
    x2: -58.975,
    y1: 317.4,
    y2: -287.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ng",
    x1: 721.566,
    x2: -154.778,
    y1: 456.227,
    y2: -148.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nh",
    x1: 703.202,
    x2: -173.249,
    y1: 482.93,
    y2: -122.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ni",
    x1: 799.024,
    x2: -77.426,
    y1: 344.082,
    y2: -260.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nj",
    x1: 694.716,
    x2: -181.606,
    y1: 495.106,
    y2: -109.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nk",
    x1: 834.275,
    x2: -42.113,
    y1: 292.964,
    y2: -311.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nl",
    x1: 807.425,
    x2: -68.919,
    y1: 331.842,
    y2: -273.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nm",
    x1: 677.917,
    x2: -198.576,
    y1: 519.586,
    y2: -85.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nn",
    x1: 851.136,
    x2: -25.251,
    y1: 268.549,
    y2: -336.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no",
    x1: 859.557,
    x2: -16.808,
    y1: 256.33,
    y2: -348.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "np",
    x1: 790.561,
    x2: -85.804,
    y1: 356.279,
    y2: -248.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nq",
    x1: 765.3,
    x2: -111.151,
    y1: 392.955,
    y2: -212.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nr",
    x1: 815.867,
    x2: -60.52,
    y1: 319.645,
    y2: -285.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ns",
    x1: 607.357,
    x2: -269.052,
    y1: 621.757,
    y2: 16.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nt",
    x1: 667.868,
    x2: -208.434,
    y1: 533.984,
    y2: -70.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nu",
    x1: 511.513,
    x2: -364.874,
    y1: 760.584,
    y2: 155.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nv",
    x1: 763.755,
    x2: -112.674,
    y1: 395.178,
    y2: -209.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nw",
    x1: 876.421,
    x2: 0.055,
    y1: 231.894,
    y2: -373.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nx",
    x1: 615.756,
    x2: -260.59,
    y1: 609.518,
    y2: 4.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ny",
    x1: 824.288,
    x2: -52.057,
    y1: 307.406,
    y2: -297.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nz",
    x1: 728.527,
    x2: -148.008,
    y1: 446.296,
    y2: -158.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nA",
    x1: 711.58,
    x2: -164.743,
    y1: 470.669,
    y2: -134.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nB",
    x1: 676.309,
    x2: -200.017,
    y1: 521.767,
    y2: -83.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nC",
    x1: 780.638,
    x2: -95.854,
    y1: 370.763,
    y2: -234.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nD",
    x1: 868,
    x2: -8.387,
    y1: 244.112,
    y2: -360.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nE",
    x1: 772.155,
    x2: -104.19,
    y1: 382.939,
    y2: -221.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nF",
    x1: 850.058,
    x2: -26.351,
    y1: 270.137,
    y2: -334.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nG",
    x1: 659.467,
    x2: -216.92,
    y1: 546.224,
    y2: -58.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nH",
    x1: 624.178,
    x2: -252.126,
    y1: 597.3,
    y2: -7.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nI",
    x1: 745.369,
    x2: -131.145,
    y1: 421.86,
    y2: -183.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nJ",
    x1: 632.661,
    x2: -243.788,
    y1: 585.123,
    y2: -19.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nK",
    x1: 736.926,
    x2: -139.523,
    y1: 434.057,
    y2: -170.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nL",
    x1: 641.082,
    x2: -235.347,
    y1: 572.905,
    y2: -32.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nM",
    x1: 849.635,
    x2: -26.858,
    y1: 270.793,
    y2: -334.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nN",
    x1: 528.375,
    x2: -348.012,
    y1: 736.147,
    y2: 131.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nO",
    x1: 519.931,
    x2: -356.434,
    y1: 748.366,
    y2: 143.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nP",
    x1: 684.773,
    x2: -191.615,
    y1: 509.569,
    y2: -95.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nQ",
    x1: 693.213,
    x2: -183.215,
    y1: 497.372,
    y2: -107.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nR",
    x1: 797.48,
    x2: -78.971,
    y1: 346.327,
    y2: -258.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nS",
    x1: 789.039,
    x2: -87.391,
    y1: 358.524,
    y2: -246.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nT",
    x1: 856.998,
    x2: -19.495,
    y1: 260.142,
    y2: -344.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nU",
    x1: 509.967,
    x2: -366.421,
    y1: 762.829,
    y2: 157.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nV",
    x1: 657.925,
    x2: -218.443,
    y1: 548.448,
    y2: -56.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nW",
    x1: 605.812,
    x2: -270.596,
    y1: 623.981,
    y2: 19.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nX",
    x1: 866.455,
    x2: -9.911,
    y1: 246.335,
    y2: -358.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nY",
    x1: 814.322,
    x2: -62.043,
    y1: 321.869,
    y2: -283.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nZ",
    x1: 753.747,
    x2: -122.597,
    y1: 409.599,
    y2: -195.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oa",
    x1: 649.503,
    x2: -226.885,
    y1: 560.666,
    y2: -44.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ob",
    x1: 666.346,
    x2: -210,
    y1: 536.229,
    y2: -68.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oc",
    x1: 858.034,
    x2: -18.374,
    y1: 258.575,
    y2: -346.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "od",
    x1: 805.901,
    x2: -70.507,
    y1: 334.087,
    y2: -270.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oe",
    x1: 874.876,
    x2: -1.468,
    y1: 234.117,
    y2: -370.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "of",
    x1: 614.211,
    x2: -262.112,
    y1: 611.741,
    y2: 6.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "og",
    x1: 770.652,
    x2: -105.797,
    y1: 385.183,
    y2: -219.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oh",
    x1: 762.211,
    x2: -114.197,
    y1: 397.402,
    y2: -207.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oi",
    x1: 701.635,
    x2: -174.772,
    y1: 485.132,
    y2: -119.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oj",
    x1: 863.874,
    x2: -12.534,
    y1: 250.105,
    y2: -354.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ok",
    x1: 883.36,
    x2: 6.846,
    y1: 221.941,
    y2: -383.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ol",
    x1: 735.34,
    x2: -141.005,
    y1: 436.259,
    y2: -168.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "om",
    x1: 726.94,
    x2: -149.468,
    y1: 448.499,
    y2: -156.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "on",
    x1: 743.761,
    x2: -132.542,
    y1: 424.041,
    y2: -180.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oo",
    x1: 848.068,
    x2: -28.36,
    y1: 273.017,
    y2: -331.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "op",
    x1: 795.893,
    x2: -80.43,
    y1: 348.529,
    y2: -256.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oq",
    x1: 518.367,
    x2: -357.936,
    y1: 750.589,
    y2: 145.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "or",
    x1: 639.538,
    x2: -236.871,
    y1: 575.129,
    y2: -29.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "os",
    x1: 526.851,
    x2: -349.598,
    y1: 738.391,
    y2: 133.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ot",
    x1: 779.052,
    x2: -97.313,
    y1: 372.965,
    y2: -231.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ou",
    x1: 631.117,
    x2: -245.353,
    y1: 587.346,
    y2: -17.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ov",
    x1: 622.653,
    x2: -253.732,
    y1: 599.544,
    y2: -5.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ow",
    x1: 674.83,
    x2: -201.664,
    y1: 524.053,
    y2: -80.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ox",
    x1: 683.207,
    x2: -193.138,
    y1: 511.792,
    y2: -93.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oy",
    x1: 691.648,
    x2: -184.696,
    y1: 499.574,
    y2: -105.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oz",
    x1: 612.688,
    x2: -263.699,
    y1: 614.007,
    y2: 9.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oA",
    x1: 725.438,
    x2: -151.097,
    y1: 450.764,
    y2: -154.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oB",
    x1: 647.958,
    x2: -228.406,
    y1: 562.889,
    y2: -42.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oC",
    x1: 700.134,
    x2: -176.382,
    y1: 487.399,
    y2: -117.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oD",
    x1: 752.202,
    x2: -124.142,
    y1: 411.844,
    y2: -193.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oE",
    x1: 760.645,
    x2: -115.72,
    y1: 399.625,
    y2: -205.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oF",
    x1: 673.284,
    x2: -203.207,
    y1: 526.276,
    y2: -78.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oG",
    x1: 873.331,
    x2: -3.013,
    y1: 236.362,
    y2: -368.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oH",
    x1: 769.129,
    x2: -107.384,
    y1: 387.449,
    y2: -217.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oI",
    x1: 516.864,
    x2: -359.545,
    y1: 752.834,
    y2: 147.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oJ",
    x1: 864.932,
    x2: -11.497,
    y1: 248.58,
    y2: -356.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oK",
    x1: 604.267,
    x2: -272.139,
    y1: 626.224,
    y2: 21.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oL",
    x1: 621.087,
    x2: -255.214,
    y1: 601.767,
    y2: -3.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oM",
    x1: 777.486,
    x2: -98.838,
    y1: 375.189,
    y2: -229.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oN",
    x1: 656.421,
    x2: -220.05,
    y1: 550.692,
    y2: -54.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oO",
    x1: 664.843,
    x2: -211.609,
    y1: 538.495,
    y2: -66.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oP",
    x1: 856.511,
    x2: -19.94,
    y1: 260.798,
    y2: -344.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oQ",
    x1: 881.774,
    x2: 5.408,
    y1: 224.143,
    y2: -380.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oR",
    x1: 698.548,
    x2: -177.859,
    y1: 489.621,
    y2: -115.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oS",
    x1: 742.301,
    x2: -134.234,
    y1: 426.328,
    y2: -178.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oT",
    x1: 525.307,
    x2: -351.123,
    y1: 740.637,
    y2: 135.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oU",
    x1: 646.392,
    x2: -229.93,
    y1: 565.112,
    y2: -39.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oV",
    x1: 846.503,
    x2: -29.863,
    y1: 275.24,
    y2: -329.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oW",
    x1: 785.971,
    x2: -90.458,
    y1: 362.991,
    y2: -241.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oX",
    x1: 533.789,
    x2: -342.828,
    y1: 728.461,
    y2: 123.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oY",
    x1: 638.015,
    x2: -238.48,
    y1: 577.374,
    y2: -27.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oZ",
    x1: 629.574,
    x2: -246.859,
    y1: 589.571,
    y2: -15.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa",
    x1: 690.126,
    x2: -186.303,
    y1: 501.84,
    y2: -103.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pb",
    x1: 890.214,
    x2: 13.828,
    y1: 211.925,
    y2: -392.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pc",
    x1: 733.773,
    x2: -142.485,
    y1: 438.482,
    y2: -166.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pd",
    x1: 681.683,
    x2: -194.702,
    y1: 514.037,
    y2: -90.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pe",
    x1: 870.792,
    x2: -5.658,
    y1: 240.11,
    y2: -364.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pf",
    x1: 750.658,
    x2: -125.686,
    y1: 414.067,
    y2: -190.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pg",
    x1: 854.945,
    x2: -21.463,
    y1: 263.043,
    y2: -341.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph",
    x1: 877.605,
    x2: 1.261,
    y1: 230.178,
    y2: -374.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pi",
    x1: 880.186,
    x2: 3.947,
    y1: 226.346,
    y2: -378.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pj",
    x1: 767.521,
    x2: -108.759,
    y1: 389.609,
    y2: -215.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk",
    x1: 680.181,
    x2: -196.312,
    y1: 516.303,
    y2: -88.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pl",
    x1: 523.739,
    x2: -352.64,
    y1: 742.858,
    y2: 137.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pm",
    x1: 723.872,
    x2: -152.599,
    y1: 452.988,
    y2: -151.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pn",
    x1: 732.293,
    x2: -144.157,
    y1: 440.769,
    y2: -164.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "po",
    x1: 619.564,
    x2: -256.78,
    y1: 604.012,
    y2: -0.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp",
    x1: 888.692,
    x2: 12.263,
    y1: 214.17,
    y2: -390.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pq",
    x1: 775.984,
    x2: -100.424,
    y1: 377.433,
    y2: -227.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pr",
    x1: 863.366,
    x2: -13,
    y1: 250.804,
    y2: -354.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ps",
    x1: 845.001,
    x2: -31.491,
    y1: 277.506,
    y2: -327.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pt",
    x1: 628.047,
    x2: -248.442,
    y1: 591.814,
    y2: -13.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pu",
    x1: 611.164,
    x2: -265.264,
    y1: 616.23,
    y2: 11.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pv",
    x1: 636.469,
    x2: -240.021,
    y1: 579.617,
    y2: -25.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pw",
    x1: 871.807,
    x2: -4.559,
    y1: 238.585,
    y2: -366.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "px",
    x1: 688.582,
    x2: -187.827,
    y1: 504.063,
    y2: -100.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "py",
    x1: 740.736,
    x2: -135.716,
    y1: 428.551,
    y2: -176.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pz",
    x1: 897.134,
    x2: 20.662,
    y1: 201.973,
    y2: -403.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pA",
    x1: 784.426,
    x2: -92.004,
    y1: 365.236,
    y2: -239.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pB",
    x1: 671.698,
    x2: -204.646,
    y1: 528.478,
    y2: -76.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pC",
    x1: 759.143,
    x2: -117.351,
    y1: 401.891,
    y2: -203.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pD",
    x1: 663.318,
    x2: -213.195,
    y1: 540.718,
    y2: -64.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pE",
    x1: 706.988,
    x2: -169.419,
    y1: 477.403,
    y2: -127.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pF",
    x1: 532.14,
    x2: -344.163,
    y1: 730.621,
    y2: 125.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pG",
    x1: 654.855,
    x2: -221.553,
    y1: 552.915,
    y2: -51.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pH",
    x1: 602.722,
    x2: -273.689,
    y1: 628.45,
    y2: 23.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pI",
    x1: 653.311,
    x2: -223.077,
    y1: 555.139,
    y2: -49.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pJ",
    x1: 697.024,
    x2: -179.426,
    y1: 491.845,
    y2: -113.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pK",
    x1: 884.565,
    x2: 8.136,
    y1: 220.141,
    y2: -384.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pL",
    x1: 705.465,
    x2: -170.984,
    y1: 479.647,
    y2: -125.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pM",
    x1: 757.577,
    x2: -118.833,
    y1: 404.094,
    y2: -200.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pN",
    x1: 861.822,
    x2: -14.544,
    y1: 253.048,
    y2: -351.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pO",
    x1: 853.38,
    x2: -22.944,
    y1: 265.245,
    y2: -339.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pP",
    x1: 749.113,
    x2: -127.21,
    y1: 416.312,
    y2: -188.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pQ",
    x1: 644.87,
    x2: -231.496,
    y1: 567.357,
    y2: -37.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pR",
    x1: 765.998,
    x2: -110.389,
    y1: 391.875,
    y2: -213.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pS",
    x1: 609.577,
    x2: -266.725,
    y1: 618.454,
    y2: 13.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pT",
    x1: 870.284,
    x2: -6.166,
    y1: 240.83,
    y2: -364.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pU",
    x1: 661.775,
    x2: -214.74,
    y1: 542.963,
    y2: -62.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pV",
    x1: 891.549,
    x2: 15.035,
    y1: 210.104,
    y2: -394.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pW",
    x1: 774.44,
    x2: -101.948,
    y1: 379.657,
    y2: -225.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pX",
    x1: 626.439,
    x2: -249.864,
    y1: 594.018,
    y2: -10.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pY",
    x1: 678.616,
    x2: -197.856,
    y1: 518.526,
    y2: -86.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pZ",
    x1: 670.194,
    x2: -206.237,
    y1: 530.724,
    y2: -74.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qa",
    x1: 887.083,
    x2: 10.802,
    y1: 216.393,
    y2: -388.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qb",
    x1: 730.727,
    x2: -145.64,
    y1: 442.972,
    y2: -161.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qc",
    x1: 878.684,
    x2: 2.339,
    y1: 228.611,
    y2: -376.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qd",
    x1: 782.902,
    x2: -93.59,
    y1: 367.481,
    y2: -237.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qe",
    x1: 618.063,
    x2: -258.389,
    y1: 606.257,
    y2: 1.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qf",
    x1: 634.882,
    x2: -241.441,
    y1: 581.799,
    y2: -23.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qg",
    x1: 703.9,
    x2: -172.488,
    y1: 481.85,
    y2: -123.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qh",
    x1: 843.414,
    x2: -32.888,
    y1: 279.687,
    y2: -325.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qi",
    x1: 903.968,
    x2: 27.686,
    y1: 191.935,
    y2: -412.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qj",
    x1: 608.054,
    x2: -268.289,
    y1: 620.677,
    y2: 15.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qk",
    x1: 877.203,
    x2: 0.668,
    y1: 230.877,
    y2: -374.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ql",
    x1: 756.075,
    x2: -120.439,
    y1: 406.359,
    y2: -198.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qm",
    x1: 747.632,
    x2: -128.882,
    y1: 418.578,
    y2: -186.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qn",
    x1: 764.431,
    x2: -111.849,
    y1: 394.098,
    y2: -210.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qo",
    x1: 898.446,
    x2: 21.953,
    y1: 200.067,
    y2: -404.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qp",
    x1: 668.651,
    x2: -207.78,
    y1: 532.947,
    y2: -71.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qq",
    x1: 739.19,
    x2: -137.282,
    y1: 430.775,
    y2: -174.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qr",
    x1: 868.719,
    x2: -7.626,
    y1: 243.053,
    y2: -361.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qs",
    x1: 772.917,
    x2: -103.513,
    y1: 381.901,
    y2: -223.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qt",
    x1: 687.057,
    x2: -189.414,
    y1: 506.308,
    y2: -98.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qu",
    x1: 851.877,
    x2: -24.595,
    y1: 267.511,
    y2: -337.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qv",
    x1: 695.478,
    x2: -180.972,
    y1: 494.111,
    y2: -110.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qw",
    x1: 643.345,
    x2: -233.103,
    y1: 569.622,
    y2: -35.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qx",
    x1: 530.596,
    x2: -345.644,
    y1: 732.845,
    y2: 128.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qy",
    x1: 860.319,
    x2: -16.131,
    y1: 255.293,
    y2: -349.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qz",
    x1: 651.808,
    x2: -224.706,
    y1: 557.405,
    y2: -47.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qA",
    x1: 616.477,
    x2: -259.868,
    y1: 608.48,
    y2: 3.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qB",
    x1: 660.186,
    x2: -216.221,
    y1: 545.207,
    y2: -59.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qC",
    x1: 606.531,
    x2: -269.899,
    y1: 622.943,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qD",
    x1: 841.912,
    x2: -34.539,
    y1: 281.953,
    y2: -323.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qE",
    x1: 710.797,
    x2: -165.61,
    y1: 471.876,
    y2: -133.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qF",
    x1: 624.917,
    x2: -251.447,
    y1: 596.282,
    y2: -8.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qG",
    x1: 702.376,
    x2: -174.139,
    y1: 484.137,
    y2: -120.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qH",
    x1: 650.243,
    x2: -226.184,
    y1: 559.627,
    y2: -45.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qI",
    x1: 885.624,
    x2: 9.089,
    y1: 218.659,
    y2: -386.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qJ",
    x1: 867.195,
    x2: -9.213,
    y1: 245.298,
    y2: -359.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qK",
    x1: 658.706,
    x2: -217.829,
    y1: 547.431,
    y2: -57.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qL",
    x1: 737.604,
    x2: -138.741,
    y1: 432.998,
    y2: -171.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qM",
    x1: 781.316,
    x2: -95.071,
    y1: 369.683,
    y2: -235.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qN",
    x1: 693.933,
    x2: -182.495,
    y1: 496.313,
    y2: -108.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qO",
    x1: 746.067,
    x2: -130.384,
    y1: 420.801,
    y2: -184.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qP",
    x1: 677.071,
    x2: -199.338,
    y1: 520.729,
    y2: -84.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qQ",
    x1: 685.492,
    x2: -190.939,
    y1: 508.553,
    y2: -96.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qR",
    x1: 762.908,
    x2: -113.478,
    y1: 396.364,
    y2: -208.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qS",
    x1: 754.487,
    x2: -121.92,
    y1: 408.561,
    y2: -196.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qT",
    x1: 729.141,
    x2: -147.097,
    y1: 445.195,
    y2: -159.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qU",
    x1: 641.759,
    x2: -234.542,
    y1: 571.825,
    y2: -33.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qV",
    x1: 633.359,
    x2: -243.028,
    y1: 584.044,
    y2: -20.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qW",
    x1: 850.354,
    x2: -26.139,
    y1: 269.735,
    y2: -335.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qX",
    x1: 858.754,
    x2: -17.654,
    y1: 257.537,
    y2: -347.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qY",
    x1: 905.322,
    x2: 28.956,
    y1: 190.03,
    y2: -414.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qZ",
    x1: 875.637,
    x2: -0.792,
    y1: 233.08,
    y2: -371.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra",
    x1: 727.681,
    x2: -148.833,
    y1: 447.461,
    y2: -157.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rb",
    x1: 675.548,
    x2: -200.901,
    y1: 522.973,
    y2: -81.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rc",
    x1: 771.329,
    x2: -105.059,
    y1: 384.167,
    y2: -220.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rd",
    x1: 884.037,
    x2: 7.67,
    y1: 220.861,
    y2: -384.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "re",
    x1: 614.93,
    x2: -261.349,
    y1: 610.682,
    y2: 5.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rf",
    x1: 683.968,
    x2: -192.522,
    y1: 510.797,
    y2: -94.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rg",
    x1: 779.793,
    x2: -96.594,
    y1: 371.907,
    y2: -233.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rh",
    x1: 667.106,
    x2: -209.321,
    y1: 535.169,
    y2: -69.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ri",
    x1: 892.5,
    x2: 16.05,
    y1: 208.643,
    y2: -396.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rj",
    x1: 623.373,
    x2: -252.927,
    y1: 598.485,
    y2: -6.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rk",
    x1: 736.124,
    x2: -140.368,
    y1: 435.242,
    y2: -169.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rl",
    x1: 912.262,
    x2: 35.769,
    y1: 180.056,
    y2: -424.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rm",
    x1: 631.836,
    x2: -244.616,
    y1: 586.288,
    y2: -18.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rn",
    x1: 605.008,
    x2: -271.462,
    y1: 625.187,
    y2: 20.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ro",
    x1: 857.188,
    x2: -19.136,
    y1: 259.74,
    y2: -345.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rp",
    x1: 613.448,
    x2: -263.108,
    y1: 612.991,
    y2: 7.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rq",
    x1: 874.072,
    x2: -2.314,
    y1: 235.303,
    y2: -369.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rr",
    x1: 865.672,
    x2: -10.821,
    y1: 247.542,
    y2: -357.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rs",
    x1: 900.921,
    x2: 24.449,
    y1: 196.467,
    y2: -408.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rt",
    x1: 848.809,
    x2: -27.705,
    y1: 271.979,
    y2: -333.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ru",
    x1: 709.253,
    x2: -167.177,
    y1: 474.121,
    y2: -130.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rv",
    x1: 692.368,
    x2: -183.976,
    y1: 498.536,
    y2: -106.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rw",
    x1: 769.827,
    x2: -106.624,
    y1: 386.391,
    y2: -218.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rx",
    x1: 744.501,
    x2: -131.822,
    y1: 423.003,
    y2: -181.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ry",
    x1: 657.098,
    x2: -219.268,
    y1: 549.633,
    y2: -55.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rz",
    x1: 648.677,
    x2: -227.689,
    y1: 561.851,
    y2: -43.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rA",
    x1: 778.227,
    x2: -98.117,
    y1: 374.151,
    y2: -230.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rB",
    x1: 761.406,
    x2: -115.064,
    y1: 398.609,
    y2: -206.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rC",
    x1: 665.54,
    x2: -210.804,
    y1: 537.415,
    y2: -67.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rD",
    x1: 700.811,
    x2: -175.557,
    y1: 486.319,
    y2: -118.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rE",
    x1: 640.257,
    x2: -236.193,
    y1: 574.091,
    y2: -30.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rF",
    x1: 752.986,
    x2: -123.55,
    y1: 410.827,
    y2: -194.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rG",
    x1: 690.802,
    x2: -185.472,
    y1: 500.758,
    y2: -104.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rH",
    x1: 682.403,
    x2: -193.966,
    y1: 513,
    y2: -91.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rI",
    x1: 674.003,
    x2: -202.469,
    y1: 525.218,
    y2: -79.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rJ",
    x1: 742.957,
    x2: -133.408,
    y1: 425.248,
    y2: -179.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rK",
    x1: 630.291,
    x2: -246.141,
    y1: 588.534,
    y2: -16.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rL",
    x1: 638.754,
    x2: -237.824,
    y1: 576.336,
    y2: -28.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rM",
    x1: 847.244,
    x2: -29.122,
    y1: 274.181,
    y2: -330.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rN",
    x1: 734.557,
    x2: -141.916,
    y1: 437.488,
    y2: -167.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rO",
    x1: 726.137,
    x2: -150.354,
    y1: 449.705,
    y2: -155.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rP",
    x1: 621.892,
    x2: -254.687,
    y1: 600.772,
    y2: -4.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rQ",
    x1: 855.685,
    x2: -20.723,
    y1: 261.984,
    y2: -342.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rR",
    x1: 603.463,
    x2: -273.073,
    y1: 627.432,
    y2: 22.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rS",
    x1: 663.996,
    x2: -212.347,
    y1: 539.659,
    y2: -65.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rT",
    x1: 647.196,
    x2: -229.427,
    y1: 564.139,
    y2: -40.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rU",
    x1: 611.906,
    x2: -264.628,
    y1: 615.213,
    y2: 10.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rV",
    x1: 864.128,
    x2: -12.322,
    y1: 249.766,
    y2: -355.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rW",
    x1: 759.883,
    x2: -116.673,
    y1: 400.832,
    y2: -204.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rX",
    x1: 707.772,
    x2: -168.911,
    y1: 476.408,
    y2: -128.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rY",
    x1: 699.245,
    x2: -177.078,
    y1: 488.563,
    y2: -116.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rZ",
    x1: 655.597,
    x2: -220.893,
    y1: 551.898,
    y2: -53.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sa",
    x1: 872.548,
    x2: -3.922,
    y1: 237.568,
    y2: -367.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sb",
    x1: 751.398,
    x2: -124.948,
    y1: 413.03,
    y2: -191.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sc",
    x1: 768.283,
    x2: -108.167,
    y1: 388.614,
    y2: -216.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sd",
    x1: 680.816,
    x2: -195.357,
    y1: 515.18,
    y2: -89.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "se",
    x1: 732.992,
    x2: -143.391,
    y1: 439.688,
    y2: -165.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sf",
    x1: 741.433,
    x2: -134.955,
    y1: 427.493,
    y2: -177.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg",
    x1: 689.321,
    x2: -187.129,
    y1: 503.026,
    y2: -101.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sh",
    x1: 724.57,
    x2: -151.777,
    y1: 451.887,
    y2: -152.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "si",
    x1: 776.745,
    x2: -99.811,
    y1: 376.396,
    y2: -228.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sj",
    x1: 628.705,
    x2: -247.578,
    y1: 590.756,
    y2: -14.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sk",
    x1: 620.347,
    x2: -256.187,
    y1: 602.974,
    y2: -2.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sl",
    x1: 845.699,
    x2: -30.709,
    y1: 276.426,
    y2: -328.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sm",
    x1: 672.438,
    x2: -204.01,
    y1: 527.462,
    y2: -77.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sn",
    x1: 637.167,
    x2: -239.177,
    y1: 578.516,
    y2: -26.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "so",
    x1: 880.969,
    x2: 4.561,
    y1: 225.329,
    y2: -379.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sp",
    x1: 601.918,
    x2: -274.534,
    y1: 629.656,
    y2: 24.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq",
    x1: 749.897,
    x2: -126.617,
    y1: 415.295,
    y2: -189.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sr",
    x1: 645.632,
    x2: -230.861,
    y1: 566.34,
    y2: -38.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss",
    x1: 706.142,
    x2: -170.183,
    y1: 478.568,
    y2: -126.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "st",
    x1: 758.275,
    x2: -118.025,
    y1: 403.034,
    y2: -201.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "su",
    x1: 653.988,
    x2: -222.21,
    y1: 554.081,
    y2: -50.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv",
    x1: 697.785,
    x2: -178.836,
    y1: 490.85,
    y2: -114.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw",
    x1: 854.205,
    x2: -22.5,
    y1: 264.271,
    y2: -340.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sx",
    x1: 862.541,
    x2: -13.783,
    y1: 251.989,
    y2: -352.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sy",
    x1: 739.889,
    x2: -136.558,
    y1: 429.736,
    y2: -175.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sz",
    x1: 600.395,
    x2: -276.14,
    y1: 631.879,
    y2: 26.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sA",
    x1: 635.602,
    x2: -240.699,
    y1: 580.761,
    y2: -24.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sB",
    x1: 627.223,
    x2: -249.288,
    y1: 593,
    y2: -11.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sC",
    x1: 844.155,
    x2: -32.254,
    y1: 278.671,
    y2: -326.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sD",
    x1: 748.289,
    x2: -127.973,
    y1: 417.477,
    y2: -187.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sE",
    x1: 723.027,
    x2: -153.404,
    y1: 454.153,
    y2: -150.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sF",
    x1: 860.996,
    x2: -15.307,
    y1: 254.234,
    y2: -350.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sG",
    x1: 652.486,
    x2: -223.874,
    y1: 556.344,
    y2: -48.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sH",
    x1: 756.709,
    x2: -119.53,
    y1: 405.258,
    y2: -199.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sI",
    x1: 644.023,
    x2: -232.216,
    y1: 568.543,
    y2: -36.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sJ",
    x1: 731.447,
    x2: -144.898,
    y1: 441.913,
    y2: -162.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sK",
    x1: 852.534,
    x2: -23.621,
    y1: 266.41,
    y2: -338.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sL",
    x1: 679.271,
    x2: -196.926,
    y1: 517.446,
    y2: -87.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sM",
    x1: 696.241,
    x2: -180.4,
    y1: 493.073,
    y2: -112.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sN",
    x1: 704.619,
    x2: -171.744,
    y1: 480.812,
    y2: -124.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sO",
    x1: 618.781,
    x2: -257.712,
    y1: 605.219,
    y2: 0.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sP",
    x1: 670.914,
    x2: -205.513,
    y1: 529.664,
    y2: -75.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sQ",
    x1: 687.756,
    x2: -188.632,
    y1: 505.249,
    y2: -99.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sR",
    x1: 610.318,
    x2: -265.985,
    y1: 617.395,
    y2: 12.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sS",
    x1: 662.45,
    x2: -213.895,
    y1: 541.883,
    y2: -63.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sT",
    x1: 775.18,
    x2: -101.312,
    y1: 378.64,
    y2: -226.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sU",
    x1: 766.738,
    x2: -109.692,
    y1: 390.838,
    y2: -214.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sV",
    x1: 608.795,
    x2: -267.611,
    y1: 619.66,
    y2: 14.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sW",
    x1: 765.172,
    x2: -111.109,
    y1: 393.061,
    y2: -211.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sX",
    x1: 660.906,
    x2: -215.417,
    y1: 544.106,
    y2: -60.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sY",
    x1: 729.881,
    x2: -146.333,
    y1: 444.136,
    y2: -160.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sZ",
    x1: 686.212,
    x2: -190.178,
    y1: 507.473,
    y2: -97.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ta",
    x1: 694.653,
    x2: -181.714,
    y1: 495.254,
    y2: -109.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tb",
    x1: 677.769,
    x2: -198.557,
    y1: 519.692,
    y2: -85.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tc",
    x1: 773.636,
    x2: -102.812,
    y1: 380.863,
    y2: -224.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "td",
    x1: 669.349,
    x2: -206.998,
    y1: 531.91,
    y2: -72.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "te",
    x1: 842.631,
    x2: -33.861,
    y1: 280.915,
    y2: -324.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tf",
    x1: 851.01,
    x2: -25.206,
    y1: 268.654,
    y2: -336.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tg",
    x1: 659.426,
    x2: -217.15,
    y1: 546.372,
    y2: -58.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "th",
    x1: 763.712,
    x2: -113.011,
    y1: 395.347,
    y2: -209.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ti",
    x1: 746.723,
    x2: -129.395,
    y1: 419.701,
    y2: -185.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tj",
    x1: 650.984,
    x2: -225.596,
    y1: 558.612,
    y2: -46.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tk",
    x1: 642.521,
    x2: -233.889,
    y1: 570.788,
    y2: -34.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tl",
    x1: 598.808,
    x2: -277.532,
    y1: 634.101,
    y2: 29.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm",
    x1: 755.207,
    x2: -121.162,
    y1: 407.525,
    y2: -197.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tn",
    x1: 607.23,
    x2: -269.056,
    y1: 621.864,
    y2: 17.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "to",
    x1: 617.237,
    x2: -259.234,
    y1: 607.442,
    y2: 2.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tp",
    x1: 625.637,
    x2: -250.711,
    y1: 595.225,
    y2: -9.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tq",
    x1: 738.366,
    x2: -138.132,
    y1: 431.962,
    y2: -173.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tr",
    x1: 634.058,
    x2: -242.205,
    y1: 582.985,
    y2: -21.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ts",
    x1: 703.075,
    x2: -173.312,
    y1: 483.057,
    y2: -121.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tt",
    x1: 728.337,
    x2: -147.856,
    y1: 446.38,
    y2: -158.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tu",
    x1: 772.092,
    x2: -104.337,
    y1: 383.087,
    y2: -221.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tv",
    x1: 719.874,
    x2: -156.178,
    y1: 458.558,
    y2: -146.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tw",
    x1: 736.842,
    x2: -139.715,
    y1: 434.205,
    y2: -170.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tx",
    x1: 684.709,
    x2: -191.803,
    y1: 509.717,
    y2: -95.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ty",
    x1: 841.107,
    x2: -35.469,
    y1: 283.16,
    y2: -321.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tz",
    x1: 676.267,
    x2: -200.265,
    y1: 521.935,
    y2: -83.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tA",
    x1: 667.804,
    x2: -208.562,
    y1: 534.133,
    y2: -70.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tB",
    x1: 615.672,
    x2: -260.694,
    y1: 609.666,
    y2: 4.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tC",
    x1: 624.092,
    x2: -252.183,
    y1: 597.446,
    y2: -7.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tD",
    x1: 632.533,
    x2: -243.808,
    y1: 585.229,
    y2: -19.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tE",
    x1: 496.024,
    x2: -380.224,
    y1: 782.92,
    y2: 178.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tF",
    x1: 640.976,
    x2: -235.391,
    y1: 573.011,
    y2: -31.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tG",
    x1: 745.241,
    x2: -131.123,
    y1: 421.965,
    y2: -182.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tH",
    x1: 693.088,
    x2: -183.195,
    y1: 497.478,
    y2: -107.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tI",
    x1: 770.589,
    x2: -106.135,
    y1: 385.374,
    y2: -219.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tJ",
    x1: 762.02,
    x2: -113.94,
    y1: 397.486,
    y2: -207.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tK",
    x1: 718.372,
    x2: -157.887,
    y1: 460.822,
    y2: -144.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tL",
    x1: 701.551,
    x2: -174.896,
    y1: 485.301,
    y2: -119.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tM",
    x1: 753.727,
    x2: -122.979,
    y1: 409.811,
    y2: -195.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tN",
    x1: 666.302,
    x2: -210.25,
    y1: 536.398,
    y2: -68.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tO",
    x1: 657.86,
    x2: -218.638,
    y1: 548.618,
    y2: -56.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tP",
    x1: 503.176,
    x2: -373.497,
    y1: 772.883,
    y2: 167.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tQ",
    x1: 649.439,
    x2: -227.151,
    y1: 560.833,
    y2: -44.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tR",
    x1: 597.286,
    x2: -279.102,
    y1: 636.326,
    y2: 31.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tS",
    x1: 614.275,
    x2: -262.804,
    y1: 611.994,
    y2: 6.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tT",
    x1: 605.728,
    x2: -270.773,
    y1: 624.13,
    y2: 19.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tU",
    x1: 641.166,
    x2: -235.07,
    y1: 572.501,
    y2: -32.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tV",
    x1: 516.776,
    x2: -359.278,
    y1: 752.71,
    y2: 148.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tW",
    x1: 510.118,
    x2: -366.492,
    y1: 762.787,
    y2: 157.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M667 0H0v553h667z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportPattern);
export default __webpack_public_path__ + "static/media/sport_pattern.cf0df1175915e7c4d92a5783d63ada04.svg";
export { ForwardRef as ReactComponent };